import { useNavigate, useLocation } from "react-router-dom";
import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { fetchProgress } from "../../api/assessmentApi";
import axios from "axios";
import { Radar } from "react-chartjs-2";
import TooltipUI from "../TooltipUI";
import TooltipUI2 from "../TooltipUI2";
import TooltipUIViewOnly from "../TooltipUIViewOnly";
import TooltipUIViewOnly2 from "../TooltipUIViewOnly2";
import ReactDOM from 'react-dom';
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import {
  FaUsers,
  FaBookOpen,
  FaIdBadge,
  FaArrowLeft,
  FaPaperPlane, 
  FaCheck, 
  FaTimes,
  FaBell,
  FaInfoCircle,
  FaSave,
  FaChessKnight,
  FaBolt,
  FaTrophy,
  FaRss,
  FaEdit,   
  FaEye,   
  FaDownload,
  FaYoutubeSquare,
  FaThumbtack,
  FaGraduationCap,   // NEW
  FaStickyNote,      // NEW
  FaChevronDown,     // NEW
  FaChevronUp, 
  FaPlus,
  FaPencilAlt,
  FaTrash,
  FaHourglassHalf,
  FaExclamationCircle,
  FaRegCompass,
  FaRegCircle,
  FaSpinner,
  FaExclamationTriangle,
  FaCheckCircle,
  FaSyncAlt,
  FaStar,
  FaWhatsapp,
  FaEnvelope,
  FaLink,
  FaShareAlt,
  FaFilter,
} from "react-icons/fa";
import "./dashboard.css";
import "./supercurricular.css";
import "./compass.css";
import "./CareerDashboard.css";
import DOMPurify from "dompurify";
import { fetchRawAnswers } from "../../api/assessmentApi";
import { getAuthHeaders } from "../../api/assessmentApi";
import confetti from 'canvas-confetti';
import { generateAndDownloadPersonalStatementDocx } from '../../utils/personalStatementDocxGenerator';
import useBookmark from '../../hooks/useBookmark';
import { generateAndDownloadPlanOfAttackDocx } from '../../utils/planOfAttackDocxGenerator';
import { avatarStyles } from '../../constants/avatarStyles';
import { useModalContext } from '../../constants/ModalContext';
import { ensureFreshCacheVersion } from './cacheVersionUtil';
import {
  getRawAnswers, saveRawAnswers,
  getSuperActivities, saveSuperActivities,
  getKnowledgeResources, saveKnowledgeResources,
  getPsGuidanceSets, savePsGuidanceSets,
  getChallengeQuestions, saveChallengeQuestions,
  appendPastChallenge,
  getStrategyCache, saveStrategyCache,
  getCalendarEvents, saveCalendarEvents,
  getPlanNotes, savePlanNotes,
  getResourceNotes, saveResourceNotes,
  getPersonalStatementAnswers, savePersonalStatementAnswers,
  getUserResources, saveUserResources,
  getOptionCompletions, saveOptionCompletions,
  getActivityStatuses, saveActivityStatuses,
  getKnowledgeCheckboxes, saveKnowledgeCheckboxes,
  getPsStatus, savePsStatus,
  getStudyLearnerIntelligence, saveStudyLearnerIntelligence,
  ensureFacetNoteCacheFreshness,
  getProfileGroupCache, saveProfileGroupCache,
  getProfileMatchesCache, saveProfileMatchesCache,  // add these
  getSubjectReasons,
  getSubjectFacetsCache, saveSubjectFacetsCache,
  } from './dashboardDb';
import { useUIFeedback } from "../UIFeedback"; 
import { radius, spacing, fontSize, color, gradientBorder, transition } from './dashboardTokens';
import { loadProfileGroupByName, computeProfileMatches } from '../../utils/Profilematching';

// Register Chart.js components for Radar chart
ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

// Debounce utility
const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};

// Group names must match the `name` field of profile_groups rows created
// in the CMS for StudyStyle. Mirrors CAREER_RADAR_KEYS in CareerDashboard.js.
const STUDY_RADAR_KEYS = [
  { key: "sensoryModalityPreferences", label: "Sensory Modality Preferences", border: "rgba(45, 212, 191, 1)" },
  { key: "socialEnvironmentalLearning", label: "Social & Environmental Learning Orientation", border: "rgba(255, 159, 64, 1)" },
  { key: "selfRegulationMetacognition", label: "Self-Regulation & Metacognition", border: "rgba(255, 99, 132, 1)" },
  { key: "motivationalAffectiveDispositions", label: "Motivational & Affective Dispositions", border: "rgba(56, 161, 255, 1)" },
  { key: "cognitiveStyleThinkingDisposition", label: "Cognitive Style & Thinking Disposition", border: "rgba(255, 206, 86, 1)" },
];

function StudyProfileMatchPill({ groupLabel, accentColor, matchResult, onClick }) {
  if (!matchResult || !matchResult.best) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', padding: `${spacing.sm} ${spacing.base}`,
        borderRadius: radius.sm, background: 'rgba(255,255,255,0.03)',
        border: `1px solid ${color.border}`, opacity: 0.5,
      }}>
        <span style={{ fontSize: fontSize.xs, color: color.textMuted }}>{groupLabel}: not available</span>
      </div>
    );
  }
  const { best, runnerUp } = matchResult;
  const isTie = runnerUp && runnerUp.fitPercent === best.fitPercent;
  const displayName = isTie ? `${best.profile.name} & ${runnerUp.profile.name}` : best.profile.name;

  return (
    <button
      onClick={onClick}
      style={{
        display: 'flex', alignItems: 'center', gap: spacing.sm, width: '100%',
        padding: `${spacing.sm} ${spacing.base}`, borderRadius: radius.sm,
        background: 'rgba(255,255,255,0.03)', border: `1px solid ${color.border}`,
        cursor: 'pointer', textAlign: 'left', transition: `border-color ${transition.fast}`,
      }}
      onMouseEnter={(e) => (e.currentTarget.style.borderColor = `${accentColor}88`)}
      onMouseLeave={(e) => (e.currentTarget.style.borderColor = color.border)}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: '11px', color: accentColor, letterSpacing: '0.03em', marginBottom: '2px' }}>
          {groupLabel}
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px', gap: '8px' }}>
          <span style={{
            fontSize: fontSize.m, fontWeight: 600, color: accentColor,
            whiteSpace: isTie ? 'normal' : 'nowrap', overflow: isTie ? 'visible' : 'hidden',
            textOverflow: isTie ? 'clip' : 'ellipsis', lineHeight: 1.35,
          }}>
            {displayName}
          </span>
          <span style={{ fontSize: fontSize.xs, color: accentColor, fontWeight: 700, flexShrink: 0, marginLeft: '8px' }}>
            {best.fitPercent}%
          </span>
        </div>
        <div style={{ height: '4px', borderRadius: radius.pill, background: 'rgba(255,255,255,0.08)', overflow: 'hidden' }}>
          <div style={{ width: `${best.fitPercent}%`, height: '100%', background: accentColor, borderRadius: radius.pill }} />
        </div>
      </div>
    </button>
  );
}

function StudyProfileMatchDetailModal({ groupLabel, accentColor, matchResult, onClose }) {
  if (!matchResult?.best) return null;
  const { best, runnerUp } = matchResult;

  return ReactDOM.createPortal(
    <div
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', zIndex: 6000,
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px',
      }}
    >
      <div style={{
        width: '620px', maxWidth: '92vw', maxHeight: '85vh', overflowY: 'auto',
        background: '#0d1424', border: `1px solid ${accentColor}55`, borderRadius: '14px', padding: '26px',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
          <div style={{ fontSize: '11px', color: accentColor, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
            {groupLabel}
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#aaa', fontSize: '22px', cursor: 'pointer', marginTop: '-8px' }}>×</button>
        </div>

        <div style={{ marginBottom: runnerUp ? '28px' : 0 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px', marginBottom: '10px' }}>
            <div>
              <div style={{ fontSize: '11px', color: accentColor, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                Best Match
              </div>
              <h3 style={{ margin: '4px 0 0 0', color: accentColor, fontSize: '22px', fontWeight: 700 }}>
                {best.profile.name}
              </h3>
            </div>
            <div style={{ textAlign: 'right', flexShrink: 0 }}>
              <div style={{ fontSize: '26px', fontWeight: 800, color: accentColor, lineHeight: 1 }}>{best.fitPercent}%</div>
              <div style={{ fontSize: '10px', color: '#888', textTransform: 'uppercase' }}>fit</div>
            </div>
          </div>
          <div style={{ height: '6px', background: 'rgba(255,255,255,0.08)', borderRadius: '3px', overflow: 'hidden', marginBottom: '14px' }}>
            <div style={{ width: `${best.fitPercent}%`, height: '100%', background: accentColor }} />
          </div>
          <p style={{ margin: 0, fontSize: '14px', color: '#ddd', lineHeight: 1.7 }}>
            {best.profile.narrative || 'No description available.'}
          </p>
        </div>

     {runnerUp && (
      <div style={{ paddingTop: '22px', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px', marginBottom: '10px' }}>
          <div>
            <div style={{ 
              fontSize: '11px', 
              color: runnerUp.fitPercent === best.fitPercent ? accentColor :'#999', 
              fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
              {runnerUp.fitPercent === best.fitPercent ? 'Tied Best Match' : 'Also Close'}
            </div>
            <h4 style={{ 
              margin: '4px 0 0 0', 
              color: runnerUp.fitPercent === best.fitPercent ? accentColor : '#bbb', 
              fontSize: runnerUp.fitPercent === best.fitPercent ? '22px' : '18px', 
              fontWeight: 700 
            }}>
              {runnerUp.profile.name}
            </h4>
          </div>
    
                  <div style={{ textAlign: 'right', flexShrink: 0 }}>
                    <div style={{ 
                      fontSize: runnerUp.fitPercent === best.fitPercent ? '26px' :'20px', 
                      fontWeight: 800, 
                      color: runnerUp.fitPercent === best.fitPercent ? accentColor :'#bbb', 
                      lineHeight: 1 }}>{runnerUp.fitPercent}%</div>
                    <div style={{ fontSize: '10px', color: '#888', textTransform: 'uppercase' }}>fit</div>
                  </div>
                </div>
                <div style={{ 
                  height: runnerUp.fitPercent === best.fitPercent ? '6px' :'5px', 
                  background: 'rgba(255,255,255,0.08)', borderRadius: '3px', overflow: 'hidden', marginBottom: '12px' }}>
                  <div style={{ width: `${runnerUp.fitPercent}%`, height: '100%', 
                  background: runnerUp.fitPercent === best.fitPercent ? accentColor :'#999' }} />
                </div>
                <p style={{ margin: 0, 
                  fontSize: runnerUp.fitPercent === best.fitPercent ? '14px' : '13.5px', 
                  color: runnerUp.fitPercent === best.fitPercent ?  '#ddd' : '#bbb', 
                  lineHeight: 1.65 }}>
                  {runnerUp.profile.narrative || 'No description available.'}
                </p>
              </div>
            )}
      </div>
    </div>,
    document.body
  );
}

function StudyProfileMatchesSidePanel({ matchesByGroupKey, loading }) {
  const [expandedGroupKey, setExpandedGroupKey] = useState(null);
  const groupsWithData = STUDY_RADAR_KEYS.filter((g) => matchesByGroupKey[g.key] !== undefined);
  if (!loading && groupsWithData.length === 0) return null;

  const expandedGroup = groupsWithData.find((g) => g.key === expandedGroupKey);

  return (
    <>
      <div style={{
        background: 'rgba(255,255,255,0.02)', border: `1px solid ${color.border}`,
        borderRadius: radius.lg, padding: spacing.base,
      }}>
        <p style={{ fontSize: fontSize.xs, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.04em', margin: `0 0 ${spacing.sm} 0`, color: '#36a7f8' }}>
          Study Style Profile Matches
        </p>
        {loading ? (
          <div style={{ color: '#888', fontStyle: 'italic', fontSize: fontSize.sm, padding: '10px 0' }}>
            Matching your profile...
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: spacing.xs }}>
            {groupsWithData.map((g) => (
              <StudyProfileMatchPill
                key={g.key}
                groupLabel={g.label}
                accentColor={g.border}
                matchResult={matchesByGroupKey[g.key]}
                onClick={() => setExpandedGroupKey(g.key)}
              />
            ))}
          </div>
        )}
      </div>

      {expandedGroup && (
        <StudyProfileMatchDetailModal
          groupLabel={expandedGroup.label}
          accentColor={expandedGroup.border}
          matchResult={matchesByGroupKey[expandedGroup.key]}
          onClose={() => setExpandedGroupKey(null)}
        />
      )}
    </>
  );
}

// Utility function to format date as DDMMMYY
const formatDateDDMMMYY = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return 'N/A';
  const day = String(date.getDate()).padStart(2, '0');
  const month = date.toLocaleString('en-US', { month: 'short' }).toUpperCase();
  const year = String(date.getFullYear()).slice(-2);
  return `${day}${month}${year}`;
};

// Sanitize email input
const sanitizeEmail = (email) => {
  if (!email) return "";
  // Trim whitespace and convert to lowercase
  let sanitized = email.trim().toLowerCase();
  // Enforce max length (254 chars per RFC 5321)
  sanitized = sanitized.slice(0, 254);
  // Validate email format
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(sanitized)) {
    return "";
  }
  return sanitized;
};

// Sanitize team answer input
const sanitizeAnswer = (text) => {
  if (!text) return "";
  // Use DOMPurify to remove all HTML tags, allowing only plain text
  let sanitized = DOMPurify.sanitize(text, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
  // Trim leading whitespace but preserve a single trailing space if present
  sanitized = sanitized.replace(/^\s+/, '');
  if (sanitized.endsWith(' ')) {
    sanitized = sanitized.replace(/\s+$/, ' '); // Ensure only one trailing space
  } else {
    sanitized = sanitized.trimEnd(); // Remove all trailing whitespace if not a single space
  }
  // Limit to 150 words
  const words = sanitized.split(/\s+/).filter((word) => word.length > 0);
  if (words.length > 150) {
    sanitized = words.slice(0, 150).join(" ");
    // Re-append a single trailing space if the original input had one
    if (text.endsWith(' ')) {
      sanitized += ' ';
    }
  }
  // Enforce max character length (1000 chars)
  if (sanitized.length > 1000) {
    sanitized = sanitized.slice(0, 1000);
    // Ensure the result doesn't cut off in the middle of a word
    const lastSpaceIndex = sanitized.lastIndexOf(' ');
    if (lastSpaceIndex > 0) {
      sanitized = sanitized.slice(0, lastSpaceIndex);
    }
    // Re-append a single trailing space if the original input had one
    if (text.endsWith(' ')) {
      sanitized += ' ';
    }
  }
  return sanitized;
};

// REPLACE getLevelNoteForScore and buildCombinedFacetNote with these:
const getLevelKeyForScore = (avgScore) => {
  if (avgScore == null || isNaN(avgScore)) return null;
  if (avgScore <= 2.49) return 'low';
  if (avgScore <= 3.49) return 'mid';
  return 'high'; // 3.50–5.00
};

const LEVEL_NOTE_META = {
  low:  { label: 'Your Result · Emerging',  color: '#ff6b6b' },
  mid:  { label: 'Your Result · Balanced',  color: '#ffd166' },
  high: { label: 'Your Result · Strong', color: '#00cc99' },
};

// Returns { general, level, levelKey } instead of a flattened string, so
// the tooltip can render each part with distinct styling.
const buildFacetNoteData = (generalNote, lowNote, midNote, highNote, avgScore) => {
  const levelKey = getLevelKeyForScore(avgScore);
  const levelNoteRaw =
    levelKey === 'low' ? lowNote :
    levelKey === 'mid' ? midNote :
    levelKey === 'high' ? highNote : null;

  const general = generalNote && generalNote.trim() ? generalNote.trim() : null;
  const level = levelNoteRaw && levelNoteRaw.trim() ? levelNoteRaw.trim() : null;

  if (!general && !level) return null;
  return { general, level, levelKey: level ? levelKey : null };
};

// Create radar chart data
const createRadarChartData = (answers, label, backgroundColor, borderColor) => {
  const facetMap = answers.reduce((acc, answer) => {
    const facet = answer.facet || "Unknown";
    if (!acc[facet]) {
      acc[facet] = {
        scores: [],
        facet_note: answer.facet_note || null,
        low_note: answer.low_note || null,
        mid_note: answer.mid_note || null,
        high_note: answer.high_note || null,
      };
    }
    acc[facet].scores.push(answer.score);
    return acc;
  }, {});

  const labels = Object.keys(facetMap);

  const avgScoreByFacet = Object.fromEntries(
    labels.map((facet) => {
      const scores = facetMap[facet].scores;
      const avg = scores.reduce((sum, s) => sum + s, 0) / scores.length;
      return [facet, avg];
    })
  );

  // Each entry is now { general, level, levelKey } (or null) instead of a
  // flattened string — lets the tooltip style the two parts differently.
  const facetNoteMap = Object.fromEntries(
    labels.map((facet) => {
      const data = facetMap[facet];
      return [
        facet,
        buildFacetNoteData(
          data.facet_note,
          data.low_note,
          data.mid_note,
          data.high_note,
          avgScoreByFacet[facet]
        ),
      ];
    })
  );

  return {
    labels,
    datasets: [
      {
        label,
        data: labels.map((facet) => avgScoreByFacet[facet]),
        totalScores: labels.map((facet) =>
          facetMap[facet].scores.reduce((sum, score) => sum + score, 0)
        ),
        facetNote: labels.map((facet) => facetNoteMap[facet] || null),
        backgroundColor,
        borderColor,
        borderWidth: 1,
      },
    ],
    facetNote: facetNoteMap,
  };
};

// Process raw answers for Learning assessment
const processRawAnswers = (answers, assessmentType) => {
  if (assessmentType !== "Learning") return {};

  const sensoryModalityPreferences = answers.filter(
    (a) => a.category === "Sensory Modality Preferences"
  );
  const socialEnvironmentalLearning = answers.filter(
    (a) => a.category === "Social & Environmental Learning Orientation"
  );
  const selfRegulationMetacognition = answers.filter(
    (a) => a.category === "Self-Regulation & Metacognition"
  );
  const motivationalAffectiveDispositions = answers.filter(
    (a) => a.category === "Motivational & Affective Dispositions"
  );
  const cognitiveStyleThinkingDisposition = answers.filter(
    (a) => a.category === "Cognitive Style & Thinking Disposition"
  );

  return {
    sensoryModalityPreferences: createRadarChartData(
      sensoryModalityPreferences,
      "Sensory Modality Preferences",
      "rgba(75, 192, 192, 0.2)",
      "rgba(75, 192, 192, 1)"
    ),
    socialEnvironmentalLearning: createRadarChartData(
      socialEnvironmentalLearning,
      "Social & Environmental Learning Orientation",
      "rgba(255, 159, 64, 0.2)",
      "rgba(255, 159, 64, 1)"
    ),
    selfRegulationMetacognition: createRadarChartData(
      selfRegulationMetacognition,
      "Self-Regulation & Metacognition",
      "rgba(255, 99, 132, 0.2)",
      "rgba(255, 99, 132, 1)"
    ),
    motivationalAffectiveDispositions: createRadarChartData(
      motivationalAffectiveDispositions,
      "Motivational & Affective Dispositions",
      "rgba(54, 162, 235, 0.2)",
      "rgba(54, 162, 235, 1)"
    ),
    cognitiveStyleThinkingDisposition: createRadarChartData(
      cognitiveStyleThinkingDisposition,
      "Cognitive Style & Thinking Disposition",
      "rgba(255, 206, 86, 0.2)",
      "rgba(255, 206, 86, 1)"
    ),
  };
};

// ─── Study Learner Intelligence (feeds the local LLM) ────────────────────
// Captures what the StudyStyle psychometrics can't infer: whether the
// generated strategy actually resonates, what's currently blocking the
// student academically, what they enjoy doing when learning, and the
// context they're learning in. Deliberately excludes anything already
// captured by StudyStyle itself (sensory/cognitive style, etc.).
const STUDY_CHALLENGE_OPTIONS = [
  'Staying focused', 'Managing time', 'Remembering information', 'Understanding concepts',
  'Getting started', 'Staying motivated', 'Preparing for exams', 'Writing assignments',
  'Working independently', 'Asking for help', 'Managing stress',
];
const STUDY_GOAL_OPTIONS = [
  'Improve grades', 'Build better habits', 'Learn more efficiently', 'Develop deeper understanding', 'Improve exam performance',
  'Become more independent', 'Prepare for university', 'Build confidence', 'Enjoy learning more',
];
const PREFERRED_ACTIVITY_OPTIONS = [
  'Solving problems', 'Practising questions', 'Researching topics', 'Writing summaries',
  'Creating diagrams', 'Discussing ideas', 'Teaching others', 'Building or creating',
  'Watching demonstrations', 'Hands-on activities', 'Independent learning',
];
const STUDY_ENVIRONMENT_OPTIONS = [
  'Quiet by myself', 'With friends', 'In class', 'Online',
  'Hands-on', 'A mix of different settings',
];
const STUDY_EXPERIENCE_OPTIONS = [
  'Building good study habits', 'Improving my routines',
  'Preparing for exams', 'Preparing for university',
  'Taking advanced subjects', 'Working on major projects',
];
const BIGGEST_PRIORITY_OPTIONS = [
  'Better grades', 'More motivation',
  'Better time management', 'More confidence',
  'More free time', 
];
const SKILLS_DEVELOPED_OPTIONS = [
  'Leadership', 'Communication', 'Teamwork', 'Problem solving',
  'Creativity', 'Organisation', 'Research', 'Initiative', 'Resilience',
];

const STUDY_INTEL_FIELD_CONFIG = {
  studyChallenge:    { label: 'Study Challenge', hint: 'What are your biggest study challenges right now? Choose up to 2.', type: 'chips-multi', options: STUDY_CHALLENGE_OPTIONS, max: 2 },
  studyGoal:         { label: 'Study Goal', hint: 'What do you want to improve most this year?', type: 'chips-single', options: STUDY_GOAL_OPTIONS },
  preferredActivities: { label: '', hint: 'Which learning activities do you enjoy most? Choose up to 5.', type: 'chips-multi', options: PREFERRED_ACTIVITY_OPTIONS, max: 5 },
  studyEnvironment:  { label: 'Best learning environment', hint: 'Where do you learn best?', type: 'chips-single', options: STUDY_ENVIRONMENT_OPTIONS },
  studyExperience:   { label: 'Current study stage', hint: 'Which best describes you right now?', type: 'chips-single', options: STUDY_EXPERIENCE_OPTIONS },
  biggestPriority:   { label: 'Biggest priority', hint: 'If your study strategy could improve just one thing, what would you choose?', type: 'chips-single', options: BIGGEST_PRIORITY_OPTIONS },
};

// 4 grouped screens, matching the recommended Enrich+ structure: Study
// Reflection stands alone (it's a logged, repeatable check-in on whether
// the strategy resonates — not a one-time pick). Challenge + Goal share a
// screen. Learning Preferences stands alone. Environment + Experience
// share a screen ("your current study context").
const STUDY_INTEL_STEPS = [
  { key: 'studyReflection', title: 'Study Strategy Reflection', subtitle: 'How well does this strategy suit the way you learn, and how confident are you that you can improve your study habits?', fields: ['studyReflection'] },
  { key: 'studyChallenges', title: 'Study Challenges & Goals', subtitle: '', fields: ['studyChallenge', 'studyGoal'] },
  { key: 'learningPreferences', title: 'Learning Activities', subtitle: '', fields: ['preferredActivities'] },
  { key: 'studyContext', title: 'Study Environment', subtitle: '', fields: ['studyEnvironment', 'studyExperience', 'biggestPriority'] },
];

const defaultStudyLearnerIntelligence = () => ({
  studyFit: 0,          // was studyReflectionHistory
  studyConfidence: 0,
  studyChallenge: [],
  studyGoal: '',
  preferredActivities: [],
  studyEnvironment: '',
  studyExperience: '',
  updatedAt: null,
});

const studyLearnerIntelligenceCompleteness = (data) => {
  if (!data) return 0;
  return [
    (data.studyFit > 0 && data.studyConfidence > 0),
    data.studyChallenge?.length > 0,
    !!data.studyGoal,
    data.preferredActivities?.length > 0,
    !!data.studyEnvironment,
    !!data.studyExperience,
  ].filter(Boolean).length;
};

// Builds a compact, LLM-friendly summary — used when generating the
// StudyStyle strategy / AI Action Plan prompt so the model reasons over
// stated intent and self-reported obstacles, not just inferred psychometrics.
const buildStudyLearnerIntelligenceSummary = (data) => {
  if (!data || studyLearnerIntelligenceCompleteness(data) === 0) return '';
  const lines = [];
  if (data.studyFit > 0 && data.studyConfidence > 0) {
    lines.push(`Study strategy reflection: fit ${data.studyFit}/5, confidence ${data.studyConfidence}/5`);
  }
  if (data.studyChallenge?.length) lines.push('Biggest study challenges: ' + data.studyChallenge.join(', '));
  if (data.studyGoal) lines.push('Study goal this year: ' + data.studyGoal);
  if (data.preferredActivities?.length) lines.push('Preferred learning activities: ' + data.preferredActivities.join(', '));
  if (data.studyEnvironment) lines.push('Preferred study environment: ' + data.studyEnvironment);
  if (data.studyExperience) lines.push('Current study experience: ' + data.studyExperience);
  return lines.join('\n');
};

// Compact, execution-focused StudyStyle summary for the AI Guided Steps prompt.
// Only clear strengths (Strong) and clear growth areas (Emerging) per category;
// "Balanced" facets are skipped to keep the signal clean.
const buildStudyStyleExecutionSummary = (visualizations, perGroup = 2) => {
  if (!visualizations) return '';
  const lines = [];

  Object.values(visualizations).forEach((viz) => {
    const labels = viz?.labels;
    const scores = viz?.datasets?.[0]?.data;
    if (!labels?.length || !scores?.length) return;

    const facets = labels
      .map((label, i) => ({ label, score: Number(scores[i]) }))
      .filter((f) => !isNaN(f.score));

    const strengths = facets
      .filter((f) => getLevelKeyForScore(f.score) === 'high')
      .sort((a, b) => b.score - a.score)
      .slice(0, perGroup);
    const growth = facets
      .filter((f) => getLevelKeyForScore(f.score) === 'low')
      .sort((a, b) => a.score - b.score)
      .slice(0, perGroup);

    if (!strengths.length && !growth.length) return;

    const fmt = (arr) => arr.map((f) => `${f.label} (${f.score.toFixed(1)}/5)`).join(', ');
    const parts = [];
    if (strengths.length) parts.push(`strengths: ${fmt(strengths)}`);
    if (growth.length) parts.push(`growth areas: ${fmt(growth)}`);
    lines.push(`- ${viz.datasets[0].label} → ${parts.join('; ')}`);
  });

  return lines.join('\n');
};

function StudyStarRating({ value, onChange, label }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '8px', marginBottom: '8px' }}>
      {label && <span style={{ fontSize: '13px', color: '#888', minWidth: '90px' }}>{label}</span>}
      <div style={{ display: 'flex', gap: '2px' }}>
        {[1, 2, 3, 4, 5].map(n => (
          <span
            key={n}
            onClick={() => onChange(n)}
            style={{ cursor: 'pointer', fontSize: '18px', color: n <= value ? '#ffd700' : 'rgba(255,255,255,0.2)' }}
          >★</span>
        ))}
      </div>
    </div>
  );
}

function StudyChoiceChips({ options, selected, onToggle, max }) {
  const safeSelected = selected || [];
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
      {options.map(opt => {
        const isSelected = safeSelected.includes(opt);
        const atMax = max && safeSelected.length >= max && !isSelected;
        return (
          <button
            key={opt}
            type="button"
            disabled={atMax}
            onClick={() => onToggle(opt)}
            style={{
              padding: '8px 14px', borderRadius: '999px', fontSize: '11px',
              cursor: atMax ? 'not-allowed' : 'pointer',
              background: isSelected ? '#028be8' : 'rgba(255,255,255,0.06)',
              color: isSelected ? 'white' : atMax ? '#555' : '#ccc',
              border: isSelected ? '1px solid #028be8' : '1px solid rgba(255,255,255,0.15)',
              opacity: atMax ? 0.5 : 1,
            }}
          >
            {opt}
          </button>
        );
      })}
    </div>
  );
}

function StudyReflectionField({ fit, confidence, onChangeFit, onChangeConfidence }) {
  return (
    <div style={{ background: 'rgba(255,255,255,0.04)', borderRadius: '10px', padding: '14px 16px', border: '1px solid rgba(255,255,255,0.08)' }}>
      <StudyStarRating label="Strategy fit" value={fit} onChange={onChangeFit} />
      <div style={{ height: '8px' }} />
      <StudyStarRating label="Confidence to improve" value={confidence} onChange={onChangeConfidence} />
    </div>
  );
}

function StudyLearnerIntelligenceModal({ userId, initialData, onClose }) {
  // Merge over defaults so a record saved under an older/partial schema
  // never leaves a field undefined.
  const [data, setData] = useState({ ...defaultStudyLearnerIntelligence(), ...(initialData || {}) });
  const [step, setStep] = useState(0);
  const totalSteps = STUDY_INTEL_STEPS.length;
  const current = STUDY_INTEL_STEPS[step];

  const debouncedSave = useMemo(() => debounce((payload) => {
    saveStudyLearnerIntelligence(userId, payload).catch(() => {});
  }, 600), [userId]);

  useEffect(() => {
    debouncedSave({ ...data, updatedAt: new Date().toISOString() });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleClose = () => {
    const finalData = { ...data, updatedAt: new Date().toISOString() };
    saveStudyLearnerIntelligence(userId, finalData).catch(() => {});
    onClose(finalData);
  };

  const toggleMulti = (field, value, max) => {
    setData(prev => {
      const list = prev[field] || [];
      if (list.includes(value)) return { ...prev, [field]: list.filter(v => v !== value) };
      if (max && list.length >= max) return prev;
      return { ...prev, [field]: [...list, value] };
    });
  };

  const selectSingle = (field, value) => {
    setData(prev => ({ ...prev, [field]: prev[field] === value ? '' : value }));
  };

  const logReflection = (fit, confidence) => {
    setData(prev => ({
      ...prev,
      studyReflectionHistory: [...(prev.studyReflectionHistory || []), { date: new Date().toISOString(), fit, confidence }],
    }));
  };

  const renderField = (fieldKey) => {
    if (fieldKey === 'studyReflection') {
      return (
        <StudyReflectionField
          key={fieldKey}
          fit={data.studyFit || 0}
          confidence={data.studyConfidence || 0}
          onChangeFit={(v) => setData(prev => ({ ...prev, studyFit: v }))}
          onChangeConfidence={(v) => setData(prev => ({ ...prev, studyConfidence: v }))}
        />
      );
    }


    const config = STUDY_INTEL_FIELD_CONFIG[fieldKey];
    if (!config) return null;

    return (
      <div key={fieldKey} style={{ marginBottom: '4px' }}>
        <div style={{ fontSize: '13.5px', color: '#ccc', fontWeight: 600, marginBottom: '2px' }}>{config.label}</div>
        <div style={{ fontSize: '11.5px', color: '#777', marginBottom: '10px' }}>{config.hint}</div>
        {config.type === 'chips-multi' && (
          <StudyChoiceChips options={config.options} selected={data[fieldKey]} max={config.max} onToggle={(v) => toggleMulti(fieldKey, v, config.max)} />
        )}
        {config.type === 'chips-single' && (
          <StudyChoiceChips options={config.options} selected={data[fieldKey] ? [data[fieldKey]] : []} onToggle={(v) => selectSingle(fieldKey, v)} />
        )}
      </div>
    );
  };

  const renderStepBody = () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: current.fields.length > 1 ? '26px' : '0px' }}>
      {current.fields.map(renderField)}
    </div>
  );

   return ReactDOM.createPortal(
    <div
      onClick={(e) => { if (e.target === e.currentTarget) handleClose(); }}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)', zIndex: 5500,
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px',
      }}
    >
      <div
            className="my-study-reflection-panel"
        style={{
          width: '660px',
          maxWidth: '95vw',
          height: 'min(88vh, 720px)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          background: 'linear-gradient(135deg, #0f1629 0%, #0a0f1f 100%)',
          color: 'white',
          borderRadius: '16px',
          border: '1px solid rgba(2,139,232,0.35)',
          boxShadow: '0 20px 60px rgba(0,0,0,0.6)',
          padding: '28px',
        }}
      >
        {/* ── Header (fixed height) ── */}
        <div style={{ flexShrink: 0 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '6px' }}>
            <div style={{ fontSize: '11px', color: '#888', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
              My Reflections · Step {step + 1} of {totalSteps}
            </div>
            <button
              onClick={handleClose}
              style={{ background: 'none', border: 'none', color: '#aaa', fontSize: '1.4rem', cursor: 'pointer', marginTop: '-15px', marginRight: '-15px' }}
            >
              ×
            </button>
          </div>

          <div style={{ display: 'flex', gap: '5px', marginBottom: '20px' }}>
            {STUDY_INTEL_STEPS.map((s, i) => (
              <div
                key={s.key}
                onClick={() => setStep(i)}
                title={s.title}
                style={{
                  flex: 1, height: '4px', borderRadius: '2px', cursor: 'pointer',
                  background: i <= step ? '#028be8' : 'rgba(255,255,255,0.12)',
                }}
              />
            ))}
          </div>

          <h3 style={{ color: '#40c4ff', margin: '0 0 6px 0', fontSize: '19px' }}>{current.title}</h3>
          <p style={{ color: '#999', fontSize: '13px', margin: '0 0 20px 0', lineHeight: 1.5 }}>{current.subtitle}</p>
        </div>

        {/* ── Body (grows / scrolls) ── */}
        <div style={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
          {renderStepBody()}
        </div>

        {/* ── Footer pinned to bottom ── */}
        <div
          style={{
            flexShrink: 0,
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '20px',
            paddingTop: '16px',
            borderTop: '1px solid rgba(255,255,255,0.08)',
          }}
        >
          <button
            onClick={() => setStep(s => Math.max(s - 1, 0))}
            disabled={step === 0}
            style={{
              background: 'none',
              border: '1px solid rgba(255,255,255,0.2)',
              color: step === 0 ? '#555' : '#ccc',
              borderRadius: '8px',
              padding: '10px 20px',
              cursor: step === 0 ? 'not-allowed' : 'pointer',
            }}
          >
            Back
          </button>
          {step < totalSteps - 1 ? (
            <button
              onClick={() => setStep(s => Math.min(s + 1, totalSteps - 1))}
              style={{
                background: '#028be8', color: 'white', border: 'none',
                borderRadius: '8px', padding: '10px 28px', cursor: 'pointer', fontWeight: 600,
              }}
            >
              Next
            </button>
          ) : (
            <button
              onClick={handleClose}
              style={{
                background: 'linear-gradient(90deg, #028be8, #00e1ff)', color: 'white', border: 'none',
                borderRadius: '8px', padding: '10px 28px', cursor: 'pointer', fontWeight: 700,
              }}
            >
              Done
            </button>
          )}
        </div>
    </div>
    </div>,
    document.body
  );
}

const JOURNAL_REF_STATUS_META = {
  not_started: { label: 'Not started', color: '#888' },
  on_track: { label: 'In progress', color: '#296dcd' },
  slower: { label: 'Behind schedule', color: '#8d54ab' },
  stuck: { label: 'Blocked', color: '#028be8' },
  completed: { label: 'Completed', color: '#00cc99' },
};

function JournalReferenceModal({ onClose, entries, loading, questionLabel, subjectLabel, reviewedActivityIds, onToggleReviewed, onOpenActivity }) {
  const reviewedCount = entries.filter((e) => reviewedActivityIds.has(e.activityId)).length;

  return ReactDOM.createPortal(
    <div
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', zIndex: 6500,
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px',
      }}
    >
      <div 
      className="my-journal-reference-panel"
      style={{
        width: '640px', maxWidth: '94vw', maxHeight: '82vh', display: 'flex', flexDirection: 'column',
        background: '#0d1424', border: '1px solid rgba(0,225,255,0.35)', borderRadius: '12px', overflow: 'hidden',
      }}>
        <div style={{ padding: '18px 20px', borderBottom: '1px solid rgba(255,255,255,0.08)', flexShrink: 0 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              <div style={{ fontSize: '16px', fontWeight: 600, color: '#00e1ff' }}>
                Reference My Super-curricular Activities
              </div>
              <div style={{ fontSize: '12px', color: '#888', marginTop: '2px' }}>
                {subjectLabel} · Writing {questionLabel}
              </div>
            </div>
            <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#aaa', fontSize: '18px', cursor: 'pointer' }}>×</button>
          </div>
          <p style={{ margin: '10px 0 0 0', fontSize: '12.5px', color: '#999', lineHeight: 1.5 }}>
          </p>
        </div>

        <div style={{ padding: '4px 20px 16px', overflowY: 'auto', flex: 1 }}>
          {loading ? (
            <div style={{ color: '#666', fontStyle: 'italic', textAlign: 'center', padding: '30px 0' }}>
              Loading your journal entries…
            </div>
          ) : entries.length === 0 ? (
            <div style={{ color: '#666', fontStyle: 'italic', textAlign: 'center', padding: '30px 0', fontSize: '13px' }}>
              No SuperCurricular Journal entries found for {subjectLabel} yet. Add a goal or log entry to an activity on the SuperCurricular page first.
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '10px' }}>
              {entries.map((entry) => {
                const statusMeta = JOURNAL_REF_STATUS_META[entry.plan.status] || JOURNAL_REF_STATUS_META.not_started;
                const isReviewed = reviewedActivityIds.has(entry.activityId);
                return (
                  <div
                    key={entry.activityId}
                    onClick={() => onOpenActivity(entry)}
                    role="button"
                    tabIndex={0}
                    style={{
                      display: 'flex', gap: '12px', alignItems: 'flex-start',
                      background: isReviewed ? 'rgba(0,200,117,0.06)' : 'rgba(255,255,255,0.04)',
                      borderRadius: '10px', padding: '14px 16px', cursor: 'pointer',
                      borderLeft: `3px solid ${isReviewed ? '#00c875' : statusMeta.color}`,
                      transition: 'background 0.15s',
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.background = isReviewed ? 'rgba(0,200,117,0.1)' : 'rgba(255,255,255,0.07)'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.background = isReviewed ? 'rgba(0,200,117,0.06)' : 'rgba(255,255,255,0.04)'; }}
                  >
                    {/* Checkbox — stops propagation so it doesn't trigger navigation */}
                    <input
                      type="checkbox"
                      checked={isReviewed}
                      onChange={() => onToggleReviewed(entry.activityId)}
                      onClick={(e) => e.stopPropagation()}
                      className="cyber-checkbox"
                      style={{ marginLeft: '0px', marginTop: '3px', flexShrink: 0, cursor: 'pointer' }}
                      title={isReviewed ? "Marked as referenced" : "Mark as referenced"}
                    />

                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '10px', marginBottom: '6px' }}>
                        <div style={{
                          color: isReviewed ? '#8fd9c4' : '#40c4ff', fontWeight: 600, fontSize: '14.5px',
                          textDecoration: isReviewed ? 'none' : 'none',
                        }}>
                          {entry.title}
                        </div>
                        <span style={{ fontSize: '11px', color: statusMeta.color, whiteSpace: 'nowrap', flexShrink: 0 }}>
                          {statusMeta.label}
                        </span>
                      </div>
                      <div style={{ fontSize: '11.5px', color: '#888', marginBottom: '4px' }}>
                        {entry.category}
                      </div>

                      {entry.plan.goal?.trim() && (
                        <p style={{ margin: '6px 0 0 0', fontSize: '13px', color: '#ddd', lineHeight: 1.5 }}>
                          <strong style={{ color: '#9fb8d4' }}>Goal:</strong> {entry.plan.goal}
                        </p>
                      )}
                      {entry.plan.outcomeReflection?.trim() && (
                        <p style={{ margin: '4px 0 0 0', fontSize: '13px', color: '#ddd', lineHeight: 1.5 }}>
                          <strong style={{ color: '#9fb8d4' }}>Reflection:</strong> {entry.plan.outcomeReflection}
                        </p>
                      )}
                      {entry.plan.logEntries?.length > 0 && (
                        <p style={{ margin: '4px 0 0 0', fontSize: '11.5px', color: '#888' }}>
                          {entry.plan.logEntries.length} progress log {entry.plan.logEntries.length === 1 ? 'entry' : 'entries'}
                        </p>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <div style={{
          padding: '14px 20px', borderTop: '1px solid rgba(255,255,255,0.08)', flexShrink: 0,
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        }}>
          <span style={{ fontSize: '12px', color: '#888' }}>
            {entries.length > 0 ? `${reviewedCount}/${entries.length} referenced` : ''}
          </span>
          <button onClick={onClose} style={{
            background: 'none', border: '1px solid rgba(255,255,255,0.2)', color: '#ccc',
            borderRadius: '6px', padding: '8px 16px', cursor: 'pointer', fontSize: '13px',
          }}>
            Close
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}

function PSExpandableNote({ label, html, color, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  if (!html) return null;
  return (
    <div style={{ marginTop: '14px' }}>
      <button
        className="ps-guidance-toggle"
        onClick={() => setOpen(o => !o)}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: '7px',
          background: 'rgba(2,139,232,0.12)', border: `1px solid ${color}55`,
          borderRadius: '6px', padding: '7px 14px', color, fontSize: '13px',
          fontWeight: 600, cursor: 'pointer',
        }}
      >
        <span style={{ display: 'inline-block', transition: 'transform 0.15s', transform: open ? 'rotate(90deg)' : 'rotate(0deg)', fontSize: '10px' }}>▶</span>
        {open ? 'Hide Guidance' : 'Guidance'}
      </button>
      {open && (
        <div
          className="ps-guidance-content"
          style={{
            marginTop: '10px', padding: '14px 16px', background: 'rgba(0,0,0,0.25)',
            borderRadius: '8px', borderLeft: `2px solid ${color}88`,
            fontSize: '14px', color: '#ccc', lineHeight: 1.6,
          }}
          dangerouslySetInnerHTML={{ __html: html }}
        />
      )}
    </div>
  );
}

function AddPSQuestionModal({ onClose, onSave, subjectLabel }) {
  const [question, setQuestion] = useState('');
  const canSave = question.trim().length > 0;

  return ReactDOM.createPortal(
    <div
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', zIndex: 6000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}
    >
      <div style={{ width: '520px', maxWidth: '92vw', background: '#0d1424', border: '1px solid rgba(156,111,228,0.4)', borderRadius: '12px', padding: '20px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
          <div style={{ fontSize: '16px', fontWeight: 600, color: '#9c6fe4' }}>Add Your Own Question</div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#aaa', fontSize: '18px', cursor: 'pointer' }}>×</button>
        </div>
        <div style={{ fontSize: '12px', color: '#888', marginBottom: '16px' }}>{subjectLabel}</div>

        <label style={{ display: 'block', fontSize: '12px', color: '#ccc', marginBottom: '6px' }}>Question *</label>
        <textarea
          value={question}
          className='space-scroll'
          onChange={(e) => setQuestion(e.target.value)}
          rows={3}
          placeholder="e.g. What extracurricular experience best demonstrates your commitment to this subject?"
          style={{ width: '100%', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '8px', padding: '10px', color: 'white', fontSize: '13px', resize: 'vertical', fontFamily: 'inherit', lineHeight: 1.5 }}
        />

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '16px' }}>
          <button onClick={onClose} style={{ background: 'none', border: '1px solid rgba(255,255,255,0.2)', color: '#ccc', borderRadius: '6px', padding: '8px 16px', cursor: 'pointer' }}>
            Cancel
          </button>
          <button
            onClick={() => canSave && onSave(question)}
            disabled={!canSave}
            style={{ background: canSave ? '#9c6fe4' : '#444', color: canSave ? '#0a0f1f' : '#888', border: 'none', borderRadius: '6px', padding: '8px 18px', fontWeight: 600, cursor: canSave ? 'pointer' : 'not-allowed' }}
          >
            Add Question
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}

// ─── Activity progress (replaces the old 3-state Not Started/In
// Progress/Completed dropdown) ────────────────────────────────────────────
const ACTIVITY_PROGRESS_STEPS = [0, 20, 40, 60, 80, 100];

const getActivityProgressColor = (percent) => {
  if (percent >= 100) return '#00e1ff';
  if (percent >= 60) return '#7fccff';
  if (percent >= 20) return '#87afcd';
  return '#4a5568';
};

// Legacy 3-state values → numeric percent, so previously-saved data
// ("not_started" / "in_progress" / "completed") still displays correctly.
const normalizeActivityProgress = (val) => {
  if (typeof val === 'number') return val;
  if (val === 'completed') return 100;
  if (val === 'in_progress') return 40;
  if (val === 'not_started') return 0;
  return 0;
};

function ActivityProgressControl({ value = 0, onChange, disabled }) {
  const trackRef = useRef(null);
  const isComplete = value === 100;
  const accent = getActivityProgressColor(value);
  const pulseColor = isComplete ? '0,225,255' : '2,139,232'; // rgb triplet matching accent

  const handleTrackClick = (e) => {
    if (disabled || !trackRef.current) return;
    const rect = trackRef.current.getBoundingClientRect();
    const ratio = Math.min(Math.max((e.clientX - rect.left) / rect.width, 0), 1);
    const nearest = ACTIVITY_PROGRESS_STEPS.reduce((prev, curr) =>
      Math.abs(curr - ratio * 100) < Math.abs(prev - ratio * 100) ? curr : prev
    );
    onChange(nearest);
  };

  return (
    <div className="progress-bar-super" style={{ width: '450px', userSelect: 'none', paddingBottom: '5px' }}>
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginBottom: '10px' }}>
        <span style={{ fontSize: '11px', color: '#028be8', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.07em' }}>
          Progress
        </span>
        <span style={{
          fontSize: '13px', fontWeight: 800, color: isComplete ? '#00e1ff' : '#40b3ff',
          display: 'inline-flex', alignItems: 'center', gap: '5px',
          textShadow: isComplete ? '0 0 12px rgba(0,225,255,0.5)' : 'none',
        }}>
          {isComplete && <FaCheckCircle size={13} style={{ color: '#00e1ff' }} />}
          {value}%
        </span>
      </div>

      <style>{`
        @keyframes activityProgressPulse {
          0%   { box-shadow: 0 0 0 0 rgba(${pulseColor}, 0.55), 0 2px 6px rgba(0,0,0,0.4); }
          70%  { box-shadow: 0 0 0 10px rgba(${pulseColor}, 0), 0 2px 6px rgba(0,0,0,0.4); }
          100% { box-shadow: 0 0 0 0 rgba(${pulseColor}, 0), 0 2px 6px rgba(0,0,0,0.4); }
        }
      `}</style>

      {/* ── Track ── */}
      <div
        ref={trackRef}
        onClick={handleTrackClick}
        role="slider"
        aria-valuenow={value}
        aria-valuemin={0}
        aria-valuemax={100}
        style={{
          position: 'relative',
          height: '16px',
          borderRadius: '99px',
          background: 'linear-gradient(180deg, #12182a, #1c2438)',
          boxShadow: 'inset 0 1px 4px rgba(0,0,0,0.55), inset 0 -1px 0 rgba(255,255,255,0.03)',
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.5 : 1,
          overflow: 'visible',
        }}
      >
        {/* clipped inner layer holds the fill + shine so corners stay rounded */}
        <div style={{ position: 'absolute', inset: 0, borderRadius: '99px', overflow: 'hidden' }}>
          {/* filled portion */}
          <div style={{
            position: 'absolute', top: 0, left: 0, height: '100%',
            width: `${value}%`,
            borderRadius: '99px',
            background: isComplete
              ? 'linear-gradient(90deg, #00a8cc, #00e1ff)'
              : 'linear-gradient(90deg, #0264a8, #028be8, #3aa8e0)',
            boxShadow: isComplete
              ? '0 0 16px rgba(0,225,255,0.55)'
              : '0 0 10px rgba(2,139,232,0.35)',
            transition: 'width 0.35s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.3s ease',
          }}>
            {/* glossy highlight on top half of the fill */}
            <div style={{
              position: 'absolute', top: 0, left: 0, right: 0, height: '50%',
              background: 'linear-gradient(180deg, rgba(255,255,255,0.35), rgba(255,255,255,0))',
              borderRadius: '99px 99px 0 0',
            }} />
          </div>

          {/* segment divider lines at 20/40/60/80 — gives the "chunked XP bar" feel */}
          {[20, 40, 60, 80].map((mark) => (
            <div
              key={mark}
              style={{
                position: 'absolute', top: 0, bottom: 0, left: `${mark}%`,
                width: '2px', transform: 'translateX(-50%)',
                background: value > mark ? 'rgba(0, 0, 0, 0)' : 'rgba(255,255,255,0.08)',
                pointerEvents: 'none',
              }}
            />
          ))}
        </div>

        {/* slider handle / knob — sits at the leading edge of the fill */}
        <button
          type="button"
          disabled={disabled}
          onClick={(e) => e.stopPropagation()}
          title={`${value}%`}
          className={!isComplete ? 'activity-progress-current-dot' : undefined}
          style={{
            position: 'absolute',
            top: '50%',
            left: `${value}%`,
            transform: 'translate(-50%, -50%)',
            width: '22px',
            height: '22px',
            borderRadius: '50%',
            border: `2.5px solid ${isComplete ? '#00e1ff' : '#028be8'}`,
            background: 'radial-gradient(circle at 35% 30%, #ffffff, #cfe9ff 55%, #a9d4f7 100%)',
            padding: 0,
            cursor: disabled ? 'not-allowed' : 'pointer',
            boxShadow: isComplete
              ? '0 0 14px rgba(0,225,255,0.7), 0 2px 6px rgba(0,0,0,0.4)'
              : '0 2px 6px rgba(0,0,0,0.4)',
            animation: !disabled ? 'activityProgressPulse 1.8s ease-out infinite' : 'none',
            transition: 'left 0.35s cubic-bezier(0.34, 1.56, 0.64, 1)',
            zIndex: 2,
          }}
        />
      </div>

      {/* step labels beneath the track */}
      <div style={{ position: 'relative', height: '14px', marginTop: '6px' }}>
        {ACTIVITY_PROGRESS_STEPS.map((step) => (
          <button
            key={step}
            type="button"
            disabled={disabled}
            onClick={() => onChange(step)}
            title={`Mark ${step}%`}
            style={{
              position: 'absolute',
              left: `${step}%`,
              transform: 'translateX(-50%)',
              background: 'none',
              border: 'none',
              padding: '2px 4px',
              fontSize: '9.5px',
              fontWeight: step === value ? 800 : 500,
              color: step === value ? (isComplete ? '#00e1ff' : '#40b3ff') : '#555f72',
              cursor: disabled ? 'not-allowed' : 'pointer',
              transition: 'color 0.15s ease',
            }}
          >
            {step}
          </button>
        ))}
      </div>
    </div>
  );
}

// ─── SuperCurricular filters & signal badges ──────────────────────────────
const SC_SEQUENCE_MODES = ['Explore', 'Investigate', 'Apply', 'Create', 'Reflect'];
const SC_FOCUS_TAGS = ['Independent Research', 'Competition', 'Leadership'];
const SC_TIME_OPTIONS = ['Hours', 'Days', 'Weeks', 'Months', 'Ongoing'];
const SC_DEPTH_OPTIONS = ['Starting', 'Developing', 'Advanced'];
const SC_DEFAULT_FILTERS = { time: '', depth: '', tags: [] };

const SC_MODE_COLORS = {
  Explore: '#36a7f8',
  Investigate: '#9c6fe4',
  Apply: '#00c875',
  Create: '#ffaa00',
  Reflect: '#ff66cc',
};
const SC_TAG_META = {
  'Independent Research': { color: '#00e1ff', icon: FaBookOpen },
  Competition: { color: '#ffd700', icon: FaStar },
  Leadership: { color: '#ff8a65', icon: FaUsers },
};
const SC_DEPTH_META = {
  Starting: { color: '#00cc99', bars: 1 },
  Developing: { color: '#ffd700', bars: 2 },
  Advanced: { color: '#ff6b6b', bars: 3 },
};
const SC_TIME_COLOR = '#40b3ff';

// Splits engagement_modes into the ordered Explore→Reflect journey and the
// separate non-sequential focus tags. Tolerates legacy string / null values.
const getActivityEngagement = (activity) => {
  const raw = activity?.engagement_modes;
  const list = Array.isArray(raw) ? raw : (typeof raw === 'string' && raw ? [raw] : []);
  return {
    sequence: list.filter((m) => SC_SEQUENCE_MODES.includes(m)),
    tags: list.filter((m) => SC_FOCUS_TAGS.includes(m)),
  };
};

const activityMatchesFilters = (activity, filters) => {
  if (filters.time && activity.time_commitment !== filters.time) return false;
  if (filters.depth && activity.depth !== filters.depth) return false;
  if (filters.tags.length > 0) {
    const { tags } = getActivityEngagement(activity);
    if (!filters.tags.some((t) => tags.includes(t))) return false; // ANY selected tag
  }
  return true;
};

function SCDepthBars({ depth, size = 1 }) {
  const meta = SC_DEPTH_META[depth];
  if (!meta) return null;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'flex-end', gap: '2px' }}>
      {[1, 2, 3].map((n) => (
        <span
          key={n}
          style={{
            width: `${4 * size}px`, height: `${(5 + n * 3) * size}px`, borderRadius: '1px',
            background: n <= meta.bars ? meta.color : 'rgba(255,255,255,0.15)',
          }}
        />
      ))}
    </span>
  );
}

// ── Detail panel: shown under the activity title ──────────────────────────
function ActivitySignalBadges({ activity }) {
  const { sequence, tags } = getActivityEngagement(activity);
  const hasTime = !!activity?.time_commitment;
  const depthMeta = SC_DEPTH_META[activity?.depth];
  if (!sequence.length && !tags.length && !hasTime && !depthMeta) return null;

  const sectionLabel = {
    fontSize: '10.5px', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase',
    color: '#7f8ea8', marginBottom: '8px',
  };

  const StatTile = ({ color, icon, label, value, sub }) => (
    <div
      style={{
        flex: '1 1 210px', display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 14px',
        borderRadius: '12px', background: `${color}10`, border: `1px solid ${color}33`,
      }}
    >
      <span
        style={{
          width: '34px', height: '34px', borderRadius: '10px', flexShrink: 0, display: 'flex',
          alignItems: 'center', justifyContent: 'center', color, background: `${color}1f`,
        }}
      >
        {icon}
      </span>
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: '10px', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', color: '#7f8ea8' }}>
          {label}
        </div>
        <div style={{ fontSize: '14.5px', fontWeight: 700, color, lineHeight: 1.25 }}>{value}</div>
        {sub && <div style={{ fontSize: '11.5px', color: '#9aa7bd', marginTop: '1px' }}>{sub}</div>}
      </div>
    </div>
  );

  return (
    <div
      className="activity-signal-badges"
      style={{
        margin: '14px 0 8px', padding: '16px', display: 'flex', flexDirection: 'column', gap: '18px',
        background: 'linear-gradient(135deg, rgba(2,139,232,0.06), rgba(255,255,255,0.02))',
        border: '1px solid rgba(255,255,255,0.08)', borderRadius: '14px',
      }}
    >
      {(hasTime || depthMeta) && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
          {hasTime && (
            <StatTile
              color={SC_TIME_COLOR}
              icon={<FaHourglassHalf size={14} />}
              label="Time commitment"
              value={activity.time_commitment}
              sub={activity.time_commitment_detail}
            />
          )}
          {depthMeta && (
            <StatTile
              color={depthMeta.color}
              icon={<SCDepthBars depth={activity.depth} />}
              label="Depth"
              value={activity.depth}
            />
          )}
        </div>
      )}

      {sequence.length > 0 && (
        <div>
          <div style={sectionLabel}>Engagement journey</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', rowGap: '8px' }}>
            {sequence.map((mode, i) => {
              const c = SC_MODE_COLORS[mode];
              return (
                <React.Fragment key={mode}>
                  <span
                    style={{
                      display: 'inline-flex', alignItems: 'center', gap: '7px', padding: '4px 12px 4px 4px',
                      borderRadius: '999px', fontSize: '12.5px', fontWeight: 600, color: c,
                      background: `${c}14`, border: `1px solid ${c}44`,
                    }}
                  >
                    <span
                      style={{
                        width: '20px', height: '20px', borderRadius: '50%', display: 'flex', alignItems: 'center',
                        justifyContent: 'center', fontSize: '10.5px', fontWeight: 800, color: '#0a0f1f', background: c,
                      }}
                    >
                      {i + 1}
                    </span>
                    {mode}
                  </span>
                  {i < sequence.length - 1 && (
                    <span style={{ width: '16px', height: '2px', margin: '0 2px', background: 'rgba(255,255,255,0.16)' }} />
                  )}
                </React.Fragment>
              );
            })}
          </div>
        </div>
      )}

      {tags.length > 0 && (
        <div>
          <div style={sectionLabel}>Focus</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {tags.map((tag) => {
              const { color, icon: Icon } = SC_TAG_META[tag];
              return (
                <span
                  key={tag}
                  style={{
                    display: 'inline-flex', alignItems: 'center', gap: '7px', padding: '5px 13px',
                    borderRadius: '8px', fontSize: '12.5px', fontWeight: 700, color,
                    background: `${color}12`, border: `1px dashed ${color}88`,
                  }}
                >
                  <Icon size={11} /> {tag}
                </span>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

// ── Filter bar: collapsible, sits above the category tabs ─────────────────
function SuperCurricularFilterBar({ activities, filters, onChange, resultCount }) {
  const [open, setOpen] = useState(false);

  const groups = [
    { key: 'time', label: 'Time commitment', options: SC_TIME_OPTIONS, multi: false,
      color: () => SC_TIME_COLOR, match: (a, v) => a.time_commitment === v },
    { key: 'depth', label: 'Depth', options: SC_DEPTH_OPTIONS, multi: false,
      color: (v) => SC_DEPTH_META[v].color, match: (a, v) => a.depth === v },
    { key: 'tags', label: 'Focus', options: SC_FOCUS_TAGS, multi: true,
      color: (v) => SC_TAG_META[v].color, match: (a, v) => getActivityEngagement(a).tags.includes(v) },
  ];

  const isSelected = (g, v) => (g.multi ? filters.tags.includes(v) : filters[g.key] === v);

  // Faceted count: how many activities would match if this option were chosen,
  // given every OTHER active filter group.
  const countFor = (g, v) => {
    const others = { ...filters, [g.key]: g.multi ? [] : '' };
    return activities.filter((a) => activityMatchesFilters(a, others) && g.match(a, v)).length;
  };

  const toggle = (g, v) => {
    if (g.multi) {
      onChange({ ...filters, tags: filters.tags.includes(v) ? filters.tags.filter((t) => t !== v) : [...filters.tags, v] });
    } else {
      onChange({ ...filters, [g.key]: filters[g.key] === v ? '' : v });
    }
  };

  const activeItems = groups.flatMap((g) =>
    g.options.filter((v) => isSelected(g, v)).map((v) => ({ g, v }))
  );
  const activeCount = activeItems.length;

  return (
    <div
      className="sc-filter-bar"
      style={{
        width: '100%', maxWidth: '1200px', margin: '0px', boxSizing: 'border-box',
        background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.09)', borderRadius: '0px',
      }}
    >
      {/* Header row */}
      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '10px', padding: '10px 14px' }}>
        <button
          type="button"
          className="filters-button"
          onClick={() => setOpen((o) => !o)}
          aria-expanded={open}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '7px 14px', borderRadius: '8px',
            fontSize: '13px', fontWeight: 700, cursor: 'pointer',
            color: activeCount > 0 ? '#00e1ff' : '#cfd8e8',
            background: activeCount > 0 ? 'rgba(0,225,255,0.1)' : 'rgba(255,255,255,0.05)',
            border: `1px solid ${activeCount > 0 ? 'rgba(0,225,255,0.45)' : 'rgba(255,255,255,0.14)'}`,
          }}
        >
          <FaFilter size={11} /> Filters
          {activeCount > 0 && (
            <span
              style={{
                minWidth: '18px', height: '18px', padding: '0 5px', borderRadius: '999px', fontSize: '11px',
                fontWeight: 800, display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                color: '#0a0f1f', background: '#00e1ff',
              }}
            >
              {activeCount}
            </span>
          )}
          {open ? <FaChevronUp size={9} /> : <FaChevronDown size={9} />}
        </button>

        {/* Active filters as removable chips */}
        {activeItems.map(({ g, v }) => {
          const c = g.color(v);
          return (
            <button
              key={`${g.key}-${v}`}
              type="button"
              onClick={() => toggle(g, v)}
              title={`Remove "${v}"`}
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '4px 10px', borderRadius: '999px',
                fontSize: '12px', fontWeight: 600, cursor: 'pointer', color: c,
                background: `${c}18`, border: `1px solid ${c}55`,
              }}
            >
              {v} <FaTimes size={9} style={{ opacity: 0.8 }} />
            </button>
          );
        })}

        <span style={{ marginLeft: 'auto', display: 'inline-flex', alignItems: 'center', gap: '14px', fontSize: '12px', color: '#8a97ad' }}>
          {activeCount > 0 && (
            <span>
              <strong style={{ color: '#40c4ff' }}>{resultCount}</strong> of {activities.length} activities
            </span>
          )}
          {activeCount > 0 && (
            <button
              type="button"
              onClick={() => onChange({ ...SC_DEFAULT_FILTERS })}
              style={{ background: 'none', border: 'none', color: '#ff8a8a', cursor: 'pointer', fontSize: '12px', fontWeight: 600, padding: 0 }}
            >
              Clear all
            </button>
          )}
        </span>
      </div>

      {/* Expanded panel */}
      {open && (
        <div
       style={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: '18px 13px',
      padding: '14px 16px 20px',
      borderTop: '1px solid rgba(255,255,255,0.07)',
    }}
        >
          {groups.map((g) => (
            <div key={g.key}>
              <div
                style={{
                  fontSize: '10.5px', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase',
                  color: '#7f8ea8', marginBottom: '8px', display: 'flex', justifyContent: 'space-between',
                }}
              >
                <span>{g.label}</span>
              </div>
              <div
                style={{
                  display: 'flex', flexWrap: 'wrap', gap: '2px', padding: '3px', borderRadius: '11px',
                  background: 'rgba(0,0,0,0.28)', border: '1px solid rgba(255,255,255,0.06)',
                }}
              >
                {g.options.map((v) => {
                  const c = g.color(v);
                  const selected = isSelected(g, v);
                  const n = countFor(g, v);
                  const disabled = n === 0 && !selected;
                  const TagIcon = g.key === 'tags' ? SC_TAG_META[v].icon : null;
                  return (
                    <button
                      key={v}
                      type="button"
                      disabled={disabled}
                      aria-pressed={selected}
                      onClick={() => toggle(g, v)}
                      style={{
                        display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '6px 8px', borderRadius: '8px',
                        fontSize: '12px', fontWeight: 600, whiteSpace: 'nowrap',
                        cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.35 : 1,
                        color: selected ? c : '#9aa7bd',
                        background: selected ? `${c}26` : 'transparent',
                        border: `1px solid ${selected ? `${c}77` : 'transparent'}`,
                        transition: 'all 0.15s ease',
                      }}
                    >
                      {g.key === 'depth' && <SCDepthBars depth={v} size={0.8} />}
                      {TagIcon && <TagIcon size={10} />}
                      {v}
                      <span style={{ fontSize: '9.5px', fontWeight: 700, opacity: 0.6 }}>{n}</span>
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── Share Activity sheet ──────────────────────────────────────────────
// Deliberately NOT a page screenshot: a literal capture would also show the
// student's own skill-progress rings, journal entries, and other unrelated
// activities in the sidebar — a privacy leak and visual mess. Instead this
// builds a clean, purpose-built message + deep link just for this activity.
function ShareActivitySheet({ activity, subject, studentName, onClose }) {
  const { showToast } = useUIFeedback();
  const [copyState, setCopyState] = useState('idle'); // 'idle' | 'copied' | 'error'

  const shareUrl = useMemo(() => {
    const url = new URL(`${window.location.origin}/invite/activity`);
    url.searchParams.set('activitySubject', subject || '');
    url.searchParams.set('activityId', activity?.supercurricular_id || '');
    url.searchParams.set('activityTitle', activity?.activity_title || '');
    if (studentName) url.searchParams.set('invitedBy', studentName);
    return url.toString();
  }, [activity, subject, studentName]);

  const detailsSnippet = activity?.activity_details
    ? activity.activity_details.slice(0, 460).trim() + (activity.activity_details.length > 160 ? '…' : '')
    : '';

  const invitePhrase = studentName
    ? `${studentName} wants to work on this together:`
    : `Let's work on this together:`;

  // Plain-text version — used for WhatsApp, and as the clipboard fallback
  // when the browser doesn't support rich (HTML) clipboard writes.
  const shareTextPlain = [
    `📚 ${invitePhrase}`,
    ``,
    `${activity?.activity_title}`,
    subject ? `Subject: ${subject}` : '',
    detailsSnippet,
    ``,
    `Join in: ${shareUrl}`,
  ].filter(Boolean).join('\n');

  // Rich HTML version — used for the styled Copy Link, so pasting into
  // email clients, Docs, Notion, Slack, etc. renders a formatted card
  // instead of a bare URL.
  const shareHtml = `
    <div style="font-family: -apple-system, Segoe UI, Arial, sans-serif; max-width: 420px; border: 1px solid #028be8; border-radius: 10px; padding: 16px 18px; background: #0d1424; color: #e6edf5;">
      <div style="font-size: 12px; color: #9fb8d4; margin-bottom: 8px;">${invitePhrase}</div>
      ${subject ? `<div style="display:inline-block; font-size: 11px; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:#40c4ff; background:rgba(2,139,232,0.12); border:1px solid rgba(2,139,232,0.4); border-radius:999px; padding:3px 10px; margin-bottom:8px;">${subject}</div>` : ''}
      <div style="font-size: 16px; font-weight: 700; color: #ffaa00; margin: 6px 0 6px 0;">${activity?.activity_title || ''}</div>
      ${detailsSnippet ? `<div style="font-size: 13px; color: #ccc; line-height: 1.5; margin-bottom: 12px;">${detailsSnippet}</div>` : ''}
      <a href="${shareUrl}" style="display:inline-block; font-size: 13px; font-weight: 700; color: #ffffff; background: linear-gradient(90deg,#028be8,#00e1ff); border-radius: 6px; padding: 8px 16px; text-decoration: none;">Join this activity →</a>
    </div>
  `.trim();

  const handleCopyLink = async () => {
    try {
      if (navigator.clipboard && typeof window.ClipboardItem === 'function') {
        const htmlBlob = new Blob([shareHtml], { type: 'text/html' });
        const textBlob = new Blob([shareTextPlain], { type: 'text/plain' });
        await navigator.clipboard.write([
          new window.ClipboardItem({ 'text/html': htmlBlob, 'text/plain': textBlob }),
        ]);
      } else {
        await navigator.clipboard.writeText(shareTextPlain);
      }
      setCopyState('copied');
      showToast('Copied! Paste it into an email, chat, or doc.', 'success');
      setTimeout(() => setCopyState('idle'), 2200);
    } catch {
      // Last-resort fallback for browsers blocking clipboard.write entirely
      try {
        await navigator.clipboard.writeText(shareTextPlain);
        setCopyState('copied');
        showToast('Copied as plain text.', 'success');
        setTimeout(() => setCopyState('idle'), 2200);
      } catch {
        setCopyState('error');
        showToast('Could not copy — please copy the link manually.', 'error');
      }
    }
  };

  const whatsappHref = `https://wa.me/?text=${encodeURIComponent(shareTextPlain)}`;
  const emailHref = `mailto:?subject=${encodeURIComponent(`Let's work on "${activity?.activity_title}" together`)}&body=${encodeURIComponent(shareTextPlain)}`;

  return ReactDOM.createPortal(
    <div
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0, 0, 0, 0.82)', zIndex: 7000,
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px',
      }}
    >
      <div 
      className="share-activity-sheet"
      style={{
        width: '440px', maxWidth: '92vw', background: '#0d1424',
        border: '1px solid rgba(0,225,255,0.3)', borderRadius: '14px', padding: '22px',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '6px' }}>
          <div style={{ fontSize: '16px', fontWeight: 700, color: '#00e1ff' }}>Invite a Friend to This Activity</div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#aaa', fontSize: '18px', cursor: 'pointer' }}>×</button>
        </div>
        <p style={{ margin: '0 0 16px 0', fontSize: '12px', color: '#888', lineHeight: 1.5 }}>
          Great for tackling a super-curricular activity together — they'll be prompted to sign in or create an account, whichever they need.
        </p>

        {/* Live preview — exactly what gets sent/copied, so students see it
            before choosing a channel. Only this activity's info, nothing
            personal from the rest of their dashboard. */}
        <div style={{
          background: 'rgba(2,139,232,0.08)', border: '1px solid rgba(2,139,232,0.3)',
          borderRadius: '10px', padding: '14px 16px', marginBottom: '18px',
        }}>
          <div style={{ fontSize: '11px', color: '#9fb8d4', marginBottom: '8px' }}>{invitePhrase}</div>
          {subject && (
            <div style={{
              display: 'inline-block', fontSize: '10px', fontWeight: 700, textTransform: 'uppercase',
              letterSpacing: '0.04em', color: '#40c4ff', background: 'rgba(2,139,232,0.12)',
              border: '1px solid rgba(2,139,232,0.4)', borderRadius: '999px', padding: '3px 10px', marginBottom: '8px',
            }}>
              {subject}
            </div>
          )}
          <div style={{ fontSize: '14.5px', fontWeight: 700, color: '#ffaa00', margin: '4px 0' }}>
            {activity?.activity_title}
          </div>
          {detailsSnippet && (
            <p style={{ margin: '0 0 10px 0', fontSize: '12.5px', color: '#ccc', lineHeight: 1.5 }}>
              {detailsSnippet}
            </p>
          )}
          <div style={{
            display: 'inline-block', fontSize: '12.5px', fontWeight: 700, color: 'white',
            background: 'linear-gradient(90deg,#028be8,#00e1ff)', borderRadius: '6px', padding: '6px 14px',
          }}>
            Join this activity →
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '10px' }}>
          <a
            href={whatsappHref} target="_blank" rel="noopener noreferrer"
            style={{
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
              background: '#25D366', color: '#0a0f1f', fontWeight: 700, fontSize: '13.5px',
              borderRadius: '8px', padding: '11px', textDecoration: 'none',
            }}
          >
            <FaWhatsapp size={16} /> WhatsApp
          </a>
          <a
            href={emailHref}
            style={{
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
              background: 'rgba(255,255,255,0.06)', color: 'white', fontWeight: 700, fontSize: '13.5px',
              border: '1px solid rgba(255,255,255,0.2)', borderRadius: '8px', padding: '11px', textDecoration: 'none',
            }}
          >
            <FaEnvelope size={15} /> Email
          </a>
        </div>

        <button
          onClick={handleCopyLink}
          style={{
            width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
            background: 'transparent', color: copyState === 'copied' ? '#00c875' : '#028be8',
            border: `1px solid ${copyState === 'copied' ? '#00c875' : '#028be8'}`, borderRadius: '8px',
            padding: '11px', fontWeight: 600, fontSize: '13.5px', cursor: 'pointer',
          }}
        >
          <FaLink size={13} /> {copyState === 'copied' ? 'Copied — paste anywhere!' : 'Copy Styled Invite'}
        </button>
      </div>
    </div>,
    document.body
  );
}

// ─── Progress Snapshot modal ──────────────────────────────────────────────
// Every started / completed activity across all subjects, with subject +
// status filters, grouped either by focus area or by subject.
const SC_DEPTH_RANK = { Starting: 1, Developing: 2, Advanced: 3 };
const SC_OTHER_COLOR = '#8fa3c4';
const SC_SUBJECT_COLOR = '#40b3ff';

function SnapshotActivityRow({ it, accent, showFocusIcons, showSubject, onOpen }) {
  const done = it.progress >= 100;
  const depthMeta = SC_DEPTH_META[it.depth];
  return (
    <button
      type="button"
      onClick={() => onOpen(it)}
      style={{
        display: 'flex', alignItems: 'center', gap: '12px 18px', flexWrap: 'wrap', width: '100%',
        textAlign: 'left', padding: '12px 14px', borderRadius: '10px', cursor: 'pointer', color: 'white',
        background: 'rgba(255,255,255,0.035)', border: '1px solid rgba(255,255,255,0.07)',
        borderLeft: `3px solid ${done ? '#00e1ff' : accent}`, transition: 'background 0.15s, box-shadow 0.15s',
      }}
      onMouseEnter={(e) => { e.currentTarget.style.background = `${accent}14`; e.currentTarget.style.boxShadow = `0 0 0 1px ${accent}55`; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.035)'; e.currentTarget.style.boxShadow = 'none'; }}
    >
      <div style={{ flex: '1 1 220px', minWidth: 0 }}>
        <div style={{ fontSize: '14px', fontWeight: 600, color: '#e6edf5', lineHeight: 1.3 }}>{it.title}</div>
        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '4px 10px', marginTop: '4px', fontSize: '11.5px', color: '#7f8ea8' }}>
          <span>{showSubject ? `${it.subject}${it.category ? ` · ${it.category}` : ''}` : it.category}</span>
          {showFocusIcons && it.tags.map((t) => {
            const { color, icon: TI } = SC_TAG_META[t];
            return (
              <span key={t} title={t} style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', color, fontWeight: 600 }}>
                <TI size={9} /> {t}
              </span>
            );
          })}
        </div>
      </div>

      {depthMeta && (
        <span
          style={{
            display: 'inline-flex', alignItems: 'center', gap: '7px', padding: '3px 10px', borderRadius: '999px',
            fontSize: '11.5px', fontWeight: 600, color: depthMeta.color, flexShrink: 0,
            background: `${depthMeta.color}14`, border: `1px solid ${depthMeta.color}44`,
          }}
        >
          <SCDepthBars depth={it.depth} size={0.7} /> {it.depth}
        </span>
      )}

      <div style={{ flex: '0 0 170px', minWidth: '140px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px', fontSize: '11.5px' }}>
          <span style={{ color: done ? '#00e1ff' : '#8a97ad', fontWeight: 600 }}>{done ? 'Completed' : 'In progress'}</span>
          <span style={{ color: done ? '#00e1ff' : accent, fontWeight: 700, display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
            {done && <FaCheckCircle size={11} />}{it.progress}%
          </span>
        </div>
        <div style={{ height: '6px', borderRadius: '99px', background: 'rgba(255,255,255,0.08)', overflow: 'hidden' }}>
          <div
            style={{
              width: `${it.progress}%`, height: '100%', borderRadius: '99px',
              background: done ? 'linear-gradient(90deg,#00a8cc,#00e1ff)' : `linear-gradient(90deg, ${accent}88, ${accent})`,
              boxShadow: done ? '0 0 10px rgba(0,225,255,0.5)' : 'none',
            }}
          />
        </div>
      </div>

      <span style={{ color: '#5f6c82', fontSize: '16px', flexShrink: 0 }}>→</span>
    </button>
  );
}

function FocusSnapshotModal({ items, loading, onClose, onOpenActivity }) {
  const [subject, setSubject] = useState('');       // '' = all subjects
  const [status, setStatus] = useState('all');      // 'all' | 'progress' | 'done'
  const [groupBy, setGroupBy] = useState('focus');  // 'focus' | 'subject'

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const started = useMemo(() => items.filter((i) => i.progress > 0), [items]);
  const completedTotal = started.filter((i) => i.progress >= 100).length;
  const statusOk = (i, s = status) =>
    s === 'all' || (s === 'done' ? i.progress >= 100 : i.progress < 100);

  // Subject chips — counts respect the active status filter
  const subjectOptions = useMemo(() => {
    const names = [...new Set(started.map((i) => i.subject).filter(Boolean))];
    return names
      .map((name) => ({
        name,
        count: started.filter((i) => i.subject === name && statusOk(i)).length,
        all: started.filter((i) => i.subject === name).length,
      }))
      .sort((a, b) => b.all - a.all || a.name.localeCompare(b.name));
  }, [started, status]);

  // Status counts respect the active subject filter
  const statusCounts = useMemo(() => {
    const pool = started.filter((i) => !subject || i.subject === subject);
    return {
      all: pool.length,
      progress: pool.filter((i) => i.progress < 100).length,
      done: pool.filter((i) => i.progress >= 100).length,
    };
  }, [started, subject]);

  const sections = useMemo(() => {
    const scoped = items.filter((i) => !subject || i.subject === subject);
    const build = (key, title, color, Icon, pool, isFocus = false) => {
      const rows = pool.filter((i) => i.progress > 0 && statusOk(i)).sort((a, b) => b.progress - a.progress);
      return {
        key, title, color, Icon, rows, isFocus, total: pool.length,
        completed: rows.filter((i) => i.progress >= 100).length,
        avg: rows.length ? Math.round(rows.reduce((s, i) => s + i.progress, 0) / rows.length) : 0,
        deepest: rows.reduce((best, i) => ((SC_DEPTH_RANK[i.depth] || 0) > (SC_DEPTH_RANK[best] || 0) ? i.depth : best), ''),
      };
    };

    if (groupBy === 'focus') {
      const list = SC_FOCUS_TAGS.map((tag) =>
        build(tag, tag, SC_TAG_META[tag].color, SC_TAG_META[tag].icon, scoped.filter((i) => i.tags.includes(tag)), true)
      );
      const other = build('__other', 'Other activities', SC_OTHER_COLOR, FaBolt, scoped.filter((i) => i.tags.length === 0));
      return other.rows.length ? [...list, other] : list;
    }

    return [...new Set(scoped.map((i) => i.subject).filter(Boolean))]
      .map((s) => build(s, s, SC_SUBJECT_COLOR, FaGraduationCap, scoped.filter((i) => i.subject === s)))
      .filter((s) => s.rows.length)
      .sort((a, b) => b.rows.length - a.rows.length);
  }, [items, subject, status, groupBy]);

  const visibleCount = groupBy === 'subject'
    ? sections.reduce((n, s) => n + s.rows.length, 0)
    : new Set(sections.flatMap((s) => s.rows.map((r) => r.id))).size;
  const filtersActive = !!subject || status !== 'all';

  const segLabel = {
    fontSize: '10px', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', color: '#7f8ea8', marginBottom: '6px',
  };
  const segWrap = {
    display: 'inline-flex', gap: '3px', padding: '3px', borderRadius: '10px',
    background: 'rgba(0,0,0,0.3)', border: '1px solid rgba(255,255,255,0.07)',
  };
  const segBtn = (active, color = '#00e1ff') => ({
    display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '5px 12px', borderRadius: '7px',
    fontSize: '12px', fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap',
    color: active ? color : '#9aa7bd', background: active ? `${color}1f` : 'transparent',
    border: `1px solid ${active ? `${color}66` : 'transparent'}`, transition: 'all 0.15s ease',
  });
  const count = (n) => <span style={{ fontSize: '10.5px', fontWeight: 700, opacity: 0.65 }}>{n}</span>;

  return ReactDOM.createPortal(
    <div
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.78)', zIndex: 6500,
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', backdropFilter: 'blur(3px)',
      }}
    >
      <div
        className="focus-snapshot-panel"
        role="dialog"
        aria-label="Progress snapshot"
        style={{
          width: '840px', maxWidth: '96vw', height: 'min(88vh, 860px)', display: 'flex', flexDirection: 'column',
          background: 'linear-gradient(135deg, #0f1629 0%, #0a0f1f 100%)',
          border: '1px solid rgba(0,225,255,0.3)', borderRadius: '16px', overflow: 'hidden',
          boxShadow: '0 24px 70px rgba(0,0,0,0.65)',
        }}
      >
        {/* ── Fixed header: title, stats, filters ── */}
        <div style={{ padding: '20px 24px 16px', borderBottom: '1px solid rgba(255,255,255,0.08)', flexShrink: 0 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '16px' }}>
            <div>
              <div className="supercurricular-achievements-title" style={{ fontSize: '19px', fontWeight: 700, color: '#00e1ff', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <FaTrophy color="#ffd700" /> My Supercurricular Achievements
              </div>
            </div>
            <button
            className="super-modal-close" 
            onClick={onClose} aria-label="Close" style={{ background: 'none', border: 'none', color: '#aaa', fontSize: '24px', cursor: 'pointer', lineHeight: 1, marginTop: '-4px' }}>×</button>
          </div>

          {/* Stat tiles */}
          <div className="stat-tiles" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', margin: '16px 0' }}>
            {[
              { label: 'Activities', value: started.length, color: '#40b3ff' },
              { label: 'In progress', value: started.length - completedTotal, color: '#00ffee' },
              { label: 'Completed', value: completedTotal, color: '#ffd700' },
              { label: 'Subjects', value: subjectOptions.length, color: '#9c6fe4' },
            ].map((s) => (
              <div
                key={s.label}
                style={{
                  flex: '1 1 110px', padding: '9px 14px', borderRadius: '10px',
                  background: `${s.color}0f`, border: `1px solid ${s.color}33`,
                }}
              >
                <div style={{ fontSize: '20px', fontWeight: 800, color: s.color, lineHeight: 1.1 }}>{s.value}</div>
                <div style={{ fontSize: '10.5px', fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', color: '#7f8ea8', marginTop: '2px' }}>{s.label}</div>
              </div>
            ))}
          </div>

          {/* Subject filter chips (horizontally scrollable) */}
          <div style={segLabel}>Subject</div>
          <div
            className="invisible-scroll"
            style={{ display: 'flex', gap: '6px', overflowX: 'auto', paddingBottom: '4px', marginBottom: '12px' }}
          >
            {[{ name: '', label: 'All subjects', count: started.filter((i) => statusOk(i)).length }, ...subjectOptions.map((s) => ({ ...s, label: s.name }))].map((s) => {
              const active = subject === s.name;
              const disabled = s.count === 0 && !active;
              return (
                <button
                  key={s.name || '__all'}
                  type="button"
                  className="subject-chip"
                  disabled={disabled}
                  aria-pressed={active}
                  onClick={() => setSubject(active ? '' : s.name)}
                  style={{
                    ...segBtn(active, SC_SUBJECT_COLOR), flexShrink: 0, padding: '6px 13px',
                    background: active ? `${SC_SUBJECT_COLOR}26` : 'rgba(255,255,255,0.04)',
                    border: `1px solid ${active ? `${SC_SUBJECT_COLOR}88` : 'rgba(255,255,255,0.1)'}`,
                    opacity: disabled ? 0.35 : 1, cursor: disabled ? 'not-allowed' : 'pointer',
                  }}
                >
                  {s.label} {count(s.count)}
                </button>
              );
            })}
          </div>

          {/* Status + group-by */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '14px 28px', alignItems: 'flex-end' }}>
            <div>
              <div style={segLabel}>Status</div>
              <div style={segWrap}>
                {[
                  { key: 'all', label: 'All' },
                  { key: 'progress', label: 'In progress' },
                  { key: 'done', label: 'Completed' },
                ].map((o) => (
                  <button 
                  className="subject-chip"
                  key={o.key} type="button" aria-pressed={status === o.key} onClick={() => setStatus(o.key)} style={segBtn(status === o.key)}>
                    {o.label} {count(statusCounts[o.key])}
                  </button>
                ))}
              </div>
            </div>

            <div>
              <div style={segLabel}>Group by</div>
              <div style={segWrap}>
                {[
                  { key: 'focus', label: 'Focus area' },
                  { key: 'subject', label: 'Subject' },
                ].map((o) => (
                  <button 
                    className="subject-chip"
                    key={o.key} type="button" aria-pressed={groupBy === o.key} onClick={() => setGroupBy(o.key)} style={segBtn(groupBy === o.key)}>
                    {o.label}
                  </button>
                ))}
              </div>
            </div>

            {filtersActive && (
              <button
                type="button"
                onClick={() => { setSubject(''); setStatus('all'); }}
                style={{ marginLeft: 'auto', background: 'none', border: 'none', color: '#ff8a8a', cursor: 'pointer', fontSize: '12px', fontWeight: 600, padding: '6px 0' }}
              >
                <FaTimes size={10} /> Clear filters
              </button>
            )}
          </div>
        </div>

        {/* ── Scrollable body ── */}
        <div className="space-scroll" style={{ padding: '18px 24px 24px', overflowY: 'auto', flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {loading && items.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px 0', color: '#666', fontStyle: 'italic' }}>Loading your activities…</div>
          ) : started.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '44px 20px', color: '#88aacc', border: '1px dashed rgba(0,225,255,0.3)', borderRadius: '14px', fontSize: '14px', lineHeight: 1.6 }}>
              <FaBolt style={{ fontSize: '24px', color: '#ffaa00', opacity: 0.8, marginBottom: '10px' }} /><br />
              You haven't started any activities yet.<br />
              <span style={{ color: '#7f8ea8', fontSize: '13px' }}>Set a progress level on any activity and it will appear here.</span>
            </div>
          ) : (
            <>
              <div style={{ fontSize: '12px', color: '#8a97ad' }}>
                Showing <strong style={{ color: '#40c4ff' }}>{visibleCount}</strong> of {started.length} activities
              </div>

              {visibleCount === 0 && (
                <div style={{ textAlign: 'center', padding: '30px 20px', color: '#88aacc', border: '1px dashed rgba(255,170,0,0.35)', borderRadius: '12px', fontSize: '13.5px' }}>
                  No activities match these filters.
                </div>
              )}

              {sections.map((sec) => {
                if (sec.rows.length === 0 && !sec.isFocus) return null;
                const { color, Icon, rows } = sec;
                const dMeta = SC_DEPTH_META[sec.deepest];
                return (
                  <section
                    key={sec.key}
                    style={{
                      padding: '16px 16px 14px', borderRadius: '14px', background: 'rgba(255,255,255,0.03)',
                      border: '1px solid rgba(255,255,255,0.08)', borderTop: `3px solid ${color}`,
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap', marginBottom: '12px' }}>
                      <span style={{ width: '34px', height: '34px', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', color, background: `${color}1f`, flexShrink: 0 }}>
                        <Icon size={14} />
                      </span>
                      <div style={{ flex: 1, minWidth: '160px' }}>
                        <div style={{ fontSize: '15px', fontWeight: 700, color }}>{sec.title}</div>
                        <div style={{ fontSize: '12px', color: '#8a97ad', marginTop: '1px' }}>
                          {rows.length} activit{rows.length === 1 ? 'y' : 'ies'}
                          {sec.completed > 0 && <> · <span style={{ color: '#00e1ff' }}>{sec.completed} completed</span></>}
                          {rows.length > 0 && <> · avg {sec.avg}%</>}
                        </div>
                      </div>
                     
                    </div>

                    {rows.length === 0 ? (
                      <div style={{ padding: '14px', textAlign: 'center', borderRadius: '10px', fontSize: '13px', lineHeight: 1.5, color: '#7f8ea8', border: `1px dashed ${color}44`, background: `${color}08` }}>
                        {sec.total > 0
                          ? <>Nothing {status === 'done' ? 'completed' : status === 'progress' ? 'in progress' : 'started'} here yet — <strong style={{ color }}>{sec.total}</strong> {sec.title.toLowerCase()} activit{sec.total === 1 ? 'y' : 'ies'} available{subject ? ` in ${subject}` : ''}.</>
                          : <>No {sec.title} activities{subject ? ` in ${subject}` : ''} yet.</>}
                      </div>
                    ) : (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        {rows.map((it) => (
                          <SnapshotActivityRow
                            key={`${sec.key}-${it.id}`}
                            it={it}
                            accent={color}
                            showSubject={groupBy === 'focus' && !subject}
                            showFocusIcons={groupBy === 'subject'}
                            onOpen={onOpenActivity}
                          />
                        ))}
                      </div>
                    )}
                  </section>
                );
              })}

              {groupBy === 'focus' && (
                <p style={{ margin: 0, textAlign: 'center', fontSize: '11.5px', color: '#5f6c82' }}>
                  An activity tagged with more than one focus area appears under each.
                </p>
              )}
            </>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}

export default function DashboardEnrich({ userId, isAdmin = false, onLogout, viewingChildId: viewingChildIdProp, childName: childNameProp }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { confirm, showToast } = useUIFeedback();
  const [completionStatus, setCompletionStatus] = useState({
    career: false,
    subject: false,
    learning: false,
  });
  const [rawAnswers, setRawAnswers] = useState({ learning: [] }); // Removed subject, subjectpart3
  const [loading, setLoading] = useState({ learningVisualizations: true });
  const [error, setError] = useState({ learningVisualizations: null });
  const [activeSidebarItem, setActiveSidebarItem] = useState(() => {
    return location.state?.sidebarItem || "enrich";
  });
  const [lastCompletionDates, setLastCompletionDates] = useState({ learning: null, subject: null, subjectpart3: null });
  const [lastCompletedSessionIds, setLastCompletedSessionIds] = useState({ learning: null, subject: null, subjectpart3: null });
  const [learningSessionId, setLearningSessionId] = useState(() => {
  const params = new URLSearchParams(window.location.search);
  const childIdFromQuery = params.get("viewingChildId");
  const childIdFromState = window.history.state?.usr?.viewingChildId;
  const hasChildId = !!(childIdFromQuery || childIdFromState);
  const storedRole = localStorage.getItem("role") || "user";
  const isParentOrMentor = storedRole === "parent" || storedRole === "mentor";

  if (hasChildId && isParentOrMentor) return null;
  return localStorage.getItem("learningSessionId") || null;
  });

  const learningRadarChartRef = useRef(null);
  const [selectedRadarGroup, setSelectedRadarGroup] = useState(null);
  const [tooltip, setTooltip] = useState({
    visible: false,
    content: "",
    x: 0,
    y: 0,
  });


  // Initialize with location.state or empty array
  const [sortedScores, setSortedScores] = useState(() => {
  const storedScores = localStorage.getItem(`sortedScores_${userId}`);
  try {
    return location.state?.sortedScores || (storedScores ? JSON.parse(storedScores) : []);
  } catch {
    localStorage.removeItem(`sortedScores_${userId}`);
    return location.state?.sortedScores || [];
  }
});
const [sortedPart3Scores, setSortedPart3Scores] = useState(() => {
  const storedPart3Scores = localStorage.getItem(`sortedPart3Scores_${userId}`);
  try {
    return location.state?.sortedPart3Scores || (storedPart3Scores ? JSON.parse(storedPart3Scores) : []);
  } catch {
    localStorage.removeItem(`sortedPart3Scores_${userId}`);
    return location.state?.sortedPart3Scores || [];
  }
});
const fullSortedScoresFromNav     = location.state?.fullSortedScores     || [];
const fullSortedPart3ScoresFromNav = location.state?.fullSortedPart3Scores || [];
const [selectedSubject, setSelectedSubject] = useState('');
const [tableData, setTableData] = useState([]);
const [checkboxStates, setCheckboxStates] = useState({});

const [teamAnswer, setTeamAnswer] = useState('');
const [teamError, setTeamError] = useState(null);
const [isLoadingTask, setIsLoadingTask] = useState(false);
const [inviteeEmails, setInviteeEmails] = useState('');
const [teamSubject, setTeamSubject] = useState('');
const [showInstructions, setShowInstructions] = useState(false);
const [teamTaskGenerated, setTeamTaskGenerated] = useState(() => {
  const cachedTask = localStorage.getItem(`team_task_${userId}`);
  try {
    const parsed = cachedTask ? JSON.parse(cachedTask) : null;
    return !!(parsed?.task?.taskId && parsed?.task?.question);
  } catch {
    return false;
  }
});

const [teamTaskGeneratedTime, setTeamTaskGeneratedTime] = useState(() => {
  const cachedTask = localStorage.getItem(`team_task_${userId}`);
  try {
    const parsed = cachedTask ? JSON.parse(cachedTask) : null;
    return parsed?.task?.created_at || null;
  } catch {
    return null;
  }
});

const [hasStoredFeedback, setHasStoredFeedback] = useState(() => {
  const cachedTask = localStorage.getItem(`team_task_${userId}`);
  try {
    const parsed = JSON.parse(cachedTask);
    return !!parsed?.task?.feedback_text;
  } catch {
    return false;
  }
});
const [pendingInvitations, setPendingInvitations] = useState(() => {
  const storedInvitations = localStorage.getItem(`pending_invitations_${userId}`);
  return storedInvitations ? JSON.parse(storedInvitations) : [];
});
const [invitationErrors, setInvitationErrors] = useState(null);
const [showInvitationList, setShowInvitationList] = useState(false);
const [notificationCount, setNotificationCount] = useState(0); // New state for notification count
const [isDropdownOpen, setIsDropdownOpen] = useState(false);
const invitationDropdownRef = useRef(null);
const [userRole, setUserRole] = useState(() => {
    const storedRole = localStorage.getItem(`app_role_${userId}`);
    return storedRole || 'user';
});
  const [restrictionUntil, setRestrictionUntil] = useState(() => {
    const storedRestriction = localStorage.getItem(`restriction_until_${userId}`);
    return storedRestriction || null;
  });
const [lastFetchTaskDetailsTime, setLastFetchTaskDetailsTime] = useState(null);
const [isProcessingInvitation, setIsProcessingInvitation] = useState(false);
const [timeUntilExpiry, setTimeUntilExpiry] = useState(null);
const [teamMemberStatuses, setTeamMemberStatuses] = useState([]);
const [canCheckTask, setCanCheckTask] = useState(true);

const [needsFeedbackFetch, setNeedsFeedbackFetch] = useState(false);
const [hasSubmittedAnswer, setHasSubmittedAnswer] = useState(false);

const [materialComments, setMaterialComments] = useState(() => {
  const cachedComments = localStorage.getItem(`material_comments_${userId}`);
  try {
    return cachedComments ? JSON.parse(cachedComments) : {};
  } catch {
    localStorage.removeItem(`material_comments_${userId}`);
    return {};
  }
});

const [chosenTopSubject, setChosenTopSubject] = useState(() => {
  const storedChosen = localStorage.getItem(`chosen_top_subject_${userId}`);
  return location.state?.chosenTopSubject || storedChosen || null;
});

const [strategy, setStrategy] = useState(null);
const [lastStrategyGenerationDate, setLastStrategyGenerationDate] = useState(null);
const [isGeneratingStrategy, setIsGeneratingStrategy] = useState(false);
const [strategyError, setStrategyError] = useState(null);
const [studyLearnerIntelligence, setStudyLearnerIntelligence] = useState(defaultStudyLearnerIntelligence());
const studyLearnerIntelligenceLoadedRef = useRef(false);
const [showStudyLearnerIntelligenceModal, setShowStudyLearnerIntelligenceModal] = useState(false);

useEffect(() => {
  studyLearnerIntelligenceLoadedRef.current = false;
  if (!userId) return;
  let cancelled = false;
  (async () => {
    try {
      const data = await getStudyLearnerIntelligence(userId);
      if (!cancelled) {
        setStudyLearnerIntelligence(data || defaultStudyLearnerIntelligence());
        studyLearnerIntelligenceLoadedRef.current = true;
      }
    } catch (e) {
      console.error("Failed to load study learner intelligence:", e);
      if (!cancelled) studyLearnerIntelligenceLoadedRef.current = true;
    }
  })();
  return () => { cancelled = true; };
}, [userId]);

const [showWhatsNextModal, setShowWhatsNextModal] = useState(false);
const [showWhatsNextModalStudyStyle, setShowWhatsNextModalStudyStyle] = useState(false);
const [selectedSuperSubject, setSelectedSuperSubject] = useState('');
const [selectedCategory, setSelectedCategory] = useState('');
const [selectedSuperActivity, setSelectedSuperActivity] = useState(null);
const [supercurricularActivities, setSupercurricularActivities] = useState([]);
const [loadingSuperActivities, setLoadingSuperActivities] = useState(false);
const [scFilters, setScFilters] = useState({ ...SC_DEFAULT_FILTERS });
const scFiltersActive = !!(scFilters.time || scFilters.depth || scFilters.tags.length > 0);

const filteredSuperActivities = useMemo(
  () => supercurricularActivities.filter((a) => activityMatchesFilters(a, scFilters)),
  [supercurricularActivities, scFilters]
);

// If a filter hides the open activity, move to the first match
// (same category first, otherwise the first category that has any).
useEffect(() => {
  if (!scFiltersActive || filteredSuperActivities.length === 0) return;
  if (filteredSuperActivities.some((a) => a.supercurricular_id === selectedSuperActivity)) return;
  const next =
    filteredSuperActivities.find((a) => a.category === selectedCategory) || filteredSuperActivities[0];
  setSelectedCategory(next.category);
  setSelectedSuperActivity(next.supercurricular_id);
}, [scFiltersActive, filteredSuperActivities, selectedSuperActivity, selectedCategory]);

const queryParams = new URLSearchParams(location.search);
const STRATEGY_CACHE_TTL = 60 * 24 * 60 * 60 * 1000;
const [teamDataLoaded, setTeamDataLoaded] = useState(false);
const [isManualFetching, setIsManualFetching] = useState(false);
const [lastManualFetchTime, setLastManualFetchTime] = useState(null);
const MANUAL_FETCH_COOLDOWN = 15 * 60 * 1000; 
const { openModal, prewarmDeckSpace } = useModalContext();
const [showAccountMenu, setShowAccountMenu] = useState(false);
const toggleAccountMenu = () => setShowAccountMenu(prev => !prev);
const menuRef = useRef(null);        // desktop
const mobileMenuRef = useRef(null);  // mobile
const [userEmail, setUserEmail] = useState(localStorage.getItem("userEmail") || "User");
const [userUsername, setUserUsername] = useState(localStorage.getItem("userUsername") || null);
const displayName = userUsername || userEmail;

const [lastStatusCheckTime, setLastStatusCheckTime] = useState(() => {
const stored = localStorage.getItem(`last_status_check_${userId}`);
  return stored ? new Date(stored) : null;
});

const [allInviteesSubmitted, setAllInviteesSubmitted] = useState(false);
const [showStatusNote, setShowStatusNote] = useState(false);


const viewingChildId =
  viewingChildIdProp ||
  queryParams.get("viewingChildId") ||
  location.state?.viewingChildId ||
  null;

const viewingChildName =
  childNameProp ||
  decodeURIComponent(queryParams.get("childName") || "") ||
  location.state?.childName ||
  "Student";

const [role] = useState(localStorage.getItem("role") || "user");
const isParentView = !!viewingChildId;
const effectiveUserId = isParentView ? viewingChildId : userId;
const isReadOnly = isParentView && !isAdmin; 
  const [lastChildMaterialsFetch, setLastChildMaterialsFetch] = useState(() => {
  if (!isReadOnly) return null;
  const stored = localStorage.getItem(`last_child_materials_fetch_${effectiveUserId}`);
  return stored ? new Date(stored) : null;
});

const viewModeBannerText = isParentView ? (
  <>
    View-Only Mode — viewing <strong>{viewingChildName}</strong>'s StudyStyle results and associated insights
  </>
) : null;

const activityStatusesLoadedRef = useRef(false);
const [activityStatuses, setActivityStatuses] = useState({});

const [completedAssessments, setCompletedAssessments] = useState({
  uniready:    false,
  studystyle:  false,
  futureready: false,
});

// === NEW BOOKMARK HOOKS ===
const {
  isBookmarked: isKnowledgeBookmarked,
  toggleBookmark: toggleKnowledgeBookmark,
  bookmarkedValue: knowledgeBookmarkValue
} = useBookmark(effectiveUserId, "knowledge");

// Progress celebration modal
const [showProgressModal, setShowProgressModal] = useState(false);
const [justCompleted, setJustCompleted] = useState(null); // "uniready" | "studystyle" | "futureready"

// Avatar selection modal (only shown after all 3)
const [showAvatarModal, setShowAvatarModal] = useState(false);
const [selectedAvatar, setSelectedAvatar] = useState(null);
const [currentAvatar, setCurrentAvatar] = useState(() =>
  localStorage.getItem(`user_avatar_${userId}`) || "fa-avatar-1"
);

// Personal Statement page state
const [showPersonalStatement, setShowPersonalStatement] = useState(false);
const [personalStatementAnswers, setPersonalStatementAnswers] = useState({}); // { subject: { 0: "...", 1: "...", 2: "..." } }
const personalStatementLoadedRef = useRef(false);

useEffect(() => {
  personalStatementLoadedRef.current = false;
  if (!userId) return;
  let cancelled = false;
  (async () => {
    const data = await getPersonalStatementAnswers(userId);
    if (!cancelled) {
      setPersonalStatementAnswers(data);
      personalStatementLoadedRef.current = true;
    }
  })();
  return () => { cancelled = true; };
}, [userId]);
const [selectedPSSubject, setSelectedPSSubject] = useState('');
// ── User-added UniStatement questions, per subject — local-only, same
// per-subject localStorage pattern already used for reviewedActivityIds ──
const [customPSQuestions, setCustomPSQuestions] = useState({}); // { [subjectLower]: [{id, question, answer, createdAt}] }
const [showAddPSQuestionModal, setShowAddPSQuestionModal] = useState(false);



useEffect(() => {
  if (!userId || !selectedPSSubject) return;
  const key = selectedPSSubject.toLowerCase().trim();
  try {
    const saved = JSON.parse(localStorage.getItem(`ps_custom_questions_${userId}_${key}`) || '[]');
    setCustomPSQuestions((prev) => ({ ...prev, [key]: saved }));
  } catch {
    setCustomPSQuestions((prev) => ({ ...prev, [key]: [] }));
  }
}, [userId, selectedPSSubject]);

const getCustomPSQuestionsForSubject = () => {
  const key = (selectedPSSubject || '').toLowerCase().trim();
  return customPSQuestions[key] || [];
};

const saveCustomPSQuestionsForSubject = (updated) => {
  const key = (selectedPSSubject || '').toLowerCase().trim();
  setCustomPSQuestions((prev) => ({ ...prev, [key]: updated }));
  if (userId && key) {
    localStorage.setItem(`ps_custom_questions_${userId}_${key}`, JSON.stringify(updated));
  }
};

const addCustomPSQuestion = (questionText) => {
  const newQ = { id: `psq_${Date.now()}`, question: questionText.trim(), answer: '', aiGuidance: '', createdAt: new Date().toISOString() };
  saveCustomPSQuestionsForSubject([...getCustomPSQuestionsForSubject(), newQ]);
  setShowAddPSQuestionModal(false);
};

const updateCustomPSQuestionAnswer = (id, value) => {
  saveCustomPSQuestionsForSubject(
    getCustomPSQuestionsForSubject().map((q) => (q.id === id ? { ...q, answer: value } : q))
  );
};

const updateCustomPSQuestionGuidance = (id, value) => {
  saveCustomPSQuestionsForSubject(
    getCustomPSQuestionsForSubject().map((q) => (q.id === id ? { ...q, aiGuidance: value } : q))
  );
};

const removeCustomPSQuestion = async (id) => {
  const ok = await confirm('Remove this question?', { danger: true });
  if (!ok) return;
  saveCustomPSQuestionsForSubject(getCustomPSQuestionsForSubject().filter((q) => q.id !== id));
};

// Replaces static PSExpandableNote guidance — user-added questions have no
// CMS-authored guidance, so this builds a Grok prompt instead, following the
// same copy-then-open pattern as handleAskGrokForCustomPSQuestion's siblings
// elsewhere in this file (e.g. InterviewPro's "Question Idea" button).
const handleAskGrokForCustomPSQuestion = async (questionText) => {
  const prompt = `You are an experienced university admissions personal statement advisor who has helped hundreds of students gain offers from top universities.

The student is applying to study **${selectedPSSubject}** and wants guidance on how to answer this additional personal statement question they've added themselves:

"${questionText}"

Provide clear, practical guidance covering:
1. What admissions tutors are really looking for in an answer to this question
2. A suggested structure or approach for answering it well
3. 2-3 concrete example angles or experiences a strong applicant might draw on
4. Common mistakes to avoid

Keep the guidance concise, actionable, and specific to a ${selectedPSSubject} application.`;

  let copied = false;
  try {
    await navigator.clipboard.writeText(prompt);
    copied = true;
  } catch {
    copied = false;
  }

  const proceed = await confirm(
    copied
      ? 'The prompt has been copied. Paste it into Grok for guidance on this question.'
      : "Couldn't copy the prompt automatically — Grok will open with it pre-filled instead.",
    { title: 'Ready for Grok', confirmLabel: 'Proceed' }
  );
  if (!proceed) return;

  if (copied) {
    window.open('https://grok.com', '_blank');
  } else {
    const encoded = encodeURIComponent(prompt);
    window.open(`https://grok.com/?q=${encoded}`, '_blank');
  }
};
// ── UniStatement: "Reference My Activities" — lets the student browse
// their SuperCurricular Journal entries (scoped to the currently selected
// UniStatement subject) while writing Question 2 / Question 3, and tick
// off which ones they've already drawn on. Purely a reference/checklist —
// nothing is auto-inserted into the answer text.
// showJournalRefModal holds the target question index (1 or 2) while open.
const [showJournalRefModal, setShowJournalRefModal] = useState(null);
const [showShareActivitySheet, setShowShareActivitySheet] = useState(false);
const [allSuperActivitiesMap, setAllSuperActivitiesMap] = useState({}); // subjectLower -> activities[]
const [journalActivitiesLoading, setJournalActivitiesLoading] = useState(false);
const [reviewedActivityIds, setReviewedActivityIds] = useState(new Set());


// Re-fetch each time the modal opens (cheap Dexie read) so titles/subjects
// stay current with anything added on the SuperCurricular tab since last open.
useEffect(() => {
  if (showJournalRefModal === null || !userId) return;
  let cancelled = false;
  setJournalActivitiesLoading(true);
  (async () => {
    try {
      const cachedRow = await getSuperActivities(userId);
      if (!cancelled) setAllSuperActivitiesMap(cachedRow.data || {});
    } catch (err) {
      console.warn('Could not load activities for journal reference:', err);
      if (!cancelled) setAllSuperActivitiesMap({});
    } finally {
      if (!cancelled) setJournalActivitiesLoading(false);
    }
  })();
  return () => { cancelled = true; };
}, [showJournalRefModal, userId]);

// Load the "reviewed" checklist for this subject whenever the modal opens
// (or the subject changes while it's open) — kept per-user-per-subject so
// ticks persist across sessions but don't leak between subjects.
useEffect(() => {
  if (showJournalRefModal === null || !userId || !selectedPSSubject) return;
  try {
    const key = `ps_reviewed_activities_${userId}_${selectedPSSubject.toLowerCase().trim()}`;
    const saved = JSON.parse(localStorage.getItem(key) || '[]');
    setReviewedActivityIds(new Set(saved));
  } catch {
    setReviewedActivityIds(new Set());
  }
}, [showJournalRefModal, userId, selectedPSSubject]);

useEffect(() => {
  if (!effectiveUserId) return;
  ensureFacetNoteCacheFreshness(effectiveUserId).catch(() => {});
}, [effectiveUserId]);

const toggleActivityReviewed = (activityId) => {
  if (!userId || !selectedPSSubject) return;
  setReviewedActivityIds((prev) => {
    const next = new Set(prev);
    if (next.has(activityId)) next.delete(activityId);
    else next.add(activityId);
    const key = `ps_reviewed_activities_${userId}_${selectedPSSubject.toLowerCase().trim()}`;
    localStorage.setItem(key, JSON.stringify(Array.from(next)));
    return next;
  });
};

// Personal Statement page state (add these lines)
const [psGuidanceSets, setPsGuidanceSets] = useState([]);           // all fetched sets
const [selectedGuidance, setSelectedGuidance] = useState(null);    // current set for selected subject
const [loadingGuidance, setLoadingGuidance] = useState(false);
const [guidanceError, setGuidanceError] = useState(null);
const canFetchAgain = !lastChildMaterialsFetch ||
  (Date.now() - lastChildMaterialsFetch.getTime() >= 24 * 60 * 60 * 1000);

const [knowledgeResources, setKnowledgeResources] = useState([]);
const [isLoadingKnowledge, setIsLoadingKnowledge] = useState(false);
const [knowledgeError, setKnowledgeError] = useState(null);
const [selectedKnowledgeSubject, setSelectedKnowledgeSubject] = useState('');
const [knowledgeTab, setKnowledgeTab] = useState('print');   // 'print' | 'media'
const [youtubePopup, setYoutubePopup] = useState(null);      // null | { url, title }
const [expandedDescriptions, setExpandedDescriptions] = useState({});

const toggleDescriptionExpanded = (rowId) => {
  setExpandedDescriptions((prev) => ({ ...prev, [rowId]: !prev[rowId] }));
};

// ── User-added knowledge resources (local-only, indefinite) ──
const [userResources, setUserResources] = useState({});
// shape: { [subjectLower]: { print: [...], video: [...], audio: [...], 'free-course': [...] } }
const [addFormOpen, setAddFormOpen] = useState({}); // type -> bool
const [addFormDraft, setAddFormDraft] = useState({});
const [editingUserResource, setEditingUserResource] = useState(null); // { type, id } | null

// Load whenever subject changes
useEffect(() => {
  if (!userId || !selectedKnowledgeSubject) return;
  let cancelled = false;
  (async () => {
    try {
      const data = await getUserResources(userId, selectedKnowledgeSubject);
      if (!cancelled) {
        setUserResources((prev) => ({ ...prev, [selectedKnowledgeSubject.toLowerCase().trim()]: data }));
      }
    } catch (err) {
      console.error('Failed to load user knowledge resources:', err);
    }
  })();
  return () => { cancelled = true; };
}, [userId, selectedKnowledgeSubject]);

const saveUserResourcesForSubject = (subject, updated) => {
  const subjKey = subject.toLowerCase().trim();
  setUserResources((prev) => ({ ...prev, [subjKey]: updated }));
  saveUserResources(userId, subject, updated).catch((err) =>
    console.error('Failed to save user knowledge resource:', err)
  );
};

const getUserResourcesForType = (type) => {
  const subjKey = (selectedKnowledgeSubject || '').toLowerCase().trim();
  return userResources[subjKey]?.[type] || [];
};

const addUserResource = (type, fields) => {
  const current = userResources[(selectedKnowledgeSubject || '').toLowerCase().trim()] || { print: [], video: [], audio: [], 'free-course': [] };
  const newResource = {
    id: `user_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    resourceType: type,
    resourceTitle: fields.title.trim(),
    author: fields.author?.trim() || '',
    resourceLink: fields.link?.trim() || '',
    source: fields.source?.trim() || '',
    difficulty: fields.difficulty || '',
    duration: fields.duration?.trim() || '',
    description: fields.details?.trim() || '',
    isUserAdded: true,
    addedAt: new Date().toISOString(),
  };
  const updated = { ...current, [type]: [newResource, ...(current[type] || [])] };
  saveUserResourcesForSubject(selectedKnowledgeSubject, updated);
};

const updateUserResource = (type, id, fields) => {
  const subjKey = (selectedKnowledgeSubject || '').toLowerCase().trim();
  const current = userResources[subjKey];
  if (!current) return;
  const updatedList = current[type].map((r) =>
    r.id === id
      ? {
          ...r,
          resourceTitle: fields.title.trim(),
          author: fields.author?.trim() || '',
          resourceLink: fields.link?.trim() || '',
          source: fields.source?.trim() || '',
          difficulty: fields.difficulty || '',
          duration: fields.duration?.trim() || '',
          description: fields.details?.trim() || '',
        }
      : r
  );
  saveUserResourcesForSubject(selectedKnowledgeSubject, { ...current, [type]: updatedList });
};

const deleteUserResource = async (type, id) => {
  const ok = await confirm('Remove this resource you added? This cannot be undone.', { danger: true });
  if (!ok) return;
  const subjKey = (selectedKnowledgeSubject || '').toLowerCase().trim();
  const current = userResources[subjKey];
  if (!current) return;
  const updatedList = current[type].filter((r) => r.id !== id);
  saveUserResourcesForSubject(selectedKnowledgeSubject, { ...current, [type]: updatedList });
};

// ── Per-resource learning notes (Reading / Video / Podcast / Free Course) ──
const [resourceNotes, setResourceNotes] = useState({}); // rowId -> NoteObject
const [expandedNotes, setExpandedNotes] = useState({});
const [noteSaveStatus, setNoteSaveStatus] = useState({});
const noteSaveTimeouts = useRef({});
const noteFieldRefs = useRef({});

const CONFIDENCE_OPTIONS = [
  { key: 'green',    label: 'Confident',      icon: FaCheckCircle,      color: '#4ade80' },
  { key: 'yellow',   label: 'Still learning',  icon: FaHourglassHalf,    color: '#fbbf24' },
  { key: 'red',      label: 'Needs Review',    icon: FaExclamationCircle,color: '#f87171' },
  { key: 'wantMore', label: 'Explore More',    icon: FaRegCompass,       color: '#36a7f8' },
];

const normalizeNote = (raw) => {
  if (!raw) return null;
  if (typeof raw === 'string') {
return { takeaway: raw, unclear: '', tag: '', confidence: null, usefulness: 0, resourceMeta: null, createdAt: null, updatedAt: null };
  }
  if (raw.text !== undefined && raw.takeaway === undefined) {
return { takeaway: raw.text || '', unclear: '', tag: '', confidence: null, usefulness: 0, resourceMeta: null, createdAt: raw.updatedAt || null, updatedAt: raw.updatedAt || null };
  }
return { usefulness: 0, resourceMeta: null, ...raw };
}; 


const timeSinceLastFetch = lastChildMaterialsFetch
  ? Math.floor((Date.now() - lastChildMaterialsFetch.getTime()) / (60 * 60 * 1000))
  : null;

const nextAllowedInHours = lastChildMaterialsFetch
  ? Math.max(0, 24 - timeSinceLastFetch)
  : 0;

// Track which question's guidance dropdown is open (0,1,2 or null)
const [openGuidanceIndex, setOpenGuidanceIndex] = useState(null);

const [optionCompletions, setOptionCompletions] = useState({});

  const navigateWithViewMode = (path, extraState = {}) => {
    if (isParentView) {
      navigate(path, {
        state: {
          ...extraState,
          viewingChildId,
          childName: viewingChildName,
        },
      });
    } else {
      navigate(path, { state: extraState });
    }
  };


// ── UniStatement (Personal Statement) status ─────────────────────────────
// 1. Start with safe default (no conditional read here)
const [psStatus, setPsStatus] = useState('not_started');
const psStatusLoadedRef = useRef(false);

// 2. Load from Dexie whenever selected subject changes (including on mount)
useEffect(() => {
  psStatusLoadedRef.current = false;
  if (!selectedPSSubject || selectedPSSubject.trim() === '' || !userId) {
    setPsStatus('not_started');
    return;
  }

  let cancelled = false;
  (async () => {
    const status = await getPsStatus(userId, selectedPSSubject);
    if (!cancelled) {
      setPsStatus(['not_started', 'in_progress', 'completed'].includes(status) ? status : 'not_started');
      psStatusLoadedRef.current = true;
    }
  })();
  return () => { cancelled = true; };
}, [selectedPSSubject, userId]);   // ← important: runs on subject change + mount

// 3. Save whenever status or subject changes
useEffect(() => {
  if (!selectedPSSubject || selectedPSSubject.trim() === '' || !userId || !psStatusLoadedRef.current) return;
  savePsStatus(userId, selectedPSSubject, psStatus).catch((err) =>
    console.warn('Failed to save UniStatement status:', err)
  );
}, [psStatus, selectedPSSubject, userId]);

const [hasResetSession, setHasResetSession] = useState(() => {
  // Check if the user has reset the session in this browser session
  return localStorage.getItem(`has_reset_session_${userId}`) === 'true';
});

const SUPER_ACTIVITIES_CACHE_TTL = 30 * 24 * 60 * 60 * 1000; // 30 days
const [isMobile, setIsMobile] = useState(window.innerWidth <= 850);

  // ←←← ADD THE IOS FIX HERE (once per page with Chart.js) ←←←
  useEffect(() => {
    // Only run on iOS devices (iPhone, iPad, iPod, or iPadOS pretending to be Mac)
    const isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    if (!isIOS) return;

    let ticking = false;

    const forceCanvasRedraw = () => {
      // This tiny 1px scroll tricks WebKit into re-compositing all canvas elements
      window.scrollBy(0, -1);
      window.scrollBy(0, 1);
      ticking = false;
    };

    const requestRedraw = () => {
      if (!ticking) {
        requestAnimationFrame(forceCanvasRedraw);
        ticking = true;
      }
    };

    // Redraw when scrolling stops (most important)
    window.addEventListener('scroll', requestRedraw, { passive: true });

    // Also handle tab switch / app background → foreground
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        requestRedraw();
      }
    });

    // Cleanup
    return () => {
      window.removeEventListener('scroll', requestRedraw);
      // visibilitychange cleanup optional
    };
  }, []); // ← empty dependency array = run once on mount
  // ↑↑↑ END OF IOS FIX ↑↑↑



// Knowledge Restore
useEffect(() => {
  if (knowledgeBookmarkValue && activeSidebarItem === "knowledge") {
    const subject = knowledgeBookmarkValue.split('_')[1];
    if (subject) setSelectedKnowledgeSubject(subject);
  }
}, [knowledgeBookmarkValue, activeSidebarItem]);


useEffect(() => {
  if (!location.state) return;

  let justCompletedType = null;

  if (location.state.justSubmittedLearning) {
    justCompletedType = "studystyle";
  } else if (location.state.justSubmittedUniReady) {
    justCompletedType = "uniready";
  } else if (location.state.justSubmittedFutureReady) {
    justCompletedType = "futureready";
  }

  if (justCompletedType) {
    setCompletedAssessments(prev => ({
      ...prev,
      [justCompletedType]: true
    }));

    setJustCompleted(justCompletedType);
    setShowProgressModal(true);

    // Optional: clean up navigation state so refresh doesn't re-trigger the modal
navigate({ pathname: location.pathname, search: location.search }, { replace: true, state: {} });
  }
}, [location.state, navigate]);


useEffect(() => {
  const handleOutside = (e) => {
    const insideDesktop = menuRef.current && menuRef.current.contains(e.target);
    const insideMobile  = mobileMenuRef.current && mobileMenuRef.current.contains(e.target);
    if (!insideDesktop && !insideMobile && !e.target.closest('.career-account-icon')) {
      setShowAccountMenu(false);
    }
  };
  document.addEventListener('mousedown', handleOutside);
  return () => document.removeEventListener('mousedown', handleOutside);
}, []);

useEffect(() => {
  if (
    completedAssessments.uniready &&
    completedAssessments.studystyle &&
    completedAssessments.futureready &&
    !showAvatarModal
  ) {
    // Small delay so user sees progress modal first
    const timer = setTimeout(() => {
      setShowAvatarModal(true);
    }, 1800);

    return () => clearTimeout(timer);
  }
}, [completedAssessments, showAvatarModal]);



useEffect(() => {
  if (showProgressModal) {
    confetti({
      particleCount: 80,
      spread: 70,
      origin: { y: 0.6 },
      colors: ['#00e1ff', '#028be8', '#36a7f8', '#ffd700'],
    });
  }
}, [showProgressModal]);

// State initialization with localStorage
const [teamTask, setTeamTask] = useState(() => {
  const cachedTask = localStorage.getItem(`team_task_${userId}`);
  try {
    const parsedTask = cachedTask ? JSON.parse(cachedTask) : null;
    if (
      parsedTask &&
      parsedTask.task &&
      parsedTask.task.taskId &&             // ← only require taskId
      Array.isArray(parsedTask.answers) &&
      Array.isArray(parsedTask.invitations)
    ) {
      console.log("Loaded valid cached task:", parsedTask.task.taskId);
      return parsedTask;
    }
  } catch (err) {
    console.error('Error parsing cached task:', err.message);
    localStorage.removeItem(`team_task_${userId}`);
  }
  console.log("Initializing default team task");
  return {
    task: {
      taskId: null,
      creatorId: null,
      subject: null,
      question: null,
      status: 'pending',
      created_at: null,
      submission_date: null, 
    },
    answers: [],
    invitations: [],
  };
});

  const [inviteLimit, setInviteLimit] = useState(() => {
    const storedLimit = localStorage.getItem(`invite_limit_${userId}`);
    return storedLimit
      ? JSON.parse(storedLimit)
      : {
          count: 0,
          resetTime: null,
          limitReached: false,
        };
  });

  const [lastStatusFetchTime, setLastStatusFetchTime] = useState(() => {
  const storedTime = localStorage.getItem(`last_status_fetch_${userId}`);
  return storedTime ? new Date(storedTime) : null;
});

const [shareComment, setShareComment] = useState('');

const [lastInvitationFetchTime, setLastInvitationFetchTime] = useState(() => {
  const storedTime = localStorage.getItem(`last_invitation_fetch_${userId}`);
  return storedTime ? new Date(storedTime) : null;
});

const [currentGroupIndex, setCurrentGroupIndex] = useState(0);

// ── New: pre-invite question selection state ──
const [draftQuestion, setDraftQuestion] = useState('');
const [draftQuestionPool, setDraftQuestionPool] = useState([]); // cached questions for teamSubject
const [isLoadingChallengeQuestions, setIsLoadingChallengeQuestions] = useState(false);
const [challengeQuestionsError, setChallengeQuestionsError] = useState(null);

const CHALLENGE_QUESTIONS_CACHE_TTL = 6 * 30 * 24 * 60 * 60 * 1000; // 6 months
const [pendingFreeCourseHighlight, setPendingFreeCourseHighlight] = useState(null);


// Fetch (with 6-month localStorage cache) all questions for a subject, then pick one at random
const fetchChallengeQuestionsForSubject = useCallback(async (subjectName) => {
  if (!subjectName) return [];

  await ensureFreshCacheVersion(); // one-time bust guard

  const cachedRow = await getChallengeQuestions(subjectName);

  if (cachedRow && Array.isArray(cachedRow.data) && cachedRow.data.length > 0 &&
      (Date.now() - (cachedRow.timestamp || 0)) < CHALLENGE_QUESTIONS_CACHE_TTL) {
    return cachedRow.data;
  }

  setIsLoadingChallengeQuestions(true);
  setChallengeQuestionsError(null);

  try {
    const response = await axios.get(`/api/team/challenge-questions/${encodeURIComponent(subjectName)}`, {
      headers: getAuthHeaders(),
    });
    const questions = Array.isArray(response.data.questions) ? response.data.questions : [];

    if (questions.length > 0) {
      await saveChallengeQuestions(subjectName, questions);
    }

    return questions;
  } catch (err) {
    console.error('Error fetching challenge questions:', err.message);
    setChallengeQuestionsError(
      err.response?.data?.error || 'Failed to load questions for this subject.'
    );
    return [];
  } finally {
    setIsLoadingChallengeQuestions(false);
  }
}, []);

const handleDownloadPlanDocx = async () => {
  const activity = supercurricularActivities.find(
    (a) => a.supercurricular_id === currentPlanActivityId
  );
  if (!activity) return;

  const plan = getPlan(currentPlanActivityId);
  const hasContent = plan.goal.trim() || plan.logEntries.length > 0 || plan.outcomeReflection.trim();
  if (!hasContent) {
    showToast('Add a goal or a log entry before downloading — even a rough outline helps.', "info");
    return;
  }

  // Compose a readable plan text from the structured plan for the docx generator
  let planText = '';
  if (plan.goal.trim()) planText += `Goal:\n${plan.goal.trim()}\n\n`;
  if (plan.whyItMatters.trim()) planText += `Why this matters:\n${plan.whyItMatters.trim()}\n\n`;
  const statusLabel = PLAN_STATUS_OPTIONS.find((s) => s.key === plan.status)?.label || 'Not started';
  planText += `Status: ${statusLabel}\n\n`;
  if (plan.logEntries.length > 0) {
    planText += `Progress Log:\n`;
    [...plan.logEntries].reverse().forEach((entry) => {
      planText += `• [${formatPlanLogDate(entry.ts)}] ${entry.text}\n`;
    });
    planText += `\n`;
  }
  if (plan.outcomeReflection.trim()) {
    planText += `Reflection (what I could say in an interview):\n${plan.outcomeReflection.trim()}\n`;
  }

  try {
    await generateAndDownloadPlanOfAttackDocx({
      activity,
      universitySubject: selectedSuperSubject,
      planText,
    });
  } catch (err) {
    console.error('Plan docx generation failed:', err);
showToast('Failed to create the Word document. Please try again.', 'error');
  }
};

// Generate (first pick) — fetches + caches the full pool, then picks random
const handleGenerateDraftQuestion = useCallback(async () => {
  if (!teamSubject) {
    setTeamError('Please select a subject first.');
    return;
  }
  setTeamError(null);
  const pool = await fetchChallengeQuestionsForSubject(teamSubject);
  if (pool.length === 0) {
    setDraftQuestion('');
    setDraftQuestionPool([]);
    setChallengeQuestionsError(`No questions available yet for ${teamSubject}. Please try another subject.`);
    return;
  }
  setDraftQuestionPool(pool);
  const randomIndex = Math.floor(Math.random() * pool.length);
  setDraftQuestion(pool[randomIndex]);
}, [teamSubject, fetchChallengeQuestionsForSubject]);

// Try Another — re-rolls from the already-cached pool (no extra fetch)
const handleRerollDraftQuestion = useCallback(() => {
  if (draftQuestionPool.length === 0) return;
  if (draftQuestionPool.length === 1) {
    setDraftQuestion(draftQuestionPool[0]);
    return;
  }
  let randomIndex = Math.floor(Math.random() * draftQuestionPool.length);
  // Avoid immediately re-picking the same question when more than one exists
  let attempts = 0;
  while (draftQuestionPool[randomIndex] === draftQuestion && attempts < 10) {
    randomIndex = Math.floor(Math.random() * draftQuestionPool.length);
    attempts++;
  }
  setDraftQuestion(draftQuestionPool[randomIndex]);
}, [draftQuestionPool, draftQuestion]);

// Reset draft question whenever the chosen subject changes (before invite is sent)
useEffect(() => {
  if (!teamTask.task.taskId) {
    setDraftQuestion('');
    setDraftQuestionPool([]);
    setChallengeQuestionsError(null);
  }
}, [teamSubject, teamTask.task.taskId]);

// Track page views for activeSidebarItem
useEffect(() => {
  if (window.gtag) {
    let pageTitle;
    switch (activeSidebarItem) {
      case "back":
        pageTitle = "Back to Dashboard";
        break;
      case "enrich":
        pageTitle = "StudyStyle Profile";
        break;
      case "knowledge":
        pageTitle = "Knowledge Dashboard";
        break;
      case "team":
        pageTitle = "Team Dashboard";
        break;
      default:
        pageTitle = "Enrich+ Dashboard";
    }
    window.gtag('config', 'G-B8RJQ1KWE4', {
      page_path: `/dashboard_enrich/${activeSidebarItem}`,
      page_title: pageTitle,
      user_id: userId, // Optional: Include user ID (ensure GDPR compliance)
    });
  }
}, [activeSidebarItem, userId]);

useEffect(() => {
  if (location.state?.sidebarItem) {
    console.log('Navigation changed sidebar to:', location.state.sidebarItem);
    setActiveSidebarItem(location.state.sidebarItem);

    if (location.state.sidebarItem === 'personalstatement') {
      setShowPersonalStatement(true);
    }

    // ── Deep link from calendar: Knowledge → Free Courses tab, correct subject ──
    if (location.state.sidebarItem === 'knowledge' && location.state.preselectedKnowledgeSubject) {
      setSelectedKnowledgeSubject(location.state.preselectedKnowledgeSubject);
      setKnowledgeTab('freecourse');
      if (location.state.preselectedFreeCourseTitle) {
        setPendingFreeCourseHighlight(location.state.preselectedFreeCourseTitle);
      }
    }

    navigate({ pathname: location.pathname, search: location.search }, { replace: true, state: {} });
  }
}, [location.state, navigate]);

// Scroll to and briefly highlight the specific free course row once it's loaded
useEffect(() => {
  if (!pendingFreeCourseHighlight) return;
  if (activeSidebarItem !== 'knowledge' || knowledgeTab !== 'freecourse') return;
  if (isLoadingKnowledge) return;

  const match = knowledgeResources.some(
    (r) => r.resourceType === 'free-course' && r.resourceTitle === pendingFreeCourseHighlight
  );
  if (!match) return;

  const timer = setTimeout(() => {
    const el = document.querySelector(
      `[data-course-title="${CSS.escape(pendingFreeCourseHighlight)}"]`
    );
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const orig = el.style.backgroundColor;
      el.style.backgroundColor = 'rgba(0,204,153,0.18)';
      setTimeout(() => { el.style.backgroundColor = orig || ''; }, 2200);
    }
    setPendingFreeCourseHighlight(null);
  }, 400);

  return () => clearTimeout(timer);
}, [pendingFreeCourseHighlight, activeSidebarItem, knowledgeTab, isLoadingKnowledge, knowledgeResources]);


// 1. Handle incoming navigation → set subject + remember intent
useEffect(() => {
  if (location.state?.sidebarItem !== "supercurricular") return;

  const {
    preselectedSuperSubject,
    preselectedCategory,
    preselectedActivityId,
    scrollToActivity = false,
  } = location.state;

  if (!preselectedSuperSubject) return;

  console.log("[NAV] Calendar deep-link received", {
    subject: preselectedSuperSubject,
    category: preselectedCategory,
    activityId: preselectedActivityId,
    scroll: scrollToActivity,
  });

  // Store the deep-link intent in state (persistent across renders)
  setDeepLinkIntent({
    subject: preselectedSuperSubject,
    category: preselectedCategory,
    activityId: preselectedActivityId,
    scrollToActivity,
  });

  // Immediately set subject if different (triggers fetch)
  if (preselectedSuperSubject !== selectedSuperSubject) {
    setSelectedSuperSubject(preselectedSuperSubject);
  }

  // Clean location.state immediately so refresh doesn't re-trigger
navigate({ pathname: location.pathname, search: location.search }, { replace: true, state: {} });

}, [location.state, navigate, selectedSuperSubject]);

// 2. New state to hold the "pending" deep-link request
const [deepLinkIntent, setDeepLinkIntent] = useState(null);

// 3. Apply preselection ONCE when activities become available
useEffect(() => {
  if (!deepLinkIntent) return;
  if (supercurricularActivities.length === 0) return;

  const { subject, category, activityId, scrollToActivity } = deepLinkIntent;
setScFilters({ ...SC_DEFAULT_FILTERS }); // make sure the target activity isn't hidden by a filter

  // Safety: only apply if activities match the intended subject
  const matchesSubject = supercurricularActivities.some(
    a => a.university_subject === subject
  );
  if (!matchesSubject) {
    console.warn("[PRESELECT] Activities loaded but wrong subject — ignoring");
    setDeepLinkIntent(null);
    return;
  }

  console.log("[PRESELECT] Activities ready — applying deep link", { subject, category, activityId });

  let targetCategory = category;

  // Infer category if missing
  if (!targetCategory && activityId) {
    const act = supercurricularActivities.find(a => a.supercurricular_id === activityId);
    if (act) targetCategory = act.category;
  }

  // Final fallback
  if (!targetCategory) {
    targetCategory = [...new Set(supercurricularActivities.map(a => a.category))][0] || null;
  }

  if (targetCategory && targetCategory !== selectedCategory) {
    console.log(`[PRESELECT] → Setting category: ${targetCategory}`);
    setSelectedCategory(targetCategory);
  }

  if (activityId) {
    const exists = supercurricularActivities.some(a => a.supercurricular_id === activityId);
    if (exists) {
      console.log(`[PRESELECT] → Setting activity: ${activityId}`);
      setSelectedSuperActivity(activityId);

      // Scroll + highlight with generous delay
      if (scrollToActivity) {
        setTimeout(() => {
          const el = document.querySelector(`[data-activity-id="${activityId}"]`);
          if (el) {
            console.log("[PRESELECT] → Scrolling to:", activityId);
            el.scrollIntoView({ behavior: "smooth", block: "center" });

            const origBg = el.style.backgroundColor;
            el.style.backgroundColor = "rgba(255, 170, 0, 0.28)";
            setTimeout(() => el.style.backgroundColor = origBg || "", 2400);
          } else {
            console.warn("[PRESELECT] Element missing:", `[data-activity-id="${activityId}"]`);
          }
        }, 900); // ← enough time for tabs + list to re-render
      }
    } else {
      console.warn("[PRESELECT] Activity not found:", activityId);
    }
  }

  // Done — clear intent so we don't repeat
  setDeepLinkIntent(null);

}, [
  deepLinkIntent,
  supercurricularActivities,
  selectedCategory,
  selectedSuperSubject,
]);

useEffect(() => {
  if (activeSidebarItem === 'personalstatement') {
    setShowPersonalStatement(true);
  } else {
    setShowPersonalStatement(false);
  }
}, [activeSidebarItem]);

useEffect(() => {
  if (lastInvitationFetchTime) {
    localStorage.setItem(`last_invitation_fetch_${userId}`, lastInvitationFetchTime.toISOString());
  }
}, [lastInvitationFetchTime, userId]);

useEffect(() => {
  if (!teamTask.task.taskId || !userId) return;
  
  // Check if we already have a submitted answer in teamTask
  const submittedAnswer = teamTask.answers.find(
    (answer) => answer.user_id === userId && answer.submitted_at
  );
  
  if (submittedAnswer) {
    // Already submitted - use that
    setTeamAnswer(sanitizeAnswer(submittedAnswer.answer_text));
    setHasSubmittedAnswer(true);
    return;
  }
  
  // Check for locally saved draft
  const savedAnswer = localStorage.getItem(`team_answer_${teamTask.task.taskId}_${userId}`);
  if (savedAnswer) {
    setTeamAnswer(sanitizeAnswer(savedAnswer));
    setHasSubmittedAnswer(false);
  }
}, [teamTask.task.taskId, userId]); 

useEffect(() => {
  if (!teamTask.task.taskId) {
    setHasSubmittedAnswer(false);
    return;
  }
  const answerInTask = teamTask.answers.some(
    (answer) => answer.user_id === userId && answer.submitted_at
  );
  setHasSubmittedAnswer(answerInTask); // Only set to true if answer is submitted to DB
}, [teamTask, userId]);

// Sync userRole and restrictionUntil with localStorage
useEffect(() => {
    localStorage.setItem(`app_role_${userId}`, userRole);
    localStorage.setItem(`restriction_until_${userId}`, restrictionUntil || '');
}, [userRole, restrictionUntil, userId]);

// Add useEffect to fetch user role and restriction status
useEffect(() => {
  if (!userId) return;

  const ROLE_KEY = `app_role_${userId}`;
  const RESTRICTION_KEY = `restriction_until_${userId}`;
  const TIMESTAMP_KEY = `role_cache_timestamp_${userId}`;

  const cachedRole = localStorage.getItem(ROLE_KEY);
  const cachedRestriction = localStorage.getItem(RESTRICTION_KEY);
  const cacheTimestamp = localStorage.getItem(TIMESTAMP_KEY);

  // ── Always use cached role if present — role only changes on user action,
  //    not on a time basis. Only fetch from DB if truly missing. ────────────
  if (cachedRole && cachedRole !== 'user') {
    // Non-default role (inviter/invitee) — always trust cache, no TTL
    setUserRole(cachedRole);
    setRestrictionUntil(cachedRestriction || null);
    console.log("Restored non-default role from cache:", cachedRole);
    return;
  }

  const isCacheFresh = cacheTimestamp && 
    (Date.now() - parseInt(cacheTimestamp)) < 60 * 60 * 1000;

  if (cachedRole && isCacheFresh) {
    setUserRole(cachedRole);
    setRestrictionUntil(cachedRestriction || null);
    console.log("Using login-cached role:", cachedRole);
    return;
  }

  const fetchRole = async () => {
    try {
      const response = await axios.get(`/api/users/${userId}/app_role`, {
        headers: getAuthHeaders(),
      });

      const newRole = response.data.app_role || "user";
const newRestriction = response.data.last_team_participation
  ? new Date(
      new Date(response.data.last_team_participation).getTime() +
      6 * 30 * 24 * 60 * 60 * 1000
    ).toISOString()
  : newRole === 'inviter'
  ? new Date(Date.now() + 6 * 30 * 24 * 60 * 60 * 1000).toISOString() // approximate
  : null;

setUserRole(newRole);
setRestrictionUntil(newRestriction);
localStorage.setItem(ROLE_KEY, newRole);
localStorage.setItem(RESTRICTION_KEY, newRestriction || "");
localStorage.setItem(TIMESTAMP_KEY, Date.now().toString());
    } catch (err) {
      console.error("Fallback role fetch failed:", err.message);
      if (err.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/login");
      }
    }
  };

  fetchRole();
}, [userId, navigate]);


// 1. LOAD checkbox states per subject (when subject changes)
const checkboxStatesLoadedRef = useRef(false);

useEffect(() => {
  checkboxStatesLoadedRef.current = false;
  if (!userId || !selectedKnowledgeSubject) {
    setCheckboxStates({});
    return;
  }

  let cancelled = false;
  (async () => {
    try {
      const data = await getKnowledgeCheckboxes(userId, selectedKnowledgeSubject);
      if (!cancelled) {
        setCheckboxStates(data);
        checkboxStatesLoadedRef.current = true;
        console.log(`✅ Loaded checkbox states for: ${selectedKnowledgeSubject}`);
      }
    } catch (err) {
      console.error("Failed to load knowledge checkbox states:", err);
      if (!cancelled) checkboxStatesLoadedRef.current = true;
    }
  })();
  return () => { cancelled = true; };
}, [userId, selectedKnowledgeSubject]);

// 2. SAVE checkbox states per subject (when they change)
useEffect(() => {
  if (!userId || !selectedKnowledgeSubject || !checkboxStatesLoadedRef.current) return;

  saveKnowledgeCheckboxes(userId, selectedKnowledgeSubject, checkboxStates)
    .then(() => console.log(`💾 Saved checkbox states for: ${selectedKnowledgeSubject}`))
    .catch((err) => console.error("Failed to save knowledge checkbox states:", err));
}, [userId, selectedKnowledgeSubject, checkboxStates]);


// Save personal statement answers
useEffect(() => {
  if (!userId || !personalStatementLoadedRef.current) return;
  savePersonalStatementAnswers(userId, personalStatementAnswers).catch((err) =>
    console.warn("Could not save personal statement answers:", err)
  );
}, [personalStatementAnswers, userId]);

 // Load task-specific timestamp when taskId changes
 useEffect(() => {
  const taskId = teamTask.task.taskId;
  if (!taskId) {
    setCanCheckTask(true);
    setLastFetchTaskDetailsTime(null);
    return;
  }

  const lastFetchTime = localStorage.getItem(`last_fetch_task_details_${userId}_${taskId}`);
  const now = new Date();
  const threeHoursInMs = 3 * 60 * 60 * 1000; // 3 hours in milliseconds

  if (lastFetchTime) {
    const timeSinceLastFetch = now.getTime() - new Date(lastFetchTime).getTime();
    setCanCheckTask(isAdmin || userRole === 'invitee' || timeSinceLastFetch >= threeHoursInMs);
    setLastFetchTaskDetailsTime(new Date(lastFetchTime));
  } else {
    setCanCheckTask(true);
    setLastFetchTaskDetailsTime(null);
  }
}, [teamTask.task.taskId, userId, isAdmin, userRole]);


useEffect(() => {
  if (lastStatusFetchTime) {
    localStorage.setItem(`last_status_fetch_${userId}`, lastStatusFetchTime.toISOString());
  }
}, [lastStatusFetchTime, userId]);

  // useEffect to store teamTask in localStorage when it changes
  useEffect(() => {
    localStorage.setItem(`team_task_${userId}`, JSON.stringify(teamTask));
  }, [teamTask, userId]);

  // useEffect to store inviteLimit in localStorage when it changes
  useEffect(() => {
    localStorage.setItem(`invite_limit_${userId}`, JSON.stringify(inviteLimit));
  }, [inviteLimit, userId]);

  useEffect(() => {
  localStorage.setItem(`pending_invitations_${userId}`, JSON.stringify(pendingInvitations));
}, [pendingInvitations, userId]);

  // useEffect for resetting invitation limit
  useEffect(() => {
    if (inviteLimit.resetTime) {
      const resetTime = new Date(inviteLimit.resetTime).getTime();
      const now = Date.now();
      const timeLeft = resetTime - now;

      if (timeLeft <= 0) {
        const resetLimit = { count: 0, resetTime: null, limitReached: false };
        setInviteLimit(resetLimit);
        localStorage.setItem(`invite_limit_${userId}`, JSON.stringify(resetLimit));
        return;
      }

      const timer = setTimeout(() => {
        const resetLimit = { count: 0, resetTime: null, limitReached: false };
        setInviteLimit(resetLimit);
        localStorage.setItem(`invite_limit_${userId}`, JSON.stringify(resetLimit));
      }, timeLeft);

      return () => clearTimeout(timer);
    }
  }, [inviteLimit.resetTime, userId]);


  // Remove console.logs in production
  if (process.env.NODE_ENV !== "development") {
    console.log = () => {};
  }



  // Initialize session ID for Learning Assessment
 useEffect(() => {
  const initializeSessionId = async () => {
    if (!userId) return;

       const sessionStorageKey = isParentView
      ? `learningSessionId_${effectiveUserId}`
      : "learningSessionId";

    let storedSessionId = localStorage.getItem("learningSessionId");
    let targetSessionId = null;
    let completedSessionId = null;
    let completionDate = null;

    // Check location.state for new session ID
    if (location.state?.learningSessionId && location.state?.justSubmittedLearning) {
      targetSessionId = location.state.learningSessionId;
      setLearningSessionId(targetSessionId);
localStorage.setItem(sessionStorageKey, targetSessionId);
    } else if (storedSessionId) {
      targetSessionId = storedSessionId;
      setLearningSessionId(storedSessionId);
    }

    const CACHE_KEY = `progress_${effectiveUserId}_Learning`;
    let progress;

    // Try to load progress from localStorage
    const cachedProgress = localStorage.getItem(CACHE_KEY);
    if (cachedProgress && !location.state?.justSubmittedLearning) {
      try {
        progress = JSON.parse(cachedProgress);
        if (progress?.lastCompletionDate && progress?.sessionId) {
          console.log("Using cached progress for Learning");
          completedSessionId = progress.sessionId;
          completionDate = progress.lastCompletionDate;
        }
      } catch {
        localStorage.removeItem(CACHE_KEY);
      }
    }

    // Fetch from DB only if no valid cached progress or just submitted
    if (!progress || location.state?.justSubmittedLearning) {
      try {
        progress = await fetchProgress(effectiveUserId, {
          assessmentType: "Learning",
          fetchLatest: true,
        });
        localStorage.setItem(
          CACHE_KEY,
          JSON.stringify({ ...progress, timestamp: Date.now() })
        );
      } catch (err) {
        console.error("Error fetching Learning progress:", err.message);
        setLastCompletedSessionIds({ learning: null });
        setLastCompletionDates({ learning: null });
        setLearningSessionId(null);
        localStorage.removeItem("learningSessionId");
        return;
      }
    }

      // Validate session ID with answers if available — via the Dexie cache
    // (session + TTL validated), never a bare localStorage flag.
    if (progress?.lastCompletionDate && progress?.sessionId) {
      const ANSWER_CACHE_TTL = 90 * 24 * 60 * 60 * 1000; // 90 days
      let answers = null;

      const cachedRow = await getRawAnswers(effectiveUserId, 'Learning');
      const isCorrectSession = cachedRow?.sessionId === progress.sessionId;
      const isFresh = cachedRow && Date.now() - (cachedRow.timestamp || 0) < ANSWER_CACHE_TTL;

      // Only trust the cache when it matches THIS session, is fresh, and
      // is genuinely non-empty — an empty cached array is never treated
      // as a confirmed "no answers" result, only ever as "need to check".
      if (isCorrectSession && isFresh && Array.isArray(cachedRow.data) && cachedRow.data.length > 0) {
        answers = cachedRow.data;
      }

      if (!answers) {
        try {
          const response = await axios.get(
            `/api/assessment/visualizations/${effectiveUserId}`,
            {
              params: { sessionId: progress.sessionId, assessmentType: "Learning" },
              headers: getAuthHeaders(),
            }
          );
          answers = response.data;
          await saveRawAnswers(effectiveUserId, 'Learning', answers, progress.sessionId);
        } catch (err) {
          console.error("Error verifying Learning answers:", err.message);
          localStorage.removeItem("learningSessionId");
          setLearningSessionId(null);
          targetSessionId = null;
        }
      }

      if (Array.isArray(answers) && answers.length > 0) {
        completedSessionId = progress.sessionId;
        completionDate = progress.lastCompletionDate;
        setRawAnswers({ learning: answers }); // keep radar in sync with what we just validated
      } else if (answers !== null) {
        // Only clear the session if a FRESH server fetch genuinely came
        // back empty — never because of a stale/mismatched cache read.
        localStorage.removeItem("learningSessionId");
        setLearningSessionId(null);
        targetSessionId = null;
      }
    }

    if (!targetSessionId && progress?.sessionId && completedSessionId) {
      targetSessionId = progress.sessionId;
      setLearningSessionId(progress.sessionId);
      localStorage.setItem("learningSessionId", progress.sessionId);
    }

    setLastCompletedSessionIds({ learning: completedSessionId });
    setLastCompletionDates({ learning: completionDate || null });
  };

  initializeSessionId();
}, [userId, location.state]);

  
const invitationMenuRef = useRef(null);

useEffect(() => {
  if (teamTask.task.subject && teamTask.invitations.length > 0) {
    setTeamSubject(teamTask.task.subject);
  }
}, [teamTask.task.subject, teamTask.invitations.length]);




// Helper function to calculate expiry
const calculateTimeUntilExpiry = (createdAt) => {
  if (!createdAt) return null;
  const now = new Date();
  const twoMonthsInMs = 6 * 30 * 24 * 60 * 60 * 1000;
  const expiryDate = new Date(new Date(createdAt).getTime() + twoMonthsInMs);
  const timeLeft = expiryDate - now;
  return timeLeft > 0 ? Math.ceil(timeLeft / (24 * 60 * 60 * 1000)) : null;
};

useEffect(() => {
  if (needsFeedbackFetch && teamTask.task.taskId && userRole === "inviter") {
    const fetchFeedback = async () => {
      let retries = 3;
      while (retries > 0) {
        try {
          const taskData = await fetchTaskDetails(teamTask.task.taskId, true);
          if (taskData?.task?.status === "submitted" && taskData?.task?.feedback_text) {
            setNeedsFeedbackFetch(false);
            setHasStoredFeedback(true);
            break;
          }
          await new Promise((resolve) => setTimeout(resolve, 2000)); // Wait 2 seconds
          retries--;
        } catch (err) {
          console.error("Error fetching feedback:", err.message);
          retries--;
        }
      }
      if (retries === 0) {
        setTeamError("Failed to fetch feedback after retries.");
        setNeedsFeedbackFetch(false);
      }
    };
    fetchFeedback();
  }
}, [needsFeedbackFetch, teamTask.task.taskId, userRole]);

useEffect(() => {
  const handleClickOutside = (event) => {
    if (
      showInvitationList &&
      invitationMenuRef.current &&
      !invitationMenuRef.current.contains(event.target)
    ) {
      // Check if click is NOT on the bell buttons (desktop or mobile)
      const mobileBell = document.querySelector(".mobile-notification-bell");
      const desktopBell = document.querySelector(".sidebar-item-enrich .sidebar-icon-notification")?.parentElement;

      const clickedOnBell = 
        (mobileBell && mobileBell.contains(event.target)) ||
        (desktopBell && desktopBell.contains(event.target));

      if (!clickedOnBell) {
        setShowInvitationList(false);
      }
    }
  };

  if (showInvitationList) {
    document.addEventListener("mousedown", handleClickOutside);
    // Also support touch on mobile
    document.addEventListener("touchstart", handleClickOutside);
  }

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
    document.removeEventListener("touchstart", handleClickOutside);
  };
}, [showInvitationList]);

const handleInvitationAction = async (invitationId, action) => {
  if (isProcessingInvitation) return;
  setIsProcessingInvitation(true);

  const invitation = pendingInvitations.find((inv) => inv.invitation_id === invitationId);
  if (!invitation || invitation.status !== 'pending') {
    setInvitationErrors('Invitation not found or already responded');  // String, not object
    setIsProcessingInvitation(false);
    return;
  }

  if (action === "accept") {
    const confirmed = await confirm(
      "Accepting this invite will lock you out of starting a new team challenge or accepting another invite for 6 months, since this is currently in beta.",
      { title: "Accept this invite?", confirmLabel: "Accept" }
    );
    if (!confirmed) {
      setIsProcessingInvitation(false);
      return;
    }

    if (restrictionUntil && new Date() < new Date(restrictionUntil)) {
      setInvitationErrors(
        `You can't accept new invitations until ${new Date(restrictionUntil).toLocaleDateString()}, since you're already part of another team challenge.`
      );
      setIsProcessingInvitation(false);
      return;
    }

    // A student who already started their own challenge can't also join someone else's
    if (userRole === 'inviter') {
      setInvitationErrors("You've already started your own team challenge, so you can't accept an invite to join someone else's.");
      setIsProcessingInvitation(false);
      return;
    }
  }

  const token = localStorage.getItem("token");

  try {
    setInvitationErrors(null);
    const response = await axios.post(
      `/api/invitations/action`,
      { invitationId, action, userId },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    // Removed the delete call for "decline" to preserve the row in DB with status 'declined'

    setPendingInvitations((prev) => {
      const updatedInvitations = prev.filter((inv) => inv.invitation_id !== invitationId);
      localStorage.setItem(`pending_invitations_${userId}`, JSON.stringify(updatedInvitations));
      return updatedInvitations;
    });
    setNotificationCount((prev) => Math.max(0, prev - 1));

    if (action === "accept") {
      const newRole = 'invitee';
      const newRestrictionUntil = new Date(Date.now() + 6 * 30 * 24 * 60 * 60 * 1000).toISOString();

      setUserRole(newRole);
      setRestrictionUntil(newRestrictionUntil);

      // Update database
      await axios.patch(
        `/api/users/${userId}/app_role`,
        {
          app_role: newRole,
          last_team_participation: new Date().toISOString(),
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const taskId = invitation.task_id || response.data.taskId;
      if (taskId) {
        localStorage.removeItem(`last_fetch_task_details_${userId}_${taskId}`);
        setLastFetchTaskDetailsTime(null);
        setCanCheckTask(true);
        await fetchTaskDetails(taskId);
      } else {
        setTeamTask((prev) => {
          const updatedInvitations = [
            ...prev.invitations,
            {
              invitation_id: invitationId,
              invitee_id: userId,
              invitee_email: invitation.invitee_email,
              inviter_id: invitation.inviter_id,
              inviter_email: invitation.inviter_email,
              subject: invitation.subject,
              status: 'accepted',
              task_id: prev.task.taskId || invitation.task_id,
            },
          ];
          const updatedTask = {
            ...prev,
            invitations: updatedInvitations,
            task: {
              ...prev.task,
              taskId: invitation.task_id,
              creatorId: invitation.inviter_id,
              subject: invitation.subject,
              status: 'pending',
            },
          };
          localStorage.setItem(`team_task_${userId}`, JSON.stringify(updatedTask));
          return updatedTask;
        });
        setCanCheckTask(true);
      }
    }
  } catch (err) {
    const errorMessage = err.response?.data?.error || `Failed to ${action} invitation`;
    console.error(`Error processing invitation action (${action}):`, {
      message: errorMessage,
      status: err.response?.status,
      data: err.response?.data,
    });
    if (err.response?.status === 401) {
      localStorage.removeItem("token");
      navigate("/login");
    }
    setInvitationErrors(errorMessage);
  } finally {
    setIsProcessingInvitation(false);
  }
};

  // Update completion status
  useEffect(() => {
  const checkCompletion = async () => {
    if (!userId) return;

    const CACHE_KEY = `progress_${effectiveUserId}_Learning`;
    let progress;

    // Try to load from localStorage first
    const cachedProgress = localStorage.getItem(CACHE_KEY);
    if (cachedProgress && !location.state?.justSubmittedLearning) {
      try {
        progress = JSON.parse(cachedProgress);
        console.log("Using cached progress for completion check");
      } catch {
        localStorage.removeItem(CACHE_KEY);
      }
    }

    // Fetch from DB if no valid cache or just submitted
    if (!progress || location.state?.justSubmittedLearning) {
      try {
        progress = await fetchProgress(effectiveUserId, {
          assessmentType: "Learning",
          sessionId: learningSessionId || undefined,
          fetchLatest: !learningSessionId,
        });
        localStorage.setItem(
          CACHE_KEY,
          JSON.stringify({ ...progress, timestamp: Date.now() })
        );
      } catch (err) {
        console.error("Error fetching Learning progress:", err.message);
        setCompletionStatus((prev) => ({ ...prev, learning: false }));
        setLastCompletionDates({ learning: null });
        setLastCompletedSessionIds({ learning: null });
        return;
      }
    }

    const lastCompletionDate = progress?.lastCompletionDate;
    const fetchedSessionId = progress?.sessionId;

     let isFullyCompleted = false;
    if (lastCompletionDate && fetchedSessionId) {
      const ANSWER_CACHE_TTL = 90 * 24 * 60 * 60 * 1000; // 90 days
      let answers = null;
      let fetchFailed = false;

      const cachedRow = await getRawAnswers(effectiveUserId, 'Learning');
      const isCorrectSession = cachedRow?.sessionId === fetchedSessionId;
      const isFresh = cachedRow && Date.now() - (cachedRow.timestamp || 0) < ANSWER_CACHE_TTL;

      if (isCorrectSession && isFresh && Array.isArray(cachedRow.data) && cachedRow.data.length > 0) {
        answers = cachedRow.data;
      }

      if (!answers) {
        try {
          const response = await axios.get(
            `/api/assessment/visualizations/${effectiveUserId}`,
            {
              params: { sessionId: fetchedSessionId, assessmentType: "Learning" },
              headers: getAuthHeaders(),
            }
          );
          answers = response.data;
          await saveRawAnswers(effectiveUserId, 'Learning', answers, fetchedSessionId);
        } catch (err) {
          console.error("Error fetching Learning answers:", err.message);
          fetchFailed = true; // network error — don't treat as "confirmed empty"
        }
      }

      isFullyCompleted = Array.isArray(answers) && answers.length > 0;

      if (isFullyCompleted) {
        setRawAnswers({ learning: answers });
      } else if (!fetchFailed) {
        // Only remove the session when a genuine, fresh server response
        // came back with zero answers — never on a network failure or a
        // stale/mismatched cache miss.
        localStorage.removeItem("learningSessionId");
      }
    }

  let canRetake = true;
if (lastCompletionDate && !isAdmin) {
  try {
    const sixMonthsInMs = 6 * 30 * 24 * 60 * 60 * 1000;
    const timeSinceLast = Date.now() - new Date(lastCompletionDate).getTime();
    canRetake = timeSinceLast >= sixMonthsInMs;
  } catch (err) {
    console.error("Invalid Learning lastCompletionDate:", err);
    canRetake = true;
  }
}

    if (isFullyCompleted && fetchedSessionId) {
      setLastCompletedSessionIds({ learning: fetchedSessionId });
      setLearningSessionId(fetchedSessionId);
      localStorage.setItem("learningSessionId", fetchedSessionId);
    }

    setCompletionStatus((prev) => ({
      ...prev,
      learning: !canRetake,
    }));
    setLastCompletionDates({ learning: lastCompletionDate || null });
  };

  checkCompletion();
}, [userId, isAdmin, learningSessionId, location.state]);


  // Fetch raw answers for Learning assessment
useEffect(() => {
  const CACHE_TTL = 90 * 24 * 60 * 60 * 1000; // 90 days

  const fetchLearningRawAnswers = debounce(async () => {
    if (!userId || !lastCompletedSessionIds.learning) {
      setLoading({ learningVisualizations: false });
      setError({ learningVisualizations: "" });
      setRawAnswers({ learning: [] });
      return;
    }

    let answers;

    // Try cache first — must match BOTH freshness (TTL) AND the current session.
    // A mismatch means a retake happened since this row was cached.
    const cachedRow = await getRawAnswers(effectiveUserId, 'Learning');
    const isCorrectSession = cachedRow?.sessionId === lastCompletedSessionIds.learning;

    if (cachedRow && isCorrectSession && !location.state?.justSubmittedLearning) {
      const cacheAge = Date.now() - (cachedRow.timestamp || 0);
      if (cacheAge < CACHE_TTL) {
        answers = cachedRow.data;
        setRawAnswers({ learning: answers });
        setLoading({ learningVisualizations: false });
        setError({ learningVisualizations: null });
        console.log("Using cached raw answers for Learning");
        return;
      }
    }

    // Fetch from DB if no valid cache, wrong session, or just submitted
    try {
      answers = await fetchRawAnswers(effectiveUserId, lastCompletedSessionIds.learning, "Learning");
      answers = Array.isArray(answers) ? answers : [];
      await saveRawAnswers(effectiveUserId, 'Learning', answers, lastCompletedSessionIds.learning);

      setRawAnswers({ learning: answers });
      setLoading({ learningVisualizations: false });
      setError({ learningVisualizations: null });
    } catch (err) {
      console.error("fetchLearningRawAnswers: Error:", err.message);
      setError({ learningVisualizations: err.message });
      setLoading({ learningVisualizations: false });
      setRawAnswers({ learning: [] });
      if (err.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/login");
      }
    }
  }, 300);

  if (
    (lastCompletionDates.learning ||
      location.state?.justSubmittedLearning ||
      location.state?.fromLearningScores) &&
    lastCompletedSessionIds.learning
  ) {
    fetchLearningRawAnswers();
  } else {
    setLoading({ learningVisualizations: false });
    setError({ learningVisualizations: "" });
  }
}, [
  userId,
  navigate,
  location.state?.justSubmittedLearning,
  location.state?.fromLearningScores,
  lastCompletionDates.learning,
  lastCompletedSessionIds.learning,
]);

  // Memoize visualizations
  const learningVisualizations = useMemo(
    () => rawAnswers.learning.length ? processRawAnswers(rawAnswers.learning, "Learning") : null,
    [rawAnswers.learning]
  );

  useEffect(() => {
  if (learningVisualizations && effectiveUserId) {
    localStorage.setItem(
      `visualizations_${effectiveUserId}_Learning`,
      JSON.stringify(learningVisualizations)
    );
  }
}, [learningVisualizations, effectiveUserId]);

const forceLoadStudyStyleForPDF = async () => {
  if (!userId || !lastCompletedSessionIds.learning) {
    console.warn("[PDF force load] Missing userId or session ID");
    return false;
  }

  // Step 1: Try cache first (even if old — better than nothing for PDF).
  // For PDF purposes we don't reject on session mismatch — any cached
  // Learning data is preferable to none — but we do prefer a session match.
  let answers = null;
  const cachedRow = await getRawAnswers(effectiveUserId, 'Learning');
  if (cachedRow?.data?.length > 0) {
    console.log("[PDF force load] → Using cached answers (possibly stale)");
    answers = cachedRow.data;
    setRawAnswers({ learning: answers });
    return true;
  }

  // Step 2: Fetch fresh from server if cache didn't help
  try {
    console.log("[PDF force load] → Fetching fresh StudyStyle answers");
    const freshAnswers = await fetchRawAnswers(
      effectiveUserId,
      lastCompletedSessionIds.learning,
      "Learning"
    );

    if (Array.isArray(freshAnswers) && freshAnswers.length > 0) {
      answers = freshAnswers;
      await saveRawAnswers(effectiveUserId, 'Learning', answers, lastCompletedSessionIds.learning);
      setRawAnswers({ learning: answers });
      console.log("[PDF force load] → Success — fresh data loaded");
      return true;
    }
  } catch (err) {
    console.error("[PDF force load] Fetch failed:", err);
  }

  console.warn("[PDF force load] → No usable StudyStyle data found");
  return false;
};

useEffect(() => {
  const isStudyStyleCompleted = 
    !!lastCompletedSessionIds.learning && 
    rawAnswers.learning?.length > 0 && 
    !!learningVisualizations;

  setCompletedAssessments(prev => {
    // Only update if actually changed → prevents unnecessary renders
    if (prev.studystyle === isStudyStyleCompleted) return prev;
    return {
      ...prev,
      studystyle: isStudyStyleCompleted
    };
  });

  // Optional: also persist this flag so parent can read it reliably
  if (isStudyStyleCompleted) {
    localStorage.setItem(`assessment_completed_studystyle_${userId}`, "true");
  }
}, [
  lastCompletedSessionIds.learning, 
  rawAnswers.learning, 
  learningVisualizations, 
  userId
]);

  // Combine radar data
  const combineRadarData = () => {
    const radarKeys = [
      { key: "sensoryModalityPreferences", label: "Sensory Modality Preferences", fill: "rgba(45, 212, 191, 0.22)", border: "rgba(45, 212, 191, 1)" },
      { key: "socialEnvironmentalLearning", label: "Social & Environmental Learning", fill: "rgba(255, 159, 64, 0.2)", border: "rgba(255, 159, 64, 1)" },
      { key: "selfRegulationMetacognition", label: "Self-Regulation & Metacognition", fill: "rgba(255, 99, 132, 0.2)", border: "rgba(255, 99, 132, 1)" },
      { key: "motivationalAffectiveDispositions", label: "Motivational & Affective Dispositions", fill: "rgba(56, 161, 255, 0.2)", border: "rgba(56, 161, 255, 1)" },
      { key: "cognitiveStyleThinkingDisposition", label: "Cognitive Style & Thinking Disposition", fill: "rgba(255, 206, 86, 0.2)", border: "rgba(255, 206, 86, 1)" },
    ];

    // First pass: union of every facet label across all groups, and stash
    // each group's raw data so datasets can be built against the FINAL
    // label set (previously each dataset was built against allLabels as it
    // stood at that point in the loop, so earlier datasets ended up shorter
    // than later ones — Chart.js was silently misaligning them).
    const allLabels = [];
    const rawByGroup = {};
    radarKeys.forEach(({ key }) => {
      const data = learningVisualizations[key];
      if (data?.labels && data?.datasets?.[0]?.data) {
        rawByGroup[key] = data;
        data.labels.forEach((lbl) => { if (!allLabels.includes(lbl)) allLabels.push(lbl); });
      }
    });

    const datasets = [];
    const facetNotesMap = {};
    const facetsByGroup = {}; // groupKey -> Set of facet labels belonging to that group only

    radarKeys.forEach(({ key, label, fill, border }) => {
      const data = rawByGroup[key];
      if (!data) return;

      facetsByGroup[key] = new Set(data.labels);
      data.labels.forEach((lbl) => {
        if (data?.facetNote?.[lbl]) facetNotesMap[lbl] = data.facetNote[lbl];
      });

      datasets.push({
        label,
        groupKey: key,
        data: allLabels.map((lbl) => {
          const index = data.labels.indexOf(lbl);
          return index !== -1 ? data.datasets[0].data[index] : 0;
        }),
        backgroundColor: fill,
        borderColor: border,
        borderWidth: 2.5,
        pointBackgroundColor: border,
        pointBorderColor: "#0a0f1f",
        pointBorderWidth: 1.5,
        pointRadius: 3,
        pointHoverRadius: 5,
        tension: 0.1,
        fill: true,
      });
    });

    return { labels: allLabels, datasets, notesMap: facetNotesMap, facetsByGroup };
  };

const constructStrategyPrompt = useCallback(() => {
  if (!learningVisualizations) return null;

  let profile = '';
  const keys = Object.keys(learningVisualizations);
  for (const key of keys) {
    const viz = learningVisualizations[key];
    if (viz?.labels && viz?.datasets?.[0]?.data) {
      profile += `${viz.datasets[0].label}:\n`;
      for (let i = 0; i < viz.labels.length; i++) {
        profile += `  - ${viz.labels[i]}: ${viz.datasets[0].data[i].toFixed(1)}/5\n`;
      }
      profile += '\n';
    }
  }

return `You are a learning strategy expert. Based on this user's StudyStyle assessment profile:

${profile}

Create a personalized learning strategy to help them optimize their study habits, including specific techniques, resources, and daily routines tailored to their strengths and weaknesses. Make it actionable and engaging for a high school student preparing for university.`;
}, [learningVisualizations]);

    const [profileMatchesByGroup, setProfileMatchesByGroup] = useState({});
  const [loadingProfileMatches, setLoadingProfileMatches] = useState(false);

useEffect(() => {
  if (!learningVisualizations) {
    setProfileMatchesByGroup({});
    return;
  }
  let cancelled = false;
  setLoadingProfileMatches(true);

  (async () => {
    const cacheUserId = effectiveUserId || userId;

    const results = {};
    for (const { key, label } of STUDY_RADAR_KEYS) {
      const chart = learningVisualizations[key];
      if (!chart?.labels?.length || !chart?.datasets?.[0]?.data?.length) continue;
      try {
        const groupData = await loadProfileGroupByName(label, getAuthHeaders(), {
          cacheGet: getProfileGroupCache,
          cacheSet: saveProfileGroupCache,
        });
        if (!groupData) continue;
        results[key] = computeProfileMatches(
          chart.labels,
          chart.datasets[0].data,
          groupData.facets,
          groupData.profiles
        );
      } catch (err) {
        console.warn(`Could not load profile matches for "${label}":`, err);
      }
    }

    if (!cancelled) {
      setProfileMatchesByGroup(results);
      setLoadingProfileMatches(false);

      if (cacheUserId && Object.keys(results).length > 0) {
        saveProfileMatchesCache(cacheUserId, 'study', results).catch((e) =>
          console.warn('Could not cache study profile matches:', e)
        );
      }
    }
  })();

  return () => { cancelled = true; };
}, [learningVisualizations, effectiveUserId, userId]);


// Updated generateStrategy function (replace existing in dashboard_enrich.js)
const generateStrategy = async () => {
  if (!userId) {
    setStrategyError('User not authenticated. Please log in.');
    return;
  }

  if (!learningVisualizations) {
    setStrategyError('Complete the StudyStyle assessment to generate strategy.');
    return;
  }

  setIsGeneratingStrategy(true);
  setStrategyError(null);

  try {
    const prompt = constructStrategyPrompt();
    if (!prompt) {
      throw new Error('Invalid prompt: empty or malformed');
    }

    console.log('Sending payload to backend:', { userId, prompt });

    const response = await axios.post(
      '/api/strategy/generate',
      { userId, payload: { prompt } },  // Wrap prompt in payload object
      {
        headers: getAuthHeaders(),
        timeout: 60000,
      }
    );

    console.log('Backend response:', response.data);

    const { strategy: fetchedStrategy, generationDate, fromCache, message } = response.data;

    if (!fetchedStrategy) {
      throw new Error('Invalid or empty response from backend');
    }

// Cache locally regardless of source
    await saveStrategyCache(userId, 'self', fetchedStrategy, generationDate);

    setStrategy(fetchedStrategy);
    setLastStrategyGenerationDate(generationDate);

    // Show message if from cache
    if (fromCache && message) {
      setStrategyError(message); // Soft info message, not an error
    } else {
      setStrategyError(null);
    }

    if (window.gtag) {
      window.gtag('event', 'generate_strategy_success', {
        event_category: 'Dashboard',
        event_label: fromCache ? 'Fetch Cached Strategy Succeeded' : 'Generate Strategy Succeeded',
        user_id: userId,
        session_id: learningSessionId,
        from_cache: fromCache,
      });
    }
  } catch (err) {
    console.error('Error generating strategy:', {
      message: err.message,
      status: err.response?.status,
      data: err.response?.data,
    });

    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      navigate('/login');
    } else if (err.response?.status === 429) {
      // xAI-specific rate limit (not user restriction)
      setStrategyError(`Rate limit exceeded. Please wait a few minutes and try again. (${err.response.data.error})`);
    } else {
      setStrategyError(`Failed to generate strategy: ${err.message}`);
    }

    if (window.gtag) {
      window.gtag('event', 'generate_strategy_failure', {
        event_category: 'Dashboard',
        event_label: 'Generate Strategy Failed',
        user_id: userId,
        error_message: err.message,
        status: err.response?.status,
      });
    }
  } finally {
    setIsGeneratingStrategy(false);
  }
};

// Add new useEffect hook (after existing useEffects, e.g., after the insights fetch useEffect)
useEffect(() => {
  if (activeSidebarItem !== "strategy") return;
  let cancelled = false;

  (async () => {
    // ── Parent View ──────────────────────
    if (isParentView) {
      const cachedRow = await getStrategyCache(effectiveUserId, 'parent_view');
      if (cancelled) return;
      if (cachedRow) {
        setStrategy(cachedRow.strategy);
        setLastStrategyGenerationDate(cachedRow.generationDate);
      } else {
        setStrategy(null);
        setLastStrategyGenerationDate(null);
      }
      return;
    }

    // ── Student View ──────────────────────
    const cachedRow = await getStrategyCache(userId, 'self');
    if (cancelled) return;
    if (cachedRow?.strategy && cachedRow?.generationDate) {
      setStrategy(cachedRow.strategy);
      setLastStrategyGenerationDate(cachedRow.generationDate);
    } else {
      setStrategy(null);
      setLastStrategyGenerationDate(null);
    }
  })();

  return () => { cancelled = true; };
}, [activeSidebarItem, effectiveUserId, isParentView, userId]);

// PDF generator still expects facet notes as plain strings.
// Radar pipeline now stores { general, level, levelKey } — flatten for export.
const flattenFacetNoteForPdf = (note) => {
  if (!note) return null;
  if (typeof note === 'string') return note.trim() || null;
  const general = note.general && String(note.general).trim();
  const level = note.level && String(note.level).trim();
  if (general && level) return `${general}\n\n${level}`;
  return general || level || null;
};

const normalizeVisualizationsForPdf = (vis) => {
  if (!vis || typeof vis !== 'object') return vis;

  const normalizeChart = (chart) => {
    if (!chart) return chart;

    const facetNoteMap =
      chart.facetNote && typeof chart.facetNote === 'object' && !Array.isArray(chart.facetNote)
        ? Object.fromEntries(
            Object.entries(chart.facetNote).map(([k, v]) => [k, flattenFacetNoteForPdf(v)])
          )
        : chart.facetNote;

    const datasets = Array.isArray(chart.datasets)
      ? chart.datasets.map((ds) => ({
          ...ds,
          facetNote: Array.isArray(ds.facetNote)
            ? ds.facetNote.map(flattenFacetNoteForPdf)
            : ds.facetNote && typeof ds.facetNote === 'object' && !Array.isArray(ds.facetNote)
              ? Object.fromEntries(
                  Object.entries(ds.facetNote).map(([k, v]) => [k, flattenFacetNoteForPdf(v)])
                )
              : flattenFacetNoteForPdf(ds.facetNote),
        }))
      : chart.datasets;

    return { ...chart, datasets, facetNote: facetNoteMap };
  };

  return Object.fromEntries(
    Object.entries(vis).map(([key, chart]) => [key, normalizeChart(chart)])
  );
};

const SUBJECT_FACETS_CACHE_TTL = 90 * 24 * 60 * 60 * 1000; // 90 days

const fetchChosenSubjectFacetNote = async (subject) => {
  if (!subject) return null;

  try {
    const cached = await getSubjectFacetsCache();
    if (cached?.data && Date.now() - cached.timestamp < SUBJECT_FACETS_CACHE_TTL) {
      const match = cached.data.find((f) => f.facet === subject);
      if (match) return match.facet_note || null;
    }
  } catch (e) {
    console.warn('Could not read subject facets cache from Dexie', e);
  }

  try {
    const response = await axios.get('/api/questions/facets');
    const allFacets = response.data || [];
    await saveSubjectFacetsCache(allFacets);
    const match = allFacets.find((f) => f.facet === subject);
    return match?.facet_note || null;
  } catch (e) {
    console.warn('Could not fetch subject facets for PDF facet note', e);
    return null;
  }
};

const handleDownloadFullReportFromEnrich = async () => {
  await new Promise(resolve => setTimeout(resolve, 400));

  const name = isParentView
    ? viewingChildName
    : (localStorage.getItem("userUsername") ||
       localStorage.getItem("userEmail")?.split("@")[0] ||
       "Student");

  // ── Insights ──
  let insightsFromStorage = '';
  if (isParentView && viewingChildId) {
    try {
      const raw = localStorage.getItem(`child_insights_${viewingChildId}`);
      insightsFromStorage = raw ? (JSON.parse(raw).insights || '') : '';
    } catch { insightsFromStorage = ''; }
    if (!insightsFromStorage) {
      insightsFromStorage =
        localStorage.getItem(`insights_${effectiveUserId}`) ||
        localStorage.getItem(`insights_${viewingChildId}`) || '';
    }
  } else {
    insightsFromStorage =
      localStorage.getItem(`insights_${userId}`) ||
      localStorage.getItem(`insights_${effectiveUserId}`) || '';
  }

 // ── Strategy ──
  let strategyFromStorage = '';
  if (isParentView && viewingChildId) {
    const parentRow = await getStrategyCache(effectiveUserId, 'parent_view');
    strategyFromStorage = parentRow?.strategy || '';
  } else {
    const selfRow = await getStrategyCache(userId, 'self');
    strategyFromStorage = selfRow?.strategy || '';
  }

   // ── Try to recover FULL subject lists from localStorage ────────────────
    let pdfSortedScores     = fullSortedScoresFromNav.length > 0
      ? fullSortedScoresFromNav
      : sortedScores;               // ← fallback to what was already there

    let pdfSortedPart3Scores = fullSortedPart3ScoresFromNav.length > 0
      ? fullSortedPart3ScoresFromNav
      : sortedPart3Scores;          // ← fallback to what was already there

  // ── Final fallback: try to recover full lists from cache ────────
    if (pdfSortedScores.length === 0) {
      const cachedRow = await getRawAnswers(effectiveUserId, 'Subject');
      if (cachedRow) {
        try {
          const answers = Array.isArray(cachedRow.data) ? cachedRow.data : [];
          const partII = answers.filter(a => a.category === "Part II");

          const facetMap = partII.reduce((acc, a) => {
            const f = a.facet || "Unknown";
            if (!acc[f]) {
              acc[f] = {
                scores: [],
                facet_note: a.facet_note || null,
                low_note: a.low_note || null,
                mid_note: a.mid_note || null,
                high_note: a.high_note || null,
              };
            }
            acc[f].scores.push(a.score);
            return acc;
          }, {});

          pdfSortedScores = Object.entries(facetMap)
            .map(([facet, data]) => {
              const avg = data.scores.reduce((sum, s) => sum + s, 0) / data.scores.length;
              return {
                _id: facet,
                averageScore: avg,
                facetNote: buildFacetNoteData(data.facet_note, data.low_note, data.mid_note, data.high_note, avg),
              };
            })
            .sort((a, b) => b.averageScore - a.averageScore);
        } catch {}
      }
    }

   if (pdfSortedPart3Scores.length === 0) {
      const cachedRow = await getRawAnswers(effectiveUserId, 'SubjectPart3');
      if (cachedRow) {
        try {
          const answers = Array.isArray(cachedRow.data) ? cachedRow.data : [];
          const partIII = answers.filter(a => a.category === "Part III");

          const facetMap = partIII.reduce((acc, a) => {
            const f = a.facet || "Unknown";
            if (!acc[f]) acc[f] = { scores: [] };
            acc[f].scores.push(a.score);
            return acc;
          }, {});

          pdfSortedPart3Scores = Object.entries(facetMap)
            .map(([facet, data]) => ({
              _id: facet,
              averageScore: data.scores.reduce((sum, s) => sum + s, 0) / data.scores.length,
            }))
            .sort((a, b) => b.averageScore - a.averageScore);
        } catch {}
      }
    }


  // ── Career visualizations ──
let resolvedCareerVis = null;
try {
  const cached = localStorage.getItem(`visualizations_${effectiveUserId}_Career`);
  if (cached) resolvedCareerVis = JSON.parse(cached);
} catch {}

// ── Fallback: rebuild from raw Career answers ──
if (!resolvedCareerVis) {
  try {
    const cachedRow = await getRawAnswers(effectiveUserId, 'Career');
    if (cachedRow) {
      const answers = Array.isArray(cachedRow.data) ? cachedRow.data : [];
      if (answers.length > 0) {

        const createRadarData = (filteredAnswers, label, bgColor, borderColor) => {
          const facetMap = filteredAnswers.reduce((acc, a) => {
            const f = a.facet || 'Unknown';
            if (!acc[f]) {
              acc[f] = {
                scores: [],
                facet_note: a.facet_note || null,
                low_note: a.low_note || null,
                mid_note: a.mid_note || null,
                high_note: a.high_note || null,
              };
            }
            acc[f].scores.push(a.score);
            return acc;
          }, {});
          const labels = Object.keys(facetMap);
          const avgByFacet = Object.fromEntries(
            labels.map(f => [f, facetMap[f].scores.reduce((s, v) => s + v, 0) / facetMap[f].scores.length])
          );
          const facetNoteMap = Object.fromEntries(
            labels.map(f => {
              const d = facetMap[f];
              return [f, buildFacetNoteData(d.facet_note, d.low_note, d.mid_note, d.high_note, avgByFacet[f])];
            })
          );
          return {
            labels,
            datasets: [{
              label,
              data: labels.map(f => avgByFacet[f]),
              totalScores: labels.map(f =>
                facetMap[f].scores.reduce((s, v) => s + v, 0)
              ),
              facetNote: labels.map(f => facetNoteMap[f] || null),
              backgroundColor: bgColor,
              borderColor: borderColor,
              borderWidth: 1,
            }],
            facetNote: facetNoteMap,
          };
        };

        const careerInterest = answers.filter(a =>
          a.sub_category === 'Career Interests & Personality'
        );
        const valuesWorkPreferences = answers.filter(a =>
          a.sub_category === 'Working Preferences & Values'
        );
        const motivationAnswers = answers.filter(a =>
          a.sub_category === 'Intrinsic vs. Extrinsic Motivation'
        );
        const bigFive = answers.filter(a =>
          a.sub_category === 'Big Five Personality Traits'
        );
        const emotionalIntelligence = answers.filter(a =>
          a.sub_category === 'Emotional Intelligence'
        );

        const intrinsicScores = motivationAnswers.filter(a => a.facet === 'Intrinsic Motivation');
        const extrinsicScores = motivationAnswers.filter(a => a.facet === 'Extrinsic Motivation');

   const intrinsicAvg = intrinsicScores.reduce((s, a) => s + a.score, 0) / (intrinsicScores.length || 1);
        const extrinsicAvg = extrinsicScores.reduce((s, a) => s + a.score, 0) / (extrinsicScores.length || 1);
        const intrinsicNote = buildFacetNoteData(
          intrinsicScores[0]?.facet_note, intrinsicScores[0]?.low_note,
          intrinsicScores[0]?.mid_note, intrinsicScores[0]?.high_note, intrinsicAvg
        );
        const extrinsicNote = buildFacetNoteData(
          extrinsicScores[0]?.facet_note, extrinsicScores[0]?.low_note,
          extrinsicScores[0]?.mid_note, extrinsicScores[0]?.high_note, extrinsicAvg
        );

        resolvedCareerVis = {
          careerInterest: createRadarData(
            careerInterest,
            'Career Interest',
            'rgba(75, 192, 192, 0.2)',
            'rgba(75, 192, 192, 1)'
          ),
          valuesWorkPreferences: createRadarData(
            valuesWorkPreferences,
            'Working Preferences & Values',
            'rgba(255, 206, 86, 0.2)',
            'rgba(255, 206, 86, 1)'
          ),
          motivation: {
            labels: ['Intrinsic Motivation', 'Extrinsic Motivation'],
            datasets: [{
              label: 'Motivation Scores',
              data: [intrinsicAvg, extrinsicAvg],
              totalScores: [
                intrinsicScores.reduce((s, a) => s + a.score, 0),
                extrinsicScores.reduce((s, a) => s + a.score, 0),
              ],
              facetNote: [intrinsicNote, extrinsicNote],
              backgroundColor: ['rgba(54, 162, 235, 0.4)', 'rgba(255, 99, 132, 0.4)'],
              borderColor: ['rgba(54, 162, 235, 1)', 'rgba(255, 99, 132, 1)'],
              borderWidth: 1,
            }],
            facetNote: {
              'Intrinsic Motivation': intrinsicNote,
              'Extrinsic Motivation': extrinsicNote,
            },
          },
          bigFive: createRadarData(
            bigFive,
            'Big Five Personality Traits',
            'rgba(54, 162, 235, 0.2)',
            'rgba(54, 162, 235, 1)'
          ),
          emotionalIntelligence: createRadarData(
            emotionalIntelligence,
            'Emotional Intelligence',
            'rgba(255, 99, 132, 0.2)',
            'rgba(255, 99, 132, 1)'
          ),
        };

        console.log("[PDF Dashboard] → Rebuilt careerVisualizations from raw answers");
      }
    }
  } catch (err) {
    console.warn("[PDF Dashboard] Could not rebuild career visualizations", err);
  }
}

 // ── StudyStyle visualizations ──
  let recoveredLearningVis = learningVisualizations || null;
  if (!recoveredLearningVis) {
    try {
      const cached = localStorage.getItem(`visualizations_${effectiveUserId}_Learning`);
      if (cached) recoveredLearningVis = JSON.parse(cached);
    } catch {}
  }
  if (!recoveredLearningVis) {
    try {
      const cachedRow = await getRawAnswers(effectiveUserId, 'Learning');
      if (cachedRow?.data?.length > 0) {
        recoveredLearningVis = processRawAnswers(cachedRow.data, "Learning");
      }
    } catch {}
  }

    // ── Build final PDF payload ─────────────────────────────────────
const cacheUserId = effectiveUserId || userId;

  let chosenTopSubjectReason = null;
  if (chosenTopSubject) {
    try {
      const allReasons = await getSubjectReasons(effectiveUserId);
      chosenTopSubjectReason = allReasons?.[chosenTopSubject] || null;
    } catch (e) {
      console.warn('Could not load subject reason for PDF', e);
    }
  }

const chosenTopSubjectFacetNote = await fetchChosenSubjectFacetNote(chosenTopSubject);


const pdfData = {
  userName: name,
  sortedScores: pdfSortedScores,
  sortedPart3Scores: pdfSortedPart3Scores,
  careerVisualizations: resolvedCareerVis,
  learningVisualizations: recoveredLearningVis || null,
  insights: insightsFromStorage || '',
  strategy: strategy || strategyFromStorage || '',
  userId,
  viewingChildId: isParentView ? viewingChildId : null,

  // Live study matches from this page
  studyProfileMatches: profileMatchesByGroup || {},
  // FutureReady / career — filled from Dexie below
  careerProfileMatches: {},
  chosenTopSubject: chosenTopSubject || null,
  chosenTopSubjectReason,
  chosenTopSubjectFacetNote,
};

// Load FutureReady (career) profile matches cached by CareerDashboard
try {
  if (cacheUserId) {
    const careerRow = await getProfileMatchesCache(cacheUserId, 'career');
    if (careerRow?.matches) {
      pdfData.careerProfileMatches = careerRow.matches;
    }
  }
} catch (e) {
  console.warn('Could not load career profile matches for PDF', e);
}

// Keep study cache warm so CareerDashboard can read it later
if (cacheUserId && pdfData.studyProfileMatches && Object.keys(pdfData.studyProfileMatches).length) {
  saveProfileMatchesCache(cacheUserId, 'study', pdfData.studyProfileMatches).catch(console.warn);
}

    // ── Debug: show exactly what we're sending to PDF ───────────────
    console.log("PDF subjects count →", {
      part2: pdfData.sortedScores.length,
      part3: pdfData.sortedPart3Scores.length,
      source: 
        fullSortedScoresFromNav.length > 0     ? "full list passed from dashboard" :
        pdfSortedScores.length > sortedScores.length     ? "recovered from Subject cache" :
        "fallback (top-N or empty)",
      sourcePart3: 
        fullSortedPart3ScoresFromNav.length > 0 ? "full list passed from dashboard" :
        pdfSortedPart3Scores.length > sortedPart3Scores.length ? "recovered from SubjectPart3 cache" :
        "fallback (top-N or empty)"
    });

  const hasAnyData =
    pdfData.sortedScores.length > 0 ||
    pdfData.sortedPart3Scores.length > 0 ||
    pdfData.careerVisualizations ||
    pdfData.learningVisualizations ||
    pdfData.insights?.trim() ||
    pdfData.strategy?.trim();

  if (!hasAnyData) {
    showToast(
      "No assessment data found. Complete UniReady, StudyStyle, or FutureReady first, then try again.",
      "error", 5000
    );
    return;
  }

  try {
    const { generateFullReport } = await import('../../utils/generateFullReport');
    await generateFullReport(pdfData);
  } catch (err) {
    console.error("PDF generation failed:", err);
    console.error("PDF payload snapshot:", {
      hasCareer: !!pdfData.careerVisualizations,
      careerKeys: pdfData.careerVisualizations ? Object.keys(pdfData.careerVisualizations) : [],
      hasLearning: !!pdfData.learningVisualizations,
      scores: pdfData.sortedScores?.length,
      part3: pdfData.sortedPart3Scores?.length,
      insightsLen: (pdfData.insights || '').length,
      strategyLen: (pdfData.strategy || '').length,
    });
    showToast(
      `Failed to create PDF${err?.message ? `: ${err.message}` : '. Please try again.'}`,
      "error",
      6000
    );
  }
};

const renderStrategyPage = () => {
  const hasCompletedAssessment = !!learningVisualizations;
  const sixMonthsInMs = 6 * 30 * 24 * 60 * 60 * 1000;
  const isWithinSixMonths = lastStrategyGenerationDate && (Date.now() - new Date(lastStrategyGenerationDate).getTime()) < sixMonthsInMs;

  // Function to parse markdown bold text and convert to HTML (reuse or copy from insights)
  const parseBoldText = (text) => {
    if (!text || typeof text !== 'string') {
      return text;
    }

    // Split into lines to handle multi-line content
    const lines = text.split('\n');
    const elements = lines.map((line, lineIndex) => {
      // Trim the line for processing
      const trimmed = line.trim();

      // Check if it's an H3 heading
      if (trimmed.startsWith('### ')) {
        // Extract content after '### '
        const content = trimmed.substring(4); // '### ' is 4 chars
        // Parse bold on the heading content
        const boldParts = content.split(/\*\*(.*?)\*\*/g);
        const headingContent = boldParts.map((part, index) => {
          if (index % 2 === 1) {
            return <strong key={`${lineIndex}-bold-${index}`}>{part}</strong>;
          }
          return part;
        });
        // Return as JSX <h3> with bold-parsed content (no extra bold on the tag itself)
        return <h5 style={{color: '#40b3ffff'}} key={`heading-${lineIndex}`}>{headingContent}</h5>;
      }

           if (trimmed.startsWith('####')) {
        // Extract content after '#### '
        const content = trimmed.substring(5); // '### ' is 4 chars
        // Parse bold on the heading content
        const boldParts = content.split(/\*\*(.*?)\*\*/g);
        const headingContent = boldParts.map((part, index) => {
          if (index % 2 === 1) {
            return <strong key={`${lineIndex}-bold-${index}`}>{part}</strong>;
          }
          return part;
        });
        // Return as JSX <h3> with bold-parsed content (no extra bold on the tag itself)
        return <h6 style={{fontWeight: 'bold', color: '#40b3ffff'}} key={`heading-${lineIndex}`}>{headingContent}</h6>;
      }

      // For non-heading lines, parse bold on the whole line
      const boldParts = trimmed.split(/\*\*(.*?)\*\*/g);
      const lineContent = boldParts.map((part, index) => {
        if (index % 2 === 1) {
          return <strong style={{color: '#028be8'}} key={`${lineIndex}-bold-${index}`}>{part}</strong>;
        }
        return part;
      });

      // Return as a fragment or span for non-headings (add <p> if needed for semantics)
      return <p key={`line-${lineIndex}`}>{lineContent}</p>; // Or just {lineContent} without <p> if inline
    });

    // Return array of JSX elements for React rendering
    return elements;
  };

// Add this near other handlers in DashboardEnrich component
const handleAskGrokClick = async () => {
  const cachedRow = isParentView && viewingChildId
    ? await getStrategyCache(effectiveUserId, 'parent_view')
    : await getStrategyCache(userId, 'self');
  const storedStrategy = cachedRow?.strategy || null;

  if (!storedStrategy) {
    setStrategyError("No strategy available to share with Grok.");
    return;
  }

  // ── StudyStyle All Facets (individual scores) ─────────────────────────────
  let studyStyleSummary = "\n\nStudyStyle Detailed Facet Scores (1-5):\n";

  if (learningVisualizations) {
    const allFacets = [];

    Object.keys(learningVisualizations).forEach(key => {
      const viz = learningVisualizations[key];
      if (viz?.labels && viz?.datasets?.[0]?.data) {
        viz.labels.forEach((name, i) => {
          allFacets.push({
            name: name,
            score: viz.datasets[0].data[i],
            category: viz.datasets[0].label
          });
        });
      }
    });

    // Sort by score descending
    allFacets.sort((a, b) => b.score - a.score);

    allFacets.forEach(f => {
      studyStyleSummary += `• ${f.name} (${f.category}): ${Number(f.score).toFixed(2)}/5\n`;
    });
  }

  // ── Subject Logic (same as requested) ─────────────────────────────
  let subjectSummary = "\nPrimary Academic Focus:\n";

  if (chosenTopSubject) {
    subjectSummary += `• ${chosenTopSubject} (Student-Chosen Priority Subject)\n`;
  } else {
    if (sortedScores.length > 0) {
      const topUni = sortedScores[0];
      subjectSummary += `• Highest UniReady: ${topUni._id} (${topUni.averageScore?.toFixed(2) || 'N/A'}/5)\n`;
    }
    if (sortedPart3Scores.length > 0) {
      const topPart3 = sortedPart3Scores[0];
      subjectSummary += `• Highest Part III: ${topPart3._id} (${topPart3.averageScore?.toFixed(2) || 'N/A'}/5)\n`;
    }
  }

const studyIntelSummary = buildStudyLearnerIntelligenceSummary(studyLearnerIntelligence);

  const prompt = `Grok, act as an expert learning strategy advisor, providing an in-depth exploration and a tailored action plan based on the following strategy profile:

Student Profile:
${studyStyleSummary}
${subjectSummary}
${studyIntelSummary ? `\nStudent's Own Stated Challenges & Preferences:\n${studyIntelSummary}\n` : ''}
Previously AI-generated Student Learning Strategy summary:
${storedStrategy}

Provide a comprehensive, actionable academic development plan based on the student's profile and higher education subject.

Focus especially on:
- Leveraging their primary academic focus
- Using their strongest StudyStyle facets for optimal learning
- Concrete techniques, routines, and resources
- Academic strategy
- Realistic short-term (next 6–12 months) and medium-term actions

Be specific, practical, and motivating.`;

  let copied = false;
  try {
    await navigator.clipboard.writeText(prompt);
    copied = true;
  } catch (err) {
    const textArea = document.createElement('textarea');
    textArea.value = prompt;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try { document.execCommand('copy'); copied = true; } catch {}
    document.body.removeChild(textArea);
  }

  const proceed = await confirm(
    copied
      ? "The prompt has been copied. Paste it into Grok to receive your personalised action plan."
      : "Couldn't copy the prompt automatically. Check the browser console for it, then paste it into Grok yourself.",
    { title: "Ready for Grok", confirmLabel: "Proceed" }
  );
  if (!copied) console.log(prompt);
  if (proceed) window.open('https://grok.com', '_blank');
};

 return (
    <div className="strategypage">
      {viewModeBannerText && (
        <div style={{ width: '1630px' }} className="view-mode-banner">
          <div className="banner-content">
            <span style={{ fontSize: "1.1rem" }} className="banner-icon"><FaEye></FaEye></span>
            <span style={{ fontSize: "1rem", padding: "9px 0 9px 0" }} className="banner-text banner-text-mobile">{viewModeBannerText}</span>
          </div>
        </div>
      )}

<div className="strategy-content-wrapper" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px', color: 'white', maxWidth: '1000px', margin: '0 auto' }}>

        {/* ── Header: title + status badge ── */}
        <div style={{ width: '100%', textAlign: 'center' }}>
          <h2 className="strategypage-h2" style={{ color: '#36a7f8', margin: '0 0 8px 0' }}>My Learning Strategy</h2>
          {strategy && (
            <span style={{
              display: 'inline-flex', alignItems: 'center', gap: '6px',
              fontSize: '11.5px', fontWeight: 700,
              color: isWithinSixMonths ? '#686868' : '#00c875',
              background: 'none',
              border: `none`,
              borderRadius: '999px', padding: '4px 12px',
            }}>
              {isWithinSixMonths
                ? `Generated ${formatDateDDMMMYY(lastStrategyGenerationDate)}`
                : `Generated ${formatDateDDMMMYY(lastStrategyGenerationDate)} · Eligible for refresh`}
            </span>
          )}
        </div>

        {/* ── Action toolbar — grouped card, matches InterviewPro/UniStatement footer pattern ── */}
        <div className="strategy-toolbar" style={{
          display: 'flex', flexWrap: 'wrap', gap: '12px', alignItems: 'center', justifyContent: 'center',
          width: '100%', 
          border: 'none', borderRadius: '12px',
        }}>
          <TooltipUI
            text={
              isReadOnly
                ? "Generation is disabled in view-only mode. You can view/refresh the child's existing strategy."
                : !hasCompletedAssessment
                ? "Complete the StudyStyle assessment to generate strategy."
                : isWithinSixMonths
                ? `Last strategy generated on ${formatDateDDMMMYY(lastStrategyGenerationDate)}. Next available after ${formatDateDDMMMYY(
                    new Date(new Date(lastStrategyGenerationDate).getTime() + sixMonthsInMs)
                  )}.`
                : "Generate new strategy or fetch your last one (if within 6 months)."
            }
          >
            <button
              className="generate-button insights-button"
              onClick={async () => {
                if (isReadOnly) {
                  const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000;
                  const cachedRow = await getStrategyCache(effectiveUserId, 'parent_view');

                  if (cachedRow) {
                    const timeSinceFetch = Date.now() - cachedRow.timestamp;
                    if (timeSinceFetch < TWENTY_FOUR_HOURS) {
                      setStrategy(cachedRow.strategy);
                      setLastStrategyGenerationDate(cachedRow.generationDate);
                      const nextAllowed = new Date(cachedRow.timestamp + TWENTY_FOUR_HOURS);
                      setStrategyError(
                        `Loaded from cache. Next refresh allowed after ${nextAllowed.toLocaleDateString()}.`
                      );
                      return;
                    }
                  }

                  setIsGeneratingStrategy(true);
                  setStrategyError(null);

                  try {
                    const response = await axios.get(
                      `/api/strategy/parent-view/${effectiveUserId}`,
                      { headers: getAuthHeaders() }
                    );

                    if (response.data.strategy) {
                      setStrategy(response.data.strategy);
                      setLastStrategyGenerationDate(response.data.generationDate);
                      await saveStrategyCache(effectiveUserId, 'parent_view', response.data.strategy, response.data.generationDate);
                      setStrategyError(null);
                    } else {
                      setStrategyError("No strategy has been generated for this student yet.");
                    }
                  } catch (err) {
                    console.error("Failed to fetch child's strategy:", err);
                    if (cachedRow) {
                      setStrategy(cachedRow.strategy);
                      setLastStrategyGenerationDate(cachedRow.generationDate);
                      setStrategyError("Could not refresh — showing last cached strategy.");
                    } else if (err.response?.status === 404) {
                      setStrategyError("This student has not generated a strategy yet.");
                    } else if (err.response?.status === 401) {
                      localStorage.removeItem("token");
                      navigate("/login");
                    } else {
                      setStrategyError("Could not load strategy. Please try again.");
                    }
                  } finally {
                    setIsGeneratingStrategy(false);
                  }

                  return;
                }

                if (!hasCompletedAssessment) {
  showToast('Complete the StudyStyle assessment first.', 'error');
  return;
}

if (!isAdmin && isWithinSixMonths) {
  const confirmed = await confirm(
    `Strategy was last generated on ${formatDateDDMMMYY(lastStrategyGenerationDate)}. Fetch existing strategy?`,
    { title: 'Fetch existing strategy?', confirmLabel: 'Fetch' }
  );
  if (!confirmed) return;
}

generateStrategy();
              }}
              disabled={
                !isReadOnly && (
                  !hasCompletedAssessment ||
                  isGeneratingStrategy ||
                  (!isAdmin && isWithinSixMonths)
                )
              }
              style={{
                opacity: isReadOnly ? 0.9 : 1,
                background: isReadOnly ? "linear-gradient(45deg, #00d6dd, #0171e9)" : undefined,
                color: isReadOnly ? "#eee" : undefined,
                cursor: isReadOnly ? "pointer" : undefined,
              }}
            >
              {isGeneratingStrategy
                ? "Loading..."
                : isReadOnly
                ? "Student's Strategy"
                : strategy ? "Refresh Strategy" : "Generate Strategy"}
            </button>
          </TooltipUI>

          {strategy && (
            <>
<div className="toolbar-divider" style={{ width: '1px', height: '28px', background: 'rgba(255,255,255,0.12)' }} />
              <TooltipUI text={!strategy ? "Generate strategy to enable Ask Grok functionality." : ""}>
                <button
                  className="ask-grok-button insights-button"
                  onClick={handleAskGrokClick}
                  disabled={!strategy}
                >
                  AI Action Plan
                </button>
              </TooltipUI>
              <button className="whats-next-button insights-button" onClick={handleWhatsNextClick}>
                What's Next?
              </button>
            </>
          )}
        </div>

        {strategyError && (
          <div className="strategy-error-banner" style={{
            width: '100%', display: 'flex', alignItems: 'center', gap: '10px',
            padding: '12px 16px', background: 'rgba(255,170,0,0.08)',
            border: '1px solid rgba(255,170,0,0.3)', borderRadius: '8px',
            color: "#ffcc66", fontSize: "13.5px",
          }}>
            <FaInfoCircle style={{ flexShrink: 0 }} />
            {strategyError}
          </div>
        )}

        {/* ── Strategy content card ── */}
        <div style={{width: '1000px' , border: 'solid 2px #028be8', background: '#3838387e'}} className="cyber-frame cyber-frame-strategy">
          {strategy ? (
            <div className="cyber-frame-content-strategy" style={{ lineHeight: 1.7 }}>
              {parseBoldText(strategy)}
            </div>
          ) : (
            <div style={{ textAlign: 'center', padding: '30px 10px', color: '#888' }}>
              <FaChessKnight style={{ fontSize: '28px', color: '#028be8', opacity: 0.6, marginBottom: '12px' }} />
              <p style={{ margin: 0, fontSize: '14.5px', lineHeight: 1.6 }}>
                {hasCompletedAssessment
                  ? "Click \"Generate Strategy\" above to get your personalised learning strategy based on your StudyStyle assessment."
                  : "Complete the StudyStyle assessment first to unlock your personalised learning strategy."}
              </p>
            </div>
          )}
        </div>

        {!isReadOnly && (
          <button
            className="my-study-strategy-button"
            onClick={() => setShowStudyLearnerIntelligenceModal(true)}
            title="Tell the AI more about how this strategy is working for you"
            style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '14px',
              width: '100%', maxWidth: '1000px', background: 'rgba(2,139,232,0.08)', marginTop: '-4px', marginBottom: '0px',
              border: '1px solid rgba(0,225,255,0.3)', borderRadius: '10px',
              padding: '12px 18px', cursor: 'pointer', color: 'white',
            }}
          >
            <span style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '13.5px' }}>
              <FaStickyNote style={{ color: '#00e1ff' }} />
              My Study Strategy Reflections
            </span>
            <span style={{
              fontSize: '11px', color: '#00e1ff', background: 'rgba(0,225,255,0.12)',
              borderRadius: '999px', padding: '4px 10px', whiteSpace: 'nowrap', fontWeight: 600,
            }}>
              {studyLearnerIntelligenceCompleteness(studyLearnerIntelligence)}/6
            </span>
          </button>
        )}
             <div className="all-answers-saved-note" style={{fontStyle: 'normal', marginTop: '0px',  marginBottom: '0px', textAlign: 'center', color: '#b6b6b6', fontSize: '14px' }}>
                          <p>Your Relections are saved locally in this browser only.</p>
                        </div>
        <h4 className="xAI">powered by OpenAI</h4>
      </div>
    </div>
  );
};

const handleWhatsNextClick = () => {
  setShowWhatsNextModal(true);
};


// Updated utility function to remove numbering and quotes
const removeNumberingAndQuotes = (title) => {
  if (!title || typeof title !== "string") return "No Title";
  // Remove numbering (e.g., "1. ", "1) ") and surrounding quotes
  return title
    .replace(/^\d+[.)-]\s*/, "") // Remove numbering
    .replace(/^"(.*)"$/, "$1") // Remove surrounding quotes
    .trim() || "No Title";
};



// Handle preselection when navigating from Dashboard tooltip
useEffect(() => {
  if (location.state?.preselectedSuperSubject && activeSidebarItem === "supercurricular") {
    const subject = location.state.preselectedSuperSubject;
    setSelectedSuperSubject(subject);
    // Trigger fetch only if subject is valid
    if (subject) {
      fetchSuperCurricularActivities(subject);
    }
  }
}, [location.state?.preselectedSuperSubject, activeSidebarItem]);

// store subject score data in localStorage
useEffect(() => {
  if (location.state) {
    const { sortedScores, sortedPart3Scores, userEmail } = location.state;

    try {
      // Update state and store sortedScores
      if (sortedScores) {
        setSortedScores(sortedScores);
        localStorage.setItem(`sortedScores_${userId}`, JSON.stringify(sortedScores));
      }

      // Update state and store sortedPart3Scores
      if (sortedPart3Scores) {
        setSortedPart3Scores(sortedPart3Scores);
        localStorage.setItem(`sortedPart3Scores_${userId}`, JSON.stringify(sortedPart3Scores));
      }

      // Store userEmail
      if (userEmail) {
        localStorage.setItem("userEmail", userEmail);
      }
    } catch (err) {
      console.error("Error storing data in localStorage:", err.message);
    }
  }
}, [location.state, userId, setSortedScores, setSortedPart3Scores]);

const resourceNotesLoadedRef = useRef(false);

useEffect(() => {
  resourceNotesLoadedRef.current = false;
  if (!userId || !selectedKnowledgeSubject) {
    setResourceNotes({});
    return;
  }
  let cancelled = false;
  (async () => {
    try {
      const raw = await getResourceNotes(userId, selectedKnowledgeSubject);
      const normalized = {};
      Object.keys(raw).forEach((rowId) => { normalized[rowId] = normalizeNote(raw[rowId]); });
      if (!cancelled) {
        setResourceNotes(normalized);
        resourceNotesLoadedRef.current = true;
      }
    } catch (err) {
      console.error('Failed to load knowledge notes:', err);
      if (!cancelled) resourceNotesLoadedRef.current = true;
    }
  })();
  return () => { cancelled = true; };
}, [userId, selectedKnowledgeSubject]);


useEffect(() => {
  if (!userId || !selectedKnowledgeSubject || !resourceNotesLoadedRef.current) return;
  saveResourceNotes(userId, selectedKnowledgeSubject, resourceNotes).catch((err) =>
    console.error('Failed to save knowledge notes:', err)
  );
}, [userId, selectedKnowledgeSubject, resourceNotes]);

 // Toggle checkbox state
const handleCheckboxChange = (rowId) => {
  setCheckboxStates((prev) => ({
    ...prev,
    [rowId]: !prev[rowId],
  }));
};

const getNote = (rowId) => resourceNotes[rowId] || { takeaway: '', unclear: '', tag: '', confidence: null, usefulness: 0, resourceMeta: null, createdAt: null, updatedAt: null };
const hasAnyNoteContent = (note) => !!(note?.takeaway?.trim() || note?.unclear?.trim() || note?.tag?.trim() || note?.confidence || note?.usefulness > 0);
const scheduleNoteSave = (rowId) => {
  setNoteSaveStatus((prev) => ({ ...prev, [rowId]: 'typing' }));
  if (noteSaveTimeouts.current[rowId]) clearTimeout(noteSaveTimeouts.current[rowId]);
  noteSaveTimeouts.current[rowId] = setTimeout(() => {
    setResourceNotes((prev) => {
      const current = prev[rowId] || {};
      return {
        ...prev,
        [rowId]: {
          ...current,
          createdAt: current.createdAt || new Date().toISOString(),
          updatedAt: new Date().toISOString(),
        },
      };
    });
    setNoteSaveStatus((prev) => ({ ...prev, [rowId]: 'saved' }));
    setTimeout(() => {
      setNoteSaveStatus((prev) => {
        const updated = { ...prev };
        delete updated[rowId];
        return updated;
      });
    }, 2200);
  }, 700);
};

const updateNoteField = (rowId, field, value, meta) => {
  setResourceNotes((prev) => ({
    ...prev,
    [rowId]: {
      ...getNote(rowId),
      ...prev[rowId],
      resourceMeta: prev[rowId]?.resourceMeta || meta || getNote(rowId).resourceMeta || null,
      [field]: value,
    },
  }));
  scheduleNoteSave(rowId);
};

// Confidence is a tap, not typing — save immediately, no debounce needed
const setNoteConfidence = (rowId, key, meta) => {
    setResourceNotes((prev) => {
    const current = getNote(rowId);
    const nextValue = current.confidence === key ? null : key; // tap again to clear
    return {
      ...prev,
      [rowId]: {
        ...current,
        confidence: nextValue,
        resourceMeta: current.resourceMeta || meta || null,
        createdAt: current.createdAt || new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      },
    };
  });
  setNoteSaveStatus((prev) => ({ ...prev, [rowId]: 'saved' }));
  setTimeout(() => {
    setNoteSaveStatus((prev) => {
      const updated = { ...prev };
      delete updated[rowId];
      return updated;
    });
  }, 1500);
};

// Usefulness rating — same tap-to-save pattern as confidence. Tapping the
// same star count again clears it (0), otherwise sets it to that count.
const setNoteUsefulness = (rowId, value, meta) => {
    setResourceNotes((prev) => {
    const current = getNote(rowId);
    const nextValue = current.usefulness === value ? 0 : value;
    return {
      ...prev,
      [rowId]: {
        ...current,
        usefulness: nextValue,
        resourceMeta: current.resourceMeta || meta || null,
        createdAt: current.createdAt || new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      },
    };
  });
  setNoteSaveStatus((prev) => ({ ...prev, [rowId]: 'saved' }));
  setTimeout(() => {
    setNoteSaveStatus((prev) => {
      const updated = { ...prev };
      delete updated[rowId];
      return updated;
    });
  }, 1500);
};

const clearNote = async (rowId) => {
  const ok = await confirm("Clear this note? This can't be undone.", { danger: true });
  if (!ok) return;
  setResourceNotes((prev) => {
    const updated = { ...prev };
    delete updated[rowId];
    return updated;
  });
  setExpandedNotes((prev) => ({ ...prev, [rowId]: false }));
};

const toggleNoteExpanded = (rowId, meta) => {
    setExpandedNotes((prev) => {
    const willOpen = !prev[rowId];
    if (willOpen) setTimeout(() => noteFieldRefs.current[`${rowId}_takeaway`]?.focus(), 50);
    return { ...prev, [rowId]: willOpen };
  });
  // Stamp metadata the moment a student opens a note editor, even before they
  // type anything — covers the case where they open it, add only a
  // confidence tap, and never touch the textarea.
  if (meta) {
    setResourceNotes((prev) => {
      if (prev[rowId]?.resourceMeta) return prev; // already stamped
      return { ...prev, [rowId]: { ...getNote(rowId), ...prev[rowId], resourceMeta: meta } };
    });
  }
};

const autoGrowTextarea = (el) => {
  if (!el) return;
  el.style.height = 'auto';
  el.style.height = `${Math.min(el.scrollHeight, 200)}px`;
};

const formatRelativeTime = (isoString) => {
  if (!isoString) return null;
  const diffMs = Date.now() - new Date(isoString).getTime();
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins} min ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d ago`;
  return new Date(isoString).toLocaleDateString();
};

// Tailored placeholder per resource type — nudges without requiring
const getTakeawayPlaceholder = (type) => {
  switch (type) {
    case 'print': return "What's the most important thing you learned?";
    case 'video': return "What's one specific example or moment that stuck with you?";
    case 'audio': return "What's the main point the guest or host made?";
    case 'free-course': return "How will you apply what you learned now that the course is over?";
    default: return 'What did you learn from this?';
  }
};


  // Calculate available subjects for Knowledge page (top 3 Part II + Part III)
 const availableKnowledgeSubjects = useMemo(() => {
  let subjects = [];
  if (chosenTopSubject) {
    subjects.push(chosenTopSubject);
  }
  if (sortedScores.length) {
    subjects.push(...sortedScores.map((score) => score._id));
  }
  if (sortedPart3Scores.length) {
    subjects.push(...sortedPart3Scores.map((score) => score._id));
  }
  return [...new Set(subjects)];
}, [sortedScores, sortedPart3Scores, chosenTopSubject]);

  // Calculate available subjects for Team page (top 3 Part II only)
const availableTeamSubjects = useMemo(() => {
  let subjects = sortedScores.map((score) => score._id);
  if (chosenTopSubject && !subjects.includes(chosenTopSubject)) {
    subjects.push(chosenTopSubject);
  }
  return subjects;
}, [sortedScores, chosenTopSubject]);

// Available subjects for Personal Statement dropdown (same logic as Knowledge page)
const availablePSSubjects = useMemo(() => {
  let subjects = [];
  if (chosenTopSubject) {
    subjects.push(chosenTopSubject);
  }
  if (sortedScores.length) {
    subjects.push(...sortedScores.map((score) => score._id));
  }
  if (sortedPart3Scores.length) {
    subjects.push(...sortedPart3Scores.map((score) => score._id));
  }
  return [...new Set(subjects)].filter(Boolean); // remove duplicates & falsy values
}, [sortedScores, sortedPart3Scores, chosenTopSubject]);

 // Fetch ALL personal statement guidance sets once (when subject is chosen)
useEffect(() => {
const fetchGuidanceSets = async () => {
    if (!userId) return;
    if (!selectedPSSubject?.trim() && psGuidanceSets.length === 0) return;

    await ensureFreshCacheVersion(); // one-time bust guard

    setLoadingGuidance(true);
    setGuidanceError(null);

    const CACHE_TTL = 60 * 24 * 60 * 60 * 1000;

    // 1. Check cache
    const cachedRow = await getPsGuidanceSets(userId);
    if (cachedRow.data && Object.keys(cachedRow.data).length > 0 && Date.now() - (cachedRow.timestamp || 0) < CACHE_TTL) {
      const subjectKey = selectedPSSubject?.toLowerCase();

      if (subjectKey && cachedRow.data[subjectKey] !== undefined) {
        // Subject already cached — serve instantly
        const matching = cachedRow.data[subjectKey];
        setPsGuidanceSets(Object.values(cachedRow.data).filter(Boolean));
        setSelectedGuidance(matching || null);
        setLoadingGuidance(false);
        return;
      }

      // Cache exists but subject missing — fetch only missing subjects
      const cachedKeys = Object.keys(cachedRow.data);
      const missingSubjects = availablePSSubjects.filter(
        s => !cachedKeys.includes(s.toLowerCase())
      );

      if (missingSubjects.length > 0) {
        const response = await axios.get('/api/questions/guidance/personal-statement', {
          params: { subjects: missingSubjects.join(',') },
          headers: getAuthHeaders(),
        });

        const newData = { ...cachedRow.data };
        missingSubjects.forEach(s => { newData[s.toLowerCase()] = null; });
        (response.data || []).forEach(set => {
          const key = set.subject?.toLowerCase();
          if (key) newData[key] = set;
        });

        await savePsGuidanceSets(userId, newData);

        const allSets = Object.values(newData).filter(Boolean);
        setPsGuidanceSets(allSets);

        if (selectedPSSubject) {
          setSelectedGuidance(newData[selectedPSSubject.toLowerCase()] || null);
        }
      } else if (selectedPSSubject) {
        setSelectedGuidance(cachedRow.data[selectedPSSubject.toLowerCase()] || null);
      }

      setLoadingGuidance(false);
      return;
    }

    // 2. No cache — single request for all top subjects
    try {
      const subjectsToFetch = availablePSSubjects.length > 0
        ? availablePSSubjects
        : (selectedPSSubject ? [selectedPSSubject] : []);

      if (subjectsToFetch.length === 0) {
        setLoadingGuidance(false);
        return;
      }

      const response = await axios.get('/api/questions/guidance/personal-statement', {
        params: { subjects: subjectsToFetch.join(',') },
        headers: getAuthHeaders(),
      });

      // Build subject → guidance set map
      const dataMap = {};
      subjectsToFetch.forEach(s => { dataMap[s.toLowerCase()] = null; });
      (response.data || []).forEach(set => {
        const key = set.subject?.toLowerCase();
        if (key && dataMap[key] !== undefined) {
          dataMap[key] = set;
        }
      });

      await savePsGuidanceSets(userId, dataMap);

      const allSets = Object.values(dataMap).filter(Boolean);
      setPsGuidanceSets(allSets);

      if (selectedPSSubject) {
        setSelectedGuidance(dataMap[selectedPSSubject.toLowerCase()] || null);
      }

    } catch (err) {
      console.error('Error fetching PS guidance:', err);
      setGuidanceError('Failed to load guidance and tutor insights.');
    } finally {
      setLoadingGuidance(false);
    }
  };

  fetchGuidanceSets();
}, [selectedPSSubject, userId, availablePSSubjects]);


const GUIDANCE_CACHE_TTL = 60 * 24 * 60 * 60 * 1000; // 30 days

const preferredSubject = useMemo(() => {
  if (location.state?.preselectedSubject) {
    const subj = location.state.preselectedSubject.trim();
    return availablePSSubjects.includes(subj) ? subj : '';
  }

  const stored = localStorage.getItem(`last_selected_ps_subject_${effectiveUserId}`);
  return stored && availablePSSubjects.includes(stored) ? stored : '';
}, [location.state, availablePSSubjects, effectiveUserId]);

// Then the effect that applies it (unchanged)
useEffect(() => {
  if (preferredSubject && preferredSubject !== selectedPSSubject) {
    setSelectedPSSubject(preferredSubject);
  }
}, [preferredSubject]);

// New handlers (add after existing handlers)
const handleSuperSubjectSelect = (event) => {
  const subject = event.target.value;
  setSelectedSuperSubject(subject);
  setSelectedCategory('');
  setSelectedSuperActivity(null);
  setScFilters({ ...SC_DEFAULT_FILTERS });
  if (subject) {
    fetchSuperCurricularActivities(subject);
  } else {
    setSupercurricularActivities([]);
  }
};

// Near other localStorage-managed states (activityStatuses, optionCompletions, ...)
const [calendarEvents, setCalendarEvents] = useState([]);
const calendarEventsLoadedRef = useRef(false);

useEffect(() => {
  calendarEventsLoadedRef.current = false;
  if (!userId) return;
  let cancelled = false;
  (async () => {
    const data = await getCalendarEvents(userId);
    if (!cancelled) {
      setCalendarEvents(data);
      calendarEventsLoadedRef.current = true;
    }
  })();
  return () => { cancelled = true; };
}, [userId]);

const addedToCalendar = useMemo(() => {
  const set = new Set();
  calendarEvents.forEach(ev => {
    if (ev.supercurricular_id) {
      set.add(ev.supercurricular_id);
    }
  });
  return set;
}, [calendarEvents]);

// Temporary values while user is filling the modal form
const [tempStartDate, setTempStartDate] = useState(() => new Date().toISOString().slice(0, 10));
const [tempEndDate, setTempEndDate] = useState(() => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return tomorrow.toISOString().slice(0, 10);
});

// Save whenever events change
useEffect(() => {
  if (!userId || !calendarEventsLoadedRef.current) return;
  saveCalendarEvents(userId, calendarEvents).catch((err) =>
    console.warn("Could not save calendar events:", err)
  );
}, [calendarEvents, userId]);

const [showCalendarModal, setShowCalendarModal] = useState(false);
const [showPlanModal, setShowPlanModal] = useState(false);
const [currentPlanActivityId, setCurrentPlanActivityId] = useState(null);

const [planNotes, setPlanNotes] = useState({});
const planNotesLoadedRef = useRef(false);

const normalizePlanEntry = (entry) => {
  if (typeof entry === 'string') {
return { goal: entry, whyItMatters: '', successMetric: '', targetDate: '', status: 'not_started', logEntries: [], outcomeReflection: '', skillsDeveloped: [], activityMeta: null, updatedAt: null };
  }
  return {
    goal: entry?.goal || '',
    whyItMatters: entry?.whyItMatters || '',
    successMetric: entry?.successMetric || '',   // Measurable
    targetDate: entry?.targetDate || '',          // Time-bound
    status: entry?.status || 'not_started',
    logEntries: entry?.logEntries || [],
    outcomeReflection: entry?.outcomeReflection || '',
    skillsDeveloped: entry?.skillsDeveloped || [],
    activityMeta: entry?.activityMeta || null,
    updatedAt: entry?.updatedAt || null,
  };
};

const getPlan = (activityId) =>
planNotes[activityId] || { goal: '', whyItMatters: '', successMetric: '', targetDate: '', status: 'not_started', logEntries: [], outcomeReflection: '', skillsDeveloped: [], activityMeta: null, updatedAt: null };

const updatePlanField = (activityId, field, value) => {
  setPlanNotes((prev) => ({
    ...prev,
    [activityId]: { ...getPlan(activityId), ...prev[activityId], [field]: value, updatedAt: new Date().toISOString() },
  }));
};

const toggleSkillDeveloped = (activityId, skill, max = 3) => {
  setPlanNotes((prev) => {
    const current = getPlan(activityId);
    const list = current.skillsDeveloped || [];
    let newList;
    if (list.includes(skill)) {
      newList = list.filter((s) => s !== skill);
    } else {
      if (max && list.length >= max) return prev;
      newList = [...list, skill];
    }
    return {
      ...prev,
      [activityId]: { ...current, skillsDeveloped: newList, updatedAt: new Date().toISOString() },
    };
  });
};

const [planLogDraft, setPlanLogDraft] = useState({}); // activityId -> current textarea text

const addPlanLogEntry = (activityId) => {
  const text = (planLogDraft[activityId] || '').trim();
  if (!text) return;
  const newEntry = { id: `log_${Date.now()}`, text, ts: new Date().toISOString() };
  setPlanNotes((prev) => {
    const current = getPlan(activityId);
    return {
      ...prev,
      [activityId]: { ...current, logEntries: [newEntry, ...current.logEntries], updatedAt: new Date().toISOString() },
    };
  });
  setPlanLogDraft((prev) => ({ ...prev, [activityId]: '' }));
};

const deletePlanLogEntry = (activityId, entryId) => {
  setPlanNotes((prev) => {
    const current = getPlan(activityId);
    return {
      ...prev,
      [activityId]: { ...current, logEntries: current.logEntries.filter((e) => e.id !== entryId) },
    };
  });
};

const PLAN_STATUS_OPTIONS = [
  { key: 'not_started', label: 'Not started',    color: '#888',    icon: FaRegCircle },
  { key: 'on_track',    label: 'In progress',    color: '#296dcd', icon: FaSpinner },
  { key: 'slower',      label: 'Behind schedule', color: '#cb7d00', icon: FaHourglassHalf },
  { key: 'stuck',       label: 'Blocked',         color: '#f01c00', icon: FaExclamationTriangle },
  { key: 'completed',   label: 'Completed',       color: '#00cc99', icon: FaCheckCircle },
];

const formatPlanLogDate = (iso) => {
  const d = new Date(iso);
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
};

const [modalActivity, setModalActivity] = useState(null); // { id, title, category, example? }
const [tempDate, setTempDate] = useState(() => new Date().toISOString().slice(0, 10));
const [tempHours, setTempHours] = useState(2);

const openCalendarModal = (activity) => {
  const isAlreadyAdded = addedToCalendar.has(activity.supercurricular_id);

  // Prepare selected examples (unchanged)
  const completionsForThis = optionCompletions[activity.supercurricular_id] || {};
  const tickedExamples = Object.entries(completionsForThis)
    .filter(([idxStr, checked]) => checked === true)
    .map(([idxStr]) => activity.suggested_options?.[Number(idxStr)])
    .filter(Boolean);

  // Base modal activity object
  const modalData = {
    supercurricular_id: activity.supercurricular_id,
    title: activity.activity_title,
    category: activity.category,
    selectedExamples: tickedExamples,
    description: ""   // default
  };

  if (isAlreadyAdded) {
    const existing = calendarEvents.find(
      ev => ev.supercurricular_id === activity.supercurricular_id
    );

    if (existing) {
      setTempStartDate(existing.startDate || "");
      setTempEndDate(existing.endDate || "");
      modalData.description = existing.description || "";   // ← LOAD EXISTING DESCRIPTION
    }
  } else {
    // New event — default dates
    const today = new Date().toISOString().slice(0, 10);
    const tomorrow = new Date(Date.now() + 86400000).toISOString().slice(0, 10);
    setTempStartDate(today);
    setTempEndDate(tomorrow);
  }

  setModalActivity(modalData);
  setShowCalendarModal(true);
};

const openCalendarModalForFreeCourse = (resource) => {
  const courseId = getFreeCourseCalendarId(selectedKnowledgeSubject, resource.resourceTitle);
  const isAlreadyAdded = addedToCalendar.has(courseId);

  const modalData = {
    supercurricular_id: courseId,
    title: resource.resourceTitle,
    category: 'Free Course',
    selectedExamples: [],
    description: '',
  };

  if (isAlreadyAdded) {
    const existing = calendarEvents.find(ev => ev.supercurricular_id === courseId);
    if (existing) {
      setTempStartDate(existing.startDate || '');
      setTempEndDate(existing.endDate || '');
      modalData.description = existing.description || '';
    }
  } else {
    const today = new Date().toISOString().slice(0, 10);
    const tomorrow = new Date(Date.now() + 86400000).toISOString().slice(0, 10);
    setTempStartDate(today);
    setTempEndDate(tomorrow);
  }

  setModalActivity(modalData);
  setShowCalendarModal(true);
};

const openPlanModal = (activity) => {
  setCurrentPlanActivityId(activity.supercurricular_id);

  // Stamp activity context onto the journal entry once, the first time it's
  // opened — mirrors resourceMeta on Knowledge notes. Never overwrites an
  // existing stamp, so edits to the underlying catalogue entry later don't
  // retroactively rewrite what the student was actually journaling against.
  const existing = getPlan(activity.supercurricular_id);
  if (!existing.activityMeta) {
    const activityMeta = {
      subject: selectedSuperSubject || null,
      activityTitle: activity.activity_title || null,
      activityDetails: activity.activity_details || null,
      impact: activity.impact || null,
      category: activity.category || null,
    };
    setPlanNotes((prev) => ({
      ...prev,
      [activity.supercurricular_id]: { ...existing, activityMeta },
    }));
  }

  setShowPlanModal(true);
};

// New function to fetch super curricular activities (add after existing functions)
const fetchSuperCurricularActivities = async (subject) => {
  if (!subject || !userId) return;

  await ensureFreshCacheVersion(); // one-time bust guard

  setLoadingSuperActivities(true);
  setSupercurricularActivities([]);

  const CACHE_TTL = 60 * 24 * 60 * 60 * 1000;

  // 1. Check cache (shared table — same one Dashboard.js reads/writes)
  const cachedRow = await getSuperActivities(userId);
  if (cachedRow.data && Object.keys(cachedRow.data).length > 0 && Date.now() - cachedRow.timestamp < CACHE_TTL) {
    const subjectKey = subject.toLowerCase();

    if (cachedRow.data[subjectKey]) {
      // Already cached — serve instantly
      setSupercurricularActivities(cachedRow.data[subjectKey]);
      loadLocalStatuses();
      setInitialCategoryAndActivity(cachedRow.data[subjectKey]);
      setLoadingSuperActivities(false);
      return;
    }

    // Cache exists but this subject missing — fetch only missing subjects
    const cachedKeys = Object.keys(cachedRow.data);
    const missingSubjects = availableKnowledgeSubjects.filter(
      s => !cachedKeys.includes(s.toLowerCase())
    );

    if (missingSubjects.length > 0) {
      const response = await axios.get('/api/questions/supercurricular-activities', {
        params: { subjects: missingSubjects.join(',') },
        headers: getAuthHeaders(),
      });

      // Group new results by subject and merge into cache
      const newData = { ...cachedRow.data };
      missingSubjects.forEach(s => { newData[s.toLowerCase()] = []; });
      (response.data || []).forEach(activity => {
        const key = activity.university_subject?.toLowerCase();
        if (key) {
          if (!newData[key]) newData[key] = [];
          newData[key].push(activity);
        }
      });

      await saveSuperActivities(userId, newData);

      const filtered = newData[subject.toLowerCase()] || [];
      setSupercurricularActivities(filtered);
      loadLocalStatuses();
      setInitialCategoryAndActivity(filtered);
    }

    setLoadingSuperActivities(false);
    return;
  }

  // 2. No cache — single request for all top subjects at once
  try {
    const subjectsToFetch = availableKnowledgeSubjects.length > 0
      ? availableKnowledgeSubjects
      : [subject];

    const response = await axios.get('/api/questions/supercurricular-activities', {
      params: { subjects: subjectsToFetch.join(',') },
      headers: getAuthHeaders(),
    });

    // Group results by subject into a map
    const dataMap = {};
    subjectsToFetch.forEach(s => { dataMap[s.toLowerCase()] = []; });
    (response.data || []).forEach(activity => {
      const key = activity.university_subject?.toLowerCase();
      if (key && dataMap[key] !== undefined) {
        dataMap[key].push(activity);
      }
    });
    // Sort each subject's activities by created_at
    Object.keys(dataMap).forEach(key => {
      dataMap[key].sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
    });

    await saveSuperActivities(userId, dataMap);

    const filtered = dataMap[subject.toLowerCase()] || [];
    setSupercurricularActivities(filtered);
    loadLocalStatuses();
    setInitialCategoryAndActivity(filtered);

  } catch (err) {
    console.error('Error fetching supercurricular activities:', err);
    setSupercurricularActivities([]);
  } finally {
    setLoadingSuperActivities(false);
  }
};



// Helper to set initial category + first activity
const setInitialCategoryAndActivity = (activities) => {
  if (activities.length === 0) return;

  const categories = [...new Set(activities.map(a => a.category))];
  const categoryOrder = ['Intellectual Pursuits', 'Clubs and Societies', 'Work Experience'];
  const sortedCategories = categoryOrder.filter(cat => categories.includes(cat));
  
  const firstCategory = sortedCategories[0] || categories[0];
  setSelectedCategory(firstCategory);

  const firstActivity = activities.find(a => a.category === firstCategory);
  if (firstActivity) {
    setSelectedSuperActivity(firstActivity.supercurricular_id);
  }
};



useEffect(() => {
  if (userId && activeSidebarItem === "supercurricular") {
    saveLocalStatuses();
  }
}, [activityStatuses, optionCompletions, userId, activeSidebarItem]);

useEffect(() => {
  if (location.state?.sidebarItem === "supercurricular") {
    const subj = location.state.preselectedSuperSubject;
    const actId = location.state.preselectedActivityId;

    if (subj) {
      setSelectedSuperSubject(subj);
      // Trigger activity fetch if needed
      fetchSuperCurricularActivities(subj);
    }

    if (actId && subj) {
      // Auto-select the activity once activities are loaded
      const timer = setTimeout(() => {
        const activity = supercurricularActivities.find(a => a.supercurricular_id === actId);
        if (activity) {
          setSelectedCategory(activity.category);
          setSelectedSuperActivity(actId);

          // Optional: smooth scroll to the activity card
          setTimeout(() => {
            const el = document.querySelector(`[data-activity-id="${actId}"]`);
            if (el) {
              el.scrollIntoView({ behavior: "smooth", block: "center" });
              // Brief highlight
              el.style.backgroundColor = "rgba(255,170,0,0.12)";
              setTimeout(() => el.style.backgroundColor = "", 1800);
            }
          }, 600);
        }
      }, 800); // give fetch time to complete

      return () => clearTimeout(timer);
    }
  }
}, [location.state, supercurricularActivities, fetchSuperCurricularActivities]);

// Helper to load statuses from Dexie
const loadLocalStatuses = async () => {
  try {
    const [statuses, completions] = await Promise.all([
      getActivityStatuses(userId),
      getOptionCompletions(userId),
    ]);
    const normalizedStatuses = {};
    Object.keys(statuses || {}).forEach((id) => {
      normalizedStatuses[id] = normalizeActivityProgress(statuses[id]);
    });
    setActivityStatuses(normalizedStatuses);
    setOptionCompletions(completions || {});
    activityStatusesLoadedRef.current = true; // only now is it safe to save
  } catch (err) {
    // Leave the ref false so a failed read can never be saved back as "empty"
    console.warn('Failed to load activity statuses:', err);
  }
};

// Saves are blocked until the first successful load
const saveLocalStatuses = () => {
  if (!userId || !activityStatusesLoadedRef.current) return;
  saveActivityStatuses(userId, activityStatuses).catch((err) =>
    console.warn('Failed to save activity statuses:', err)
  );
  saveOptionCompletions(userId, optionCompletions).catch((err) =>
    console.warn('Failed to save option completions:', err)
  );
};

useEffect(() => {
  activityStatusesLoadedRef.current = false; // new user → block saves until their data is loaded
  if (!userId) return;
  loadLocalStatuses();
}, [userId]);

// ── Focus Snapshot (modal summary of progress under the 3 focus areas) ──
const [showFocusSnapshot, setShowFocusSnapshot] = useState(false);
const [focusSnapshotMap, setFocusSnapshotMap] = useState({});
const [focusSnapshotLoading, setFocusSnapshotLoading] = useState(false);

// Reads the shared Dexie cache (all subjects). Re-runs when the modal opens
// and whenever a subject's activities finish loading.
useEffect(() => {
  if (!userId) return;
  let cancelled = false;
  setFocusSnapshotLoading(true);
  (async () => {
    try {
      const row = await getSuperActivities(userId);
      if (!cancelled) setFocusSnapshotMap(row?.data || {});
    } catch {
      if (!cancelled) setFocusSnapshotMap({});
    } finally {
      if (!cancelled) setFocusSnapshotLoading(false);
    }
  })();
  return () => { cancelled = true; };
}, [userId, showFocusSnapshot, supercurricularActivities]);

// Flat list of every activity carrying at least one focus tag, with the
// student's current progress (0–100) attached.
const focusSnapshotItems = useMemo(
  () =>
    Object.values(focusSnapshotMap)
      .flatMap((arr) => (Array.isArray(arr) ? arr : []))
      .map((a) => ({
        id: a.supercurricular_id,
        title: a.activity_title || a.category || 'Untitled activity',
        subject: a.university_subject,
        category: a.category,
        depth: a.depth || '',
        tags: getActivityEngagement(a).tags,
        progress: activityStatuses[a.supercurricular_id] ?? 0,
      }))
  ,
  [focusSnapshotMap, activityStatuses]
);
const focusStartedCount = focusSnapshotItems.filter((i) => i.progress > 0).length;

// Click an activity in the modal → switch subject if needed, then reuse the
// existing deep-link effect to select its category/activity and scroll to it.
const handleOpenFocusActivity = (item) => {
  setShowFocusSnapshot(false);
  setScFilters({ ...SC_DEFAULT_FILTERS });

  const alreadyLoaded = item.subject === selectedSuperSubject && supercurricularActivities.length > 0;
  if (!alreadyLoaded) {
    // Clear in the SAME batch as the intent so the deep-link effect waits
    // for the new subject's activities instead of discarding the request.
    setSupercurricularActivities([]);
    setSelectedSuperSubject(item.subject);
    fetchSuperCurricularActivities(item.subject);
  }
  setDeepLinkIntent({
    subject: item.subject,
    category: item.category,
    activityId: item.id,
    scrollToActivity: true,
  });
};

// Handler for category tab click
const handleCategoryTabClick = (category) => {
  setSelectedCategory(category);
  setSelectedSuperActivity(null);
  const firstActivity = filteredSuperActivities.find(a => a.category === category);
  if (firstActivity) {
    setSelectedSuperActivity(firstActivity.supercurricular_id);
  }
};
// Handler for activity tab click
const handleSuperActivityTabClick = (activityId) => {
  setSelectedSuperActivity(activityId);
};

// Update progress (0/20/40/60/80/100)
const updateActivityStatus = (activityId, percent) => {
  setActivityStatuses(prev => {
    const wasComplete = prev[activityId] === 100;
    if (percent === 100 && !wasComplete) {
      confetti({
        particleCount: 60,
        spread: 65,
        origin: { y: 0.6 },
        colors: ['#00ff9d', '#7ed957', '#ffd700'],
      });
    }
    return { ...prev, [activityId]: percent };
  });
};

// Toggle option completion
const toggleOptionCompletion = (activityId, optionIndex) => {
  setOptionCompletions(prev => ({
    ...prev,
    [activityId]: {
      ...prev[activityId],
      [optionIndex]: !prev[activityId]?.[optionIndex]
    }
  }));
};

  
    useEffect(() => {
      document.body.classList.add('specific-page-enrich');
      return () => document.body.classList.remove('specific-page-enrich');
    });
  

// Updated renderSuperCurricularSection (replace the existing function)
const renderSuperCurricularSection = () => {
  // Use same sortedScores and sortedPart3Scores for top subjects
  const allTopSubjects = [];
  if (chosenTopSubject) {
    allTopSubjects.push({ name: chosenTopSubject, score: 5.0, type: 'Chosen' });
  }
  allTopSubjects.push(
    ...sortedScores.slice(0, 3).map(score => ({ name: score._id, score: score.averageScore, type: 'UniReady' })),
    ...sortedPart3Scores.slice(0, 3).map(score => ({ name: score._id, score: score.averageScore, type: 'Advanced Exploration' }))
  );
  // Sort by score descending, with chosen subject prioritized (high score)
  allTopSubjects.sort((a, b) => b.score - a.score);

const currentActivities = selectedCategory 
  ? filteredSuperActivities.filter(a => a.category === selectedCategory)
  : [];

  const selectedActivityData = currentActivities.find(a => a.supercurricular_id === selectedSuperActivity);

const categories = [...new Set(filteredSuperActivities.map(a => a.category))];
  const categoryOrder = ['Intellectual Pursuits', 'Clubs and Societies', 'Work Experience'];
  const sortedCategories = categoryOrder.filter(cat => categories.includes(cat));

  const categoryCounts = Object.fromEntries(
  sortedCategories.map((cat) => [cat, filteredSuperActivities.filter((a) => a.category === cat).length])
);

  return (
    <div className="superpage">
          {showFocusSnapshot && (
      <FocusSnapshotModal
        items={focusSnapshotItems}
        loading={focusSnapshotLoading}
        currentSubject={selectedSuperSubject}
        onClose={() => setShowFocusSnapshot(false)}
        onOpenActivity={handleOpenFocusActivity}
      />
    )}
         {viewModeBannerText && (
              <div style={{width: '1630px'}} className="view-mode-banner banner-super">
                <div className="banner-content">
                  <span style={{fontSize: "1.1rem"}} className="banner-icon"><FaEye></FaEye></span>
                  <span style={{fontSize: "1rem", padding: "9px 0 9px 0"}} className="banner-text banner-text-mobile">{viewModeBannerText}</span>
                </div>
              </div>
            )}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '20px',
          color: 'white',
          width: 'max',
          margin: '0 auto',
        }}
      >
        <h2 style={{ color: '#36a7f8', textAlign: 'center' }}>Super Curricular Activities</h2>
<div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'center', flexWrap: 'wrap', gap: '0px' }}>
        <div className="cyber-select2-container-super">
          <label
            htmlFor="super-subject-select"
            className="select-title"
            style={{
              fontSize: "16px",
              color: "#028be8",
              marginBottom: "8px",
              marginLeft: "20px",
            }}
          >
            Select a Top UniReady or Exploration Subject:
          </label>
          <select
            id="super-subject-select"
            onChange={handleSuperSubjectSelect}
            className="cyber-select2-super"
            value={selectedSuperSubject}
          >
            <option value="">-- Select a Subject --</option>
            {allTopSubjects.map((subject, index) => (
              <option key={index} value={subject.name}>
                {subject.name}
              </option>
            ))}
          </select>
        </div>

 {!isReadOnly && (
    <button
      type="button"
      className="focus-snapshot-btn"
      onClick={() => setShowFocusSnapshot(true)}
      title="See your progress in Independent Research, Competition and Leadership"
      style={{
        marginBottom: "8px",
        height: '50px', padding: '0 20px', display: 'inline-flex', alignItems: 'center', gap: '9px',
        borderRadius: '10px', fontSize: '14px', fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap',
        color: '#00e1ff', background: 'rgba(0,225,255,0.08)', border: '1px solid rgba(0,225,255,0.45)',
        boxShadow: '0 4px 14px rgba(0,225,255,0.12)', transition: 'all 0.2s ease',
      }}
      onMouseOver={(e) => { e.currentTarget.style.background = 'rgba(0,225,255,0.16)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
      onMouseOut={(e) => { e.currentTarget.style.background = 'rgba(0,225,255,0.08)'; e.currentTarget.style.transform = 'translateY(0)'; }}
    >
      <FaTrophy color="#ffd700" size={14} /> My Achievements
      {focusStartedCount > 0 && (
        <span
          style={{
            minWidth: '20px', height: '20px', padding: '0 6px', borderRadius: '999px', fontSize: '11px', fontWeight: 800,
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#0a0f1f', background: '#00e1ff',
          }}
        >
          {focusStartedCount}
        </span>
      )}
    </button>
  )}
</div>

        {allTopSubjects.length === 0 && (
          <p style={{ color: '#ffaa00', fontStyle: 'italic' }}>
            Complete your UniReady and/or Advanced Exploration assessments to see your top subjects.
          </p>
        )}
        {selectedSuperSubject && (
          <div className="cyber-jobposts-container-super">
          {loadingSuperActivities ? (
              <div  style={{ maxWidth: '640px', margin: '10px auto' }}>
                <style>{`
                  @keyframes superSkeletonPulse { 0%, 100% { opacity: 0.35; } 50% { opacity: 0.7; } }
                `}</style>
                {[1, 2, 3].map((i) => (
                  <div key={i} style={{
                    display: 'flex', alignItems: 'center', gap: '14px', padding: '14px 16px',
                    marginBottom: '8px', background: 'rgba(255,255,255,0.03)', borderRadius: '8px',
                  }}>
                    <div style={{
                      width: '8px', height: '8px', borderRadius: '50%', background: 'rgba(54,167,248,0.4)',
                      animation: 'superSkeletonPulse 1.4s ease-in-out infinite', animationDelay: `${i * 0.12}s`, flexShrink: 0,
                    }} />
                    <div style={{
                      flex: 1, height: '12px', borderRadius: '4px', background: 'rgba(255,255,255,0.08)',
                      animation: 'superSkeletonPulse 1.4s ease-in-out infinite', animationDelay: `${i * 0.12}s`,
                      maxWidth: `${75 - i * 10}%`,
                    }} />
                  </div>
                ))}
              </div>
            ) : supercurricularActivities.length === 0 ? (
              <div style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px',
                padding: '28px 20px', textAlign: 'center', color: '#88aacc',
                background: 'rgba(255,255,255,0.03)', border: '1px dashed rgba(255,170,0,0.35)',
                borderRadius: '12px', maxWidth: '460px', margin: '10px auto',
              }}>
                <FaBolt style={{ fontSize: '24px', color: '#ffaa00', opacity: 0.75 }} />
                <span style={{ fontSize: '14px', lineHeight: 1.5 }}>
                  No super curricular activities found for {selectedSuperSubject} yet.
                </span>
              </div>
                               ) : (
              <>
                <SuperCurricularFilterBar
                  activities={supercurricularActivities}
                  filters={scFilters}
                  onChange={setScFilters}
                  resultCount={filteredSuperActivities.length}
                />

                {/* Top Horizontal Category Tabs */}
                <div className="category-tabs" style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginBottom: '20px' }}>
                 {sortedCategories.map((category) => {
  const n = categoryCounts[category] ?? 0;
  const isActiveTab = selectedCategory === category;
  return (
    <button
      key={category}
      className={`tab-button-2 ${isActiveTab ? 'active' : ''}`}
      onClick={() => handleCategoryTabClick(category)}
      style={{
       marginBottom: '-18px',
      }}
    >
      {category}
      <span
        style={{
          marginLeft: '8px', fontSize: '10.5px', fontWeight: 700, padding: '1px 7px', borderRadius: '999px',
          background: n === 0 ? 'rgba(255,255,255,0.06)' : isActiveTab ? 'rgba(255,255,255,0.22)' : 'rgba(255,255,255,0.12)',
          color: n === 0 ? '#6b768a' : '#e6edf5',
          transition: 'all 0.2s ease',
        }}
      >
        {n}
      </span>
    </button>
  );
})}
                </div>

                {/* Activities Table - 100% wider */}
                <div className="cyber-jobposts-table-wrapper-super" style={{ width: '100%' }}>
                  <table className="cyber-table2-super" style={{ width: '100%' }}>
                    <tbody>
                      <tr>
 <td className="tabs-column-super" style={{ width: '400px', verticalAlign: 'top', padding: '0' }}>
                          <div className="vertical-tabs-container2">
                            <div className="vertical-tabs-header-super">
                              <h4 style={{ fontSize: '20px', color: '#36a7f8', margin: '10px 0', textTransform: "uppercase" }}>Activity</h4>
                            </div>

                           

                      <div className="vertical-tabs-super">
{currentActivities.length === 0 && (
  <div style={{ padding: '22px 16px', textAlign: 'center', fontSize: '13px', lineHeight: 1.5, color: '#7f8ea8' }}>
    No activities in this category match your filters.
    {scFiltersActive && (
      <div>
        <button
          type="button"
          onClick={() => setScFilters({ ...SC_DEFAULT_FILTERS })}
          style={{ marginTop: '8px', background: 'none', border: 'none', color: '#00e1ff', cursor: 'pointer', fontSize: '12.5px', fontWeight: 600 }}
        >
          Clear filters
        </button>
      </div>
    )}
  </div>
)}
{currentActivities.map((activity) => {
    const isAddedToCalendar = addedToCalendar.has(activity.supercurricular_id);
    const progressPercent = activityStatuses[activity.supercurricular_id] ?? 0;
    const progressColor = getActivityProgressColor(progressPercent);
    const dotColor = isAddedToCalendar ? '#00ffaa' : '#88888800'; // orange if added, grey otherwise
    const isJournaled = hasPlanContent(activity.supercurricular_id);
    const journalTargetDate = getPlan(activity.supercurricular_id).targetDate;
    return (
      <button
        key={activity.supercurricular_id}
        className={`tab-button-3-super ${selectedSuperActivity === activity.supercurricular_id ? 'active' : ''}`}
        onClick={() => handleSuperActivityTabClick(activity.supercurricular_id)}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingRight: '16px',
        }}
        data-activity-id={activity.supercurricular_id} // useful for deep linking / scrolling
      >
        <span className="tab-title-super">
          {activity.activity_title || activity.category}
        </span>

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginLeft: '12px', flexShrink: 0 }}>
            {progressPercent > 0 && (
            <span
              title={`${progressPercent}% complete`}
              className="progress-badge-super"
              style={{
                fontSize: '12px', fontWeight: 700,
                color: progressPercent === 100 ? '#00e1ff' : progressColor,
                background: progressPercent === 100 ? 'rgba(0,225,255,0.12)' : 'rgba(255,255,255,0.06)',
                border: `1px solid ${progressPercent === 100 ? 'rgba(0,225,255,0.4)' : 'rgba(255, 255, 255, 0.41)'}`,
                borderRadius: '999px', padding: '1px 6px', whiteSpace: 'nowrap',
              }}
            >
              {progressPercent}%
            </span>
          )}
          {isJournaled && (
            <FaEdit size={14} style={{ color: '#00FFAA' }} title="Journal entry started" />
          )}
          {/* Calendar dot */}
          <div
            className="status-indicator"
            style={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              backgroundColor: isAddedToCalendar ? '#00ffaa' : '#88888800',
              boxShadow: isAddedToCalendar 
                ? '0 0 8px #04bb7e8e' 
                : 'none',
              transition: 'all 0.3s ease',
            }}
            title={isAddedToCalendar ? "Added to calendar" : "Not in calendar"}
          />
        </div>
      </button>
      );
  })}
</div>
                          </div>
                        </td>
                        <td className="details-column-super" style={{ verticalAlign: 'top', padding: '20px', width: '100%' }}>
                       {selectedActivityData ? (
  <div>
    <h5 className="activity" style={{ color: '#ffaa00', marginBottom: '10px', fontWeight: 'bold' }}>
      {selectedActivityData.activity_title}
    </h5>
    <ActivitySignalBadges activity={selectedActivityData} />

    <div className="skills-row-super" style={{ marginTop: '15px' }}>
      <div className="description-row-super" style={{ marginTop: '15px' }}>
        <div className="content-section">
          <h4 style={{ fontSize: '20px', color: '#36a7f8', marginBottom: '20px', textTransform: "uppercase" }}>
            Activity Details
          </h4>
          <div className="description-content">
            <p>{selectedActivityData.activity_details}</p>
          </div>

          {/* Top Examples — keep this block as is */}
          {selectedActivityData.suggested_options && selectedActivityData.suggested_options.length > 0 && (
            <div className="skills-row-super" style={{ marginTop: '25px' }}>
              <h5 style={{ color: '#36a7f8', marginBottom: '15px', fontSize: '18px' }}>
                Top Examples
              </h5>
              <div className="skills-content">
                <ul className="skills-content-ul" style={{ listStyle: 'none', padding: 0 }}>
                  {selectedActivityData.suggested_options.map((option, index) => (
                    <li key={index} className="skill-item-super" style={{ display: 'flex', alignItems: 'center', padding: '8px 0' }}>
                      <TooltipUIViewOnly2
              text={
                isReadOnly 
                  ? "This function is for student self-learning and is only enabled for students." 
                  : ""
              }
              position="right"
              // Hide tooltip completely in normal/student mode
              disabled={!isReadOnly}
            >
                      <input
                        type="checkbox"
                        id={`option-${selectedActivityData.supercurricular_id}-${index}`}
                        className="cyber-checkbox supercurricular-box"
                        checked={optionCompletions[selectedActivityData.supercurricular_id]?.[index] || false}
                        onChange={() => toggleOptionCompletion(selectedActivityData.supercurricular_id, index)}
                        disabled={isReadOnly}    
                        style={{ marginRight: '10px', flexShrink: 0 }}
                      />
                        </TooltipUIViewOnly2>
                      <a
                        href={`https://www.google.com/search?q=${encodeURIComponent(option)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="skill-link-super"
                        style={{ color: '#e0e0e0', textDecoration: 'none', fontSize: '15px' }}
                        onMouseEnter={(e) => e.target.style.color = '#36a7f8'}
                        onMouseLeave={(e) => e.target.style.color = '#e0e0e0'}
                      >
                        {option}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>

    {/* Impact */}
    <div className="description-row-super" style={{ marginTop: '15px' }}>
      <div className="content-section">
        <h4 style={{ fontSize: '20px',color: '#36a7f8', marginBottom: '20px' }}>Impact</h4>
        <div className="description-content">
          <p>{selectedActivityData.impact}</p>
        </div>
      </div>
    </div>

 {/* How to Achieve? - with AI Guidance button next to heading */}
<div className="description-row-super" style={{ marginTop: '15px' }}>
  <div className="content-section">
<div className="how-to-achieve-header" style={{ 
      display: 'flex', 
      alignItems: 'center', 
      marginBottom: '16px',
    }}>
      <h4 style={{ fontSize: '20px', color: '#36a7f8', margin: 0 }}>How to Achieve?</h4>

      {/* AI Guidance Button - positioned right next to the heading */}
      <button
        className=" ai-guidance-button"
        onClick={() => {
        const activity = selectedActivityData;
if (!activity) return;

const studyStyleSummary = buildStudyStyleExecutionSummary(learningVisualizations);
const studyContextSummary = buildStudyLearnerIntelligenceSummary(studyLearnerIntelligence);
const { sequence: modes, tags: focusTags } = getActivityEngagement(activity);
const activitySignals = [
  activity.time_commitment && `Time commitment: ${activity.time_commitment}${activity.time_commitment_detail ? ` (${activity.time_commitment_detail})` : ''}`,
  activity.depth && `Depth level: ${activity.depth}`,
  modes.length && `Engagement journey: ${modes.join(' → ')}`,
  focusTags.length && `Focus area: ${focusTags.join(', ')}`,
].filter(Boolean).join('\n');

const prompt = `You are an expert Oxbridge/Ivy League admissions mentor helping an ambitious high school student implement a super-curricular activity.

**Subject:** ${selectedSuperSubject || 'N/A'}
**Activity:** ${activity.activity_title}
**Category:** ${activity.category}
${activitySignals ? `\n${activitySignals}\n` : ''}
**Activity Details:**
${activity.activity_details || 'N/A'}

**Impact:**
${activity.impact || 'N/A'}

**How to Achieve:**
${activity.how_to_achieve || 'N/A'}

**Online Tools & Resources:**
${activity.how_resources && Array.isArray(activity.how_resources) 
  ? activity.how_resources.map(r => `• ${r.description} → ${r.url}`).join('\n')
  : 'None listed'}
${studyStyleSummary ? `
---

**Student's Learning Profile (StudyStyle assessment, scores out of 5, grouped by category):**
${studyStyleSummary}
${studyContextSummary ? `\n**Student's own stated context:**\n${studyContextSummary}\n` : ''}` : ''}
---

**Your Task:**
Guide the student step-by-step on **how to best implement this activity** to make it impressive for university applications.

Structure your response with these sections:

1. **Overall Strategy** – Why this activity matters and best approach.
2. **Step-by-Step Implementation Plan** – Clear, realistic steps with suggested timeline.
3. **How to Use the Online Tools/Resources** – Specific advice for each resource.
4. **Evidence & Reflection** – What to document and how to reflect for applications/interviews.
5. **Pro Tips & Pitfalls** – How to stand out and common mistakes to avoid.
${studyStyleSummary ? `6. **Tailored to My Learning Style** – Using the StudyStyle profile above, give 2–3 specific adjustments for how I should execute THIS activity (e.g. how to structure my time, whether to work alone or with others, how to stay motivated, how to handle the parts that will be hardest for me). Treat the profile as a soft guide, not a label: do not stereotype, do not repeat generic study tips, and only mention a trait if it genuinely changes how I should carry out this activity.` : ''}

Be practical, encouraging, and focused on depth for top university applications.`;

                    (async () => {
            let copied = false;
            try {
              await navigator.clipboard.writeText(prompt);
              copied = true;
            } catch {
              copied = false;
            }

            const proceed = await confirm(
              copied
                ? "The prompt has been copied. Paste it into Grok for a personalised implementation plan."
                : "Couldn't copy the prompt automatically. Check the browser console for it, then paste it into Grok yourself.",
              { title: "Ready for Grok", confirmLabel: "Proceed" }
            );
            if (!copied) console.log(prompt);
            if (proceed) window.open("https://grok.com", "_blank");
          })();
        }}
        style={{
          background: 'linear-gradient(90deg, #028be8, #02a3b9)',
          color: 'white',
          border: 'none',
          padding: '4px 4px',
          borderRadius: '8px',
          fontSize: '14.5px',
          fontWeight: 'Bold',
          cursor: 'pointer',
          marginLeft: '15px',
          boxShadow: '0 3px 12px rgba(2,139,232,0.35)',
          transition: 'all 0.2s ease',
          whiteSpace: 'nowrap',
          width: '140px',
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.transform = 'translateY(-1px)';
          e.currentTarget.style.boxShadow = '0 6px 16px rgba(2,139,232,0.5)';
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 3px 12px rgba(2,139,232,0.35)';
        }}
      >
        AI Guided Steps
      </button>
       {/* === NEW: My Plan Button === */}
{/* === NEW: My Plan / Journal Button (turns green when content exists) === */}
<button
  className="cyber-button my-plan"
  onClick={() => openPlanModal(selectedActivityData)}
  style={{
    background: hasPlanContent(selectedActivityData.supercurricular_id) 
      ? '#00cc9900' 
      : 'none',
    color: hasPlanContent(selectedActivityData.supercurricular_id) 
      ? '#00FFAA' 
      : '#028BE8',
    border: hasPlanContent(selectedActivityData.supercurricular_id)
      ? 'solid 1px #00FFAA'
      : 'solid 1px #028BE8',
    padding: '4px 8px',
    borderRadius: '8px',
    marginLeft: '10px',
    fontWeight: '600',
    cursor: 'pointer',
    fontSize: '14.5px',
    transition: 'all 0.2s ease',
  }}
>
  <FaEdit 
    style={{ 
      color: hasPlanContent(selectedActivityData.supercurricular_id) 
        ? '#00FFAA' 
        : '#028BE8', 
      marginRight: '6px' 
    }} 
  /> 
  Journal
</button>
    </div>

    <div className="description-content">
      <p>{selectedActivityData.how_to_achieve}</p>

      {/* Online Tools & Resources - Colorful Pill Buttons (unchanged) */}
      {selectedActivityData.how_resources && 
       Array.isArray(selectedActivityData.how_resources) && 
       selectedActivityData.how_resources.length > 0 && (
        <div className="online-tool" style={{ marginTop: '28px' }}>
          <h5 style={{ color: '#36a7f8', marginBottom: '14px', fontSize: '18px' }}>
            Online Tools & Resources
          </h5>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {selectedActivityData.how_resources.map((resource, idx) => {
              if (!resource?.url || !resource?.description) return null;
              const colors = ['#ff66cc','#00e1ff', '#00ffaa',  '#9b5de5', '#f15bb5', '#028be8', '#00cc99'];
              const bgColor = colors[idx % colors.length];

              return (
                <a
                  key={idx}
                  href={resource.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    background: `linear-gradient(135deg, ${bgColor}22, rgba(255,255,255,0.08))`,
                    color: bgColor,
                    padding: '6px 18px',
                    borderRadius: '25px',
                    border: `2px solid ${bgColor}44`,
                    textDecoration: 'none',
                    fontSize: '12px',
                    fontWeight: '600',
                    transition: 'all 0.25s ease',
                    whiteSpace: 'nowrap',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.background = `linear-gradient(135deg, ${bgColor}33, rgba(255,255,255,0.12))`;
                    e.currentTarget.style.borderColor = bgColor;
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.background = `linear-gradient(135deg, ${bgColor}22, rgba(255,255,255,0.08))`;
                    e.currentTarget.style.borderColor = `${bgColor}44`;
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  {resource.description}
                </a>
              );
            })}
          </div>
        </div>
      )}
    </div>
  </div>
</div>

    {/* Status Dropdown + Add to Calendar button – same row */}
<div
  className="activity-actions-row"
  style={{
    marginTop: '20px',
    marginLeft: '0px',
    display: 'flex',
    alignItems: 'center',
    gap: '26px',
    flexWrap: 'wrap'
  }}
>


   <TooltipUI2
    text={isReadOnly ? "This function is for student self-learning and is only enabled for students." : ""}
    position="top"
    disabled={!isReadOnly}
  >
    <button
      className="cyber-button add-to-calendar-btn"
      onClick={() => openCalendarModal(selectedActivityData)}
      disabled={isReadOnly}   // ← disable in view-only mode
      style={{
        height: '50px',
        padding: '0 24px',
        fontSize: '15px',
        background: isReadOnly 
          ? '#555' 
          : addedToCalendar.has(selectedActivityData.supercurricular_id) 
            ? '#a5a5a5' 
            : '#028be8',
        color: isReadOnly ? '#ccc' : 'white',
        border: 'none',
        borderRadius: '8px',
        cursor: isReadOnly ? 'not-allowed' : 'pointer',
        whiteSpace: 'nowrap',
        boxShadow: addedToCalendar.has(selectedActivityData.supercurricular_id)
          ? '0 2px 8px rgba(127, 127, 127, 0.5)'
          : '0 2px 8px rgba(2,139,232,0.4)',
        transition: 'all 0.2s ease',
        opacity: isReadOnly ? 0.75 : 1,
      }}
    >
      {addedToCalendar.has(selectedActivityData.supercurricular_id)
        ? 'Edit Calendar'
        : 'Add to Calendar'}
    </button>
  </TooltipUI2>

  {!isReadOnly && (
    <button
      onClick={() => setShowShareActivitySheet(true)}
      title="Share this activity with a friend"
      className="share-activity"
      style={{
        height: '50px', padding: '0 20px', display: 'inline-flex', alignItems: 'center', gap: '8px',
        background: 'transparent', color: '#00e1ff', border: '1px solid #00e1ff',
        borderRadius: '8px', fontWeight: 600, fontSize: '14px', cursor: 'pointer', marginLeft: '-15px'
      }}
    >
      <FaShareAlt size={13} /> Share
    </button>
  )}

    <TooltipUI2
    text={isReadOnly ? "This function is for student self-learning and is only enabled for students." : ""}
    position="top"
    disabled={!isReadOnly}
  >
    <ActivityProgressControl
      value={activityStatuses[selectedActivityData.supercurricular_id] ?? 0}
      onChange={(percent) => updateActivityStatus(selectedActivityData.supercurricular_id, percent)}
      disabled={isReadOnly}
    />
  </TooltipUI2>
</div>

    {showShareActivitySheet && (
      <ShareActivitySheet
        activity={selectedActivityData}
        subject={selectedSuperSubject}
        studentName={displayName}
        onClose={() => setShowShareActivitySheet(false)}
      />
    )}

    {/* ────────────────────────────────────────────────
        IMPORTANT: Move the MODAL here — outside of any conditional
        It should be a sibling of the sections above, not nested
    ──────────────────────────────────────────────── */}
 {showCalendarModal && modalActivity && (
  <div 
    className="modal-overlay" 
    onClick={() => setShowCalendarModal(false)} // close on backdrop click
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 2000,
      backdropFilter: "blur(4px)",
    }}
  >
    <div 
      className="modal-content-calendar"
      onClick={e => e.stopPropagation()} // prevent closing when clicking inside
      style={{
        background: "linear-gradient(135deg, #0f1629 0%, #0a0f1f 100%)",
        color: "white",
        padding: "2rem",
        borderRadius: "16px",
        width: "min(92vw, 600px)",
        border: "1px solid rgba(2, 139, 232, 0.35)",
        boxShadow: "0 20px 60px rgba(0,0,0,0.6), 0 0 0 1px rgba(2,139,232,0.18) inset",
        position: "relative",
        maxHeight: "90vh",
        overflowY: "auto",
      }}
    >
      {/* Close button – top right */}
      <button
        onClick={() => setShowCalendarModal(false)}
        style={{
          position: "absolute",
          top: "14px",
          right: "16px",
          background: "none",
          border: "none",
          color: "#aaa",
          fontSize: "1.6rem",
          cursor: "pointer",
          lineHeight: 1,
        }}
      >
        ×
      </button>

      <h3 style={{
        margin: "0 0 1.5rem 0",
        color: "#40c4ff",
        fontSize: "1.5rem",
        fontWeight: 600,
        letterSpacing: "-0.02em",
      }}>
        {addedToCalendar.has(modalActivity.supercurricular_id) 
          ? "Edit Calendar Entry" 
          : "Add to Calendar"}
      </h3>

      {/* Activity Card */}
      <div style={{
        background: "rgba(2, 139, 232, 0.08)",
        borderRadius: "12px",
        padding: "1.25rem",
        marginBottom: "1.5rem",
        border: "1px solid rgba(2,139,232,0.25)",
      }}>
        <FaBolt style={{ fontWeight: 600, fontSize: "1.1rem", marginBottom: "0.35rem", color: "#40c4ff" }} />
          {' '}{modalActivity.title}
        <div style={{ color: "#88ccff", fontSize: "0.9rem", opacity: 0.9 }}>
          {modalActivity.category}
        </div>
      </div>

      {/* Selected Examples (if any) */}
      {modalActivity.selectedExamples?.length > 0 && (
        <div style={{
          marginBottom: "1.5rem",
          padding: "1rem",
          background: "rgba(255, 170, 0, 0.07)",
          border: "1px solid rgba(255,170,0,0.22)",
          borderRadius: "10px",
          fontSize: "0.95rem",
        }}>
          <div style={{
            color: "#ffca28",
            fontWeight: 600,
            marginBottom: "0.7rem",
            fontSize: "1rem",
          }}>
            Activities
          </div>
          <ul style={{
            margin: 0,
            paddingLeft: "1.4rem",
            listStyle: "disc",
            color: "#e0f7ff",
            lineHeight: 1.5,
          }}>
            {modalActivity.selectedExamples.map((ex, i) => (
              <li key={i} style={{ marginBottom: "0.4rem" }}>{ex}</li>
            ))}
          </ul>
        </div>
      )}

      {/* Dates – nicer layout */}
      <div 
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "1.25rem",
        marginBottom: "1.5rem",
      }}>
        <div>
          <label 
          style={{
            display: "block",
            marginBottom: "0.5rem",
            color: "#40c4ff",
            fontSize: "0.95rem",
            fontWeight: 500,
          }}>
            Start Date
          </label>
          <input
            type="date"
            value={tempStartDate}
            onChange={e => setTempStartDate(e.target.value)}
            className="startdate"
            style={{
              width: "100%",
              padding: "0.75rem",
              background: "rgba(20, 30, 60, 0.6)",
              border: "1px solid rgba(2,139,232,0.45)",
              borderRadius: "8px",
              color: "white",
              fontSize: "1rem",
            }}
          />
        </div>

        <div>
          <label style={{
            display: "block",
            marginBottom: "0.5rem",
            color: "#40c4ff",
            fontSize: "0.95rem",
            fontWeight: 500,
          }}>
            End Date
          </label>
          <input
            type="date"
            value={tempEndDate}
            min={tempStartDate}
            onChange={e => setTempEndDate(e.target.value)}
            className="startdate"
            style={{
              width: "100%",
              padding: "0.75rem",
              background: "rgba(20, 30, 60, 0.6)",
              border: "1px solid rgba(2,139,232,0.45)",
              borderRadius: "8px",
              color: "white",
              fontSize: "1rem",
            }}
          />
        </div>
      </div>

      {/* New: Description field */}
      <div style={{ marginBottom: "1.75rem" }}>
        <label style={{
          display: "block",
          marginBottom: "0.5rem",
          color: "#40c4ff",
          fontSize: "0.95rem",
          fontWeight: 500,
        }}>
          Notes <small style={{ opacity: 0.7 }}>(optional)</small>
        </label>
        <textarea
        className='space-scroll'
          value={modalActivity.description || ""}
          onChange={(e) => {
            setModalActivity(prev => ({
              ...prev,
              description: e.target.value
            }));
          }}
          placeholder="e.g. Prepare presentation slides, contact mentor, read chapter 3–5, etc."
          rows={3}
          style={{
            width: "100%",
            padding: "0.8rem",
            background: "rgba(20, 30, 60, 0.6)",
            border: "1px solid rgba(2,139,232,0.45)",
            borderRadius: "8px",
            color: "white",
            fontSize: "0.97rem",
            resize: "vertical",
            minHeight: "86px",
            lineHeight: 1.45,
          }}
        />
      </div>

      {/* Buttons */}
      <div 
      className="calendar-button-row"
      style={{
        display: "flex",
        gap: "1rem",
        justifyContent: addedToCalendar.has(modalActivity.supercurricular_id) 
          ? "space-between" 
          : "flex-end",
        marginTop: "1rem",
      }}>
              {addedToCalendar.has(modalActivity.supercurricular_id) && (
          <button
            onClick={async () => {
              const ok = await confirm("Remove this activity from your calendar?", { danger: true });
              if (!ok) return;
              setCalendarEvents(prev => 
                prev.filter(ev => ev.supercurricular_id !== modalActivity.supercurricular_id)
              );
              setShowCalendarModal(false);
            }}
            style={{
              padding: "0.75rem 1.5rem",
              background: "#780101",
              color: "white",
              border: "none",
              borderRadius: "8px",
              fontWeight: 500,
              cursor: "pointer",
            }}
          >
            Delete
          </button>
        )}

        <div style={{ display: "flex", gap: "1rem" }}>
          <button
            onClick={() => setShowCalendarModal(false)}
            style={{
              padding: "0.75rem 1.5rem",
              background: "transparent",
              border: "1px solid #555",
              color: "#ccc",
              borderRadius: "8px",
              fontWeight: 500,
              cursor: "pointer",
            }}
          >
            Cancel
          </button>

          <button
            onClick={() => {
                         if (!tempStartDate || !tempEndDate) {
                showToast("Please select both start and end dates.", "error");
                return;
              }
              if (new Date(tempEndDate) < new Date(tempStartDate)) {
                showToast("End date cannot be before start date.", "error");
                return;
              }

              const eventData = {
              supercurricular_id: modalActivity.supercurricular_id,
              title: modalActivity.title,
              category: modalActivity.category,
              universitySubject: selectedSuperSubject,     
              startDate: tempStartDate,
              endDate: tempEndDate,
              description: modalActivity.description?.trim() || "",   // ← always include (empty string if blank)
              selectedExamples: modalActivity.selectedExamples || [],
              addedAt: new Date().toISOString(),
              };

              if (addedToCalendar.has(modalActivity.supercurricular_id)) {
                // Update
                setCalendarEvents(prev =>
                  prev.map(ev =>
                    ev.supercurricular_id === modalActivity.supercurricular_id
                      ? { ...ev, ...eventData }
                      : ev
                  )
                );
                           showToast("Calendar entry updated.", "success");
              } else {
                // Create
                setCalendarEvents(prev => [
                  ...prev,
                  { ...eventData, id: Date.now().toString() }
                ]);
                showToast("Activity added to your calendar!", "success");
              }
              setShowCalendarModal(false);
            }}
            style={{
              padding: "0.75rem 1.8rem",
              background: "#028be8)",
              color: "white",
              border: "none",
              borderRadius: "8px",
              fontWeight: 600,
              cursor: "pointer",
              boxShadow: "0 4px 14px rgba(2,139,232,0.4)",
            }}
          >
            {addedToCalendar.has(modalActivity.supercurricular_id) 
              ? "Save" 
              : "Add to Calendar"}
          </button>
        </div>
      </div>
    </div>
  </div>
)}

{/* === My Plan Modal — Plan / Log / Reflect === */}
{showPlanModal && currentPlanActivityId && (() => {
  const plan = getPlan(currentPlanActivityId);
  const activityTitle = supercurricularActivities.find(
    (a) => a.supercurricular_id === currentPlanActivityId
  )?.activity_title || '';
  const statusMeta = PLAN_STATUS_OPTIONS.find((s) => s.key === plan.status) || PLAN_STATUS_OPTIONS[0];

return (
  <div
    className="modal-overlay"
    onClick={() => setShowPlanModal(false)}
    style={{
      position: 'fixed', inset: 0, zIndex: 2100, background: '#000000e3',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px',
    }}
  >
    <div
      className="my-plan-modal"
      onClick={(e) => e.stopPropagation()}
      style={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        width: 'min(900px, 100%)',
        height: 'auto',
        maxHeight: '92vh',          // use '92dvh' too if mobile browser bars clip it
        boxSizing: 'border-box',
        overflow: 'hidden',         // the box itself never overflows...
        border: '1px solid #028ce885',
        borderRadius: '20px',
        padding: '25px',
      }}
    >
      {/* Close button lives outside the scroll area so it stays put */}
      <button
        className="my-plan-cross"
        onClick={() => setShowPlanModal(false)}
        aria-label="Close journal"
        style={{
          position: 'absolute', top: '14px', right: '16px', zIndex: 2,
          fontSize: '1.8rem', background: 'none', border: 'none', color: '#aaa', cursor: 'pointer',
        }}
      >
        ×
      </button>

      {/* ...this inner area scrolls instead */}
      <div
        className="invisible-scroll"
        style={{ flex: 1, minHeight: 0, overflowY: 'auto', paddingRight: '6px' }}
      >
        <h3 style={{ color: '#ffaa00', marginBottom: '8px' }}>Activity Journal</h3>

        <div
          className="your-reflection-notice-knowledge"
          style={{ fontStyle: 'normal', marginTop: '-5px', marginBottom: '5px', textAlign: 'left', color: '#757575', fontSize: '14px' }}
        >
          <p>Your Journal is saved locally in this browser only.</p>
        </div>
        <p style={{ color: "#bbb", marginBottom: "20px" }}>{activityTitle}</p>

        {/* ── Status selector ── */}
        <div style={{ marginBottom: "22px" }}>
       <label style={{ display: "block", fontSize: "13px", color: "#40b3ff", fontWeight: 700, marginBottom: "8px", textTransform: "uppercase" }}>
  Current Status
</label>
<div style={{ marginLeft: "-10px", display: "flex", gap: "8px", flexWrap: "wrap" }}>
  {PLAN_STATUS_OPTIONS.map((opt) => {
    const isSelected = plan.status === opt.key;
    const Icon = opt.icon;
    return (
      <button
        key={opt.key}
        onClick={() => updatePlanField(currentPlanActivityId, 'status', opt.key)}
        style={{
          display: "inline-flex", alignItems: "center", gap: "6px",
          padding: "7px 14px", borderRadius: "999px", fontSize: "13px", fontWeight: 600,
          border: "none",
          background: "none",
          color: isSelected ? opt.color : "#aaa",
          cursor: "pointer",
          transition: "all 0.15s ease",
        }}
      >
        <Icon size={13} style={{ color: isSelected ? opt.color : '#888' }} />
        {opt.label}
      </button>
    );
  })}
</div>
        </div>

            {/* ── Goal + Why it matters (set once, editable) ── */}
        <div style={{ display: "grid", gap: "16px", marginBottom: "22px" }}>
          <div>
            <label style={{ display: "block", fontSize: "12px", color: "#9fb8d4", marginBottom: "6px" }}>
              My goal
            </label>
            <textarea
            className='space-scroll'
              value={plan.goal}
              onChange={(e) => updatePlanField(currentPlanActivityId, 'goal', e.target.value)}
              placeholder="What am I trying to achieve here? Be specific — e.g. 'Lead the fundraising subgroup and raise £200' rather than 'get involved more'."
              rows={3}
              maxLength={500}
              style={{
                width: "100%", background: "rgba(20,30,60,0.7)", border: "1px solid #028be8",
                borderRadius: "8px", color: "white", padding: "12px", fontSize: "14px",
                lineHeight: 1.5, resize: "vertical", boxSizing: "border-box",
              }}
            />
          </div>

          {/* Measurable + Time-bound — optional, lightweight, never block a
              quick one-line goal, but give the SMART-minded student a place
              to sharpen it without a rigid form. */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 160px", gap: "12px" }}>
            <div>
              <label style={{ display: "block", fontSize: "12px", color: "#9fb8d4", marginBottom: "6px" }}>
                Success looks like <span style={{ color: "#5a6b85", fontWeight: 400 }}>(optional)</span>
              </label>
              <input
                type="text"
                value={plan.successMetric}
                onChange={(e) => updatePlanField(currentPlanActivityId, 'successMetric', e.target.value)}
                placeholder="How will I know I've achieved it? e.g. 'Completed 3 sessions' or 'Raised £200'"
                maxLength={150}
                style={{
                  width: "100%", background: "rgba(20,30,60,0.7)", border: "1px solid rgba(2,139,232,0.45)",
                  borderRadius: "8px", color: "white", padding: "10px 12px", fontSize: "13.5px",
                  boxSizing: "border-box",
                }}
              />
            </div>
            <div>
              <label style={{ display: "block", fontSize: "12px", color: "#9fb8d4", marginBottom: "6px" }}>
                Target date <span style={{ color: "#5a6b85", fontWeight: 400 }}>(optional)</span>
              </label>
              <input
                type="date"
                value={plan.targetDate}
                onChange={(e) => updatePlanField(currentPlanActivityId, 'targetDate', e.target.value)}
                style={{
                  width: "100%", background: "rgba(20,30,60,0.7)", border: "1px solid rgba(2,139,232,0.45)",
                  borderRadius: "8px", color: "white", padding: "9px 10px", fontSize: "13.5px",
                  boxSizing: "border-box", colorScheme: "dark",
                }}
              />
            </div>
          </div>

          <div>
            <label style={{ display: "block", fontSize: "12px", color: "#9fb8d4", marginBottom: "6px" }}>
              Why this matters
            </label>
            <textarea
              value={plan.whyItMatters}
              onChange={(e) => updatePlanField(currentPlanActivityId, 'whyItMatters', e.target.value)}
              placeholder="How does this connect to my subject or future goals?"
              rows={2}
              maxLength={500}
              className="space-scroll"
              style={{
                width: "100%", background: "rgba(20,30,60,0.7)", border: "1px solid #028be8",
                borderRadius: "8px", color: "white", padding: "12px", fontSize: "14px",
                lineHeight: 1.5, resize: "vertical", boxSizing: "border-box",
              }}
            />
          </div>
        </div>

        {/* ── Progress Log — dated entries, newest first ── */}
        <div style={{ marginBottom: "22px" }}>
          <label style={{ display: "block", fontSize: "13px", color: "#40b3ff", fontWeight: 700, marginBottom: "10px", textTransform: "uppercase" }}>
            My Progress {plan.logEntries.length > 0 && `(${plan.logEntries.length})`}
          </label>

          <div style={{ display: "flex", gap: "10px", marginBottom: "14px" }}>
            <input
              type="text"
              value={planLogDraft[currentPlanActivityId] || ''}
              onChange={(e) => setPlanLogDraft((prev) => ({ ...prev, [currentPlanActivityId]: e.target.value }))}
              onKeyDown={(e) => { if (e.key === 'Enter') addPlanLogEntry(currentPlanActivityId); }}
              placeholder="What did I achieve? e.g. Attended first session, emailed mentor..."
              maxLength={300}
              style={{
                flex: 1, background: "rgba(20,30,60,0.6)", border: "1px solid rgba(2,139,232,0.45)",
                borderRadius: "8px", color: "white", padding: "10px 12px", fontSize: "14px",
              }}
            />
            <button
              onClick={() => addPlanLogEntry(currentPlanActivityId)}
              disabled={!(planLogDraft[currentPlanActivityId] || '').trim()}
              style={{
                padding: "0 18px", borderRadius: "8px", border: "none", fontWeight: 700, fontSize: "13px",
                background: (planLogDraft[currentPlanActivityId] || '').trim() ? "#028be8" : "#334155",
                color: (planLogDraft[currentPlanActivityId] || '').trim() ? "white" : "#94a3b8",
                cursor: (planLogDraft[currentPlanActivityId] || '').trim() ? "pointer" : "not-allowed",
              }}
            >
              Add
            </button>
          </div>

          {plan.logEntries.length > 0 ? (
            <div style={{ display: "flex", flexDirection: "column", gap: "8px", maxHeight: "220px", overflowY: "auto" }}>
              {plan.logEntries.map((entry) => (
                <div
                  key={entry.id}
                  style={{
                    display: "flex", justifyContent: "space-between", alignItems: "flex-start",
                    background: "rgba(255,255,255,0.04)", borderRadius: "8px", padding: "10px 12px",
                    borderLeft: `3px solid ${statusMeta.color}`,
                  }}
                >
                  <div>
                    <div style={{ fontSize: "11px", color: "#888", marginBottom: "3px" }}>
                      {formatPlanLogDate(entry.ts)}
                    </div>
                    <div style={{ fontSize: "13.5px", color: "#ddd", lineHeight: 1.4 }}>{entry.text}</div>
                  </div>
                  <button
                    onClick={() => deletePlanLogEntry(currentPlanActivityId, entry.id)}
                    style={{ background: "none", border: "none", color: "#666", fontSize: "11px", cursor: "pointer", flexShrink: 0, marginLeft: "10px" }}
                  >
                    Remove
                  </button>
                </div>
              ))}
            </div>
          ) : (
            <p style={{ margin: 0, fontSize: "12.5px", color: "#666", fontStyle: "italic" }}>
            </p>
          )}
        </div>

{/* ── Skills developed ── */}
<div style={{ marginBottom: "22px" }}>
  <label style={{ display: "block", fontSize: "13px", color: "#40b3ff", fontWeight: 700, marginBottom: "4px", textTransform: "uppercase" }}>
    Skills Developed
  </label>
  <p style={{ margin: "0 0 10px 0", fontSize: "11.5px", color: "#888" }}>
    Choose up to 3.
  </p>
  <StudyChoiceChips
    options={SKILLS_DEVELOPED_OPTIONS}
    selected={plan.skillsDeveloped}
    max={3}
    onToggle={(skill) => toggleSkillDeveloped(currentPlanActivityId, skill, 3)}
  />
</div>

        {/* ── Reflection — only unlocked once marked Completed ── */}
        {plan.status === 'completed' && (
          <div style={{ marginBottom: "10px" }}>
            <label style={{ display: "block", fontSize: "13px", color: "#40b3ff", fontWeight: 700, marginBottom: "8px", textTransform: "uppercase" }}>
              My Reflection
            </label>
            <textarea
                        className='space-scroll'
              value={plan.outcomeReflection}
              onChange={(e) => updatePlanField(currentPlanActivityId, 'outcomeReflection', e.target.value)}
              placeholder="What's the most valuable thing you learned?"
              rows={3}
              maxLength={800}
              style={{
                width: "100%", background: "rgba(2,139,232,0.08)", border: "1px solid #028be8",
                borderRadius: "8px", color: "white", padding: "12px", fontSize: "14px",
                lineHeight: 1.5, resize: "vertical", boxSizing: "border-box",
              }}
            />
          </div>
        )}

        <div style={{ marginTop: "40px", display: "flex", gap: "12px", justifyContent: "space-between", alignItems: "center" }}>
          <button
            className="my-plan-learning-record"
            onClick={handleDownloadPlanDocx}
            title="Download activity details and your plan as a Word document"
            style={{
              display: "inline-flex", alignItems: "center", gap: "8px", padding: "10px 18px",
              background: "transparent", color: "#00e1ff", border: "1px solid #00e1ff",
              borderRadius: "8px", fontWeight: "600", cursor: "pointer", transition: "all 0.2s ease",
            }}
            onMouseOver={(e) => (e.currentTarget.style.background = "rgba(0,225,255,0.12)")}
            onMouseOut={(e) => (e.currentTarget.style.background = "transparent")}
          >
            <FaDownload /> Learning Record
     </button>
        </div>
      </div>   {/* closes .invisible-scroll */}
    </div>   
  </div>       
);
})()}

  </div>
) : (
  <div className="select-prompt">
 <p style={{ color: '#ffaa00', textAlign: 'center', margin: '40px 0' }}>
  {currentActivities.length === 0 && scFiltersActive
    ? 'Try another category tab or adjust your filters.'
    : 'Click an activity title on the left to view details.'}
</p>
  </div>
)}
                        </td>
                      </tr>
                    </tbody>
                                    </table>
                </div>
                </>
                )}
          </div>
        )}
      </div>
    </div>
  );
};

// Color accent per type, used on the notes editor border for quick visual grouping
const getAccentColor = (type) => {
  switch (type) {
    case 'video': return '#f63e3e';
    case 'audio': return '#9b59b6';
    case 'free-course': return '#00cc99';
    default: return '#028be8';
  }
};

const inputStyle = {
  padding: '9px 11px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.15)',
  borderRadius: '6px', color: 'white', fontSize: '13px', boxSizing: 'border-box', width: '100%',
};

const AddResourceForm = ({
  type,
  isOpen,
  draft,
  isEditing,
  isReadOnly,
  onOpen,
  onCancel,
  onFieldChange,
  onSubmit,
}) => {
  const accentColor = getAccentColor(type);
  const typeLabel = type === 'print' ? 'reading' : type === 'video' ? 'video' : type === 'audio' ? 'podcast' : 'free course';

  // Simple local state for the form
  const [formData, setFormData] = useState({});
  const { showToast } = useUIFeedback();

  // Reset form when it opens
  useEffect(() => {
    if (isOpen) {
      setFormData({ ...draft });
    }
  }, [isOpen, draft]);

  // Handle input changes
  const handleChange = (field, value) => {
    const newData = { ...formData, [field]: value };
    setFormData(newData);
  };

  // Handle save
  const handleSave = (e) => {
    e.stopPropagation();
    
    const title = formData.title?.trim();
    if (!title) {
      showToast('Please enter a title.', 'error');
      return;
    }

    // Submit the form data directly
    onSubmit(formData);
  };

  // Handle cancel
  const handleCancelClick = (e) => {
    e.stopPropagation();
    onCancel();
  };

  // Handle open
  const handleOpenClick = (e) => {
    e.stopPropagation();
    onOpen();
  };

  // Stop propagation
  const stopPropagation = (e) => {
    e.stopPropagation();
  };

  if (!isOpen) {
    return (
      <button
      className="add-resource first-time-reason-prompt"
        onClick={handleOpenClick}
        style={{
          display: 'flex', alignItems: 'center', gap: '8px', width: '104%',
          padding: '12px 16px', marginTop: '14px',
          background: 'rgba(255,255,255,0.03)', border: `1px dashed ${accentColor}66`,
          borderRadius: '10px', color: `${accentColor}80`, fontSize: '13.5px', fontWeight: 600,
          cursor: isReadOnly ? 'not-allowed' : 'pointer', opacity: isReadOnly ? 0.5 : 1,
        }}
        disabled={isReadOnly}
        type="button"
      >
        <FaPlus size={12} /> Add your own {typeLabel} resource
      </button>
    );
  }

  return (
    <div 
    className="first-time-reason-prompt"
      style={{
        marginTop: '14px', padding: '16px', borderRadius: '10px',
        background: `${accentColor}0d`, border: `1px solid ${accentColor}55`,
        width: '104%',     
      }}
      onClick={stopPropagation}
      onMouseDown={stopPropagation}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px'}}>
        <span className="cyber-table-knowledge-add" style={{ fontSize: '13px', fontWeight: 700, color: accentColor, textTransform: 'uppercase' }}>
          {isEditing ? 'Edit your resource' : `Add your own ${typeLabel} resource`}
        </span>
        <button 
          onClick={handleCancelClick}
          type="button"
          style={{ background: 'none', border: 'none', color: '#888', cursor: 'pointer', fontSize: '18px' }}
        >
          ×
        </button>
      </div>

<div className="add-resource-form-grid" style={{ display: 'grid', gridTemplateColumns: type === 'free-course' ? '1fr 1fr' : '1fr', gap: '10px', marginBottom: '10px' }}>
          <input
          placeholder="Title *"
          value={formData.title || ''}
          onChange={(e) => handleChange('title', e.target.value)}
          onMouseDown={stopPropagation}
          onClick={stopPropagation}
          style={inputStyle}
          autoFocus={!isEditing}
        />
        {type === 'free-course' ? (
          <input 
            placeholder="Source (e.g. Coursera, MIT)" 
            value={formData.source || ''} 
            onChange={(e) => handleChange('source', e.target.value)}
            onMouseDown={stopPropagation}
            onClick={stopPropagation}
            style={inputStyle} 
          />
        ) : (
          <input 
            placeholder="Author" 
            value={formData.author || ''} 
            onChange={(e) => handleChange('author', e.target.value)}
            onMouseDown={stopPropagation}
            onClick={stopPropagation}
            style={inputStyle} 
          />
        )}

        {type !== 'print' && (
          <input 
            placeholder="Link (https://...)" 
            value={formData.link || ''} 
            onChange={(e) => handleChange('link', e.target.value)}
            onMouseDown={stopPropagation}
            onClick={stopPropagation}
            style={{ ...inputStyle, gridColumn: type === 'free-course' ? 'span 2' : 'auto' }} 
          />
        )}

        {type === 'free-course' && (
          <>
            <select 
              value={formData.difficulty || ''} 
              onChange={(e) => handleChange('difficulty', e.target.value)}
              onMouseDown={stopPropagation}
              onClick={stopPropagation}
  style={{ ...inputStyle, fontSize: '13px', border: '1px solid #b1b1b142', color: '#b1b1b1b1', background: '#000000ec' }}
            >
              <option value="">Difficulty</option>
              <option value="beginner">Beginner</option>
              <option value="intermediate">Intermediate</option>
              <option value="advanced">Advanced</option>
            </select>
            <input 
              placeholder="Duration (e.g. 6 hours, 4 weeks)" 
              value={formData.duration || ''} 
              onChange={(e) => handleChange('duration', e.target.value)}
              onMouseDown={stopPropagation}
              onClick={stopPropagation}
              style={inputStyle} 
            />
            <textarea
            className='space-scroll'
              placeholder="Details / description"
              value={formData.details || ''}
              onChange={(e) => handleChange('details', e.target.value)}
              onMouseDown={stopPropagation}
              onClick={stopPropagation}
              rows={2}
              style={{ ...inputStyle, gridColumn: 'span 2', resize: 'vertical' }}
            />
          </>
        )}
      </div>

      <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
        <button 
        className="add-resource-knowledge" 
          onClick={handleCancelClick}
          type="button"
          style={{ padding: '6px 14px', background: 'none', border: '1px solid #555', color: '#ccc', borderRadius: '6px', cursor: 'pointer', fontSize: '12.5px' }}
        >
          Cancel
        </button>
        <button
        className="add-resource-knowledge" 
          onClick={handleSave}
          type="button"
          style={{ padding: '6px 16px', background: accentColor, color: '#0a0f1f', border: 'none', borderRadius: '6px', fontWeight: 700, cursor: 'pointer', fontSize: '12.5px' }}
        >
          {isEditing ? 'Save Changes' : 'Add Resource'}
        </button>
      </div>
    </div>
  );
};

const DIFFICULTY_ORDER = { beginner: 0, intermediate: 1, advanced: 2 };

const sortByDifficulty = (resources) => {
  return [...resources].sort((a, b) => {
    const rankA = DIFFICULTY_ORDER[(a.difficulty || '').toLowerCase()] ?? 99;
    const rankB = DIFFICULTY_ORDER[(b.difficulty || '').toLowerCase()] ?? 99;
    return rankA - rankB;
  });
};

// 3-bar difficulty indicator: beginner=1 green, intermediate=2 orange, advanced=3 red
const DifficultyBars = ({ difficulty }) => {
  const level = (difficulty || '').toLowerCase();
  const config = {
    beginner: { filled: 1, color: '#00cc99' },
    intermediate: { filled: 2, color: '#ffd700' },
    advanced: { filled: 3, color: '#ff6b6b' },
  };
  const { filled, color } = config[level] || { filled: 0, color: '#666' };

  return (
    <span
      title={difficulty ? difficulty.charAt(0).toUpperCase() + difficulty.slice(1) : 'Unknown'}
      style={{   
      background: color + '22',
      padding: '6px 14px',
      color,
      border: `1px solid ${color}44`,
      borderRadius: '100px',
      display: 'inline-flex', 
      alignItems: 'flex-end',
      gap: '2px', 
      verticalAlign: 'middle' }}
    >
      {[1, 2, 3].map((barIndex) => (
        <span
          key={barIndex}
          style={{
            display: 'inline-block',
            width: '4px',
            height: `${5 + barIndex * 3}px`,
            borderRadius: '1px',
            background: barIndex <= filled ? color : 'rgba(255,255,255,0.15)',
            transition: 'background 0.2s ease',
          }}
        />
      ))}
      {difficulty && (
  <span style={{ 
      marginLeft: '5px', 
      fontSize: '11.5px', 
      color, 
      textTransform: 'capitalize',
      display: 'inline-block', // Added to respect vertical alignment
      lineHeight: '1'          // Added to remove default bottom font padding
    }}>
                {difficulty}
        </span>
      )}
    </span>
  );
};

const getFreeCourseCalendarId = (subject, title) => {
  const norm = (s) => (s || '').toLowerCase().trim().replace(/\s+/g, '_');
  return `freecourse_${norm(subject)}_${norm(title)}`;
};

// Render Knowledge page
const renderKnowledgePage = () => {
  const hasUniReadyOrChosen = sortedScores.length > 0 || chosenTopSubject;
 
  // ── Resource splits ────────────────────────────────────────────────────────
const printResources = [...knowledgeResources.filter((r) => r.resourceType === 'print'), ...getUserResourcesForType('print')];
const videoResources = [...knowledgeResources.filter((r) => r.resourceType === 'video'), ...getUserResourcesForType('video')];
const audioResources = [...knowledgeResources.filter((r) => r.resourceType === 'audio'), ...getUserResourcesForType('audio')];

// Free courses: CMS resources sorted by difficulty first, user resources appended at the bottom
const freeCourseResources = [
  ...sortByDifficulty(knowledgeResources.filter((r) => r.resourceType === 'free-course')),
  ...getUserResourcesForType('free-course'),
];
const hasMedia = videoResources.length > 0 || audioResources.length > 0;

// ── Completion progress (Reading + Video/Podcast + Free Courses).
// Free courses don't have a "completed" checkbox — being scheduled on the
// calendar is their completion signal, matching how they're actioned
// elsewhere on this page. ──
const countCompleted = (list, type) =>
  list.filter((_, i) => checkboxStates[`db_${type}_${selectedKnowledgeSubject}_${i}`]).length;
const printCompletedCount = countCompleted(printResources, 'print');
const videoCompletedCount = countCompleted(videoResources, 'video');
const audioCompletedCount = countCompleted(audioResources, 'audio');
const freeCourseScheduledCount = freeCourseResources.filter((r) =>
  addedToCalendar.has(getFreeCourseCalendarId(selectedKnowledgeSubject, r.resourceTitle))
).length;
const totalTrackable = printResources.length + videoResources.length + audioResources.length + freeCourseResources.length;
const totalCompleted = printCompletedCount + videoCompletedCount + audioCompletedCount + freeCourseScheduledCount;
const notesAddedCount = Object.values(resourceNotes).filter((n) => hasAnyNoteContent(n)).length;

// First not-yet-completed resource across ALL types (Reading → Video →
// Podcast → Free Course), in that priority order — powers "Jump to next
// unread". Each entry knows which tab it lives on so the button can switch
// tabs before scrolling.
const nextUnreadResource = (() => {
  const sections = [
    { type: 'print', tab: 'print', list: printResources, isDone: (r, i) => !!checkboxStates[`db_print_${selectedKnowledgeSubject}_${i}`] },
    { type: 'video', tab: 'media', list: videoResources, isDone: (r, i) => !!checkboxStates[`db_video_${selectedKnowledgeSubject}_${i}`] },
    { type: 'audio', tab: 'media', list: audioResources, isDone: (r, i) => !!checkboxStates[`db_audio_${selectedKnowledgeSubject}_${i}`] },
    {
      type: 'free-course', tab: 'freecourse', list: freeCourseResources,
      isDone: (r) => addedToCalendar.has(getFreeCourseCalendarId(selectedKnowledgeSubject, r.resourceTitle)),
    },
  ];

  for (const section of sections) {
    const idx = section.list.findIndex((r, i) => !section.isDone(r, i));
    if (idx !== -1) {
      return { tab: section.tab, rowId: `db_${section.type}_${selectedKnowledgeSubject}_${idx}` };
    }
  }
  return null;
})();

const scrollToRow = (rowId) => {
  if (!rowId) return;
  const el = document.querySelector(`[data-row-id="${CSS.escape(rowId)}"]`);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const orig = el.style.backgroundColor;
    el.style.backgroundColor = 'rgba(0,204,153,0.14)';
    setTimeout(() => { el.style.backgroundColor = orig || ''; }, 1800);
  }
};


  // ── YouTube embed URL helper ───────────────────────────────────────────────
  const toYoutubeEmbed = (url) => {
    if (!url) return null;
    try {
      const u = new URL(url);
      let videoId = null;
      if (u.hostname.includes('youtu.be')) {
        videoId = u.pathname.slice(1);
      } else if (u.hostname.includes('youtube.com')) {
        videoId = u.searchParams.get('v');
      }
      return videoId ? `https://www.youtube.com/embed/${videoId}?autoplay=1` : null;
    } catch {
      return null;
    }
  };
 
  // ── Shared: build insight prompt ───────────────────────────────────────────
const buildInsightPrompt = (resourceTitle, author, type) => {
  const authorText = author && author.trim() ? ` — ${author}` : '';
  const typeLabel = type === 'video' ? 'YouTube lecture/video' : type === 'audio' ? 'podcast episode' : 'reading resource';
  return `You are an experienced Oxbridge/Ivy League academic tutor advising a very ambitious 17–18-year-old preparing for top-tier university applications and interviews.

Your task is to write a short, high-signal introduction that helps the student decide whether this ${typeLabel} is worth their time. The introduction must work strictly as a teaser — it should never replace the work of actually engaging with the resource.

Strict rules:
- Do not summarise or list the main arguments, conclusions, key concepts, or evidence.
- Do not give any concrete takeaways or points the student could use in essays, interviews, or personal statements.
- Do not reveal the intellectual payoff. Leave real curiosity intact.
- Write in clear, direct language that an intelligent high-school student can easily understand. Avoid dense academic jargon or overly complex sentences. Be precise but readable.

Structure your response using exactly these headings:

1. Why This Resource Is Worth Considering
   (2–3 clear sentences on the intellectual area it covers and why a serious applicant in ${selectedKnowledgeSubject} might find it valuable. Keep it high-level.)

2. What Kind of Thinking It Demands
   (Briefly describe the level of challenge, style of thinking, or intellectual effort required — without mentioning any specific ideas.)

3. University-Level Signal
   (Explain how seriously engaging with this kind of material can strengthen a student’s thinking or preparation for university. Do not give ready-made points.)

4. One Thought-Provoking Question
   (One strong, open-ended question that could spark deeper thinking or serve as an interview discussion starter. The question must be answerable only after the student has properly engaged with the resource.)

Resource: ${resourceTitle}${authorText}

Keep the total length between 180–250 words. Be clear, confident, and slightly challenging in tone, but always easy for a high-school student to follow.`;
};
 
  const handleCopyAndOpenGrok = async (resourceTitle, author, type) => {
    const prompt = buildInsightPrompt(resourceTitle, author, type);
    let copied = false;
    try {
      await navigator.clipboard.writeText(prompt);
      copied = true;
    } catch {
      copied = false;
    }

    const proceed = await confirm(
      copied
        ? `The prompt has been copied. Paste it into Grok to get an insightful summary for: ${resourceTitle}`
        : "Couldn't copy the prompt automatically. Check the browser console for it, then paste it into Grok yourself.",
      { title: "Ready for Grok", confirmLabel: "Proceed" }
    );
    if (!copied) console.log(prompt);
    if (proceed) window.open('https://grok.com', '_blank', 'noopener,noreferrer');
  };

    // ── Recommend further resources from My Takes ─────────────────────────────
  const buildRecommendResourcesPrompt = (resource, type, note) => {
    const title = resource.resourceTitle || 'Untitled resource';
    const authorOrSource =
      type === 'free-course'
        ? (resource.source || '').trim()
        : (resource.author || '').trim();
    const typeLabel =
      type === 'video'
        ? 'video'
        : type === 'audio'
        ? 'podcast / audio'
        : type === 'free-course'
        ? 'free course'
        : 'reading / print';

    const confidenceLabel =
      CONFIDENCE_OPTIONS.find((o) => o.key === note?.confidence)?.label || null;

    const takesLines = [];
    if (note?.takeaway?.trim()) takesLines.push(`Key takeaway: ${note.takeaway.trim()}`);
    if (note?.unclear?.trim()) takesLines.push(`Explore next / still curious about: ${note.unclear.trim()}`);
    if (note?.tag?.trim()) takesLines.push(`Tags: ${note.tag.trim()}`);
    if (confidenceLabel) takesLines.push(`Understanding: ${confidenceLabel}`);
    if (note?.usefulness > 0) takesLines.push(`Usefulness rating: ${note.usefulness}/5`);

    const takesBlock =
      takesLines.length > 0
        ? takesLines.join('\n')
        : '(No My Takes notes yet — recommend based on the resource and subject only.)';

    return `You are an academic mentor helping a motivated high-school / early university student deepen their knowledge for competitive university applications.

Subject focus: ${selectedKnowledgeSubject || 'N/A'}
Current resource type: ${typeLabel}
Current resource title: ${title}${authorOrSource ? `\nAuthor / source: ${authorOrSource}` : ''}
${resource.resourceLink ? `Link (if available): ${resource.resourceLink}` : ''}
${type === 'free-course' && resource.description ? `Course details: ${resource.description}` : ''}

Student's My Takes on this resource:
${takesBlock}

Task:
Recommend exactly 5 further high-quality ${typeLabel} resources that build on this one and on the student's notes (especially any "explore next" themes). Prefer free or easily accessible materials where possible.

For each of the 5 ${typeLabel} resource recommendations, provide:
1. Title
2. Author or source (if known)
3. Why it fits (1–2 sentences tied to the current resource and the student's takes)
4. Suggested next step (how to use it)
5. A search query or likely URL the student can use to find it

Constraints:
- Make the set complementary (not five near-duplicates of the same resource).
- Match roughly the student's level and interest signal from My Takes.
- Keep the total response concise and scannable.
- Do not invent paywalled-only must-haves if free alternatives exist.`;
  };

  const handleRecommendResources = async (resource, type, note) => {
    const prompt = buildRecommendResourcesPrompt(resource, type, note);
    let copied = false;
    try {
      await navigator.clipboard.writeText(prompt);
      copied = true;
    } catch {
      copied = false;
    }

    const proceed = await confirm(
      copied
        ? 'The prompt has been copied. Paste it into Google Gemini to get 5 further resource recommendations.'
        : "Couldn't copy the prompt automatically. Check the browser console for it, then paste it into Google Gemini yourself.",
      { title: 'Ready for Google AI', confirmLabel: 'Open Google AI' }
    );
    if (!copied) console.log(prompt);
    if (proceed) {
      window.open('https://gemini.google.com/app', '_blank', 'noopener,noreferrer');
    }
  };

const noteTextareaStyle = (accentColor, disabled) => ({
  width: '100%',
  background: 'rgba(255,255,255,0.05)',
  border: `1px solid ${accentColor}55`,
  borderRadius: '8px',
  padding: '9px 12px',
  color: 'white',
  fontSize: '13.5px',
  lineHeight: 1.5,
  resize: 'none',
  minHeight: '40px',
  maxHeight: '200px',
  overflowY: 'auto',
  boxSizing: 'border-box',
  opacity: disabled ? 0.6 : 1,
  cursor: disabled ? 'not-allowed' : 'text',
  fontFamily: 'inherit',
});

const getResourceHeaderContent = (type) => {
  switch (type) {
    case 'print':
      return (
        <>
          Discovery Material: Reading{' '}
          <span className="cyber-table-knowledge-icon" 
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginLeft: '8px',
              width: '22px',
              height: '22px',
              borderRadius: '50%',
              background: '#028be8',
              flexShrink: 0,
              color: 'white',
              fontSize: '11px',
            }}
          >
            <FaBookOpen />
          </span>
        </>
      );
    case 'video':
      return (
        <>
          Discovery Material: Video{' '}
          <span className="cyber-table-knowledge-icon" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginLeft: '8px', width: '22px', height: '22px', borderRadius: '50%', background: '#ff0000', flexShrink: 0 }}>
            <span   style={{ display: 'inline-block', width: 0, height: 0, borderTop: '5px solid transparent', borderBottom: '5px solid transparent', borderLeft: '9px solid white', marginLeft: '2px' }} />
          </span>
        </>
      );
    case 'audio':
      return (
        <>
          Discovery Material: Podcast{' '}
          <span className="cyber-table-knowledge-icon" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginLeft: '8px', width: '22px', height: '22px', borderRadius: '50%', background: '#9b59b6', flexShrink: 0, color: 'white', fontSize: '12px' }}>♪</span>
        </>
      );
    case 'free-course':
      return (
        <>
          Discovery Material: Free Course{' '}
          <span className="cyber-table-knowledge-icon" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginLeft: '8px', width: '22px', height: '22px', borderRadius: '50%', background: '#00cc99', flexShrink: 0, color: 'white', fontSize: '11px' }}>
            <FaGraduationCap />
          </span>
        </>
      );
    default:
      return 'Discovery Material';
  }
};





  // ── Shared: render one table ───────────────────────────────────────────────
const renderResourceTable = (resources, type) => {
  const isPrint = type === 'print';
  const isFreeCourse = type === 'free-course';
  const accentColor = getAccentColor(type);
  const totalColumns = isPrint ? 4 : 3;

  return (
      <>
    <table className="cyber-table cyber-table-knowledge">
      <thead>
        <tr>
          <th className="table-heading" style={{ width: '100%' }}>{getResourceHeaderContent(type)}</th>
          {isPrint && (
            <th className=" table-heading ai-insight-header" style={{ width: '110px', minWidth: '110px', whiteSpace: 'nowrap' }}>
              AI Intro
            </th>
          )}
<th className="table-heading" style={{ width: '100%',  whiteSpace: 'nowrap' }}>My Takes</th>
<th className="table-heading" style={{ width: isFreeCourse ? '160px' : '100%',  }}>
  {isFreeCourse ? 'Calendar' : 'Completed'}
</th>
        </tr>
      </thead>
      <tbody>
        {resources.length > 0 ? (
          resources.map((resource, index) => {
            const rowId = `db_${type}_${selectedKnowledgeSubject}_${index}`;
            const resourceTitle = resource.resourceTitle || 'No title available';

            const authorRaw = isFreeCourse ? (resource.source || '') : (resource.author || '');
            const authorText = authorRaw && authorRaw.trim() !== '' ? ` - ${authorRaw}` : '';

            const description = isFreeCourse ? (resource.description || '') : '';

            const rawLink = resource.resourceLink || '';
            const resourceUrl = rawLink.trim() !== ''
              ? rawLink
              : `https://www.google.com/search?q=${encodeURIComponent(`${resourceTitle}${authorText}`)}`;

            const resourceMeta = {
              subject: selectedKnowledgeSubject,
              resourceType: type,
              resourceTitle,
              author: (isFreeCourse ? resource.source : resource.author) || null,
              resourceLink: rawLink || null,
              details: isFreeCourse ? (resource.description || null) : null,
              isUserAdded: !!resource.isUserAdded,
            };

            const embedUrl = type === 'video' ? toYoutubeEmbed(resourceUrl) : null;

            const handleResourceClick = (e) => {
              if (type === 'video') {
                e.preventDefault();
                if (embedUrl) {
                  setYoutubePopup({ url: embedUrl, title: resourceTitle });
                } else {
                  window.open(resourceUrl, '_blank', 'noopener,noreferrer');
                }
              }
            };

        const noteEntry = getNote(rowId);
const hasNote = hasAnyNoteContent(noteEntry);
const isNoteOpen = !!expandedNotes[rowId];
const savingState = noteSaveStatus[rowId];

            return (
              <React.Fragment key={rowId}>
<tr data-course-title={isFreeCourse ? resourceTitle : undefined} data-row-id={rowId}>
                    {/* ── Resource title cell ── */}
                  <td>
                    {type === 'video' ? (
                      <button
                        onClick={handleResourceClick}
                        style={{ background: 'none', border: 'none', padding: 0, color: '#028be8', cursor: 'pointer', fontSize: 'inherit', fontWeight: '100', textAlign: 'left', textDecoration: 'none' }}
                        title="Open YouTube video"
                      >
                        <span style={{}}>
                          <span style={{ }} />
                        </span>
                        {resourceTitle}
                        {authorText && <span className="cyber-table-knowledge-author" style={{ color: '#606060d6', fontSize: '13px' }}>{authorText}</span>}
                      {resource.isUserAdded && (
  <span style={{
    display: 'inline-block', marginLeft: '8px', fontSize: '10px', fontWeight: 700,
    color: '#ffcc00', background: 'rgba(255,204,0,0.12)', border: '1px solid rgba(255,204,0,0.35)',
    borderRadius: '999px', padding: '1px 8px', verticalAlign: 'middle',
  }}>
    User
  </span>
)}
                      </button>
                    ) : type === 'audio' ? (
                      <a href={resourceUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#028be8', textDecoration: 'none' }} title="Open podcast in new tab">
                        <span style={{ }}></span>
                        {resourceTitle}
                        {authorText && <span className="cyber-table-knowledge-author" style={{ color: '#606060d6', fontSize: '13px' }}>{authorText}</span>}
                      {resource.isUserAdded && (
  <span style={{
    display: 'inline-block', marginLeft: '8px', fontSize: '10px', fontWeight: 700,
    color: '#ffcc00', background: 'rgba(255,204,0,0.12)', border: '1px solid rgba(255,204,0,0.35)',
    borderRadius: '999px', padding: '1px 8px', verticalAlign: 'middle',
  }}>
    User
  </span>
)}
                      </a>
                    ) : (
    <div>
      <a 
        href={resourceUrl} 
        target="_blank" 
        rel="noopener noreferrer" 
        style={{ color: '#028be8', textDecoration: 'none' }}
      >
        {/* Reading Resource Icon */}
        {type === 'print' && (
          <span style={{
 
          }}>
         
          </span>
        )}

        {/* Free Course Resource Icon */}
        {type === 'free-course' && (
          <span style={{
        
          }}>
        
          </span>
        )}

        {resourceTitle}
        {authorText && <span className="cyber-table-knowledge-author" style={{ color: '#606060d6', fontSize: '13px' }}>{authorText}</span>}
      {resource.isUserAdded && (
  <span style={{
    display: 'inline-block', marginLeft: '8px', fontSize: '10px', fontWeight: 700,
    color: '#ffaa00', background: 'rgba(255,204,0,0.12)', border: '1px solid rgba(255,204,0,0.35)',
    borderRadius: '999px', padding: '1px 8px', verticalAlign: 'middle',
  }}>
      Added by {displayName || 'User'} 
  </span>
)}
      </a>
                        {/* ── Free course meta: description + duration + difficulty bars, under the title ── */}
  {/* ── Free course meta: duration + difficulty always visible, description collapsible ── */}
{isFreeCourse && (
  <div style={{ marginTop: '6px', paddingRight: '20px' }}>
    <div className="difficulty-bars" style={{ display: 'flex', alignItems: 'center', gap: '14px', flexWrap: 'wrap' }}>
      <DifficultyBars difficulty={resource.difficulty} />
      {resource.duration && (
        <span style={{ fontSize: '12px', color: '#888' }}>⏱ {resource.duration}</span>
      )}
      {description && (
        <button
          onClick={() => toggleDescriptionExpanded(rowId)}
          aria-expanded={!!expandedDescriptions[rowId]}
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            color: '#888',
            fontSize: '12px',
            fontWeight: 100,
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '4px',
          }}
        >
          {expandedDescriptions[rowId] ? 'Hide' : 'Details'}
          {expandedDescriptions[rowId] ? <FaChevronUp size={9} /> : <FaChevronDown size={9} />}
        </button>
      )}
    </div>

    {description && expandedDescriptions[rowId] && (
      <p
      className="knowledge-course-description"
        style={{
          margin: '8px 0 0 0',
          padding: '10px 12px',
          fontSize: '13px',
          color: '#c7c7d6',
          lineHeight: 1.55,
          background: 'rgba(0,204,153,0.06)',
          borderLeft: '2px solid rgba(0,204,153,0.4)',
          borderRadius: '0 6px 6px 0',
          animation: 'fadeInNote 0.15s ease',
        }}
      >
        {description}
      </p>
    )}
  </div>
)}

                      </div>
                    )}
                      {resource.isUserAdded && !isReadOnly && (
  <td style={{ border: 'none', padding: '0px', textAlign: 'left', whiteSpace: 'nowrap' }}>
    <button
      onClick={() => {
  setEditingUserResource({ type, id: resource.id });
  setAddFormDraft((prev) => ({
    ...prev,
    [type]: {
      title: resource.resourceTitle, author: resource.author, link: resource.resourceLink,
      source: resource.source, difficulty: resource.difficulty, duration: resource.duration, details: resource.description,
    },
  }));
  setAddFormOpen((prev) => ({ ...prev, [type]: true }));
}}
      style={{ background: 'none', border: 'none', color: '#888', cursor: 'pointer', marginRight: '0px' }}
      title="Edit"
    >
      <FaPencilAlt size={12} />
    </button>
    <button
      onClick={() => deleteUserResource(type, resource.id)}
      style={{ background: 'none', border: 'none', color: '#ff6b6b', cursor: 'pointer', marginLeft: '-10px'  }}
      title="Delete"
    >
      <FaTrash size={12} />
    </button>
  </td>
)}
                  </td>

                  {isPrint && (
                    <td style={{ textAlign: 'center', padding: '12px', width: '110px' }}>
                      <button
                        className="ai-insight-button"
                        onClick={() => handleCopyAndOpenGrok(resourceTitle, resource.author, type)}
                        title="Copy prompt & open Grok"
                        style={{ background: 'linear-gradient(90deg, #028be8, #00e1ff)', color: '#ffffff', border: 'none', borderRadius: '6px', padding: '6px 10px', fontSize: '13px', cursor: 'pointer', whiteSpace: 'nowrap' }}
                      >
                        AI Intro
                      </button>
                    </td>
                  )}

                  {/* ── Notes toggle (now before Completed) ── */}
                  <td style={{ textAlign: 'center' }}>
           
                      <button
                        onClick={() => toggleNoteExpanded(rowId, resourceMeta)}
                        aria-expanded={isNoteOpen}
                        aria-label={hasNote ? "View or edit your notes" : "Add a note"}
                        style={{
                          background: 'none',
                          border: 'none',
                          borderRadius: '20px',
                          cursor: 'pointer',
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '5px',
                          color: hasNote ? '#00e1ff' : '#777',
                          fontSize: '13px',
                          padding: '5px 10px',
                          transition: 'all 0.2s ease',
                        }}
                      >
                        <FaStickyNote size={20} />
                        {hasNote && <span style={{ fontSize: '11px', fontWeight: 600 }}></span>}
                      </button>

                  </td>

                  {/* ── Completed checkbox (non-free-course) OR Add to Calendar (free-course) ── */}
<td style={{ textAlign: 'center' }}>
  {isFreeCourse ? (
    (() => {
      const courseId = getFreeCourseCalendarId(selectedKnowledgeSubject, resourceTitle);
      const isAdded = addedToCalendar.has(courseId);
      return (
          <button 
            onClick={() => openCalendarModalForFreeCourse(resource)}
            className="add-to-calendar-knowledge"
            style={{
              display: 'flex',
              gap: '6px',
              padding: '6px 8px 6px 5px',
              borderRadius: '20px',
              border: isAdded ? '1px solid rgba(0,204,153,0.5)' : '1px solid rgba(0,204,153,0.35)',
              background: isAdded ? 'rgba(0,204,153,0.15)' : 'transparent',
              color: '#00cc99',
              fontSize: '12.5px',
              fontWeight: 600,
              cursor: 'pointer',
              whiteSpace: 'nowrap',
              width: '130px',
              transition: 'all 0.2s ease',
            }}
          >
            <FaBolt size={11}             
            style={{ opacity: 0}} />
            {isAdded ? '✓ Scheduled' : '+ Add to Calendar'}
          </button>

      );
    })()
  ) : isReadOnly ? (
    <TooltipUIViewOnly text="Marking completed is a student-only self-tracking feature" position="left">
      <input
        type="checkbox"
        className="cyber-checkbox"
        checked={checkboxStates[rowId] || false}
        disabled
        readOnly
        style={{ opacity: 0.5, cursor: 'not-allowed', backgroundColor: 'rgba(158, 158, 158, 0.24)', borderColor: 'rgba(131, 131, 131, 0.4)' }}
      />
    </TooltipUIViewOnly>
  ) : (
    <input
      type="checkbox"
      className="cyber-checkbox"
      checked={checkboxStates[rowId] || false}
      onChange={() => handleCheckboxChange(rowId)}
    />
  )}
</td>
                </tr>

                {/* ── Expandable notes editor ── */}
               {isNoteOpen && (
  <tr className="note-row">
  <td colSpan={totalColumns} style={{ padding: '0', background: 'rgba(255,255,255,0.02)' }}>
      <div
        className="knowledge-note-editor"
        style={{
          margin: '10px 14px 16px 14px',
          padding: '14px 16px',
          borderLeft: `1px solid ${accentColor}`,
          background: 'rgba(2,139,232,0.05)',
          borderRadius: '0 10px 10px 0',
        }}
      >
        <div  style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
          <label className="knowledge-note-editor-title" style={{ fontSize: '12px', color: '#40b3ff', fontWeight: 700, letterSpacing: '0.02em', textTransform: 'uppercase' }}>
            Learning Reflection
          </label>
          {hasAnyNoteContent(noteEntry) && !isReadOnly && (
            <button  className="knowledge-note-editor-clear"
              onClick={() => clearNote(rowId)}
              style={{ background: 'none', border: 'none', color: '#888', fontSize: '12px', cursor: 'pointer', textDecoration: 'underline' }}
            >
              Clear
            </button>
          )}
        </div>

        {/* Key takeaway */}
        <div style={{ marginBottom: '10px' }}>
          <label style={{ display: 'block', fontSize: '11.5px', color: '#9fb8d4', marginBottom: '4px' }}>
            Key takeaway
          </label>
          <textarea
          className='space-scroll'
            ref={(el) => { noteFieldRefs.current[`${rowId}_takeaway`] = el; if (el) autoGrowTextarea(el); }}
            value={noteEntry.takeaway || ''}
            onChange={(e) => { updateNoteField(rowId, 'takeaway', e.target.value, resourceMeta); autoGrowTextarea(e.target); }}
            placeholder={getTakeawayPlaceholder(type)}
            maxLength={600}
            rows={2}
            disabled={isReadOnly}
            style={{ ...noteTextareaStyle(accentColor, isReadOnly) }}
          />
        </div>

        {/* Still unclear — optional */}
        <div style={{ marginBottom: '10px' }}>
          <label style={{ display: 'block', fontSize: '11.5px', color: '#9fb8d4', marginBottom: '4px' }}>
            Explore next
          </label>
          <textarea
            className='space-scroll'
            value={noteEntry.unclear || ''}
onChange={(e) => { updateNoteField(rowId, 'unclear', e.target.value, resourceMeta); autoGrowTextarea(e.target); }}
            placeholder="What would you like to explore further?"
            maxLength={400}
            rows={1}
            disabled={isReadOnly}
            style={{ ...noteTextareaStyle(accentColor, isReadOnly), minHeight: '42px' }}
          />
        </div>

        {/* Tag — optional, plain language with concrete examples */}
        <div style={{ marginBottom: '12px' }}>
          <label style={{ display: 'block', fontSize: '11.5px', color: '#9fb8d4', marginBottom: '4px' }}>
            Tags
          </label>
          <input
            type="text"
            value={noteEntry.tag || ''}
           onChange={(e) => updateNoteField(rowId, 'tag', e.target.value, resourceMeta)}
            placeholder="e.g. 'exam prep', 'essay idea', 'personal statement'"
            maxLength={60}
            disabled={isReadOnly}
            style={{ ...noteTextareaStyle(accentColor, isReadOnly), minHeight: 'auto', padding: '8px 12px' }}
          />
        </div>

     {/* Confidence chips — one tap, no typing */}
        <div style={{  marginBottom: '4px' }}>
          <label style={{ marginTop: '20px', display: 'block', fontSize: '11.5px', color: '#9fb8d4', marginBottom: '6px' }}>
            How well did you understand this?
          </label>
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
  {CONFIDENCE_OPTIONS.map((opt) => {
    const isSelected = noteEntry.confidence === opt.key;
    const Icon = opt.icon;   // ← this line must be here, inside the callback
    return (
      <button
        key={opt.key}
        onClick={() => !isReadOnly && setNoteConfidence(rowId, opt.key, resourceMeta)}
        disabled={isReadOnly}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: '5px',
          padding: '5px 11px', borderRadius: '999px', fontSize: '12px', fontWeight: 600,
          border: 'none',
          background: 'none',
          boxShadow: 'none',
          color: isSelected ? opt.color : '#aaa',
          cursor: isReadOnly ? 'not-allowed' : 'pointer',
          opacity: isReadOnly ? 0.6 : 1,
          transition: 'all 0.15s ease',
        }}
      >
        <Icon size={13} style={{ color: isSelected ? opt.color : '#888' }} />
        {opt.label}
      </button>
    );
  })}
</div>
        </div>

        {/* Usefulness rating — lightweight signal for future recommendation quality */}
        <div style={{ marginTop: '16px', marginBottom: '4px' }}>
          <label style={{ display: 'block', fontSize: '11.5px', color: '#9fb8d4', marginBottom: '6px' }}>
            How useful was this?
          </label>
          <div style={{ display: 'flex', gap: '2px' }}>
            {[1, 2, 3, 4, 5].map((star) => {
              const isFilled = star <= (noteEntry.usefulness || 0);
              return (
                <span
                  key={star}
                  onClick={() => !isReadOnly && setNoteUsefulness(rowId, star, resourceMeta)}
                  role="button"
                  aria-label={`Rate usefulness ${star} out of 5`}
                  style={{
                    fontSize: '19px',
                    lineHeight: 1,
                    cursor: isReadOnly ? 'not-allowed' : 'pointer',
                    color: isFilled ? '#ffd700' : 'rgba(255,255,255,0.2)',
                    opacity: isReadOnly ? 0.6 : 1,
                    transition: 'color 0.15s ease',
                  }}
                >
                  ★
                </span>
              );
            })}
          </div>
        </div>

               <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '12px',
          flexWrap: 'wrap',
          marginTop: '14px',
          paddingTop: '12px',
          borderTop: '1px solid rgba(255,255,255,0.06)',
          fontSize: '11.5px',
          color: '#888',
        }}>
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', minHeight: '16px' }}>
            {savingState === 'typing' && (
              <>
                <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#ffaa00', display: 'inline-block' }} />
                Saving…
              </>
            )}
            {savingState === 'saved' && (
              <span style={{ color: '#00ff9d', display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                <FaCheck size={10} /> Saved
              </span>
            )}
          </span>

          {!isReadOnly && (
            <button
            className="knowledge-recommend-resources-btn"
              type="button"
              onClick={() => handleRecommendResources(resource, type, noteEntry)}
              title="Generate a prompt for 5 further resources from this item + your My Takes, then open Google AI"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '7px',
                background: `linear-gradient(90deg, ${accentColor}, ${accentColor}cc)`,
                color: type === 'video' || type === 'audio' ? '#fff' : '#0a0f1f',
                border: 'none',
                borderRadius: '8px',
                padding: '7px 14px',
                fontSize: '12.5px',
                fontWeight: 700,
                cursor: 'pointer',
                boxShadow: `0 4px 14px ${accentColor}33`,
                whiteSpace: 'nowrap',
              }}
            >
              <FaStar size={12} />
              Recommend Further Resources
            </button>
          )}
        </div>
      </div>
    </td>
  </tr>
)}
             
              </React.Fragment>
            );
          })
        ) : (
          <tr>
            <td colSpan={totalColumns} style={{ textAlign: 'center' }}>
              No{' '}
              {type === 'print' ? 'print' : type === 'video' ? 'video' : type === 'audio' ? 'podcast / audio' : 'free course'}{' '}
              resources found for {selectedKnowledgeSubject}.
            </td>
          </tr>
        )}
      </tbody>
    </table>
        <AddResourceForm
      type={type}
      isOpen={!!addFormOpen[type]}
      draft={addFormDraft[type] || {}}
      isEditing={editingUserResource?.type === type}
      isReadOnly={isReadOnly}
      onOpen={() => setAddFormOpen((prev) => ({ ...prev, [type]: true }))}
      onCancel={() => {
        setAddFormDraft((prev) => ({ ...prev, [type]: {} }));
        setEditingUserResource(null);
        setAddFormOpen((prev) => ({ ...prev, [type]: false }));
      }}
      onFieldChange={(field, value) =>
        setAddFormDraft((prev) => ({ ...prev, [type]: { ...prev[type], [field]: value } }))
      }
onSubmit={(formData) => {
  // Use the form data passed directly from the child
  if (!formData.title?.trim()) {
    showToast('Please enter a title.', 'error');
    return;
  }
  if (editingUserResource?.type === type) {
    updateUserResource(type, editingUserResource.id, formData);
  } else {
    addUserResource(type, formData);
  }
  setAddFormDraft((prev) => ({ ...prev, [type]: {} }));
  setEditingUserResource(null);
  setAddFormOpen((prev) => ({ ...prev, [type]: false }));
}}
    />
  </>
);
};
 


  // ── Main render ────────────────────────────────────────────────────────────
  return (
    <div className="main-knowledge" style={{width:'1200px'}}>  
          <h2 style={{ color: '#36a7f8', textAlign: 'center' }}>Knowledge Library</h2>
    <div >
      {/* View-only banner */}
      {viewModeBannerText && (
        <div style={{ width: '100%' }} className="view-mode-banner banner-knowledge">
          <div className="banner-content banner-knowledge-content">
            <span style={{ fontSize: '1.1rem' }} className="banner-icon">
              <FaEye />
            </span>
            <span
              style={{ fontSize: '1rem', padding: '9px 0 9px 0' }}
              className="banner-text banner-text-mobile"
            >
              {viewModeBannerText}
            </span>
          </div>
        </div>
      )}
 </div>
     <button
  onClick={() => {
    if (!selectedKnowledgeSubject) {
    showToast('Please select a subject first.', 'error');
      return;
    }
    toggleKnowledgeBookmark(selectedKnowledgeSubject);
  }}
  className=" knowledge-bookmark-btn"
  disabled={isReadOnly}
  style={{
    position: 'absolute',
    top: '0px',
    right: '80px',
    color: isReadOnly ? '#666' : (isKnowledgeBookmarked ? '#028be8' : '#ddd'),
    borderRadius: '8px',
    cursor: isReadOnly ? 'not-allowed' : 'pointer',
    opacity: isReadOnly ? 0.5 : 1,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontWeight: '600',
    zIndex: 100,
  }}
  title={isKnowledgeBookmarked ? "Remove pin" : "Pin this Knowledge page with current subject"}
>
  <FaThumbtack/> {isKnowledgeBookmarked ? "Pinned" : "Pin"}
</button>
      <div className="knowledge-content"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '20px',
          color: 'white',
          maxWidth: '1000px',
          margin: '0 auto',
          padding: '20px',
        }}
      >
         <div className="your-reflection-notice-knowledge" style={{ fontStyle: 'normal', marginTop: '-20px',  marginBottom: '-20px', textAlign: 'center', color: '#b6b6b6', fontSize: '14px' }}>
      <p>Your Notes and Schedules are saved locally in this browser only.</p>
    </div>
        {/* ── Subject dropdown ── */}
        {hasUniReadyOrChosen || isReadOnly ? (
          <div
            className="button-container-knowledge"
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '20px',
              justifyContent: 'center',
              alignItems: 'flex-end',
              marginBottom: '10px',
            }}
          >
            <div className="cyber-select-container">
              <label className="cyber-select-container-knowledge-label"
                htmlFor="subject-select"
                style={{ fontSize: '16px', color: '#028be8', marginBottom: '8px' }}
              >
                Select a Top UniReady or Exploration Subject:
              </label>
              <select
                id="subject-select"
                value={selectedKnowledgeSubject}
                onChange={(e) => {
                  setSelectedKnowledgeSubject(e.target.value);
                  setKnowledgeTab('print'); // reset tab on new subject
                }}
                className="cyber-select"
              >
                <option value="">-- Select a Subject --</option>
                {availableKnowledgeSubjects.map((subject) => (
                  <option key={subject} value={subject}>
                    {subject}
                  </option>
                ))}
              </select>
            </div>
          </div>
      ) : (
          <div style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px',
            padding: '28px 20px', textAlign: 'center', color: '#88aacc',
            background: 'rgba(255,255,255,0.03)', border: '1px dashed rgba(54,167,248,0.3)',
            borderRadius: '12px', maxWidth: '460px', margin: '0 auto',
          }}>
            <FaGraduationCap style={{ fontSize: '26px', color: '#36a7f8', opacity: 0.7 }} />
            <span style={{ fontSize: '14px', lineHeight: 1.5 }}>
              Complete UniReady, or choose a top subject, to unlock curated reading, video, and course resources.
            </span>
          </div>
        )}
 
        {/* ── Errors / loading ── */}
        {knowledgeError && (
          <div
            style={{
              color: '#ff00ff',
              fontSize: '14px',
              marginTop: '10px',
              textShadow: '0 0 5px rgba(255, 0, 255, 0.3)',
            }}
          >
            {knowledgeError}
          </div>
        )}
      {isLoadingKnowledge && (
          <div style={{ width: '100%', maxWidth: '1000px' }}>
            <style>{`
              @keyframes knowledgeSkeletonPulse {
                0%, 100% { opacity: 0.35; }
                50% { opacity: 0.7; }
              }
            `}</style>
            {[1, 2, 3, 4].map((i) => (
              <div key={i} style={{
                display: 'flex', alignItems: 'center', gap: '14px',
                padding: '14px 16px', marginBottom: '8px',
                background: 'rgba(255,255,255,0.03)', borderRadius: '8px',
              }}>
                <div style={{
                  width: '22px', height: '22px', borderRadius: '50%',
                  background: 'rgba(2,139,232,0.25)', animation: 'knowledgeSkeletonPulse 1.4s ease-in-out infinite',
                  animationDelay: `${i * 0.12}s`, flexShrink: 0,
                }} />
                <div style={{ flex: 1, height: '12px', borderRadius: '4px', background: 'rgba(255,255,255,0.08)',
                  animation: 'knowledgeSkeletonPulse 1.4s ease-in-out infinite', animationDelay: `${i * 0.12}s`,
                  maxWidth: `${70 - i * 8}%` }} />
              </div>
            ))}
          </div>
        )}
 
        {/* ── Content: only shown after subject selected and not loading ── */}
        {selectedKnowledgeSubject && !isLoadingKnowledge && (
          <>
         
           {/* ── Progress summary ── */}
         {totalTrackable > 0 && (
             <div className="knowledge-progress-strip" style={{
               display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center',
               gap: '18px', marginBottom: '10px', padding: '12px 20px',
               background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)',
               borderRadius: '10px', maxWidth: '620px', width: '100%', marginTop: '-10px',
             }}>
               <div style={{ display: 'flex', alignItems: 'center', gap: '10px', minWidth: '180px' }}>
                 <span style={{ fontSize: '12.5px', color: '#aaa', whiteSpace: 'nowrap' }}>
                   {totalCompleted}/{totalTrackable} completed
                 </span>
                 <div style={{ flex: 1, height: '6px', background: 'rgba(255,255,255,0.08)', borderRadius: '99px', overflow: 'hidden', minWidth: '70px' }}>
                   <div style={{
                     height: '100%', borderRadius: '99px',
                     width: `${totalTrackable ? Math.round((totalCompleted / totalTrackable) * 100) : 0}%`,
                     background: 'linear-gradient(90deg, #00cc99, #00e1ff)', transition: 'width 0.4s ease',
                   }} />
                 </div>
               </div>

               {notesAddedCount > 0 && (
                 <span style={{ fontSize: '12px', color: '#00e1ff', display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
                   <FaStickyNote size={11} /> My Takes: {notesAddedCount}
                 </span>
               )}

           {nextUnreadResource && nextUnreadResource.tab  && (
                 <button
                   onClick={() => {
                     setKnowledgeTab(nextUnreadResource.tab);
                     setTimeout(() => scrollToRow(nextUnreadResource.rowId), 120);
                   }}
                   style={{
                     background: 'rgba(0,204,153,0.12)', border: '1px solid rgba(0,204,153,0.4)',
                     color: '#00cc99', borderRadius: '999px', padding: '5px 14px', fontSize: '11.5px',
                     fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap',
                   }}
                 >
                   Jump to next resource →
                 </button>
               )}
             </div>
           )}

           <div className="knowledge-button-3" style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginBottom: '15px' }}>
  <button
    className={`tab-button-3 ${knowledgeTab === 'print' ? 'active' : ''}`}
    onClick={() => setKnowledgeTab('print')}
    style={{ marginBottom: '-18px', width: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
  >
    Reading
    {printResources.length > 0 && (
      <span className="knowledge-table-stats" style={{
        fontSize: '10.5px', fontWeight: 700, padding: '1px 7px', borderRadius: '999px',
        background: printCompletedCount === printResources.length ? 'rgba(0,204,153,0.25)' : 'rgba(255,255,255,0.12)',
        color: printCompletedCount === printResources.length ? '#00cc99' : '#ccc',
      }}>
        {printCompletedCount}/{printResources.length}
      </span>
    )}
  </button>

  {hasMedia && (
    <button
      className={`tab-button-3 ${knowledgeTab === 'media' ? 'active' : ''}`}
      onClick={() => setKnowledgeTab('media')}
      style={{ marginBottom: '-18px', width: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
    >
      Video / Podcast
      <span className="knowledge-table-stats"  style={{
        fontSize: '10.5px', fontWeight: 700, padding: '1px 7px', borderRadius: '999px',
        background: 'rgba(255,255,255,0.12)', color: '#ccc',
        color: videoCompletedCount + audioCompletedCount === videoResources.length + audioResources.length ? '#00cc99' : '#ccc',
      }}>
        {videoCompletedCount + audioCompletedCount}/{videoResources.length + audioResources.length}
      </span>
    </button>
  )}

{freeCourseResources.length > 0 && (
    <button
      className={`tab-button-3 ${knowledgeTab === 'freecourse' ? 'active' : ''}`}
      onClick={() => setKnowledgeTab('freecourse')}
      style={{ marginBottom: '-18px', width: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
    >
      Free Courses
      <span className="knowledge-table-stats"  style={{
        fontSize: '10.5px', fontWeight: 700, padding: '1px 7px', borderRadius: '999px',
        background: freeCourseScheduledCount === freeCourseResources.length ? 'rgba(0,204,153,0.25)' : 'rgba(255,255,255,0.12)',
        color: freeCourseScheduledCount === freeCourseResources.length ? '#00cc99' : '#ccc',
      }}>
        {freeCourseScheduledCount}/{freeCourseResources.length}
      </span>
    </button>
  )}
</div>
 
            {/* ── Table area ── */}
            <div
              className="cyber-table-nav"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '20px',
                width: '100%',
                maxWidth: '1200px',
                justifyContent: 'space-between',
              }}
            >
            <div style={{ width: '100%' }}>
  {knowledgeTab === 'print' && renderResourceTable(printResources, 'print')}

  {knowledgeTab === 'media' && (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
      {videoResources.length > 0 && <div>{renderResourceTable(videoResources, 'video')}</div>}
      {audioResources.length > 0 && <div>{renderResourceTable(audioResources, 'audio')}</div>}
      {videoResources.length === 0 && audioResources.length === 0 && (
        <p style={{ color: '#888', textAlign: 'center' }}>
          No video or podcast resources found for {selectedKnowledgeSubject}.
        </p>
      )}
    </div>
  )}

  {knowledgeTab === 'freecourse' && renderResourceTable(freeCourseResources, 'free-course')}
</div>
            </div>

          </>
        )}
      </div>
 
      {/* ── YouTube popup overlay ── */}
      {youtubePopup && (
        <div
          onClick={() => setYoutubePopup(null)}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.82)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 3000,
            backdropFilter: 'blur(4px)',
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: 'relative',
              width: 'min(860px, 94vw)',
              background: '#0a0f1e',
              borderRadius: '14px',
              border: '1px solid rgba(255,0,0,0.35)',
              boxShadow: '0 20px 60px rgba(0,0,0,0.7)',
              overflow: 'hidden',
            }}
          >
            {/* Header bar */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '10px 16px',
                background: 'rgba(255,0,0,0.08)',
                borderBottom: '1px solid rgba(255,0,0,0.2)',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                {/* YouTube wordmark dot */}
                <span
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '26px',
                    height: '18px',
                    borderRadius: '4px',
                    background: '#ff0000',
                    flexShrink: 0,
                  }}
                >
                  <span
                    style={{
                      display: 'inline-block',
                      width: 0,
                      height: 0,
                      borderTop: '5px solid transparent',
                      borderBottom: '5px solid transparent',
                      borderLeft: '9px solid white',
                      marginLeft: '1px',
                    }}
                  />
                </span>
                <span
                  style={{
                    color: 'white',
                    fontSize: '14px',
                    fontWeight: 500,
                    maxWidth: '620px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {youtubePopup.title}
                </span>
              </div>
 
              {/* Controls: open in YouTube + close */}
              <div style={{ display: 'flex', gap: '10px', flexShrink: 0 }}>
                <a
                  href={youtubePopup.url.replace('/embed/', '/watch?v=').replace('?autoplay=1', '')}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: '#aaa',
                    fontSize: '13px',
                    textDecoration: 'none',
                    padding: '4px 10px',
                    border: '1px solid #444',
                    borderRadius: '6px',
                    background: 'transparent',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                  }}
                >
                  Open in YouTube ↗
                </a>
                <button
                  onClick={() => setYoutubePopup(null)}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#aaa',
                    fontSize: '22px',
                    cursor: 'pointer',
                    lineHeight: 1,
                    padding: '0 4px',
                  }}
                  aria-label="Close video"
                >
                  ×
                </button>
              </div>
            </div>
 
            {/* Embed */}
            <div style={{ position: 'relative', paddingTop: '56.25%' /* 16:9 */ }}>
              <iframe
                src={youtubePopup.url}
                title={youtubePopup.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{
                  position: 'absolute',
                  inset: 0,
                  width: '100%',
                  height: '100%',
                  border: 'none',
                }}
              />
            </div>
          </div>
        </div>
      )}

   {showCalendarModal && modalActivity && modalActivity.category === 'Free Course' && (
  <div
    className="modal-overlay"
    onClick={() => setShowCalendarModal(false)}
    style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 2000, backdropFilter: 'blur(4px)',
    }}
  >
    <div
      className="modal-content-calendar"
      onClick={e => e.stopPropagation()}
      style={{
        background: 'linear-gradient(135deg, #0f1629 0%, #0a0f1f 100%)',
        color: 'white', padding: '2rem', borderRadius: '16px',
        width: 'min(92vw, 600px)', border: '1px solid rgba(0, 204, 153, 0.35)',
        boxShadow: '0 20px 60px rgba(0,0,0,0.6), 0 0 0 1px rgba(0,204,153,0.18) inset',
        position: 'relative', maxHeight: '90vh', overflowY: 'auto',
      }}
    >
      <button
        onClick={() => setShowCalendarModal(false)}
        style={{ position: 'absolute', top: '14px', right: '16px', background: 'none', border: 'none', color: '#aaa', fontSize: '1.6rem', cursor: 'pointer', lineHeight: 1 }}
      >
        ×
      </button>

      <h3 style={{ margin: '0 0 1.5rem 0', color: '#00e0b8', fontSize: '1.5rem', fontWeight: 600, letterSpacing: '-0.02em' }}>
        {addedToCalendar.has(modalActivity.supercurricular_id) ? 'Edit Calendar Entry' : 'Add to Calendar'}
      </h3>

      {/* Course card */}
      <div style={{ background: 'rgba(0,204,153,0.08)', borderRadius: '12px', padding: '1.25rem', marginBottom: '1.5rem', border: '1px solid rgba(0,204,153,0.25)' }}>
        <FaGraduationCap style={{ fontWeight: 600, fontSize: '1.1rem', marginBottom: '0.35rem', color: '#00e0b8' }} />
        {' '}{modalActivity.title}
        <div style={{ color: '#7fffdf', fontSize: '0.9rem', opacity: 0.9 }}>
          {selectedKnowledgeSubject} · Free Course
        </div>
      </div>

      {/* Dates */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.25rem', marginBottom: '1.5rem' }}>
        <div>
          <label style={{ display: 'block', marginBottom: '0.5rem', color: '#00e0b8', fontSize: '0.95rem', fontWeight: 500 }}>
            Start Date
          </label>
          <input
            type="date"
            value={tempStartDate}
            onChange={e => setTempStartDate(e.target.value)}
            className="startdate"
            style={{ width: '100%', padding: '0.75rem', background: 'rgba(20, 30, 60, 0.6)', border: '1px solid rgba(0,204,153,0.45)', borderRadius: '8px', color: 'white', fontSize: '1rem' }}
          />
        </div>
        <div>
          <label style={{ display: 'block', marginBottom: '0.5rem', color: '#00e0b8', fontSize: '0.95rem', fontWeight: 500 }}>
            Target Finish Date
          </label>
          <input
            type="date"
            value={tempEndDate}
            min={tempStartDate}
            onChange={e => setTempEndDate(e.target.value)}
            className="startdate"
            style={{ width: '100%', padding: '0.75rem', background: 'rgba(20, 30, 60, 0.6)', border: '1px solid rgba(0,204,153,0.45)', borderRadius: '8px', color: 'white', fontSize: '1rem' }}
          />
        </div>
      </div>

      {/* Notes */}
      <div style={{ marginBottom: '1.75rem' }}>
        <label style={{ display: 'block', marginBottom: '0.5rem', color: '#00e0b8', fontSize: '0.95rem', fontWeight: 500 }}>
          Notes <small style={{ opacity: 0.7 }}>(optional)</small>
        </label>
        <textarea
        className='space-scroll'
          value={modalActivity.description || ''}
          onChange={(e) => setModalActivity(prev => ({ ...prev, description: e.target.value }))}
          placeholder="e.g. Aim for 2 modules a week, focus on the case studies first..."
          rows={3}
          style={{ width: '100%', padding: '0.8rem', background: 'rgba(20, 30, 60, 0.6)', border: '1px solid rgba(0,204,153,0.45)', borderRadius: '8px', color: 'white', fontSize: '0.97rem', resize: 'vertical', minHeight: '86px', lineHeight: 1.45 }}
        />
      </div>

      {/* Buttons – FIXED onClick */}
      <div style={{ display: 'flex', gap: '1rem', justifyContent: addedToCalendar.has(modalActivity.supercurricular_id) ? 'space-between' : 'flex-end', marginTop: '1rem' }}>
             {addedToCalendar.has(modalActivity.supercurricular_id) && (
          <button
            onClick={async () => {
              const ok = await confirm('Remove this course from your calendar?', { danger: true });
              if (!ok) return;
              setCalendarEvents(prev => prev.filter(ev => ev.supercurricular_id !== modalActivity.supercurricular_id));
              setShowCalendarModal(false);
            }}
            style={{ padding: '0.75rem 1.5rem', background: '#780101', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 500, cursor: 'pointer' }}
          >
            Delete
          </button>
        )}

        <div style={{ display: 'flex', gap: '1rem' }}>
          <button
            onClick={() => setShowCalendarModal(false)}
            style={{ padding: '0.75rem 1.5rem', background: 'transparent', border: '1px solid #555', color: '#ccc', borderRadius: '8px', fontWeight: 500, cursor: 'pointer' }}
          >
            Cancel
          </button>

          <button
            onClick={async () => {
                      if (!tempStartDate || !tempEndDate) {
                showToast('Please select both start and finish dates.', "error");
                return;
              }
              if (new Date(tempEndDate) < new Date(tempStartDate)) {
                showToast('Finish date cannot be before start date.', "error");
                return;
              }

              // ── FIX: Fetch latest events from Dexie before merging ──
              const latestEvents = await getCalendarEvents(userId);
              const exists = latestEvents.some(ev => ev.supercurricular_id === modalActivity.supercurricular_id);

              const eventData = {
                supercurricular_id: modalActivity.supercurricular_id,
                title: modalActivity.title,
                category: 'Free Course',
                universitySubject: selectedKnowledgeSubject,
                startDate: tempStartDate,
                endDate: tempEndDate,
                description: modalActivity.description?.trim() || '',
                selectedExamples: [],
                addedAt: new Date().toISOString(),
              };

              let newEvents;
              if (exists) {
                newEvents = latestEvents.map(ev =>
                  ev.supercurricular_id === modalActivity.supercurricular_id ? { ...ev, ...eventData } : ev
                );
                        showToast('Calendar entry updated.', "success");
              } else {
                newEvents = [...latestEvents, { ...eventData, id: Date.now().toString() }];
                showToast('Course added to your calendar!', "success");
              }

              // Update state and Dexie
              setCalendarEvents(newEvents);
              await saveCalendarEvents(userId, newEvents);

              setShowCalendarModal(false);
            }}
            style={{ padding: '0.75rem 1.8rem', background: '#00cc99', color: '#0a0f1f', border: 'none', borderRadius: '8px', fontWeight: 700, cursor: 'pointer', boxShadow: '0 4px 14px rgba(0,204,153,0.4)' }}
          >
            {addedToCalendar.has(modalActivity.supercurricular_id) ? 'Save' : 'Add to Calendar'}
          </button>
        </div>
      </div>
    </div>
  </div>
)}
    </div>
  );
};



// Fetch pending invitations and validate them

// ===== REPLACE THE EXISTING fetchAndValidateInvitations WITH THIS =====
const fetchAndValidateInvitations = useCallback(async () => {
  if (!userId) return;

  const INVITATION_CACHE_KEY = `pending_invitations_${userId}`;
  const LAST_FETCH_KEY = `last_invitation_fetch_${userId}`;
  const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000; // ← CHANGE THIS LINE (was 1 hour)
  const now = new Date();

  // Early role check
  const userAppRole = localStorage.getItem(`app_role_${userId}`) || 'user';

  if (userAppRole === "invitee") {
    console.log("Skipping invitation validation for invitee user");
    setTeamError("You cannot accept new invitations as you are already an invitee in an active team.");

    // Still show cached invitations
    const cached = localStorage.getItem(INVITATION_CACHE_KEY);
    if (cached) {
      try {
        const parsed = JSON.parse(cached);
        setPendingInvitations(parsed);
        setNotificationCount(parsed.length);
      } catch (e) {}
    }
    return;
  }
  
  const cachedInvitations = localStorage.getItem(INVITATION_CACHE_KEY);
  const lastFetchTime = localStorage.getItem(LAST_FETCH_KEY);

  // Use fresh cache if available
  if (cachedInvitations && lastFetchTime) {
    const timeSinceLastFetch = now.getTime() - new Date(lastFetchTime).getTime();
    if (timeSinceLastFetch < TWENTY_FOUR_HOURS) { // ← CHANGE THIS CONDITION
      try {
        const parsed = JSON.parse(cachedInvitations);
        setPendingInvitations(parsed);
        setNotificationCount(parsed.length);
        return;
      } catch (e) {
        localStorage.removeItem(INVITATION_CACHE_KEY);
      }
    }
  }

  // ===== USE UNIFIED FETCH FOR INVITATIONS =====
  // Check if fetchTeamData exists (will be defined after we add it)
  if (typeof fetchTeamData === 'function') {
    // Use the unified fetch - this will handle both:
    // - Fetching pending invitations
    // - Refreshing invitation statuses
    const success = await fetchTeamData({ 
      fetchFullDetails: false,
      fetchInvitations: true,    // Get pending invitations list
      fetchStatusOnly: true,     // Also refresh statuses for existing task
      force: false,              // Respect cooldown
    });
    
    if (success) {
      // The unified fetch already updated pendingInvitations state
      // But we still need to run validation logic (expired invites, etc.)
      // So we'll get the updated invitations from state after a short delay
      // or we can access them from the fetch result
      
      // For now, we'll fetch the updated list from the same source
      // The unified fetch already stored them in localStorage
      const updatedCached = localStorage.getItem(INVITATION_CACHE_KEY);
      if (updatedCached) {
        try {
          let invitations = JSON.parse(updatedCached);
          
          // Run validation on the fetched invitations
          await validateInvitationsList(invitations);
          return;
        } catch (e) {
          console.error("Error parsing updated invitations:", e);
        }
      }
    }
  }

  // ===== FALLBACK: Direct API call if unified fetch not available =====
  // (Keep this for backward compatibility during transition)
  try {
    const response = await axios.get("/api/team/invitations", {
      params: { userId },
      headers: getAuthHeaders(),
    });

    let invitations = response.data.invitations || [];

    // Run validation on invitations
    await validateInvitationsList(invitations);

  } catch (err) {
    console.error("Error fetching invitations:", err.message);
    setTeamError(err.response?.data?.error || "Failed to fetch invitations");
    if (err.response?.status === 401) {
      localStorage.removeItem("token");
      navigate("/login");
    }
  }

}, [userId, sortedScores, navigate]);

// ===== EXTRACT VALIDATION LOGIC INTO SEPARATE FUNCTION =====
const validateInvitationsList = useCallback(async (invitations) => {
  const now = new Date();
  const INVITATION_CACHE_KEY = `pending_invitations_${userId}`;
  const LAST_FETCH_KEY = `last_invitation_fetch_${userId}`;

  // Validation for expired invitations (unchanged — local date math, no API cost)
  const fiveDaysInMs = 5 * 24 * 60 * 60 * 1000;
  const expiredInvitations = invitations.filter(
    (inv) => inv.status === "pending" && now - new Date(inv.created_at) > fiveDaysInMs
  );

  for (const invitation of expiredInvitations) {
    try {
      await axios.post("/api/invitations/action", {
        invitationId: invitation.invitation_id,
        action: "decline",
        userId
      }, { headers: getAuthHeaders() });
    } catch (err) {
      console.error(`Error declining expired invitation:`, err.message);
    }
  }

  invitations = invitations.filter(
    (inv) => inv.status === "pending" && now - new Date(inv.created_at) <= fiveDaysInMs
  );

  // ── BATCHED subject-match validation (replaces per-invitation loop) ──
  const topSubjects = sortedScores.slice(0, 3).map(s => s._id).filter(Boolean);
  const idsToValidate = invitations.map(inv => inv.invitation_id).filter(Boolean);

  if (idsToValidate.length > 0) {
    try {
      const batchResponse = await axios.post(
        "/api/team/invitations/validate-batch",
        { userId, invitationIds: idsToValidate, topSubjects },
        { headers: getAuthHeaders() }
      );

      const resultsById = new Map(
        batchResponse.data.results.map(r => [r.invitationId, r])
      );

      const invalidIds = [];
      let firstErrorMessage = null;

      invitations = invitations.filter((inv) => {
        const result = resultsById.get(inv.invitation_id);
        if (!result || !result.valid) {
          invalidIds.push(inv.invitation_id);
          if (!firstErrorMessage && result?.reason) {
            firstErrorMessage = result.reason;
          }
          return false;
        }
        return true;
      });

      // Clean up invalid invitations server-side (only those NOT already
      // auto-declined by the batch endpoint due to subject mismatch —
      // calling delete on an already-declined row is harmless/idempotent)
      for (const id of invalidIds) {
        try {
          await axios.delete(`/api/invitations/${id}`, { headers: getAuthHeaders() });
        } catch (deleteErr) {
          console.error(`Error deleting invalid invitation ${id}:`, deleteErr.message);
        }
      }

      if (firstErrorMessage) {
        setInvitationErrors(firstErrorMessage);
      }
    } catch (err) {
      if (err.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/login");
        return;
      }
      // On a hard validation failure, fail safe: keep invitations as-is
      // rather than silently dropping them, and surface the error.
      console.error("Batch validation error:", err.message);
      setInvitationErrors(err.response?.data?.error || "Failed to validate invitations");
    }
  }

  // Update state and cache
  setPendingInvitations(invitations);
  setNotificationCount(invitations.length);
  localStorage.setItem(INVITATION_CACHE_KEY, JSON.stringify(invitations));
  localStorage.setItem(LAST_FETCH_KEY, new Date().toISOString());
  setLastInvitationFetchTime(new Date());
  setTeamError(null);

}, [userId, sortedScores, navigate]);


  // Update notification count when pendingInvitations change
  useEffect(() => {
    setNotificationCount(pendingInvitations.length);
  }, [pendingInvitations]);

// Helper function to check if task is submittable
const canSubmitTask = useMemo(() => {
  if (!teamTask.task.taskId) {
    return false; // Early return if no taskId
  }
  if (teamTask.task.status === "submitted") {
    console.log("Task already submitted", { status: teamTask.task.status });
    return false;
  }
  if (!teamTask.task.creatorId || teamTask.task.creatorId !== userId) {
    console.log("User is not inviter", { creatorId: teamTask.task.creatorId, userId });
    return false;
  }
  if (!teamTaskGenerated) {
    console.log("Task not generated");
    return false;
  }
  if (!teamTask.invitations.some((inv) => inv.status === "accepted")) {
    console.log("No accepted invitations");
    return false;
  }
  const allSubmitted = teamTask.invitations
    .filter((inv) => inv.status === "accepted")
    .every((inv) =>
      teamTask.answers.some(
        (answer) => answer.user_id === inv.invitee_id && answer.submitted_at
      )
    );
  if (!allSubmitted) {
    console.log("Not all invitees have submitted");
    return false;
  }
  const creatorSubmitted = teamTask.answers.some(
    (answer) => answer.user_id === userId && answer.submitted_at
  );
  if (!creatorSubmitted) {
    console.log("Creator has not submitted");
    return false;
  }
  console.log("canSubmitTask: true");
  return true;
}, [teamTask, userId, teamTaskGenerated]);

// Helper to check if all invitees have submitted
const checkAllSubmitted = useCallback((taskData) => {
  if (!taskData?.task?.taskId || !Array.isArray(taskData.answers)) return false;

  const acceptedInvitees = taskData.invitations
    .filter(inv => inv?.status === "accepted")
    .map(inv => inv?.invitee_id)
    .filter(Boolean);

  // Fallback: if invitee_id missing, derive expected submitter count
  // from accepted invitations count instead of relying on invitee_id match
  if (acceptedInvitees.length === 0) {
    const acceptedCount = taskData.invitations.filter(inv => inv?.status === "accepted").length;
    if (acceptedCount === 0) return false;
    // Total participants = creator + accepted invitees
    const expectedSubmitters = acceptedCount + 1;
    const distinctSubmitters = new Set(taskData.answers.map(a => a.user_id)).size;
    return distinctSubmitters >= expectedSubmitters;
  }

  return acceptedInvitees.every(inviteeId =>
    taskData.answers.some(ans => ans.user_id === inviteeId && (ans.submitted_at || ans.saved_at))
  );
}, []);

// Add this near getPlan(), updatePlanField(), etc.
const hasPlanContent = (activityId) => {
  if (!activityId) return false;
  const plan = getPlan(activityId);
  return !!(
    plan.goal?.trim() ||
    plan.whyItMatters?.trim() ||
    (plan.logEntries && plan.logEntries.length > 0) ||
    plan.outcomeReflection?.trim()
  );
};

// State to track if a fetch is in progress
const [isFetchingTasks, setIsFetchingTasks] = useState(false);


// Fetch task details
const fetchTaskDetails = async (taskId, forceRefresh = false) => {
  const now = new Date();
  console.log(`fetchTaskDetails called with taskId: ${taskId}, forceRefresh: ${forceRefresh}`);
  const cachedTask = localStorage.getItem(`team_task_${userId}`);
  const lastFetchTime = localStorage.getItem(`last_fetch_task_details_${userId}_${taskId}`);
  const savedAnswer = localStorage.getItem(`team_answer_${taskId}_${userId}`);
  const threeHoursInMs = 3 * 60 * 60 * 1000;
  const fiveMinutesInMs = 5 * 60 * 1000; // Shorter TTL for status-sensitive fetches

  // Use shorter TTL if forceRefresh for statuses
  const effectiveTTL = forceRefresh ? fiveMinutesInMs : threeHoursInMs;

  // Check cached task for expiration
  if (cachedTask && !forceRefresh) {
    try {
      const parsedTask = JSON.parse(cachedTask);
     if (
  parsedTask &&
  parsedTask.task &&
  parsedTask.task.taskId === taskId &&      // ← only require taskId match
  Array.isArray(parsedTask.answers) &&
  Array.isArray(parsedTask.invitations)
) {
  // Guard expiry only if created_at is actually present
  if (parsedTask.task.created_at) {
    const createdAt = new Date(parsedTask.task.created_at);
    const twoMonthsInMs = 6 * 30 * 24 * 60 * 60 * 1000;
    const expiryDate = new Date(createdAt.getTime() + twoMonthsInMs);
    const timeLeft = expiryDate - now;

    if (timeLeft <= 0) {
      console.log("Cached task in fetchTaskDetails is expired, resetting state");
      resetTeamState();
      return null;
    }

    // Check cache freshness
    if (lastFetchTime) {
      const timeSinceLastFetch = now.getTime() - new Date(lastFetchTime).getTime();
      if (timeSinceLastFetch < effectiveTTL) {
        console.log("Using cached task data in fetchTaskDetails");
        setTeamTask(parsedTask);
        setTeamTaskGenerated(!!parsedTask.task.question);
        setTeamTaskGeneratedTime(parsedTask.task.created_at || null);
        setHasStoredFeedback(!!parsedTask.task.feedback_text);
        setTimeUntilExpiry(Math.ceil(timeLeft / (24 * 60 * 60 * 1000)));
        updateTeamMemberStatuses(parsedTask, taskId);
        const userAnswer = parsedTask.answers.find(
          (answer) => answer.user_id === userId && answer.submitted_at
        );
        if (userAnswer) {
          localStorage.setItem(`team_answer_${taskId}_${userId}`, sanitizeAnswer(userAnswer.answer_text));
          setTeamAnswer(sanitizeAnswer(userAnswer.answer_text));
          setHasSubmittedAnswer(true);
        } else if (savedAnswer) {
          setTeamAnswer(sanitizeAnswer(savedAnswer));
          setHasSubmittedAnswer(false);
        } else {
          setTeamAnswer("");
          setHasSubmittedAnswer(false);
          localStorage.removeItem(`team_answer_${taskId}_${userId}`);
        }
        setTeamError(null);
        setNeedsFeedbackFetch(
          parsedTask.task.creatorId === userId &&
          parsedTask.task.status === "submitted" &&
          !parsedTask.task.feedback_text
        );
        return parsedTask;
      }
    }
  }
}
    } catch (err) {
      console.error("Error parsing cached task in fetchTaskDetails:", err.message);
      localStorage.removeItem(`team_task_${userId}`);
    }
  }

  // If no taskId, try to find one from invitations
  if (!taskId) {
    console.log("No taskId provided, fetching invitations");
    try {
      const response = await axios.get(`/api/team/invitations`, {
        params: { userId },
        headers: getAuthHeaders(),
      });
      const invitations = Array.isArray(response.data.invitations) ? response.data.invitations : [];
      const acceptedInvitation = invitations.find(
        (inv) => inv?.status === "accepted" && inv?.invitee_id === userId
      );
      if (acceptedInvitation && acceptedInvitation.task_id) {
        taskId = acceptedInvitation.task_id;
      } else {
        console.log("No accepted invitations found, resetting state");
        setTeamError("No active task found. Please start a new team challenge.");
        resetTeamState();
        return null;
      }
    } catch (err) {
      console.error("Error fetching invitations:", err.message);
      setTeamError("Failed to fetch invitations. Please try again.");
      resetTeamState();
      return null;
    }
  }

  // Fetch task from DB
  console.log(`Fetching task details for taskId: ${taskId}`);
setIsLoadingTask(true);
try {
  const response = await axios.get(`/api/team/task/${taskId}`, {
    params: { userId },
    headers: getAuthHeaders(),
  });
  const updatedTask = response.data;
  
  // --- ADD THIS LOGGING TO DEBUG ---
  console.log("📊 Fetched task data:", {
    taskId: updatedTask.task?.taskId,
    created_at: updatedTask.task?.created_at,
    submission_date: updatedTask.task?.submission_date,
    status: updatedTask.task?.status,
  });
  // --- END DEBUG LOGGING ---
  
  if (
    !updatedTask ||
    !updatedTask.task ||
    !Array.isArray(updatedTask.answers) ||
    !Array.isArray(updatedTask.invitations)
  ) {
    throw new Error("Invalid task data received from server");
  }

  // --- ADD THIS FIX: Ensure created_at is preserved ---
  // If the task has a submission_date but no created_at, use submission_date
  if (!updatedTask.task.created_at && updatedTask.task.submission_date) {
    updatedTask.task.created_at = updatedTask.task.submission_date;
  }
  
  // If we still don't have created_at, use the current time as fallback
  if (!updatedTask.task.created_at) {
    console.warn("⚠️ Task has no created_at, using fallback");
    updatedTask.task.created_at = new Date().toISOString();
  }
  // --- END FIX ---

  // Check expiration before saving
  const createdAt = new Date(updatedTask.task.created_at);
  const sixMonthsInMs = 6 * 30 * 24 * 60 * 60 * 1000;
  const expiryDate = new Date(createdAt.getTime() + sixMonthsInMs);
  const timeLeft = expiryDate - now;

  console.log("⏰ Task expiry check:", {
    created_at: updatedTask.task.created_at,
    expiryDate: expiryDate.toISOString(),
    timeLeftDays: Math.ceil(timeLeft / (24 * 60 * 60 * 1000)),
    isExpired: timeLeft <= 0,
  });

  // --- MODIFY THIS PART: Don't auto-reset, just mark as expired ---
  if (timeLeft <= 0) {
    console.log("📅 Task is expired - allowing Start New Session");
    // Don't reset state - just set a flag and let the button handle it
    updatedTask.task.isExpired = true;
    // Keep the task data intact
  }
  // --- END MODIFICATION ---

  // Update state - ALWAYS update the state, even for expired tasks
  console.log("💾 Saving fetched task data to localStorage");
  localStorage.setItem(`team_task_${userId}`, JSON.stringify(updatedTask));
  localStorage.setItem(`last_fetch_task_details_${userId}_${taskId}`, now.toISOString());
  localStorage.setItem(`team_task_timestamp_${userId}`, now.toISOString());

  setTeamTask(updatedTask);
  setTeamTaskGenerated(!!updatedTask.task.question);
  setTeamTaskGeneratedTime(updatedTask.task.created_at || null);
  setHasStoredFeedback(!!updatedTask.task.feedback_text);
  
  // --- MODIFY: Only set timeUntilExpiry if not expired ---
  if (timeLeft > 0) {
    setTimeUntilExpiry(Math.ceil(timeLeft / (24 * 60 * 60 * 1000)));
  } else {
    setTimeUntilExpiry(null);
    setTeamError("Your team challenge has expired. Click 'Start New Session' to begin a new one.");
  }
  // --- END MODIFICATION ---
  
  updateTeamMemberStatuses(updatedTask, taskId);

     // === ADD THIS BLOCK HERE ===
    const allSubmitted = checkAllSubmitted(updatedTask);
    console.log("✅ All submitted check result:", allSubmitted, {
  answersCount: updatedTask.answers.length,
  acceptedInvitees: updatedTask.invitations.filter(i => i.status === "accepted").length
});

    setAllInviteesSubmitted(allSubmitted);
    setShowStatusNote(updatedTask.task.status === "submitted" && !allSubmitted);

    setLastFetchTaskDetailsTime(now);
    setCanCheckTask(isAdmin || forceRefresh); // Reset canCheckTask if forceRefresh

const userAnswer = updatedTask.answers.find(
  (answer) => answer.user_id === userId && answer.submitted_at
);

if (userAnswer) {
  // User has submitted to DB - always show the submitted answer
  const sanitizedAnswer = sanitizeAnswer(userAnswer.answer_text);
  localStorage.setItem(`team_answer_${taskId}_${userId}`, sanitizedAnswer);
  setTeamAnswer(sanitizedAnswer);
  setHasSubmittedAnswer(true);
} else {
  // Check for locally saved draft
  const savedAnswer = localStorage.getItem(`team_answer_${taskId}_${userId}`);
  if (savedAnswer) {
    setTeamAnswer(sanitizeAnswer(savedAnswer));
    setHasSubmittedAnswer(false);
  } else {
    setTeamAnswer("");
    setHasSubmittedAnswer(false);
  }
}

    setTeamError(null);
    return updatedTask;
  } catch (err) {
    console.error("Error fetching task details:", err.message);
    setTeamError(err.response?.data?.error || "Failed to fetch task details.");
    if (err.response?.status === 401) {
      localStorage.removeItem("token");
      navigate("/login");
    }
    resetTeamState();
    return null;
  } finally {
    setIsLoadingTask(false);
  }
};


const updateTeamMemberStatuses = useCallback((task, taskId) => {
  const teamMembers = [
    task.task.creatorId,
    ...task.invitations
      .filter((inv) => inv?.status === "accepted")
      .map((inv) => inv?.invitee_id),
  ].filter((id) => id);

  const statuses = teamMembers.map((member) => ({
    userId: member,
    taskId,
    hasSubmitted: task.answers.some((answer) => 
      answer?.user_id === member && 
      (answer.submitted_at || answer.saved_at)
    ),
    email: member === task.task.creatorId ? 
      (task.task.inviter_email || "Inviter") : 
      task.invitations.find((inv) => inv?.invitee_id === member)?.invitee_email || "Unknown",
  }));

  setTeamMemberStatuses(statuses);
}, []);


const resetTeamState = useCallback(() => {
  console.log("Resetting team state for new session");

  localStorage.removeItem(`team_task_${userId}`);
  localStorage.removeItem(`pending_invitations_${userId}`);
  localStorage.removeItem(`last_invitation_fetch_${userId}`);
  localStorage.removeItem(`invite_limit_${userId}`);
  localStorage.removeItem(`last_fetch_user_tasks_${userId}`);
  localStorage.removeItem(`team_task_timestamp_${userId}`);
  localStorage.removeItem(`no_active_task_${userId}`);

  if (teamTask.task.taskId) {
    const allParticipants = [
      teamTask.task.creatorId,
      ...teamTask.invitations
        .filter((inv) => inv?.status === "accepted")
        .map((inv) => inv?.invitee_id),
    ].filter((id) => id);

    allParticipants.forEach((participant) => {
      localStorage.removeItem(`team_answer_${teamTask.task.taskId}_${participant}`);
      localStorage.removeItem(`last_fetch_task_details_${participant}_${teamTask.task.taskId}`);
      localStorage.removeItem(`force_feedback_fetch_${participant}`);
      localStorage.removeItem(`last_challenge_submission_${participant}`);
    });
  }

  setTeamTask({
    task: {
      taskId: null,
      creatorId: null,
      subject: null,
      question: null,
      status: "pending",
      created_at: null,
    },
    answers: [],
    invitations: [],
  });
  setTeamAnswer("");
  setTeamTaskGenerated(false);
  setTeamTaskGeneratedTime(null);
  setTeamMemberStatuses([]);
  setHasSubmittedAnswer(false);
  setPendingInvitations([]);
  setInviteLimit({ count: 0, resetTime: null, limitReached: false });
  setTeamSubject("");
  setInviteeEmails("");
  setTeamError("The team challenge has been reset. You can now start a new team challenge.");
  setTimeUntilExpiry(null);
  setCanCheckTask(true);
  setLastFetchTaskDetailsTime(null);
  setHasStoredFeedback(false);
  setNeedsFeedbackFetch(false);

  
  if (userRole !== "user" && (!restrictionUntil || new Date() >= new Date(restrictionUntil))) {
    setUserRole("user");
    setRestrictionUntil(null);
    localStorage.setItem(`app_role_${userId}`, "user");
    localStorage.setItem(`restriction_until_${userId}`, "");
  }
}, [userId, userRole, teamTask.task.taskId, teamTask.invitations, restrictionUntil]);


// This function intelligently fetches only what's needed based on context
const fetchTeamData = useCallback(async (options = {}) => {
  const {
    fetchFullDetails = false,     // Get full task details (answers, feedback)
    fetchInvitations = false,     // Get pending invitations list
    fetchStatusOnly = false,      // Only refresh invitation statuses
    force = false,                // Ignore cooldown
  } = options;

  const now = Date.now();
  
    // --- ADD THIS: Check if user has reset the session ---
  const hasReset = localStorage.getItem(`has_reset_session_${userId}`) === 'true';
  if (hasReset && !force) {
    console.log("🔄 Session was reset by user. Skipping fetch of completed tasks.");
    setTeamDataLoaded(true);
    return true;
  }
  // --- END ADD ---

  // Cooldown check (30 seconds between fetches)
  if (!force && lastManualFetchTime && (now - lastManualFetchTime) < MANUAL_FETCH_COOLDOWN) {
    const secondsLeft = Math.ceil((MANUAL_FETCH_COOLDOWN - (now - lastManualFetchTime)) / 1000);
    setTeamError(`Please wait ${secondsLeft} seconds before refreshing.`);
    return false;
  }

  setIsManualFetching(true);
  setTeamError(null);

  try {
    // ─────────────────────────────────────────────
    // 1. FETCH INVITATION STATUS (lightweight)
    //    ONLY if there's an active task (taskId exists)
    // ─────────────────────────────────────────────
  const isInviterRole = userRole === 'inviter' || teamTask.task.creatorId === userId;

if ((fetchInvitations || fetchStatusOnly) && teamTask.task.taskId && isInviterRole) {
  // ── ADD CACHE CHECK ──
  const STATUS_CACHE_KEY = `invitation_status_cache_${userId}_${teamTask.task.taskId}`;
  const STATUS_FETCH_KEY = `invitation_status_fetch_${userId}_${teamTask.task.taskId}`;
  const FIFTEEN_MINUTES = 15 * 60 * 1000;
  const now = new Date();
  
  const cachedStatus = localStorage.getItem(STATUS_CACHE_KEY);
  const lastFetchTime = localStorage.getItem(STATUS_FETCH_KEY);
  
  // Use cached status if less than 15 minutes old
  if (cachedStatus && lastFetchTime) {
    const timeSinceFetch = now.getTime() - new Date(lastFetchTime).getTime();
    if (timeSinceFetch < FIFTEEN_MINUTES) {
      try {
        const parsedInvitations = JSON.parse(cachedStatus);
        setTeamTask(prev => {
          const updated = { ...prev, invitations: parsedInvitations };
          localStorage.setItem(`team_task_${userId}`, JSON.stringify(updated));
          return updated;
        });
        setLastStatusFetchTime(new Date());
        return; // ← EXIT EARLY, use cache
      } catch (e) {
        localStorage.removeItem(STATUS_CACHE_KEY);
      }
    }
  }
  
  // ── Cache expired or missing - fetch from API ──
  try {
    const statusResponse = await axios.get(`/api/team/invitations/status`, {
          params: { taskId: teamTask.task.taskId },
          headers: getAuthHeaders(),
        });
        
        const updatedInvitations = statusResponse.data.invitations || [];
        
        // ── STORE IN CACHE ──
        localStorage.setItem(STATUS_CACHE_KEY, JSON.stringify(updatedInvitations));
        localStorage.setItem(STATUS_FETCH_KEY, new Date().toISOString());
        
        setTeamTask(prev => {
          const updated = { ...prev, invitations: updatedInvitations };
          localStorage.setItem(`team_task_${userId}`, JSON.stringify(updated));
          return updated;
        });
        
        // Check if all declined - user can start new session
        if (updatedInvitations.every(inv => inv.status === 'declined')) {
          resetTeamState();
          setTeamError("All invitations declined. You can now start a new challenge.");
        }
        
        setLastStatusFetchTime(new Date());
      } catch (statusErr) {
        // If 400 error, it means no active task - just log and continue
        if (statusErr.response?.status === 400) {
          console.log("No active task found for status check - this is normal when no task exists.");
        } else {
          console.error("Error fetching invitation status:", statusErr.message);
        }
      }
    }
    
    // ─────────────────────────────────────────────
    // 2. FETCH PENDING INVITATIONS (lightweight)
    //    Used when: notification bell clicked
    // ─────────────────────────────────────────────
    if (fetchInvitations) {
      const invitationsResponse = await axios.get("/api/team/invitations", {
        params: { userId },
        headers: getAuthHeaders(),
      });
      
      const invitations = invitationsResponse.data.invitations || [];
      const pending = invitations.filter(inv => inv.status === 'pending');
      
      setPendingInvitations(pending);
      setNotificationCount(pending.length);
      
      localStorage.setItem(`pending_invitations_${userId}`, JSON.stringify(pending));
      localStorage.setItem(`last_invitation_fetch_${userId}`, new Date().toISOString());
    }
    

    // ─────────────────────────────────────────────
    // 4. FETCH USER TASKS (lightweight - metadata only)
    //    Used when: user selects subject dropdown
    // ─────────────────────────────────────────────
    const USER_TASKS_CACHE_KEY = `user_tasks_cache_${userId}`;
const USER_TASKS_FETCH_KEY = `user_tasks_fetch_${userId}`;
const SIXTY_DAYS = 60 * 24 * 60 * 60 * 1000;
const now = Date.now();

const cachedTasks = localStorage.getItem(USER_TASKS_CACHE_KEY);
const lastFetchTime = localStorage.getItem(USER_TASKS_FETCH_KEY);

// Use cached tasks if less than 60 days old
if (cachedTasks && lastFetchTime && !options.force) {
  const timeSinceFetch = now - new Date(lastFetchTime).getTime();
  if (timeSinceFetch < SIXTY_DAYS) {
    try {
      const tasks = JSON.parse(cachedTasks);
      if (tasks.length === 0) {
        setTeamDataLoaded(true);
        setLastManualFetchTime(now);
        setIsManualFetching(false);
        return true;
      }
      // Process cached tasks (skip API call entirely)
      const task = tasks[0];
      const createdAt = new Date(task.created_at);
      const sixMonthsInMs = 6 * 30 * 24 * 60 * 60 * 1000;
      const expiryDate = new Date(createdAt.getTime() + sixMonthsInMs);
      
      if (Date.now() > expiryDate) {
        setTeamError("Your team challenge has expired. Start a new session.");
        resetTeamState();
        setTeamDataLoaded(true);
        setLastManualFetchTime(now);
        setIsManualFetching(false);
        return true;
      }
      
      // Rebuild task from cache (same as API response)
      const existingCached = (() => {
        try {
          const c = localStorage.getItem(`team_task_${userId}`);
          return c ? JSON.parse(c) : null;
        } catch { return null; }
      })();
      
      let restoredInvitations = [];
      try {
        const statusRes = await axios.get(`/api/team/invitations/status`, {
          params: { taskId: task.task_id },
          headers: getAuthHeaders(),
        });
        restoredInvitations = statusRes.data.invitations || [];
      } catch (statusErr) {
        console.warn("Could not fetch invitation statuses:", statusErr.message);
        // Fall back to cache
        const cachedTask = localStorage.getItem(`team_task_${userId}`);
        if (cachedTask) {
          try {
            const parsed = JSON.parse(cachedTask);
            if (Array.isArray(parsed?.invitations)) {
              restoredInvitations = parsed.invitations;
            }
          } catch { /* ignore */ }
        }
      }
      
      const rebuiltTask = {
        task: {
          taskId: task.task_id,
          creatorId: task.creator_id,
          subject: task.subject,
          question: task.question || null,
          status: task.status,
          created_at: task.created_at || existingCached?.task?.created_at || null,
          feedback_text: task.feedback_text || null,
        },
        answers: [],
        invitations: restoredInvitations,
      };
      
      localStorage.setItem(`team_task_${userId}`, JSON.stringify(rebuiltTask));
      localStorage.setItem(
        `last_fetch_task_details_${userId}_${task.task_id}`,
        new Date().toISOString()
      );
      
      setTeamTask(rebuiltTask);
      setTeamTaskGenerated(!!task.question);
      setTeamTaskGeneratedTime(task.created_at || existingCached?.task?.created_at || null);
      setTimeUntilExpiry(
        Math.ceil((expiryDate - Date.now()) / (24 * 60 * 60 * 1000))
      );
      setTeamDataLoaded(true);
      setLastManualFetchTime(now);
      setIsManualFetching(false);
      return true;
    } catch (err) {
      console.error("Error parsing cached user tasks:", err);
      localStorage.removeItem(USER_TASKS_CACHE_KEY);
    }
  }
}

// ── Cache expired or missing - fetch from API ──
const tasksRes = await axios.get(`/api/team/user-tasks/${userId}`, {
  headers: getAuthHeaders(),
});

const tasks = tasksRes.data.tasks || [];

// ── STORE IN CACHE ──
localStorage.setItem(USER_TASKS_CACHE_KEY, JSON.stringify(tasks));
localStorage.setItem(USER_TASKS_FETCH_KEY, new Date().toISOString());
    if (tasks.length === 0) {
      setTeamDataLoaded(true);
      setLastManualFetchTime(now);
      setIsManualFetching(false);
      return true;
    }
    
    const task = tasks[0];
    const createdAt = new Date(task.created_at);
    const twoMonthsInMs = 6 * 30 * 24 * 60 * 60 * 1000;
    const expiryDate = new Date(createdAt.getTime() + twoMonthsInMs);
    
    if (Date.now() > expiryDate) {
      setTeamError("Your team challenge has expired. Start a new session.");
      resetTeamState();
      setTeamDataLoaded(true);
      setLastManualFetchTime(now);
      setIsManualFetching(false);
      return true;
    }
    
    // ─────────────────────────────────────────────
    // 5. FETCH FULL TASK DETAILS (heavy - answers, feedback)
    //    Used when: Status button clicked
    // ─────────────────────────────────────────────
    if (fetchFullDetails) {
      const taskData = await fetchTaskDetails(task.task_id, true);
      if (taskData) {
        setTeamTask(taskData);
        setTeamTaskGenerated(!!taskData.task.question);
        setTeamTaskGeneratedTime(taskData.task.created_at || null);
        setHasStoredFeedback(!!taskData.task.feedback_text);
        setTimeUntilExpiry(Math.ceil((expiryDate - Date.now()) / (24 * 60 * 60 * 1000)));
        updateTeamMemberStatuses(taskData, task.task_id);
        
        const savedAnswer = localStorage.getItem(`team_answer_${task.task_id}_${userId}`);
        if (savedAnswer) {
          setTeamAnswer(sanitizeAnswer(savedAnswer));
        }
        setHasSubmittedAnswer(
          taskData.answers.some(answer => answer.user_id === userId && answer.submitted_at)
        );
      }
} else {
  // Lightweight mode — fetch invitation statuses so buttons render correctly
let restoredInvitations = [];
try {
  const statusRes = await axios.get(`/api/team/invitations/status`, {
    params: { taskId: task.task_id },
    headers: getAuthHeaders(),
  });
  restoredInvitations = statusRes.data.invitations || [];
} catch (statusErr) {
  console.warn("Could not restore invitation statuses:", statusErr.message);
  // Fall back to whatever invitations are already in the cached task
  const cachedTask = localStorage.getItem(`team_task_${userId}`);
  if (cachedTask) {
    try {
      const parsed = JSON.parse(cachedTask);
      if (Array.isArray(parsed?.invitations)) {
        restoredInvitations = parsed.invitations;
        console.log("Using cached invitations as fallback:", restoredInvitations.length);
      }
    } catch { /* ignore */ }
  }
}

 const existingCached = (() => {
  try {
    const c = localStorage.getItem(`team_task_${userId}`);
    return c ? JSON.parse(c) : null;
  } catch { return null; }
})();

const rebuiltTask = {
  task: {
    taskId: task.task_id,
    creatorId: task.creator_id,
    subject: task.subject,
    question: task.question || null,
    status: task.status,
    // Prefer API value, fall back to what was previously cached
    created_at: task.created_at 
      || existingCached?.task?.created_at 
      || null,
    feedback_text: task.feedback_text || null,
  },
  answers: [],
  invitations: restoredInvitations,
};

  // Persist so page refresh survives
  localStorage.setItem(`team_task_${userId}`, JSON.stringify(rebuiltTask));
  localStorage.setItem(
    `last_fetch_task_details_${userId}_${task.task_id}`,
    new Date().toISOString()
  );

  setTeamTask(rebuiltTask);
  setTeamTaskGenerated(!!task.question);
  setTeamTaskGeneratedTime(task.created_at || null);
  setTimeUntilExpiry(
    Math.ceil((expiryDate - Date.now()) / (24 * 60 * 60 * 1000))
  );
}
    
    setTeamDataLoaded(true);
    setLastManualFetchTime(now);
    setIsManualFetching(false);
    return true;
    
  } catch (err) {
    console.error("Team data fetch error:", err);
    // Don't show error for 400 when no task exists - it's expected
    if (err.response?.status !== 400) {
      setTeamError(err.response?.data?.error || "Failed to load team data");
    }
    setIsManualFetching(false);
    return false;
  }
}, [userId, teamTask.task.taskId, lastManualFetchTime, resetTeamState, updateTeamMemberStatuses, fetchTaskDetails]);

// ===== ADD THIS FUNCTION - Manual fetch triggered by user actions =====
const fetchTeamDataManually = useCallback(async (options = { force: false }) => {
  const now = Date.now();
  
  // --- ADD THIS: Check if user has reset the session ---
  const hasReset = localStorage.getItem(`has_reset_session_${userId}`) === 'true';
  if (hasReset && !options.force) {
    console.log("🔄 Session was reset by user. Skipping manual fetch.");
    setTeamDataLoaded(true);
    return true;
  }
  // --- END ADD ---

  // Check cooldown to prevent rapid clicking
  if (!options.force && lastManualFetchTime && (now - lastManualFetchTime) < MANUAL_FETCH_COOLDOWN) {
    const secondsLeft = Math.ceil((MANUAL_FETCH_COOLDOWN - (now - lastManualFetchTime)) / 1000);
    setTeamError(`Please wait ${secondsLeft} seconds before checking again.`);
    return false;
  }

  setIsManualFetching(true);
  setTeamError(null);

  try {
    // 1. Check if user has a task (lightweight call)
    const hasTaskRes = await axios.get(`/api/team/has-task/${userId}`, {
      headers: getAuthHeaders(),
    });

    if (!hasTaskRes.data.hasTask) {
      // No active task - user can start a new one
      setTeamTask({
        task: { taskId: null, creatorId: null, subject: null, question: null, status: 'pending', created_at: null },
        answers: [],
        invitations: [],
      });
      setTeamTaskGenerated(false);
      setTeamMemberStatuses([]);
      setHasSubmittedAnswer(false);
      setTeamError(null);
      setTeamDataLoaded(true);
      setLastManualFetchTime(now);
      setIsManualFetching(false);
      return true;
    }

    // 2. Fetch user tasks (lightweight - only task metadata)
    const tasksRes = await axios.get(`/api/team/user-tasks/${userId}`, {
      headers: getAuthHeaders(),
    });
    
    const tasks = tasksRes.data.tasks || [];
    if (tasks.length === 0) {
      setTeamDataLoaded(true);
      setLastManualFetchTime(now);
      setIsManualFetching(false);
      return true;
    }

    const task = tasks[0];
  const createdAt = new Date(task.created_at);
  const sixMonthsInMs = 6 * 30 * 24 * 60 * 60 * 1000;
  const expiryDate = new Date(createdAt.getTime() + sixMonthsInMs);

  if (Date.now() > expiryDate) {
    setTeamError("Your team challenge has expired. Click 'Start New Session' to begin a new one.");
    // Don't auto-reset - let user click the button
    setTeamDataLoaded(true);
    setLastManualFetchTime(now);
    setIsManualFetching(false);
    return true;
  }

    // 3. Fetch full task details only when needed (heavier call)
    if (options.fetchFullDetails) {
      const taskData = await fetchTaskDetails(task.task_id, true);
      if (taskData) {
        setTeamTask(taskData);
        setTeamTaskGenerated(!!taskData.task.question);
        setTeamTaskGeneratedTime(taskData.task.created_at || null);
        setHasStoredFeedback(!!taskData.task.feedback_text);
        setTimeUntilExpiry(Math.ceil((expiryDate - Date.now()) / (24 * 60 * 60 * 1000)));
        updateTeamMemberStatuses(taskData, task.task_id);
        
        const savedAnswer = localStorage.getItem(`team_answer_${task.task_id}_${userId}`);
        if (savedAnswer) {
          setTeamAnswer(sanitizeAnswer(savedAnswer));
        }
        setHasSubmittedAnswer(
          taskData.answers.some(answer => answer.user_id === userId && answer.submitted_at)
        );
      }
   // AFTER — persist to localStorage so refresh survives:
} else {
  let restoredInvitations = [];

  // ── Only the inviter (creator) needs live invitation statuses ──
  // Invitee already accepted — their invitation data is in the cached task
  const isInviterRole = userRole === 'inviter' || task.creator_id === userId;

  if (isInviterRole) {
    try {
      const statusRes = await axios.get(`/api/team/invitations/status`, {
        params: { taskId: task.task_id },
        headers: getAuthHeaders(),
      });
      restoredInvitations = statusRes.data.invitations || [];
    } catch (statusErr) {
      console.warn("Could not fetch invitation statuses:", statusErr.message);
      // Fall back to cache on error
      const cachedTask = localStorage.getItem(`team_task_${userId}`);
      if (cachedTask) {
        try {
          const parsed = JSON.parse(cachedTask);
          if (Array.isArray(parsed?.invitations)) {
            restoredInvitations = parsed.invitations;
            console.log("Inviter: using cached invitations as fallback");
          }
        } catch { /* ignore */ }
      }
    }
  } else {
    // ── Invitee: always restore from cache — no API call needed ──
    const cachedTask = localStorage.getItem(`team_task_${userId}`);
    if (cachedTask) {
      try {
        const parsed = JSON.parse(cachedTask);
        if (Array.isArray(parsed?.invitations)) {
          restoredInvitations = parsed.invitations;
          console.log("Invitee: restored invitations from cache");
        }
      } catch { /* ignore */ }
    }
  }

  const existingCached = (() => {
    try {
      const c = localStorage.getItem(`team_task_${userId}`);
      return c ? JSON.parse(c) : null;
    } catch { return null; }
  })();

  const rebuiltTask = {
    task: {
      taskId: task.task_id,
      creatorId: task.creator_id,
      subject: task.subject,
      question: task.question || null,
      status: task.status,
      created_at: task.created_at || existingCached?.task?.created_at || null,
      feedback_text: task.feedback_text || null,
    },
    answers: [],
    invitations: restoredInvitations,
  };

  localStorage.setItem(`team_task_${userId}`, JSON.stringify(rebuiltTask));
  localStorage.setItem(
    `last_fetch_task_details_${userId}_${task.task_id}`,
    new Date().toISOString()
  );

  setTeamTask(rebuiltTask);
  setTeamTaskGenerated(!!task.question);
  setTeamTaskGeneratedTime(task.created_at || existingCached?.task?.created_at || null);
  setTimeUntilExpiry(
    Math.ceil((expiryDate - Date.now()) / (24 * 60 * 60 * 1000))
  );
}
    setTeamDataLoaded(true);
    setLastManualFetchTime(now);
    setIsManualFetching(false);
    return true;

  } catch (err) {
    console.error("Manual fetch error:", err);
    // Don't show error for 400 when no task exists
    if (err.response?.status !== 400) {
      setTeamError(err.response?.data?.error || "Failed to load team data");
    }
    setIsManualFetching(false);
    return false;
  }
}, [userId, lastManualFetchTime, resetTeamState, updateTeamMemberStatuses, fetchTaskDetails]);



useEffect(() => {
  const checkTaskExpiry = () => {
    console.log("checkTaskExpiry running", {
      taskId: teamTask.task.taskId,
      created_at: teamTask.task.created_at,
      question: teamTask.task.question,
    });

    // ── Guard 1: No task at all — nothing to check ──────────────────────────
    if (!teamTask.task.taskId) {
      setTimeUntilExpiry(null);
      setTeamError(null);
      return;
    }

    // ── Guard 2: Task exists but no created_at yet — wait, don't reset ──────
    // This happens after accepting an invite before the inviter generates
    if (!teamTask.task.created_at) {
      setTimeUntilExpiry(null);
      setTeamError("Waiting for task to be generated...");
      return;
    }

    const creationTime = new Date(teamTask.task.created_at);

    // ── Guard 3: Unparseable date — log but don't reset (avoid loop) ────────
    if (isNaN(creationTime.getTime())) {
      console.warn("checkTaskExpiry: invalid created_at, skipping reset", teamTask.task.created_at);
      setTimeUntilExpiry(null);
      return;
    }

    const now = new Date();
    const sixMonthsInMs = 6 * 30 * 24 * 60 * 60 * 1000; // 6 months
    const expiryDate = new Date(creationTime.getTime() + sixMonthsInMs);
    const timeLeft = expiryDate - now;

    if (timeLeft <= 0) {
      console.log("checkTaskExpiry: task is expired");
      setTimeUntilExpiry(null);
      // Don't auto-reset - let user click "Start New Session"
      setTeamError("Your team challenge has expired. Click 'Start New Session' to begin a new one.");
      return;
    }

    const daysLeft = Math.ceil(timeLeft / (24 * 60 * 60 * 1000));
    setTimeUntilExpiry(daysLeft);
    // Clear error if task is active and not expired
    if (teamTask.task.status === "active" || teamTask.task.status === "submitted") {
      setTeamError(null);
    }
  };

  checkTaskExpiry();
  const interval = setInterval(checkTaskExpiry, 24 * 60 * 60 * 1000);
  return () => clearInterval(interval);

  // ── Removed resetTeamState from deps — it changing must not re-trigger ───
}, [teamTask.task.taskId, teamTask.task.created_at, teamTask.task.question, teamTask.task.status]);

const handleStartNewSession = useCallback(async () => {
  const confirmed = await confirm(
    "This will reset your current team challenge session so you can start a new one. Your existing task data is kept — nothing is deleted. Continue?",
    { title: "Start new session?", confirmLabel: "Start New Session" }
  );
  if (!confirmed) return;

  try {
    // Check if the task is actually expired before allowing reset
    let isExpired = false;
    if (teamTask.task.taskId && teamTask.task.created_at) {
      const createdAt = new Date(teamTask.task.created_at);
      const sixMonthsInMs = 6 * 30 * 24 * 60 * 60 * 1000;
      const expiryDate = new Date(createdAt.getTime() + sixMonthsInMs);
      isExpired = Date.now() >= expiryDate;
      
      // Also check if all invitations are declined
      const allDeclined = teamTask.invitations.every(inv => inv.status === 'declined');
      
      if (!isExpired && !allDeclined) {
        setTeamError("Cannot reset an active task. It must be expired (over 6 months old) or all invitations must be declined.");
        return;
      }
    }

    // Archive the task in database if it's expired
    if (teamTask.task.taskId && isExpired) {
      try {
        await axios.post(`/api/team/task/${teamTask.task.taskId}/archive`, {
          userId
        }, {
          headers: getAuthHeaders(),
        });
      } catch (archiveErr) {
        console.warn("Could not archive task:", archiveErr.message);
        // Non-fatal: continue with local reset
      }
    }

    // Clear all team-related localStorage
    const keysToRemove = [
      `team_task_${userId}`,
      `pending_invitations_${userId}`,
      `last_invitation_fetch_${userId}`,
      `invite_limit_${userId}`,
      `last_fetch_user_tasks_${userId}`,
      `team_task_timestamp_${userId}`,
      `no_active_task_${userId}`,
      `last_status_check_${userId}`,
      `has_reset_session_${userId}` // Clear this flag
    ];
    keysToRemove.forEach(key => localStorage.removeItem(key));

    // Clear participant-specific localStorage
    if (teamTask.task.taskId) {
      const allParticipants = [
        teamTask.task.creatorId,
        ...teamTask.invitations
          .filter((inv) => inv?.status === "accepted")
          .map((inv) => inv?.invitee_id),
      ].filter((id) => id);

      allParticipants.forEach((participant) => {
        localStorage.removeItem(`team_answer_${teamTask.task.taskId}_${participant}`);
        localStorage.removeItem(`last_fetch_task_details_${participant}_${teamTask.task.taskId}`);
        localStorage.removeItem(`force_feedback_fetch_${participant}`);
        localStorage.removeItem(`last_challenge_submission_${participant}`);
      });
    }

    // Reset state
    resetTeamState();
    setTeamError("Team challenge reset. You can now start a new team challenge.");
  } catch (err) {
    console.error("Error resetting team session:", err);
    setTeamError("Failed to reset team challenge. Please try again.");
  }
}, [userId, teamTask, resetTeamState, setTeamError, confirm]);

// Add this function near other useEffect hooks
const restoreTeamSession = useCallback(async () => {
  if (!userId) return;

  // Check if the user has a stored team task
  const storedTask = localStorage.getItem(`team_task_${userId}`);
  if (!storedTask) {
    console.log("No stored team task found");
    return;
  }

  try {
    const parsedTask = JSON.parse(storedTask);
    
    // If there's no taskId, don't try to restore
    if (!parsedTask.task?.taskId) {
      console.log("Stored task has no taskId, skipping restore");
      return;
    }

    // Check if the task is expired
    const createdAt = parsedTask.task.created_at;
    if (createdAt) {
      const sixMonthsInMs = 6 * 30 * 24 * 60 * 60 * 1000;
      const expiryDate = new Date(new Date(createdAt).getTime() + sixMonthsInMs);
      
      if (Date.now() >= expiryDate) {
        console.log("Stored task is expired, showing reset button");
        setTeamTask(parsedTask);
        setTimeUntilExpiry(null);
        setTeamError("Your team challenge has expired. Click 'Start New Session' to begin a new one.");
        return;
      }
    }

    // Check if all invitations are declined
    if (parsedTask.invitations?.every(inv => inv.status === 'declined')) {
      console.log("All invitations declined, showing reset button");
      setTeamTask(parsedTask);
      setTeamError("All invitations declined. Click 'Start New Session' to begin a new one.");
      return;
    }

    // Check if task status is submitted
    if (parsedTask.task?.status === 'submitted') {
  setTeamTask((prev) => {
    // Avoid a redundant state write (and the resulting render loop) when
    // the restored task is identical to what's already in state.
    if (prev.task?.taskId === parsedTask.task?.taskId && prev.task?.status === 'submitted') {
      return prev;
    }
    console.log("Task already submitted, showing reset button");
    return parsedTask;
  });
  setTeamError("");
  return;
}

    // Task is valid - restore it
    console.log("Restoring valid team task:", parsedTask.task.taskId);
    setTeamTask(parsedTask);
    setTeamTaskGenerated(!!parsedTask.task.question);
    setTeamTaskGeneratedTime(parsedTask.task.created_at || null);
    setHasStoredFeedback(!!parsedTask.task.feedback_text);
    
    if (parsedTask.task.created_at) {
      const timeLeft = new Date(new Date(parsedTask.task.created_at).getTime() + 6 * 30 * 24 * 60 * 60 * 1000) - Date.now();
      if (timeLeft > 0) {
        setTimeUntilExpiry(Math.ceil(timeLeft / (24 * 60 * 60 * 1000)));
      }
    }

    // Restore user answer if exists
    if (parsedTask.task.taskId) {
      const savedAnswer = localStorage.getItem(`team_answer_${parsedTask.task.taskId}_${userId}`);
      if (savedAnswer) {
        setTeamAnswer(sanitizeAnswer(savedAnswer));
        const hasSubmitted = parsedTask.answers.some(
          answer => answer.user_id === userId && answer.submitted_at
        );
        setHasSubmittedAnswer(hasSubmitted);
      }
    }

    // Update member statuses
    updateTeamMemberStatuses(parsedTask, parsedTask.task.taskId);
    setTeamError(null);
    
  } catch (err) {
    console.error("Error restoring team session:", err);
    localStorage.removeItem(`team_task_${userId}`);
  }
}, [userId, updateTeamMemberStatuses]);

// Add this useEffect to restore session on mount and after login
useEffect(() => {
  if (userId) {
    restoreTeamSession();
  }
}, [userId, updateTeamMemberStatuses]);

// Cold-start restore: only fetch from DB if role suggests an active task
// but the task cache is missing (i.e. cache was cleared)
useEffect(() => {
  if (activeSidebarItem !== 'team') return;
  if (teamTask.task.taskId) return;       // cache intact — nothing to do
  if (!userId) return;

  const cachedRole = localStorage.getItem(`app_role_${userId}`);
  // Only roles that imply an active task warrant a DB round-trip
  if (cachedRole !== 'inviter' && cachedRole !== 'invitee') return;

  fetchTeamData({
    fetchFullDetails: false,
    fetchInvitations: true,
    fetchStatusOnly: false,
    force: true,
  });
}, [activeSidebarItem, userId]); // ← intentionally excludes teamTask.task.taskId
                                  //   so it only runs on tab switch, not every state update

// Handle task generation
const handleGenerateTask = async () => {
  if (userRole === 'invitee') {
    setTeamError("Only the person who started this challenge can generate the question.");
    return;
  }
  if (restrictionUntil && new Date() < new Date(restrictionUntil)) {
    setTeamError(
      `Restricted from generating tasks until ${new Date(restrictionUntil).toLocaleDateString('en-US', { timeZone: 'Asia/Hong_Kong' })}.`
    );
    return;
  }
  if (!teamTask.task.taskId || teamTask.task.question) {
    setTeamError("A question has already been generated for this challenge.");
    return;
  }
  const confirmed = await confirm(
    "Team Challenge is available once every 6 months while it's in beta. Generate your question now?",
    { title: "Generate question?", confirmLabel: "Generate" }
  );
  if (!confirmed) return;
  try {

    const response = await axios.post(
      `/api/team/generate/${teamTask.task.taskId}`,
      { userId },
      { headers: getAuthHeaders()}
    );

    let newQuestion = response.data.question; 

 const generatedTime = new Date().toISOString();

const updatedTask = {
  ...teamTask,
  task: {
    ...teamTask.task,
    question: newQuestion,
    status: "active",
    // Keep existing created_at from DB if present, otherwise use now
    created_at: teamTask.task.created_at || generatedTime,
  },
  answers: teamTask.answers || [],
  invitations: teamTask.invitations || [],
};

    setTeamTask(updatedTask);
    localStorage.setItem(`team_task_${userId}`, JSON.stringify(updatedTask));
    localStorage.setItem(`last_fetch_task_details_${userId}_${teamTask.task.taskId}`, new Date().toISOString()); // Added to track last fetch
    setTeamTaskGenerated(true);
    setTeamTaskGeneratedTime(generatedTime);
    setTeamError(null);
  } catch (err) {
    setTeamError(err.response?.data?.error || "Failed to generate task");
  }
};




// Handle answer save (local storage only)
const handleAnswerSubmit = async () => {
  if (teamTask.task.status === "submitted") {
    setTeamError("Cannot save answer after challenge submission.");
    return;
  }
  if (hasSubmittedAnswer) {
    setTeamError("You have already submitted your answer to the database.");
    return;
  }

  const sanitizedAnswer = sanitizeAnswer(teamAnswer);
  if (!sanitizedAnswer) {
    setTeamError("Answer is required and must be valid.");
    return;
  }
  const wordCount = sanitizedAnswer.split(/\s+/).filter((word) => word.length > 0).length;
  if (wordCount > 150) {
    setTeamError("Answer must be 150 words or less.");
    return;
  }

  try {
    // ── Save answer to localStorage ──
    localStorage.setItem(`team_answer_${teamTask.task.taskId}_${userId}`, sanitizedAnswer);

    // Update teamTask state to reflect the local answer
    setTeamTask((prev) => {
      const updatedAnswers = prev.answers.filter((answer) => answer.user_id !== userId);
      updatedAnswers.push({
        user_id: userId,
        answer_text: sanitizedAnswer,
        submitted_at: null, // Not submitted to DB yet
      });
      const updatedTask = { ...prev, answers: updatedAnswers };
      localStorage.setItem(`team_task_${userId}`, JSON.stringify(updatedTask));
      return updatedTask;
    });

    // Update teamMemberStatuses
    setTeamMemberStatuses((prev) =>
      prev.map((member) =>
        member.userId === userId
          ? { ...member, hasSubmitted: false, taskId: teamTask.task.taskId }
          : member
      )
    );

    // ── Keep the answer in state ──
    setTeamAnswer(sanitizedAnswer);
    setTeamError(null);
    showToast("Answer saved on this device — submit it to finalize.", "success");
  } catch (err) {
    setTeamError("Failed to save answer locally.");
    console.error("Error saving answer to localStorage:", err.message);
  }
};

// Handle Answer Submit
const handleAnswerSubmitToDB = async () => {
  if (teamTask.task.status === "submitted") {
    setTeamError("Cannot submit answer after challenge submission.");
    return;
  }
  if (hasSubmittedAnswer) {
    setTeamError("You have already submitted your answer.");
    return;
  }

  const confirmed = await confirm("Once submitted, your answer can't be changed. Submit now?", { confirmLabel: "Submit" });
  if (!confirmed) return;

  try {
    const sanitizedAnswer = sanitizeAnswer(teamAnswer);
    if (!sanitizedAnswer) {
      setTeamError("You must enter an answer before submitting.");
      return;
    }
    const wordCount = sanitizedAnswer.split(/\s+/).filter((word) => word.length > 0).length;
    if (wordCount > 150) {
      setTeamError("Answer must be 150 words or less.");
      return;
    }

    // Save the answer to the Neon database
    await axios.post(
      "/api/team/answer",
      { userId, taskId: teamTask.task.taskId, answerText: sanitizedAnswer },
      { headers: getAuthHeaders() }
    );

     // Track success event
    if (window.gtag) {
      window.gtag('event', 'submit_answer_success', {
        event_category: 'Team Dashboard',
        event_label: 'Submit Answer Succeeded',
        user_id: userId,
        task_id: teamTask.task.taskId,
        subject: teamTask.task.subject,
      });
    }

    // Update teamTask state to reflect the submitted answer
    setTeamTask((prev) => {
      const updatedAnswers = prev.answers.filter((answer) => answer.user_id !== userId);
      updatedAnswers.push({
        user_id: userId,
        answer_text: sanitizedAnswer,
        submitted_at: new Date().toISOString(),
      });
      const updatedTask = { ...prev, answers: updatedAnswers };
      localStorage.setItem(`team_task_${userId}`, JSON.stringify(updatedTask));
      return updatedTask;
    });

    // Update teamMemberStatuses
    setTeamMemberStatuses((prev) =>
      prev.map((member) =>
        member.userId === userId
          ? { ...member, hasSubmitted: true, taskId: teamTask.task.taskId }
          : member
      )
    );

    // Keep the local answer in localStorage for display
    localStorage.setItem(`team_answer_${teamTask.task.taskId}_${userId}`, sanitizedAnswer);
    setTeamAnswer(sanitizedAnswer);
    setHasSubmittedAnswer(true);
    setTeamError(null);
    showToast("Your answer has been submitted.", "success");
  
 if (teamTask.task.creatorId === userId) {
      setShowStatusNote(true);   // Show note until others submit
    }


  } catch (err) {
    // Track failure event
    if (window.gtag) {
      window.gtag('event', 'submit_answer_failure', {
        event_category: 'Team Dashboard',
        event_label: 'Submit Answer Failed - Server Error',
        user_id: userId,
        error_message: err.response?.data?.error || 'Failed to submit answer',
      });
    }
    setTeamError(err.response?.data?.error || "Failed to submit answer");
    console.error("Error during answer submission:", err.message);
    if (err.response?.status === 401) {
      localStorage.removeItem("token");
      navigate("/login");
    }
  }
};

const handleChallengeSubmit = async () => {
  const confirmed = await confirm(
    "Once the challenge is submitted, no changes can be made and feedback will be generated. Submit now?",
    { title: "Submit challenge?", confirmLabel: "Submit" }
  );
  if (!confirmed) return;

  try {
    // Submit the task to the backend
    const response = await axios.post(
      `/api/team/submit/${teamTask.task.taskId}`,
      { userId: userId },           // ← Must be the creator's userId
      {
        headers: getAuthHeaders(),
        timeout: 20000 // 20-second timeout
      }
    );

    // Track success event
    if (window.gtag) {
      window.gtag('event', 'submit_challenge_success', {
        event_category: 'Team Dashboard',
        event_label: 'Submit Challenge Succeeded',
        user_id: userId,
        task_id: teamTask.task.taskId,
        subject: teamTask.task.subject,
      });
    }

    // Keep local answers in localStorage for display
    const allParticipants = [
      teamTask.task.creatorId,
      ...teamTask.invitations
        .filter((inv) => inv.status === "accepted")
        .map((inv) => inv.invitee_id),
    ].filter((id) => id);

    allParticipants.forEach((participant) => {
      const answer = teamTask.answers.find((ans) => ans.user_id === participant)?.answer_text;
      if (answer) {
        localStorage.setItem(`team_answer_${teamTask.task.taskId}_${participant}`, answer);
      }
    });

    // Update teamTask state to reflect submitted status
    setTeamTask((prev) => ({
      ...prev,
      task: { ...prev.task, status: "submitted" },
    }));
    const updatedTask = {
      ...teamTask,
      task: { ...teamTask.task, status: "submitted" },
    };
    localStorage.setItem(`team_task_${userId}`, JSON.stringify(updatedTask));

   // Signal PastChallenges.js to fetch new data
    localStorage.setItem(`force_feedback_fetch_${userId}`, "true");
    localStorage.setItem(`last_challenge_submission_${userId}`, new Date().toISOString());

    // Store minimal challenge data — shape matches PastChallenges.js's
    // normalizeChallenge() expectations (nested `task` object), so it can
    // actually be read back correctly.
    const todayKey = new Date().toISOString().split("T")[0];
    const newChallenge = {
      task: {
        task_id: teamTask.task.taskId,
        creator_id: teamTask.task.creatorId,
        subject: teamTask.task.subject,
        question: teamTask.task.question,
        status: "submitted",
        submission_date: new Date().toISOString(),
        inviter_email: teamTask.task.inviter_email || "Inviter",
        created_at: teamTask.task.created_at || new Date().toISOString(),
        feedback_text: null, // Feedback will be fetched incrementally
      },
      answers: teamTask.answers,
      invitations: teamTask.invitations,
    };
    await appendPastChallenge(userId, todayKey, newChallenge);

    // Poll for task details to handle delayed feedback
    const fetchTaskDetailsWithPolling = async (taskId, maxAttempts = 5, interval = 2000) => {
      for (let attempt = 0; attempt < maxAttempts; attempt++) {
        try {
          const response = await axios.get(
            `/api/team/task/${taskId}?userId=${userId}`,
            {headers: getAuthHeaders() }
          );
          const updatedTask = response.data.task;
          setTeamTask(response.data);
          setAllInviteesSubmitted(true);   // Since creator just submitted
          setShowStatusNote(false);
          if (updatedTask.feedback_text) {
            return; // Feedback received
          }
          await new Promise(resolve => setTimeout(resolve, interval));
        } catch (err) {
          console.error("Error fetching task details:", err.message);
        }
      }
      setTeamError("Feedback not yet available. Please check again later.");
    };

      await fetchTaskDetailsWithPolling(teamTask.task.taskId);
    setTeamError(null);
    showToast(response.data.message || "Team challenge submitted successfully.", "success");
  } catch (err) {
    if (window.gtag) {
      window.gtag('event', 'submit_challenge_failure', {
        event_category: 'Team Dashboard',
        event_label: 'Submit Challenge Failed - Server Error',
        user_id: userId,
        error_message: err.response?.data?.error || 'Failed to submit challenge',
      });
    }
    const errorMsg = err.response?.data?.error || "Failed to submit challenge";
    if (errorMsg.includes("rate limit")) {
      setTeamError("Rate limit exceeded. Please try again later.");
    } else {
      setTeamError(errorMsg);
    }
    console.error("Error during challenge submission:", err.message);
    if (err.response?.status === 401) {
      localStorage.removeItem("token");
      navigate("/login");
    }
  }
};

// Handle invitation form submission
const handleInviteSubmit = async (e) => {
       e.preventDefault();
      if (userRole === 'invitee') {
        setTeamError("You've already joined someone else's team challenge, so you can't send invites of your own.");
        return;
    }
    // Allow creator to invite for their own non-submitted task, or require no restriction
    if (
        !(teamTask.task.creatorId === userId && teamTask.task.status !== "submitted") &&
        restrictionUntil && new Date() < new Date(restrictionUntil)
    ) {
        setTeamError(
            `You are restricted from sending invitations until ${new Date(restrictionUntil).toLocaleDateString()}.`
        );
        return;
    }
  if (!teamSubject) {
        setTeamError("Please select a subject.");
        return;
    }

    // Only require a generated question for the FIRST invitation on this task.
    // A second invitation to the same task reuses the already-locked question.
    if (!teamTask.task.taskId && !draftQuestion) {
        setTeamError("Please generate a question before sending the invitation.");
        return;
    }

    const email = sanitizeEmail(inviteeEmails.trim());
    if (!email) {
        setTeamError("Please enter a valid email address.");
        return;
    }

    const userEmail = localStorage.getItem("userEmail")?.trim().toLowerCase();
    if (email === userEmail) {
        setTeamError("You cannot invite yourself to the team.");
        return;
    }

    const pendingOrAccepted = teamTask.invitations.filter(
        (inv) => inv.status === "pending" || inv.status === "accepted"
    ).length;
    if (pendingOrAccepted >= 2) {
        setTeamError("Maximum of two pending or accepted invitations allowed.");
        return;
    }

    if (!isAdmin && inviteLimit.limitReached) {
        const resetTime = new Date(inviteLimit.resetTime).toLocaleTimeString();
        setTeamError(
            `Invitation limit reached (3 per hour). Try again after ${resetTime}.`
        );
        return;
    }

    if (teamTask.invitations.length === 0) {
        const confirmed = await confirm(
            `You're about to send an invitation for "${teamSubject}". Your subject and question will be locked in, and you won't be able to accept other invites for the next 6 months. Send it?`,
            { title: "Send invitation?", confirmLabel: "Send" }
        );
        if (!confirmed) return;
    }

    try {
        const now = new Date();  
       const response = await axios.post(
            "/api/team/invite",
            {
                userId,
                emails: [email],
                subject: teamSubject,
                // Only send a question when creating the task (first invite).
                // For a second invite on an existing task, omit it so the
                // backend doesn't attempt to overwrite the locked question.
                ...(!teamTask.task.taskId && { question: draftQuestion }),
            },
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            }
        );

        // Track success event
    if (window.gtag) {
      window.gtag('event', 'team_invite_success', {
        event_category: 'Team Dashboard',
        event_label: 'Invite Sent Successfully',
        user_id: userId,
        subject: teamSubject,
      });
    }

        // Update invitation limit
        setInviteLimit((prev) => {
            const newCount = prev.count + 1;
            const resetTime = prev.resetTime || new Date(Date.now() + 60 * 60 * 1000).toISOString();
            const limitReached = !isAdmin && newCount >= 3;
            const updatedLimit = {
                count: newCount,
                resetTime,
                limitReached,
            };
            localStorage.setItem(`invite_limit_${userId}`, JSON.stringify(updatedLimit));
            return updatedLimit;
        });

    // Update teamTask with new invitation and subject
        const newInvitation = {
            invitation_id: response.data.invitationIds[0] || `temp_${Date.now()}`,
            invitee_email: email,
            status: "pending",
            subject: teamSubject,
            inviter_email: localStorage.getItem("userEmail") || "unknown",
        };

        // Preserve the locked-in question: either it already existed on the
        // task (2nd invite case) or it's the draft question just generated
        // (1st invite / task-creation case).
        const lockedQuestion = teamTask.task.question || draftQuestion || "";
        const generatedTimeNow = new Date().toISOString();

        const updatedTask = {
            task: {
                taskId: response.data.taskId,
                creatorId: userId,
                subject: teamTask.task.subject || teamSubject,
                question: lockedQuestion,
                status: "active",
                created_at: teamTask.task.created_at || generatedTimeNow,
            },
            answers: [],
            invitations: [...teamTask.invitations, newInvitation],
        };
        
        localStorage.removeItem(`has_reset_session_${userId}`);
        setHasResetSession(false);
        
        setTeamTask(updatedTask);
        localStorage.setItem(`team_task_${userId}`, JSON.stringify(updatedTask));

        // Question is now locked in — mark as generated and clear draft state
        setTeamTaskGenerated(true);
        setTeamTaskGeneratedTime(updatedTask.task.created_at);
        setDraftQuestion("");
        setDraftQuestionPool([]);

         // Invalidate cache after invite (new task)
    localStorage.removeItem(`no_active_task_${userId}`);
    localStorage.setItem(`team_task_timestamp_${userId}`, now.toISOString()); 

        // Set user as inviter
        setUserRole('inviter');
        await axios.patch(
            `/api/users/${userId}/app_role`,
            {
                app_role: 'inviter',
            },
            {
                headers: getAuthHeaders(),
            }
        );

        setTeamTaskGenerated(false);
        setInviteeEmails("");
        setTeamError(null);
    } catch (err) {
      // Track failure event
    if (window.gtag) {
      window.gtag('event', 'team_invite_failure', {
        event_category: 'Team Dashboard',
        event_label: 'Invite Failed - Server Error',
        user_id: userId,
        error_message: err.response?.data?.error || 'Failed to submit invitation',
      });
    }
        setInviteLimit((prev) => {
            const newCount = prev.count + 1;
            const resetTime = prev.resetTime || new Date(Date.now() + 60 * 60 * 1000).toISOString();
            const limitReached = !isAdmin && newCount >= 3;
            const updatedLimit = {
                count: newCount,
                resetTime,
                limitReached,
            };
            localStorage.setItem(`invite_limit_${userId}`, JSON.stringify(updatedLimit));
            return updatedLimit;
        });
        setTeamError(err.response?.data?.error || "Failed to submit invitation.");
    }
};

useEffect(() => {
  if (lastStatusCheckTime) {
    localStorage.setItem(`last_status_check_${userId}`, lastStatusCheckTime.toISOString());
  }
}, [lastStatusCheckTime, userId]);

// Load plan notes (one-time migration of legacy plain-string plans, same as before)
useEffect(() => {
  planNotesLoadedRef.current = false;
  if (!userId) return;
  let cancelled = false;
  (async () => {
    try {
      const raw = await getPlanNotes(userId);
      const migrated = {};
      Object.keys(raw).forEach((activityId) => {
        migrated[activityId] = normalizePlanEntry(raw[activityId]);
      });
      if (!cancelled) {
        setPlanNotes(migrated);
        planNotesLoadedRef.current = true;
      }
    } catch (e) {
      console.warn('Failed to load plan notes:', e);
      if (!cancelled) planNotesLoadedRef.current = true;
    }
  })();
  return () => { cancelled = true; };
}, [userId]);

// Save plan notes
useEffect(() => {
  if (!userId || !planNotesLoadedRef.current) return;
  savePlanNotes(userId, planNotes).catch((err) =>
    console.warn('Failed to save plan notes:', err)
  );
}, [planNotes, userId]);

// Add useEffect to reset invitation limit after 1 hour
useEffect(() => {
  if (inviteLimit.resetTime) {
    const resetTime = new Date(inviteLimit.resetTime).getTime();
    const now = Date.now();
    const timeLeft = resetTime - now;

    if (timeLeft <= 0) {
      const resetLimit = { count: 0, resetTime: null, limitReached: false };
      setInviteLimit(resetLimit);
      localStorage.setItem(`invite_limit_${userId}`, JSON.stringify(resetLimit));
      return;
    }

    const timer = setTimeout(() => {
      const resetLimit = { count: 0, resetTime: null, limitReached: false };
      setInviteLimit(resetLimit);
      localStorage.setItem(`invite_limit_${userId}`, JSON.stringify(resetLimit));
    }, timeLeft);

    return () => clearTimeout(timer);
  }
}, [inviteLimit.resetTime, userId]);

const helpButtonRef = useRef(null);

// Handle click outside to close instructions modal
useEffect(() => {
  const handleClickOutside = (event) => {
    if (
      showInstructions &&
      helpButtonRef.current &&
      !helpButtonRef.current.contains(event.target) &&
      !event.target.closest(".instruction-modal")
    ) {
      setShowInstructions(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, [showInstructions]);

// Calculate time until submit is enabled
const getSubmitTooltipText = () => {
  if (!teamTask?.task?.taskId || !teamTaskGeneratedTime) {
    return "";
  }
  if (teamTask?.task?.status !== "active") {
    return "Task is not active or has been reset.";
  }
  if (teamTask.task.status === "submitted") {
    return "Challenge already submitted.";
  }
  const oneWeekInMs = 1;
  const timeSinceCreation = Date.now() - new Date(teamTaskGeneratedTime).getTime();
  if (timeSinceCreation < oneWeekInMs) {
    const daysLeft = Math.ceil((oneWeekInMs - timeSinceCreation) / (24 * 60 * 60 * 1000));
    return `Task cannot be submitted until one week has elapsed since question generation. ${daysLeft} day(s) remaining.`;
  }
  const acceptedInvitees = Array.isArray(teamTask.invitations)
    ? teamTask.invitations
        .filter((inv) => inv?.status === "accepted")
        .map((inv) => inv?.invitee_id)
        .filter((id) => id)
    : [];
  const allParticipants = [
    teamTask.task.creatorId,
    ...acceptedInvitees,
  ].filter((id) => id);
  const submittedAnswers = Array.isArray(teamTask.answers)
    ? teamTask.answers.map((answer) => answer?.user_id).filter((id) => id)
    : [];
  if (!allParticipants.every((participant) => submittedAnswers.includes(participant))) {
    return "All team members (inviter and invitees) must submit their answers before the challenge can be submitted.";
  }
  return "Click to submit the team challenge. No changes can be made after submission.";
};


// Render Team page
const renderTeamPage = ({ helpButtonRef, isDropdownOpen, setIsDropdownOpen, invitationDropdownRef }) => {
 // Determine if the current task is expired
 const isTaskExpired = (() => {
  // If no created_at, check submission_date
  const dateRef = teamTask.task.created_at || teamTask.task.submission_date;
  
  if (!dateRef) {
    console.log("🔍 No created_at or submission_date for task:", teamTask.task.taskId);
    return false;
  }
  
  const createdAt = new Date(dateRef);
  if (isNaN(createdAt.getTime())) {
    console.warn("⚠️ Invalid date reference:", dateRef);
    return false;
  }
  
  const sixMonthsInMs = 6 * 30 * 24 * 60 * 60 * 1000;
  const expiryDate = new Date(createdAt.getTime() + sixMonthsInMs);
  const now = new Date();
  const isExpired = now >= expiryDate;
  
  console.log("🔍 Expiry check:", {
    taskId: teamTask.task.taskId,
    dateRef: dateRef,
    expiryDate: expiryDate.toISOString(),
    now: now.toISOString(),
    isExpired: isExpired,
    daysUntilExpiry: Math.ceil((expiryDate - now) / (24 * 60 * 60 * 1000)),
  });
  
  return isExpired;
})();

// Check if there is any task at all (active or completed)
const hasAnyTask = !!teamTask.task.taskId;

  // Check if there are any pending or accepted invitations in the current task
  const hasPendingOrAccepted = teamTask.invitations && teamTask.invitations.some(
    inv => inv.status === 'pending' || inv.status === 'accepted'
  );

const isStartNewSessionEnabled = (() => {
  // No task at all — nothing to reset yet
  if (!hasAnyTask) return false;

  // All invitations declined — can start fresh regardless of age
  if (
    teamTask.invitations.length > 0 &&
    teamTask.invitations.every(inv => inv.status === 'declined')
  ) return true;

  // Task expired (created_at > 6 months ago) — always enabled
  if (isTaskExpired) return true;

  // Task submitted — only enabled if also past 6-month cooldown
  if (teamTask.task.status === 'submitted') {
    const submissionRef =
      teamTask.task.submission_date ||
      teamTask.task.created_at ||
      null;
    if (!submissionRef) return false;
    const sixMonthsInMs = 6 * 30 * 24 * 60 * 60 * 1000;
    return Date.now() - new Date(submissionRef).getTime() >= sixMonthsInMs;
  }

  // Task active with pending/accepted invitations — locked
  if (hasPendingOrAccepted) return false;

  return false;
})();

  console.log("🔘 Start New Session button state:", {
    hasAnyTask,
    isTaskExpired,
    hasPendingOrAccepted,
    isStartNewSessionEnabled,
    taskId: teamTask.task.taskId,
    status: teamTask.task.status,
    created_at: teamTask.task.created_at,
    submission_date: teamTask.task.submission_date,
    invitationStatuses: teamTask.invitations.map(inv => ({ 
      email: inv.invitee_email, 
      status: inv.status 
    }))
  });

  if (!availableTeamSubjects.length) {
    return (
      <div className="team-no-subjects">
        Complete the UniReady assessment to access the Team feature.
      </div>
    );
  }

  const hasNonDeclinedInvitations = teamTask.invitations.some(inv => inv.status !== 'declined');
  const hasAcceptedInvitations = teamTask.invitations.some(
    (inv) => inv.status === "accepted"
  );
  const isTaskReady =
    teamTask.task.taskId && hasAcceptedInvitations && teamTaskGenerated;
  const isInviter = teamTask.task.creatorId === userId;
  const isInvitee = teamTask.invitations.some(
    (inv) => inv.invitee_id === userId && inv.status === "accepted"
  );
  const pendingOrAccepted = teamTask.invitations.filter(
    (inv) => inv.status === "pending" || inv.status === "accepted"
  ).length;
  const now = new Date();
  const oneHourInMs = 1 * 60 * 60 * 1000;
  const lastFetchTime = teamTask.task.taskId
    ? localStorage.getItem(`last_fetch_task_details_${userId}_${teamTask.task.taskId}`)
    : null;
// Inviter can draft answer as soon as the question is locked (invite sent).
  // Invitee still needs task to be fully ready (question exists + their invite accepted).
  const isAnswerEditable = 
    teamTask.task.status === "active" &&
    !hasSubmittedAnswer &&
    (
      // Inviter: question exists = ready to answer
      (teamTask.task.creatorId === userId && !!teamTask.task.question) ||
      // Invitee: full isTaskReady check still applies
      isTaskReady
    );

 const toggleDropdown = async () => {
  if (isDropdownOpen) {
    setIsDropdownOpen(false);
    return;
  }
  
  // Use unified fetch - only get invitation statuses
  await fetchTeamData({ 
    fetchFullDetails: false,
    fetchInvitations: false,
    fetchStatusOnly: true,
  });
  
  setIsDropdownOpen(true);
};

const isRoleLoading = !userRole; // userRole initialises from localStorage so never null,
                                  // but add a loaded flag for safety

// Inviter has an active task if:
// (a) taskId is known and they're the creator, OR
// (b) userRole resolved to 'inviter' (meaning DB confirmed active task)
const inviterHasActiveTask =
  (teamTask.task.creatorId === userId && !!teamTask.task.taskId) ||
  userRole === 'inviter';

// Invitation form always visible for inviter/user — only the button enable state changes
const showInvitationForm =
  userRole !== "invitee" &&
  (!restrictionUntil || new Date() >= new Date(restrictionUntil));

// Count only active (pending + accepted) invitations for the 2-slot cap
const activeInvitationCount = teamTask.invitations.filter(
  inv => inv.status === 'pending' || inv.status === 'accepted'
).length;

// Invite button enabled when active slots < 2 and task not yet submitted
const isInviteButtonEnabled =
  !!teamSubject &&
  (!teamTask.task.taskId || activeInvitationCount < 2) &&
  (!teamTask.task.taskId ? !!draftQuestion : true) &&
  teamTask.task.status !== "submitted" &&
  (isAdmin || !inviteLimit.limitReached);

  const parseMarkdown = (text) => {
  if (!text) return '';
  // Handle ### as bold title paragraphs
  let processed = text.replace(/###\s*(.+?)(?=\n\n|\n$|$)/gmi, '<p><strong>$1</strong></p>');
  // Handle **bold** within text
  processed = processed.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  // Split into paragraphs on double newlines, preserving single newlines as <br>
  const paragraphs = processed.split(/\n\n+/).map(p => p.replace(/\n/g, '<br>'));
  const html = paragraphs.map(p => `<p>${p.trim()}</p>`).join('');
  return DOMPurify.sanitize(html);
};


  const threeHoursInMs = 3 * 60 * 60 * 1000;

  return (
    <div className="teampage">
    <div className="team-container">
      <div className="team-invite-header">
        <h2 className="team-invite-title">
          Team Challenge
        </h2>
        <button
          type="button"
          ref={helpButtonRef}
          onClick={() => setShowInstructions(true)}
          className="help-button"
          aria-label="Show instructions"
        >
          <FaInfoCircle className="help-button-icon" />
        </button>
        {showInstructions && (
          <div className="instruction-modal">
            <ul className="instruction-list">
              <li>
                Invite up to 2 friends who have your selected subject in their top 3.
              </li>
              <li>
                At least 1 must accept invite.
              </li>
              <li>
                Generate a team question, brainstorm offline, and submit responses.
              </li>
              <li>
                Once all submitted, generate team feedback.
              </li>
            </ul>
          </div>
        )}
   <button
          type="button"
          className="cyber-button new-session-button"
          onClick={handleStartNewSession}
          aria-label="Start new team challenge session"
          disabled={!isStartNewSessionEnabled}
        >
          Start New Session
        </button>
        <button
          className="past-challenge-button"
          onClick={() => {
            const cachedChallenges = localStorage.getItem(`past_challenges_${userId}`);
            let pastChallenges = [];
            if (cachedChallenges) {
              try {
                pastChallenges = JSON.parse(cachedChallenges);
                if (!Array.isArray(pastChallenges)) {
                  pastChallenges = [];
                  localStorage.setItem(`past_challenges_${userId}`, JSON.stringify([]));
                }
              } catch {
                localStorage.removeItem(`past_challenges_${userId}`);
                pastChallenges = [];
              }
            }
            if (teamTask.task.taskId && teamTask.task.status === "submitted") {
              const isAlreadyIncluded = pastChallenges.some(
                (c) => c.taskId === teamTask.task.taskId
              );
              if (!isAlreadyIncluded) {
                pastChallenges.push({
                  task: {
                    taskId: teamTask.task.taskId,
                    creatorId: teamTask.task.creatorId,
                    subject: teamTask.task.subject,
                    question: teamTask.task.question,
                    status: teamTask.task.status,
                    feedback_text: teamTask.task.feedback_text || null,
                    submitted_at: teamTask.task.submission_date || new Date().toISOString(),
                    inviter_email: teamTask.task.inviter_email || "Inviter",
                    created_at: teamTask.task.created_at || new Date().toISOString(),
                  },
                  answers: teamTask.answers,
                  invitations: teamTask.invitations,
                });
                localStorage.setItem(
                  `past_challenges_${userId}`,
                  JSON.stringify(pastChallenges)
                );
              }
            }
            navigate("/past-challenges", {
              state: {
                hasCompletedChallenges: pastChallenges.length > 0,
                pastChallenges: pastChallenges,
              },
            });
          }}
        >
          Team History
        </button>
      </div>
   {showInvitationForm && (
  <form onSubmit={handleInviteSubmit} className="team-invite-form">
    <div className="team-invite-row">

      {/* Subject select — only shown before task is created */}
      {!teamTask.task.taskId && (
        <div className="team-field-container">
          <label htmlFor="team-subject-select" className="team-label">
            Select a Top UniReady Subject:
          </label>
          <div className="cyber-select-container-team">
            <TooltipUI text="">
              <select
                id="team-subject-select"
                value={teamSubject}
                onChange={(e) => setTeamSubject(e.target.value)}
                onFocus={async () => {
                  const hasReset = localStorage.getItem(`has_reset_session_${userId}`) === 'true';
                  if (hasReset) return;
                  const needsFullLoad = !teamDataLoaded || !teamTask.task.taskId;
                  await fetchTeamData({
                    fetchFullDetails: needsFullLoad,
                    fetchInvitations: needsFullLoad,
                    fetchStatusOnly: !needsFullLoad,
                    force: needsFullLoad,
                  });
                }}
                className="cyber-select team-subject-select"
                disabled={teamTask.task.status === "submitted"}
              >
                <option value="">-- Select a Subject --</option>
                {availableTeamSubjects.map((subject) => (
                  <option key={subject} value={subject}>
                    {subject}
                  </option>
                ))}
              </select>
            </TooltipUI>
          </div>
        </div>
      )}

      {/* Subject + active slot count display — shown once task exists */}
      {teamTask.task.taskId && teamTask.task.subject && (
        <div className="team-field-container">
          <label className="team-label">Subject</label>
          <div className="team-subject-locked" style={{
            padding: "10px 14px",
            background: "rgba(2, 139, 232, 0.08)",
            border: "1px solid rgba(0, 225, 255, 0.25)",
            borderRadius: "8px",
            color: "#e0f7ff",
            fontSize: "14px",
            height: "50px",
            width: "360px",
            display: "flex",
            alignItems: "center",
          }}>
            {teamTask.task.subject}
          </div>
        </div>
      )}

      {/* Email input — always shown for inviter */}
      <div className="team-field-container">
        <label htmlFor="invitee-email" className="team-label">
          Friend's Email:
        </label>
        <input
          id="invitee-email"
          type="email"
          value={inviteeEmails}
          onChange={(e) => {
            const inputValue = e.target.value;
            setInviteeEmails(inputValue);
            const sanitized = sanitizeEmail(inputValue);
            if (inputValue && !sanitized) {
              setTeamError("Invalid email format.");
            } else {
              setTeamError(null);
            }
          }}
          className="cyber-input team-email-input"
          placeholder="friend@example.com"
          disabled={teamTask.task.status === "submitted"}
        />
      </div>

      {/* Invite button — controlled by isInviteButtonEnabled */}
      <TooltipUI
        text={
          teamTask.task.status === "submitted"
            ? "Challenge already submitted."
            : activeInvitationCount >= 2
            ? "Maximum of 2 active invitations reached (pending or accepted)."
            : !teamSubject
            ? "Select a subject first."
            : !teamTask.task.taskId && !draftQuestion
            ? "Generate a question before sending the invitation."
            : !isAdmin && inviteLimit.limitReached
            ? "Invitation limit reached (3 per hour)."
            : ""
        }
      >
        <button
          type="submit"
          className="cyber-button team-invite-button"
          disabled={!isInviteButtonEnabled}
        >
          <FaPaperPlane className="team-button-icon" />
          Invite!
        </button>
      </TooltipUI>

      {/* Invitation Status dropdown — always shown for inviter once any invitation exists */}
      {teamTask.invitations.length > 0 && (
        <div className="team-task-section-invite" ref={invitationDropdownRef}>
          <button
            type="button"
            className="invitation-dropdown-toggle"
            onClick={async () => {
              await fetchTeamData({
                fetchFullDetails: false,
                fetchInvitations: false,
                fetchStatusOnly: true,
              });
              setIsDropdownOpen(!isDropdownOpen);
            }}
            aria-expanded={isDropdownOpen}
          >
            Invitation Status ({teamTask.invitations.length})
            <span className="dropdown-arrow">{isDropdownOpen ? "▲" : "▼"}</span>
          </button>
          {isDropdownOpen && (
            <ul id="invitation-dropdown" className="invitation-dropdown-list">
              {teamTask.invitations.map((inv, index) => (
                <li
                  key={index}
                  className="invitation-dropdown-item"
                  style={{
                    color:
                      inv.status === 'accepted' ? '#00ff00' :
                      inv.status === 'declined' ? '#ff6666' :
                      '#ffaa00',
                  }}
                >
                  {inv.invitee_email} — {inv.status}
                </li>
              ))}
            </ul>
          )}
        </div>
      )}

    </div>

    {!isAdmin && (
      <div className="invite-limit-status">
        Invitation attempts this hour: {inviteLimit.count}/3
        {inviteLimit.resetTime && (
          <span> (Resets at {new Date(inviteLimit.resetTime).toLocaleTimeString()})</span>
        )}
      </div>
    )}
    {teamError && <div className="team-error">{teamError}</div>}
  </form>
)}
      <div className="team-task-container">
        <div className="team-task-title-container">
          <h5 className="team-task-title">
            Team Challenge: {teamTask.task.subject || "Not Selected"}
          </h5>
          {timeUntilExpiry !== null && !isNaN(timeUntilExpiry) ? (
            <div className="team-expiry-notice">
              Days until challenge resets: {timeUntilExpiry} day(s)
            </div>
          ) : (
            <div className="team-expiry-notice">
            </div>
          )}
        </div>
        {teamMemberStatuses.length > 0 && (
          <div className="team-member-status">
            <ul>
              {teamMemberStatuses.map((member, index) => (
                <li key={index}>
                  {member.email}: {member.hasSubmitted ? "Submitted" : "Not Submitted"}{" "}
                  {member.userId === userId && !member.hasSubmitted && localStorage.getItem(`team_answer_${teamTask.task.taskId}_${userId}`)
                    ? "(Saved Locally)"
                    : ""}
                </li>
              ))}
            </ul>
          </div>
        )}
        {isLoadingTask ? (
          <div className="team-loading">Loading...</div>
        ) : (
          <>
           <div className="task-preview-card" style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div className="task-preview-section task-question" style={psCardStyle('#028ce876')}>
  <h3 style={{ margin: '0 0 14px 0', color: '#40c4ff', fontSize: '15px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.03em' }}>Question</h3>

 {/* ── Question content area ── */}
  {(() => {
  // ── Case 1: Invitee → show locked question only, no buttons ──
    if (userRole === 'invitee') {
      return (
        <div
          className="question-content"
          style={{ color: isTaskReady ? "inherit" : "grey" }}
          dangerouslySetInnerHTML={{
            __html: isTaskReady
              ? parseMarkdown(teamTask.task.question)
              : "<p>Waiting for inviter to generate the team challenge.</p>",
          }}
        />
      );
    }

    // ── Case 1b: Inviter, task locked (invite sent) → locked question + disabled button ──
    if (teamTask.task.taskId && teamTask.task.question) {
      return (
        <>
          <div
            className="question-content"
            style={{ color: "inherit" }}
            dangerouslySetInnerHTML={{ __html: parseMarkdown(teamTask.task.question) }}
          />
          <div style={{ marginTop: "12px" }}>
            <TooltipUI text="Question is locked in. Start a new session to choose a new one.">
              <button
                type="button"
                className="cyber-button team-generate-button"
                disabled={true}
                style={{ opacity: 0.45, cursor: 'not-allowed' }}
              >
                Generate
              </button>
            </TooltipUI>
          </div>
        </>
      );
    }

    // ── Case 2: Inviter, no task yet — show draft question UI ──
    return (
      <>
        {/* Question text area */}
        <div
          className="question-content"
          style={{ color: draftQuestion ? "inherit" : "grey" }}
          dangerouslySetInnerHTML={{
            __html: draftQuestion
              ? parseMarkdown(draftQuestion)
              : teamSubject
              ? `<p></p>`
              : "<p></p>",
          }}
        />

        {challengeQuestionsError && (
          <div style={{ color: "#ffaa00", fontSize: "13px", margin: "8px 0" }}>
            {challengeQuestionsError}
          </div>
        )}

        {/* ── Always-visible button row ── */}
        <div style={{ display: "flex", gap: "10px", marginTop: "12px" }}>

          {/* Generate Question — hidden once draft exists, disabled until subject chosen */}
          {!draftQuestion && (
            <TooltipUI
              text={
                !teamSubject
                  ? "Select a subject first to generate a question."
                  : isLoadingChallengeQuestions
                  ? "Loading questions…"
                  : "Generate a challenge question for this subject."
              }
            >
              <button
                type="button"
                className="cyber-button team-generate-button"
                onClick={handleGenerateDraftQuestion}
                disabled={!teamSubject || isLoadingChallengeQuestions}
                style={{
                  opacity: !teamSubject ? 0.45 : 1,
                  cursor: (!teamSubject || isLoadingChallengeQuestions)
                    ? 'not-allowed'
                    : 'pointer',
                }}
              >
                {isLoadingChallengeQuestions ? "Loading..." : "Generate"}
              </button>
            </TooltipUI>
          )}

          {/* Try Another — shown once draft exists and pool has multiple entries */}
          {draftQuestion && draftQuestionPool.length > 1 && (
            <TooltipUI text="Pick a different question from the same subject pool.">
              <button
                type="button"
                className="cyber-button team-generate-button"
                onClick={handleRerollDraftQuestion}
              >
                Try Another
              </button>
            </TooltipUI>
          )}

        </div>
      </>
    );
  })()}

             {(() => {
  // Inviter recovery: role says inviter but taskId not yet in state
  if (userRole === 'inviter' && !teamTask.task.taskId) {
    return (
      <TooltipUI text="Restore your existing team task from the server.">
        <button
          className="cyber-button team-generate-button"
          onClick={async () => {
            await fetchTeamData({
              fetchFullDetails: true,
              fetchInvitations: true,
              fetchStatusOnly: false,
              force: true,
            });
          }}
          disabled={isManualFetching}
        >
          {isManualFetching ? "Loading..." : "Load Task"}
        </button>
      </TooltipUI>
    );
  }

return null;
})()}

{(() => {
  const isCurrentUserInvitee =
    userRole === 'invitee' ||
    teamTask.invitations.some(
      inv => inv.invitee_id === userId && inv.status === 'accepted'
    );

  if (!isCurrentUserInvitee) return null;

  // ── Compute cooldown state ──────────────────────────────────────
  const threeHoursInMs = 3 * 60 * 60 * 1000;
  const lastFetch = teamTask.task.taskId
    ? localStorage.getItem(`last_fetch_task_details_${userId}_${teamTask.task.taskId}`)
    : null;
  const timeSinceFetch = lastFetch
    ? Date.now() - new Date(lastFetch).getTime()
    : Infinity;
  const cooldownActive = !isAdmin && timeSinceFetch < threeHoursInMs;
  const minutesLeft = cooldownActive
    ? Math.ceil((threeHoursInMs - timeSinceFetch) / 60000)
    : 0;

  const handleStatusClick = async () => {
    if (teamTask.task.taskId) {
      await fetchTaskDetails(teamTask.task.taskId, true);
    } else {
      await fetchTeamData({
        fetchFullDetails: true,
        fetchInvitations: false,
        fetchStatusOnly: false,
        force: true,
      });
    }
  };

  return (
    <TooltipUI
      text={
        cooldownActive
          ? `Please wait ${minutesLeft} minute(s) before checking again.`
          : hasStoredFeedback
          ? "Feedback is stored locally. Refresh to re-fetch."
          : teamTask.task.taskId
          ? "Check for the latest question and feedback from your team."
          : "Fetch your team task status."
      }
    >
      <button
        className="cyber-button team-generate-button"
        onClick={handleStatusClick}
        disabled={cooldownActive || isManualFetching}
      >
        {isManualFetching
          ? "Loading..."
          : teamTask.task.taskId
          ? "Status"
          : "Status"}
      </button>
    </TooltipUI>
  );
})()}
              </div>
         <div className="task-preview-section task-answer" style={psCardStyle('#9c6fe47e')}>
  <div className="your-answer-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px' }}>
    <h3 style={{ margin: 0, color: '#9c6fe4', fontSize: '15px', textTransform: 'uppercase', fontWeight: 600, letterSpacing: '0.03em' }}>Your Answer</h3>
    <TooltipUI
      text={
        !isTaskReady
          ? ""
          : teamTask.task.status === "submitted"
          ? "Challenge submitted. Saving is disabled."
          : hasSubmittedAnswer
          ? "Your answer has been submitted and cannot be saved again."
          : "Save your answer locally without submitting."
      }
    >
      <button
        className="cyber-button-save team-save-button"
        onClick={handleAnswerSubmit}
        disabled={
          !isTaskReady ||
          teamTask.task.status === "submitted" ||
          hasSubmittedAnswer
        }
        aria-label="Save answer locally"
      >
        <FaSave className="team-save-icon" />
      </button>
    </TooltipUI>
  </div>
  
 <textarea
    value={isAnswerEditable || hasSubmittedAnswer ? teamAnswer : ""}
    onChange={(e) => {
      if (isAnswerEditable) {
        const inputValue = e.target.value;
        setTeamAnswer(inputValue);
        
        // ── Auto-save to localStorage on every change ──
        if (teamTask.task.taskId) {
          localStorage.setItem(
            `team_answer_${teamTask.task.taskId}_${userId}`,
            sanitizeAnswer(inputValue)
          );
        }
        
        const wordCount = sanitizeAnswer(inputValue)
          .split(/\s+/)
          .filter((word) => word.length > 0).length;
        if (wordCount > 150) {
          setTeamError("Answer must be 150 words or less.");
        } else {
          setTeamError(null);
        }
      }
    }}
    className="cyber-input team-answer-textarea space-scroll"
    placeholder="Enter your answer (150 words or less)."
    maxLength={1000}
    disabled={!isAnswerEditable}
    aria-describedby="answer-instruction"
  />
  
 <span id="answer-instruction" className="instruction-text">
    {teamTask.task.status === "submitted"
      ? "Challenge submitted. Answers can no longer be edited."
      : hasSubmittedAnswer
      ? "Your answer has been submitted and cannot be edited."
      : isAnswerEditable
      ? localStorage.getItem(`team_answer_${teamTask.task.taskId}_${userId}`)
        ? "Your answer is saved locally. Submit to the database to finalize."
        : "Enter your response (max 150 words)."
      : !teamTask.task.taskId
      ? "Select a subject and send invitations to start a new team challenge."
      : isInvitee && !isTaskReady
      ? "Waiting for the inviter to lock in the team challenge question."
      : ""}
  </span>

  <div className="button-row-save-submit">
    <TooltipUI
      text={
        !isTaskReady
          ? ""
          : teamTask.task.status === "submitted"
          ? "Challenge already submitted."
          : hasSubmittedAnswer
          ? "Your answer has been submitted to the database."
          : localStorage.getItem(`team_answer_${teamTask.task.taskId}_${userId}`)
          ? "Click to submit your locally saved answer to the database. No changes can be made after submission."
          : "Enter and save an answer locally before submitting to the database."
      }
    >
      <button
        className="cyber-button team-save-submit-button team-save-submit-answer-button"
        onClick={handleAnswerSubmitToDB}
        disabled={
          !isTaskReady ||
          teamTask.task.status === "submitted" ||
          hasSubmittedAnswer ||
          !localStorage.getItem(`team_answer_${teamTask.task.taskId}_${userId}`)
        }
      >
        Submit
      </button>
    </TooltipUI>
  </div>
</div>

              <div className="task-preview-section task-feedback" style={psCardStyle('#00c87584')}>
                <h3 style={{ margin: '0 0 14px 0', color: '#00c875', fontSize: '15px', textTransform: 'uppercase', letterSpacing: '0.03em', fontWeight: 600 }}>Feedback</h3>
      <div
    className="feedback-content"
    style={{ color: isTaskReady ? "inherit" : "grey" }}
    dangerouslySetInnerHTML={{
      __html: isTaskReady &&
        teamTask.task.status === "submitted" &&
        teamTask.task.feedback_text
        ? parseMarkdown(teamTask.task.feedback_text)
        : "<p>All team members must submit their answers before AI feedback can be generated.</p>",
    }}
  />

  {/* INVITER CONTROLS */}
 {!teamTask.task.feedback_text && teamTask.task.creatorId === userId && teamTask.task.taskId && (
    <div style={{ marginTop: "20px" }}>
      <TooltipUI
        text={
          !hasSubmittedAnswer
            ? "Submit your own answer first before checking team status."
            : allInviteesSubmitted
            ? "All members submitted. Click to generate final AI feedback."
            : "Check if all invitees have submitted their answers."
        }
      >
        <button
          className="cyber-button team-save-submit-button"
          onClick={async () => {
            if (allInviteesSubmitted) {
              // All submitted → Generate Feedback
              await handleChallengeSubmit();
            } else {
              // Not all submitted → Check Status
              const now = Date.now();
              const oneHourInMs = 60 * 60 * 1000;

              if (lastStatusCheckTime && (now - lastStatusCheckTime.getTime() < oneHourInMs)) {
                const minutesLeft = Math.ceil((oneHourInMs - (now - lastStatusCheckTime.getTime())) / 60000);
                setTeamError(`Please wait ${minutesLeft} minute(s) before checking again.`);
                return;
              }

              setIsManualFetching(true);
              setTeamError(null);

              try {
                const freshTask = await fetchTaskDetails(teamTask.task.taskId, true);
                if (freshTask) {
                  const allSubmittedNow = checkAllSubmitted(freshTask);
                  setAllInviteesSubmitted(allSubmittedNow);
                  setShowStatusNote(!allSubmittedNow);

                  if (!allSubmittedNow) {
                    setTeamError("Not all invitees have submitted their answers yet.");
                  }
                  setLastStatusCheckTime(new Date());
                }
              } catch (err) {
                setTeamError("Failed to check status.");
              } finally {
                setIsManualFetching(false);
              }
            }
          }}
          disabled={isManualFetching || !hasSubmittedAnswer}
        >
          {isManualFetching
            ? "Processing..."
            : allInviteesSubmitted
            ? "Generate"
            : "Status"}
        </button>
      </TooltipUI>

      {showStatusNote && !allInviteesSubmitted && (
        <div style={{
          marginTop: "12px",
          padding: "12px 16px",
          background: "rgba(255, 170, 0, 0.15)",
          border: "1px solid #ffaa00",
          borderRadius: "8px",
          color: "#ffcc66",
          fontSize: "14px"
        }}>
          ⏳ Not all invitees have submitted their answers yet.<br />
          Please check again later (1-hour restriction between checks).
        </div>
      )}
    </div>
  )}
</div>
            </div>
          </>
        )}
        <h4 className="xAI-team">powered by OpenAI</h4>
      </div>
    </div>
    </div>
  );
};


const downloadPersonalStatementDocx = () => {
  generateAndDownloadPersonalStatementDocx({
    personalStatementAnswers,
    selectedPSSubject,
    selectedGuidance,
  });
};

// ── Flatten the cached { subjectLower: activities[] } map into a lookup
// by supercurricular_id, so journal entries (keyed by activity id only)
// can show a title/subject/category without a second fetch per entry.
const journalActivityMetaById = useMemo(() => {
  const map = {};
  Object.entries(allSuperActivitiesMap).forEach(([subjectKey, activities]) => {
    (activities || []).forEach((a) => {
      map[a.supercurricular_id] = {
        title: a.activity_title || 'Untitled activity',
        category: a.category || '',
        subject: a.university_subject || subjectKey,
      };
    });
  });
  return map;
}, [allSuperActivitiesMap]);

// Every SuperCurricular Journal entry with actual content, scoped to the
// subject currently selected on UniStatement (e.g. only "Law" entries when
// the student picked Law) — newest updates first.
const journalEntriesForReference = useMemo(() => {
  if (!selectedPSSubject) return [];
  const normalizedTarget = selectedPSSubject.toLowerCase().trim();
  return Object.keys(planNotes)
    .filter((activityId) => hasPlanContent(activityId))
    .map((activityId) => {
      const meta = journalActivityMetaById[activityId] || { title: 'Activity (details loading…)', category: '', subject: '' };
      return { activityId, ...meta, plan: getPlan(activityId) };
    })
    .filter((entry) => (entry.subject || '').toLowerCase().trim() === normalizedTarget)
    .sort((a, b) => new Date(b.plan.updatedAt || 0) - new Date(a.plan.updatedAt || 0));
}, [planNotes, journalActivityMetaById, selectedPSSubject]);

// Sends the student to the SuperCurricular page with this exact activity
// pre-selected and scrolled into view — reuses the same deep-link shape the
// app already relies on elsewhere (see the location.state effect above).
const handleOpenJournalActivity = (entry) => {
  setShowJournalRefModal(null);
  navigateWithViewMode(location.pathname, {
    sidebarItem: 'supercurricular',
    preselectedSuperSubject: entry.subject,
    preselectedActivityId: entry.activityId,
    scrollToActivity: true,
  });
};

// ─── Shared visual system for UniStatement (mirrors PortfolioX/InterviewPro) ───
const psCardStyle = (accentColor) => ({
  padding: '22px 24px',
  background: 'rgba(35, 35, 35, 0.49)',
  borderRadius: '14px',
  border: '1px solid rgba(255,255,255,0.08)',
  borderTop: `3px solid ${accentColor}`,
  boxShadow: '0 4px 18px rgba(0,0,0,0.18)',
});



const renderPersonalStatementPage = () => {
  if (!showPersonalStatement) return null;

  const currentAnswers = personalStatementAnswers[selectedPSSubject] || {};
  const currentStatus = selectedPSSubject?.trim() ? psStatus : 'not_started';

  const ucasQuestions = [
    "Why do you want to study this course or subject?",
    "How have your qualifications and studies helped you to prepare for this course or subject?",
    "What else supports your application?",
  ];
  const questionAccent = ['#028be8', '#9c6fe4', '#00c875'];

  const currentGuidanceSet = selectedGuidance || null;
  const guidances = currentGuidanceSet?.guidances || [];
  const tutorInsights = currentGuidanceSet?.tutor_insights || "";
  const shouldShowInsights = selectedPSSubject && selectedPSSubject.trim() !== "" && tutorInsights?.trim();

  const answeredCount = ucasQuestions.filter((_, i) => (currentAnswers[i] || '').trim().length > 0).length;
  const totalChars = ucasQuestions.reduce((sum, _, i) => sum + (currentAnswers[i] || '').length, 0);

  const statusMeta = {
    not_started: { label: 'Not Started', color: '#888' },
    in_progress: { label: 'In Progress', color: '#00dbff' },
    completed: { label: 'Completed', color: '#00ff00' },
  }[currentStatus];

  return (
    <div className="personalstatement-page">
      <h2 style={{ color: '#36a7f8', textAlign: 'center', marginBottom: '10px' }}>
        University Application Essays
      </h2>
 <div className="your-reflection-notice-knowledge" style={{ fontStyle: 'normal', marginTop: '-5px',  marginBottom: '5px', textAlign: 'center', color: '#b6b6b6', fontSize: '14px' }}>
      <p>Your Essays are saved locally in this browser only.</p>
    </div>

      {/* Subject dropdown */}
      <div className="ps-dropdown-container" style={{ maxWidth: "440px", margin: "0 auto 24px auto", padding: "0 20px" }}>
        <div className="cyber-select2-container-ps">
          <label htmlFor="ps-subject-select" className="select-title" style={{ fontSize: "16px", color: "#028be8", marginBottom: "8px", marginLeft: "20px" }}>
            Select a Top UniReady or Exploration Subject:
          </label>
          <select
            id="ps-subject-select"
            value={selectedPSSubject}
            onChange={(e) => setSelectedPSSubject(e.target.value)}
            className="cyber-select2-ps"
          >
            <option value="">-- Select a Subject --</option>
            {availablePSSubjects.map((subj) => (
              <option key={subj} value={subj}>{subj}</option>
            ))}
          </select>
        </div>
      </div>

      {selectedPSSubject && (
        <div style={{ maxWidth: "1400px", margin: "0 auto", padding: "0 20px 40px", width: "100%", boxSizing: "border-box" }}>

          {/* ── Progress / status strip ── */}
          <div className="ps-progress-strip" style={{
            display: 'flex', flexWrap: 'wrap', gap: '14px', alignItems: 'center', justifyContent: 'space-between',
            marginBottom: '20px', padding: '14px 20px', background: 'rgba(255,255,255,0.03)',
            border: '1px solid rgba(255,255,255,0.08)', borderRadius: '10px',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '18px', flexWrap: 'wrap' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ fontSize: '13px', color: '#888' }}>Progress:</span>
                <span style={{ fontSize: '13px', fontWeight: 700, color: '#40c4ff' }}>{answeredCount}/3 questions</span>
              </div>
              <div style={{ display: 'flex', gap: '4px' }}>
                {ucasQuestions.map((_, i) => {
                  const answered = (currentAnswers[i] || '').trim().length > 0;
                  return (
                    <span key={i} style={{
                      width: '22px', height: '5px', borderRadius: '3px',
                      background: answered ? questionAccent[i] : 'rgba(255,255,255,0.12)',
                    }} />
                  );
                })}
              </div>
              <span style={{ fontSize: '12px', color: '#888' }}>{totalChars} characters total</span>
            </div>
            <span style={{
              fontSize: '11px', fontWeight: 700, color: statusMeta.color,
              background: `${statusMeta.color}1f`, border: `1px solid ${statusMeta.color}55`,
              borderRadius: '999px', padding: '4px 12px',
            }}>
              {statusMeta.label}
            </span>
          </div>

<div className="ps-columns-wrapper" style={{ display: 'flex', gap: '20px', alignItems: 'flex-start', flexWrap: 'wrap' }}>

            {/* LEFT: Tutor Insights — only takes space when there's content */}
            {shouldShowInsights && (
              <div className="ps-insights-column" style={{ width: '340px', flexShrink: 0, position: 'sticky', top: '20px' }}>
                <div style={psCardStyle('#36a7f8')}>
                  <h4 style={{ color: "#36a7f8", margin: '0 0 16px 0', fontSize: '16px', fontWeight: 700 }}>
                    Admissions Tutor Insights
                  </h4>
                  {loadingGuidance ? (
                    <p style={{ color: '#888', fontSize: '13px' }}>Loading insights...</p>
                  ) : guidanceError ? (
                    <p style={{ color: "#ffaa00", fontSize: '13px' }}>{guidanceError}</p>
                  ) : (
                    <div
                      className="insights-column-content"
                      style={{ fontSize: "14px", lineHeight: 1.6, color: '#ddd', maxHeight: 'calc(100vh - 260px)', overflowY: 'auto' }}
                      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(tutorInsights) }}
                    />
                  )}
                </div>
              </div>
            )}

            {/* RIGHT: Questions */}
            <div className='questions-column-mobile' style={{ flex: 1, maxWidth: '800px', display: "flex", flexDirection: "column", gap: "16px" }}>
              {ucasQuestions.map((question, index) => {
                const savedAnswer = currentAnswers[index] || "";
                const isAnswered = savedAnswer.trim().length > 0;
                const guidanceItem = guidances.find((g) => g.order === index + 1);
                const hasGuidance = !!guidanceItem?.guidance_text;
                const accent = questionAccent[index];

return (
                  <div key={index} className="ps-question-card" style={psCardStyle(accent)}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '14px' }}>
                      <span style={{
                        flexShrink: 0, width: '28px', height: '28px', borderRadius: '50%',
                        background: isAnswered ? 'rgba(0,200,117,0.15)' : `${accent}22`,
                        color: isAnswered ? '#00c875' : accent,
                        border: `1px solid ${isAnswered ? '#00c875' : accent}55`,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: '12px', fontWeight: 700,
                      }}>
                        {isAnswered ? '✓' : index + 1}
                      </span>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: '11px', color: '#888', textTransform: 'uppercase', letterSpacing: '0.03em', marginBottom: '4px' }}>
                          Question {index + 1}
                        </div>
                        <p className="personal-questions" style={{ margin: 0, color: "#fff", lineHeight: 1.5, fontSize: '15px', fontWeight: 500 }}>
                          {question}
                        </p>
                      </div>
                    </div>

                    {/* Reference SuperCurricular — available on every question, styled as a card action */}
<button
                      type="button"
                      className="ps-reference-btn"
                      onClick={() => setShowJournalRefModal(index)}
                      title="Browse your SuperCurricular Journal entries for this subject"
                      disabled={!selectedPSSubject}
                      style={{
                        display: 'inline-flex', alignItems: 'center', gap: '6px', marginBottom: '14px', marginLeft: '40px',
                        background: 'transparent', color: '#9c6fe4', border: '1px solid #9c6fe4',
                        borderRadius: '6px', padding: '6px 12px', fontSize: '12px', fontWeight: 600,
                        cursor: selectedPSSubject ? 'pointer' : 'not-allowed',
                        opacity: selectedPSSubject ? 1 : 0.5,
                      }}
                    >
                      <FaBookOpen size={12} /> Reference My SuperCurricular
                    </button>

                    <div className="ps-answer-wrapper" style={{ marginLeft: '40px' }}>
                      <textarea
                      className='space-scroll'
                        value={savedAnswer}
                        onChange={(e) => {
                          const newAnswer = e.target.value;
                          setPersonalStatementAnswers((prev) => ({
                            ...prev,
                            [selectedPSSubject]: { ...prev[selectedPSSubject], [index]: newAnswer },
                          }));
                        }}
                        placeholder="Draft your answer here... (aim for ~1200–1500 characters)"
                        rows={7}
                        style={{
                          width: "100%",
                          background: "rgba(255,255,255,0.05)",
                          border: `1px solid ${isAnswered ? 'rgba(0,200,117,0.4)' : `${accent}55`}`,
                          borderRadius: "8px", padding: "12px", color: "white", fontSize: "14.5px",
                          resize: "vertical", minHeight: "120px", boxSizing: "border-box",
                          transition: 'border-color 0.15s',
                        }}
                        maxLength={6000}
                      />
                      <div style={{ marginTop: "6px", fontSize: "12px", color: "#888", textAlign: "right" }}>
                        {savedAnswer.length} characters
                      </div>

                      <PSExpandableNote
                        label="Guidance"
                        html={hasGuidance ? DOMPurify.sanitize(guidanceItem.guidance_text) : null}
                        color={accent}
                      />
                    </div>
                  </div>
                );
                           })}

              {/* ── Your Added Questions ── */}
              {getCustomPSQuestionsForSubject().length > 0 && (
                <div style={{ marginTop: '4px' }}>
                  <h5 style={{ color: '#9c6fe4', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.04em', margin: '0 0 2px 0' }}>
                    Your Added Questions
                  </h5>
                  {getCustomPSQuestionsForSubject().map((q, idx) => {
                    const isAnswered = (q.answer || '').trim().length > 0;
                    return (
                      <div key={q.id} className="ps-question-card" style={psCardStyle('#9c6fe4')}>
                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '14px' }}>
                          <span style={{
                            flexShrink: 0, width: '28px', height: '28px', borderRadius: '50%',
                            background: isAnswered ? 'rgba(0,200,117,0.15)' : 'rgba(156,111,228,0.15)',
                            color: isAnswered ? '#00c875' : '#9c6fe4',
                            border: `1px solid ${isAnswered ? '#00c875' : '#9c6fe4'}55`,
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: '12px', fontWeight: 700,
                          }}>
                            {isAnswered ? '✓' : ucasQuestions.length + idx + 1}
                          </span>
                          <div style={{ flex: 1 }}>
                            <div style={{ fontSize: '11px', color: '#888', textTransform: 'uppercase', letterSpacing: '0.03em', marginBottom: '4px' }}>
                              Your Question
                            </div>
                            <p style={{ margin: 0, color: '#fff', lineHeight: 1.5, fontSize: '15px', fontWeight: 500 }}>
                              {q.question}
                            </p>
                          </div>
                          <button
                            onClick={() => removeCustomPSQuestion(q.id)}
                            title="Remove question"
                            style={{ flexShrink: 0, background: 'none', border: 'none', color: '#ff6666', cursor: 'pointer', fontSize: '14px', opacity: 0.7 }}
                            onMouseEnter={(e) => { e.currentTarget.style.opacity = 1; }}
                            onMouseLeave={(e) => { e.currentTarget.style.opacity = 0.7; }}
                          >
                            <FaTrash />
                          </button>
                        </div>

                        <div style={{ marginLeft: '40px' }}>
                          <textarea
                            value={q.answer}
                            onChange={(e) => updateCustomPSQuestionAnswer(q.id, e.target.value)}
                            placeholder="Draft your answer here..."
                            rows={7}
                            style={{
                              width: '100%', background: 'rgba(255,255,255,0.05)',
                              border: `1px solid ${isAnswered ? 'rgba(0,200,117,0.4)' : 'rgba(156,111,228,0.35)'}`,
                              borderRadius: '8px', padding: '12px', color: 'white', fontSize: '14.5px',
                              resize: 'vertical', minHeight: '120px', boxSizing: 'border-box',
                              transition: 'border-color 0.15s',
                            }}
                            maxLength={6000}
                          />
                          <div style={{ marginTop: '6px', fontSize: '12px', color: '#888', textAlign: 'right' }}>
                            {(q.answer || '').length} characters
                          </div>

                                           <button
                            onClick={() => handleAskGrokForCustomPSQuestion(q.question)}
                            style={{
                              display: 'inline-flex', alignItems: 'center', gap: '7px', marginTop: '10px',
                              background: 'rgba(156,111,228,0.12)', border: '1px solid rgba(156,111,228,0.4)',
                              borderRadius: '6px', padding: '7px 14px', color: '#9c6fe4', fontSize: '13px',
                              fontWeight: 600, cursor: 'pointer',
                            }}
                          >
                            <FaPaperPlane size={11} /> Ask AI for Guidance
                          </button>

                          <div style={{ marginTop: '12px' }}>
                            <label style={{ display: 'block', fontSize: '11px', color: '#9fb8d4', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.03em' }}>
                              AI Guidance <span style={{ textTransform: 'none', opacity: 0.7 }}>(paste AI's response here)</span>
                            </label>
                            <textarea
                              value={q.aiGuidance || ''}
                              onChange={(e) => updateCustomPSQuestionGuidance(q.id, e.target.value)}
                              placeholder="Paste the guidance AI gives you here, so it's saved with this question..."
                              rows={4}
                              style={{
                                width: '100%', background: 'rgba(156,111,228,0.05)',
                                border: `1px solid ${(q.aiGuidance || '').trim() ? 'rgba(156,111,228,0.4)' : 'rgba(255,255,255,0.15)'}`,
                                borderRadius: '8px', padding: '10px 12px', color: '#e8ddff', fontSize: '13.5px',
                                resize: 'vertical', minHeight: '80px', boxSizing: 'border-box',
                                fontFamily: 'inherit', lineHeight: 1.5, transition: 'border-color 0.15s',
                              }}
                              maxLength={4000}
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}

              <button
                type="button"
                onClick={() => setShowAddPSQuestionModal(true)}
                disabled={!selectedPSSubject}
                style={{
                  display: 'flex', alignItems: 'center', gap: '8px', width: '100%',
                  padding: '12px 16px', margin: '4px 0 0',
                  background: 'rgba(255,255,255,0.03)', border: '1px dashed rgba(156,111,228,0.4)',
                  borderRadius: '10px', color: '#9c6fe480', fontSize: '13.5px', fontWeight: 600,
                  cursor: selectedPSSubject ? 'pointer' : 'not-allowed', opacity: selectedPSSubject ? 1 : 0.5,
                }}
              >
                <FaPlus size={12} /> Add your own question
              </button>

              {/* ── Action toolbar — grouped like InterviewPro's footer ── */}
              <div className="ps-action-toolbar" style={{
                display: 'flex', flexWrap: 'wrap', gap: '14px', alignItems: 'center',
                padding: '18px 20px', background: 'rgba(255,255,255,0.03)',
                border: '1px solid rgba(255,255,255,0.08)', borderRadius: '12px',
              }}>
                <button
                  className="ask-ai-button ask-ai-btn-personal"
                  style={{ height: "45px" }}
                  onClick={async () => {
                    let draftText = `Personal Statement Draft for ${selectedPSSubject}:\n\n`;
                    ucasQuestions.forEach((q, i) => {
                      const ans = currentAnswers[i] || "(not answered)";
                      draftText += `Question ${i + 1}: ${q}\nAnswer:\n${ans}\n\n---\n\n`;
                    });

                    const prompt = `You are an experienced university application personal statement advisor who has helped hundreds of students gain offers from top universities (Oxford, Cambridge, UCL, Harvard, Yale, etc.).

Act as the admissions tutor for ${selectedPSSubject} at a top-tier university. Provide detailed, honest, constructive feedback on this draft personal statement.

Full draft:
${draftText}

Instructions:
1. Evaluate each of the three answers separately (label them Question 1, 2, 3).
2. For each section:
   - Rate 1–10 for strength (1 = very weak / likely rejection, 10 = outstanding / very competitive)
   - Highlight strengths (specific examples, academic depth, relevance to ${selectedPSSubject})
   - Point out weaknesses (generic content, lack of evidence, poor structure, not subject-focused)
   - Suggest 2–3 concrete improvements with example rephrasings
3. Overall:
   - Would this statement be competitive for a top university ${selectedPSSubject} course? (Strong / Possible / Unlikely — explain why)
   - Biggest strength and biggest risk
   - Character count estimate and whether it fits ~4000 char limit
4. Be candid but encouraging — focus on making it more academic, reflective, and subject-specific.

Keep feedback realistic for a high-achieving 18-year-old applicant.`;

                                       let copied = false;
                    try {
                      await navigator.clipboard.writeText(prompt);
                      copied = true;
                    } catch (err) {
                      console.error("Copy failed:", err);
                    }

                    const proceed = await confirm(
                      copied
                        ? "The prompt has been copied. Paste it into Grok to get expert feedback."
                        : "Couldn't copy the prompt automatically. Check the browser console for it, then paste it into Grok yourself.",
                      { title: "Ready for Grok", confirmLabel: "Proceed" }
                    );
                    if (!copied) console.log(prompt);
                    if (proceed) window.open("https://grok.com", "_blank");
                  }}
                  disabled={!selectedPSSubject}
                >
                  AI Feedback
                </button>

                <button
                  onClick={downloadPersonalStatementDocx}
                  disabled={!selectedPSSubject}
                  title="Download your answers as a Word document"
                  className="ask-ai-btn-personal-download"
                  style={{
                    display: "inline-flex", alignItems: 'center', backgroundColor: "transparent",
                    color: "#00e1ff", border: "1px solid #00e1ff", padding: "10px 22px",
                    borderRadius: "6px", fontWeight: "bold", fontSize: "0.97rem", cursor: "pointer",
                    height: "45px", transition: "all 0.2s ease",
                  }}
                  onMouseOver={(e) => { e.currentTarget.style.backgroundColor = "rgba(0,225,255,0.12)"; }}
                  onMouseOut={(e) => { e.currentTarget.style.backgroundColor = "transparent"; }}
                >
                  <FaDownload style={{ marginRight: '10px' }} /> Personal Statement
                </button>

                <TooltipUI2
                  text={isReadOnly ? "Status selection is only available to the student" : ""}
                  position="top"
                  disabled={!isReadOnly}
                >
                  <select
                    value={psStatus}
                    onChange={(e) => setPsStatus(e.target.value)}
                    className="dropdown-personal"
                    disabled={isReadOnly}
                    style={{
                      width: "200px", height: "45px",
                      background: isReadOnly ? 'linear-gradient(45deg, #444, #555)' : 'linear-gradient(45deg, #1a1a2e4b, #16213e77)',
                      color: psStatus === 'not_started' ? '#888888ff' : psStatus === 'in_progress' ? '#00dbff' : '#00ff00',
                      border: `2px solid ${isReadOnly ? '#777' : '#028be8'}`,
                      borderRadius: '8px', fontSize: '15px', padding: '0 12px',
                      cursor: isReadOnly ? 'not-allowed' : 'pointer', opacity: isReadOnly ? 0.75 : 1,
                    }}
                  >
                    <option value="not_started" style={{ color: '#888888ff' }}>Not Started</option>
                    <option value="in_progress" style={{ color: '#00dbff' }}>In Progress</option>
                    <option value="completed" style={{ color: '#00ff00' }}>Completed</option>
                  </select>
                </TooltipUI2>

              </div>
            </div>
          </div>
        </div>
      )}

      {showJournalRefModal !== null && (
        <JournalReferenceModal
          onClose={() => setShowJournalRefModal(null)}
          entries={journalEntriesForReference}
          loading={journalActivitiesLoading}
          questionLabel={`Question ${showJournalRefModal + 1}`}
          subjectLabel={selectedPSSubject}
          reviewedActivityIds={reviewedActivityIds}
          onToggleReviewed={toggleActivityReviewed}
          onOpenActivity={handleOpenJournalActivity}
        />
      )}

      {showAddPSQuestionModal && (
        <AddPSQuestionModal
          onClose={() => setShowAddPSQuestionModal(false)}
          onSave={addCustomPSQuestion}
          subjectLabel={selectedPSSubject}
        />
      )}
    </div>
  );
};

// ADD — just above getRadarOptions
const renderFacetTooltipNote = (noteData) => {
  if (!noteData || (!noteData.general && !noteData.level)) {
    return (
      <p style={{ margin: 0, fontSize: fontSize.sm, color: color.textSecondary, lineHeight: 1.5 }}>
        No description available.
      </p>
    );
  }

  const levelMeta = noteData.levelKey ? LEVEL_NOTE_META[noteData.levelKey] : null;

  return (
    <>
      {/* Personalized result leads — it's what the student actually wants to
          know, and the colored badge is the most eye-catching element, so
          it should be the first thing seen, not buried below a definition. */}
      {noteData.level && levelMeta && (
        <div
          style={{
            marginBottom: noteData.general ? spacing.sm : 0,
            padding: '10px 12px',
            background: `${levelMeta.color}18`,
            border: `1px solid ${levelMeta.color}55`,
            borderRadius: '8px',
          }}
        >
          <div
            style={{
              fontSize: '10.5px',
              fontWeight: 700,
              letterSpacing: '0.04em',
              textTransform: 'uppercase',
              color: levelMeta.color,
              marginBottom: '4px',
            }}
          >
            {levelMeta.label}
          </div>
          <p style={{ margin: 0, fontSize: fontSize.sm, color: '#ddd', lineHeight: 1.5 }}>
            {noteData.level}
          </p>
        </div>
      )}

      {/* General definition follows as quieter supporting context, with a
          muted label so it doesn't read as more result-specific commentary
          right after the colored "Your Result" badge above. */}
      {noteData.general && (
        <div>
          {noteData.level && (
            <div
              style={{
                fontSize: '10px',
                fontWeight: 700,
                letterSpacing: '0.04em',
                textTransform: 'uppercase',
                color: color.textMuted,
                marginBottom: '4px',
              }}
            >
              About this facet
            </div>
          )}
          <p
            style={{
              margin: 0,
              fontSize: fontSize.sm,
              color: color.textSecondary,
              lineHeight: 1.5,
            }}
          >
            {noteData.general}
          </p>
        </div>
      )}
    </>
  );
};

  // Radar chart options
  const getRadarOptions = (title, notesMap, facetsByGroup = {}) => {
  const isPortraitMobile = isMobile && window.innerHeight > window.innerWidth;

  let defaultColors = [];
  let updateTimeout;

  const baseFontSize = isMobile ? 11 : 14;
  const mobileTitleSize = isMobile ? 16 : 22;
  const mobileTickSize = isMobile ? 11 : 14;
  const mobileLegendSize = isMobile ? 11 : 14;

  const defaultFont = (context) => ({
    size: isMobile
      ? (context.chart?.data?.labels?.[context.dataIndex]?.length > 14 ? 11 : 11)
      : (context.chart?.data?.labels?.[context.dataIndex]?.length > 14 ? 12 : 14)
  });

  return {
    scales: {
      r: {
        beginAtZero: true,
        suggestedMax: 5,
        angleLines: { color: "rgba(2, 139, 232, 0.22)", lineWidth: 1 },
        ticks: { stepSize: 1, color: "rgba(255,255,255,0.45)", backdropColor: "transparent", font: { size: mobileTickSize } },
        pointLabels: {
          display: !isPortraitMobile,
          color: (context) => defaultColors[context.dataIndex] || "rgba(255,255,255,0.85)",
          font: (context) => ({
            ...defaultFont(context),
            weight: defaultColors[context.dataIndex] === "#FFFF00" ? "bold" : "500"
          }),
          padding: isMobile ? 11 : 22,
          backdropColor: "transparent",
          callback: (label) => {
            // When a group is focused, hide labels for facets that belong
            // to OTHER groups — they aren't comparable to the selected
            // group's metrics, so showing them just adds noise.
            if (selectedRadarGroup && facetsByGroup[selectedRadarGroup] && !facetsByGroup[selectedRadarGroup].has(label)) {
              return '';
            }
            return label?.length > 50 ? label.substring(0, 47) + "..." : label || "Unknown";
          },
        },
        // Circular rings (was `circular: false`, which draws jagged
        // polygon rings that look broken with 5+ facets) + softer color
        grid: { color: "rgba(2, 139, 232, 0.30)", circular: true, lineWidth: 1 },

        // HUGE tap area on mobile portrait
        pointRadius: isPortraitMobile ? 32 : 6,
        pointHoverRadius: isPortraitMobile ? 38 : 8,
        pointHitRadius: isPortraitMobile ? 70 : 10,   // ~140px invisible tap zone – impossible to miss
      },
    },
    plugins: {
  legend: {
    display: true,
    position: "top",
    onClick: (evt, legendItem, legend) => {
      const chart = legend.chart;
      const clickedGroupKey = chart.data.datasets[legendItem.datasetIndex]?.groupKey;
      if (!clickedGroupKey) return;
      // Toggle focus rather than Chart.js's default "hide dataset" behavior —
      // clicking the same group again clears the focus and shows everything.
      setSelectedRadarGroup((prev) => (prev === clickedGroupKey ? null : clickedGroupKey));
    },
    labels: {
      padding: 20,
      font: { size: mobileLegendSize },
      generateLabels: (chart) => {
        const datasets = chart.data.datasets || [];
        return datasets.map((dataset, i) => {
          const isFocused = dataset.groupKey === selectedRadarGroup;
          const isDimmed = selectedRadarGroup && !isFocused;
          return {
            text: dataset.label + (isFocused ? '  ●' : ''),
            fillStyle: dataset.backgroundColor,
            strokeStyle: dataset.borderColor,
            lineWidth: isFocused ? 3 : 2,
            fontColor: isDimmed ? 'rgba(255,255,255,0.35)' : dataset.borderColor,
            hidden: false,
            datasetIndex: i,
          };
        });
      },
    },
  },
        title: { display: true, text: title, padding: 15, color: "#34A0EF", align: "center", font: { size: mobileTitleSize } },
      tooltip: { enabled: false },
    },
    maintainAspectRatio: false,
    resizeDelay: 100, // prevents getComputedStyle(null) crash on rapid resize

    // CLICK & HOVER – 100% safe, no more crashes
    onClick: (event, elements, chart) => {
      if (!chart?.canvas) return;

      const canvas = chart.canvas;
      const rect = canvas.getBoundingClientRect();
      const clickX = event.native?.offsetX ?? (event.x - rect.left);
      const clickY = event.native?.offsetY ?? (event.y - rect.top);

      // Desktop / Landscape → click label text
      if (!isPortraitMobile && chart.data.labels) {
        const { ctx, chartArea } = chart;
        const labels = chart.data.labels || [];
        const area = chartArea || { left: 0, right: canvas.width, top: 0, bottom: canvas.height };
        const centerX = area.left + (area.right - area.left) / 2;
        const centerY = area.top + (area.bottom - area.top) / 2;
        const radius = chart.scales.r.maxRadius || (Math.min(area.right - area.left, area.bottom - area.top) / 2) * 0.8;

        for (let i = 0; i < labels.length; i++) {
          const labelText = labels[i];
          const fontSize = labelText.length > 14 ? 12 : 14;
          ctx.font = `${fontSize}px Arial`;
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          const textMetrics = ctx.measureText(labelText);
          const labelWidth = textMetrics.width + 10;
          const labelHeight = fontSize * 1.4;
          const angle = ((i * 360) / labels.length - 90) * (Math.PI / 180);
          const x = centerX + (radius + 20) * Math.cos(angle);
          const y = centerY + (radius + 20) * Math.sin(angle);

          if (clickX >= x - labelWidth && clickX <= x + labelWidth &&
              clickY >= y - labelHeight / 2 && clickY <= y + labelHeight / 2) {
         const noteData = notesMap[labelText] || null;

const searchQuery = `explain how ${labelText} can be leveraged in the AI era for studying ${chosenTopSubject}`;

setTooltip({
  visible: true,
  content: (
    <>
      <div style={{ paddingBottom: "10px" }}>
        <strong 
          style={{ 
            color: "#36a7f8", 
            cursor: "pointer",
            textDecoration: "none"
          }}
          onClick={() => window.open(`https://www.google.com/search?q=${encodeURIComponent(searchQuery)}`, '_blank')}
        >
          {labelText} ↗
        </strong>
      </div>
      <div style={{
        paddingBottom: spacing.sm, borderBottom: `1px solid ${color.border}`, marginBottom: spacing.base, wordWrap: "break-word",
      }}>
        {renderFacetTooltipNote(noteData)}
      </div>
    </>
  ),
  x: Math.min(Math.max(clickX - 150, 10), window.innerWidth - 320),
  y: Math.min(clickY + 20, window.innerHeight - 150),
});
return;
          }
        }
      }

      // Any view (especially mobile portrait) → tap huge data point
      if (elements.length > 0) {
        const el = elements[0];
        const label = chart.data.labels?.[el.index];
        const value = chart.data.datasets[el.datasetIndex]?.data?.[el.index];

       const noteData = notesMap[label] || null;

setTooltip({
  visible: true,
  content: (
    <>
      <div style={{ paddingBottom: "10px" }}><strong style={{ color: "#36a7f8" }}>{label}</strong></div>
      <p style={{ margin: '0 0 8px 0', fontSize: fontSize.sm, color: color.textSecondary }}>
        Score: {value != null ? Number(value).toFixed(1) : "N/A"}
      </p>
      {renderFacetTooltipNote(noteData)}
    </>
  ),
  x: isPortraitMobile ? window.innerWidth / 2 - 150 : clickX - 150,
  y: isPortraitMobile ? window.innerHeight - 220 : clickY + 20,
});
return;
      }

      // Clicked outside
      setTooltip({ visible: false, content: "", x: 0, y: 0 });
    },

    onHover: (event, elements, chart) => {
      if (!chart?.canvas) return;
      const canvas = chart.canvas;
      canvas.style.cursor = elements.length > 0 || (!isPortraitMobile && defaultColors.some(c => c === "#FFFF00")) ? "pointer" : "default";

      if (!isPortraitMobile) {
        // label hover highlight (desktop/landscape)
        const { ctx, chartArea } = chart;
        const labels = chart.data.labels || [];
        const area = chartArea || { left: 0, right: canvas.width, top: 0, bottom: canvas.height };
        const centerX = area.left + (area.right - area.left) / 2;
        const centerY = area.top + (area.bottom - area.top) / 2;
        const radius = chart.scales.r.maxRadius || (Math.min(area.right - area.left, area.bottom - area.top) / 2) * 0.8;
        const hoverX = event.native?.offsetX ?? (event.x - canvas.getBoundingClientRect().left);
        const hoverY = event.native?.offsetY ?? (event.y - canvas.getBoundingClientRect().top);

        let hoveredIndex = null;
        for (let i = 0; i < labels.length; i++) {
          const angle = ((i * 360) / labels.length - 90) * (Math.PI / 180);
          const x = centerX + (radius + 20) * Math.cos(angle);
          const y = centerY + (radius + 20) * Math.sin(angle);
          if (Math.hypot(hoverX - x, hoverY - y) < 40) {
            hoveredIndex = i;
            break;
          }
        }

        defaultColors = labels.map((_, i) => i === hoveredIndex ? "#FFFF00" : "white");
        chart.options.scales.r.pointLabels.color = (ctx) => defaultColors[ctx.dataIndex] || "white";
        chart.options.scales.r.pointLabels.font = (ctx) => ({
          ...defaultFont(ctx),
          weight: defaultColors[ctx.dataIndex] === "#FFFF00" ? "bold" : "normal"
        });

        clearTimeout(updateTimeout);
        updateTimeout = setTimeout(() => chart.update("none"), 16);
      }
    },
  };
};

// Reset StudyStyle data the instant we switch who we're looking at
// (student vs. a different child in parent view). This is the one
// legitimate "clear" signal — everything else (transient session
// mismatches, failed fetches) should leave rawAnswers alone.
useEffect(() => {
  setRawAnswers({ learning: [] });
}, [effectiveUserId]);

// ── Instant hydrate: paint the StudyStyle radar from cached answers the
// moment the page mounts, without waiting on the session/completion
// network round-trips below. Those effects still run and will correct
// this if the cache turns out to be stale or for the wrong session.
useEffect(() => {
  if (!effectiveUserId) return;
  let cancelled = false;
  (async () => {
    try {
      const cachedRow = await getRawAnswers(effectiveUserId, 'Learning');
      if (!cancelled && cachedRow?.data?.length > 0) {
        setRawAnswers({ learning: cachedRow.data });
        setLoading({ learningVisualizations: false });
        setLastCompletedSessionIds((prev) => ({
          learning: prev.learning || cachedRow.sessionId || null,
        }));
      }
    } catch (err) {
      console.warn('Could not hydrate cached StudyStyle answers:', err);
    }
  })();
  return () => { cancelled = true; };
}, [effectiveUserId]);

  // Clean up radar chart
 useEffect(() => {
  const chartInstance = learningRadarChartRef.current?.chart; // Capture the ref value
  return () => {
    if (chartInstance) {
      chartInstance.destroy(); // Use the captured value
    }
  };
}, []);

useEffect(() => {
  if (!userId || !selectedKnowledgeSubject?.trim()) {
    setKnowledgeResources([]);
    setIsLoadingKnowledge(false);
    setKnowledgeError(null);
    return;
  }

const fetchAllKnowledgeResources = async () => {
    await ensureFreshCacheVersion(); // one-time bust guard — runs before any cache read below
    setIsLoadingKnowledge(true);
    setKnowledgeError(null);

    const CACHE_TTL = 60 * 24 * 60 * 60 * 1000;

    // 1. Check cache
    const cachedRow = await getKnowledgeResources(userId);
    if (cachedRow.data && Object.keys(cachedRow.data).length > 0 && Date.now() - cachedRow.timestamp < CACHE_TTL) {
      const subjectKey = selectedKnowledgeSubject.toLowerCase();

      if (cachedRow.data[subjectKey] !== undefined) {
        // Subject already cached — serve instantly
        setKnowledgeResources(cachedRow.data[subjectKey]);
        setIsLoadingKnowledge(false);
        return;
      }

      // Cache exists but this subject is missing — fetch only missing subjects
      const cachedKeys = Object.keys(cachedRow.data);
      const missingSubjects = availableKnowledgeSubjects.filter(
        s => !cachedKeys.includes(s.toLowerCase())
      );

      if (missingSubjects.length > 0) {
        const response = await axios.get('/api/questions/knowledge-resources', {
          params: { subjects: missingSubjects.join(',') },
          headers: getAuthHeaders(),
        });

        const newData = { ...cachedRow.data };
        missingSubjects.forEach(s => { newData[s.toLowerCase()] = []; });
        (response.data || []).forEach(entry => {
          const key = entry.subject_title?.toLowerCase();
          if (key) newData[key] = entry.resources || [];
        });

        await saveKnowledgeResources(userId, newData);

        setKnowledgeResources(newData[selectedKnowledgeSubject.toLowerCase()] || []);
      } else {
        setKnowledgeResources(cachedRow.data[selectedKnowledgeSubject.toLowerCase()] || []);
      }

      setIsLoadingKnowledge(false);
      return;
    }

    // 2. No cache — single request for all top subjects
    try {
      const subjectsToFetch = availableKnowledgeSubjects.length > 0
        ? availableKnowledgeSubjects
        : [selectedKnowledgeSubject];

      const response = await axios.get('/api/questions/knowledge-resources', {
        params: { subjects: subjectsToFetch.join(',') },
        headers: getAuthHeaders(),
      });

      // Build subject → resources map
      const dataMap = {};
      subjectsToFetch.forEach(s => { dataMap[s.toLowerCase()] = []; });
      (response.data || []).forEach(entry => {
        const key = entry.subject_title?.toLowerCase();
        if (key && dataMap[key] !== undefined) {
          dataMap[key] = entry.resources || [];
        }
      });

      await saveKnowledgeResources(userId, dataMap);

      setKnowledgeResources(dataMap[selectedKnowledgeSubject.toLowerCase()] || []);

    } catch (err) {
      console.error('Error fetching knowledge resources:', err);
      setKnowledgeError('Failed to load resources. Please try again.');
      if (err.response?.status === 401) {
        localStorage.removeItem('token');
        navigate('/login');
      }
    } finally {
      setIsLoadingKnowledge(false);
    }
  };

  fetchAllKnowledgeResources();
}, [selectedKnowledgeSubject, userId, availableKnowledgeSubjects]);


  // Handle clicks outside charts
  useEffect(() => {
    const handleClickOutside = (event) => {
      const chartContainer = document.querySelector(".charts-container");
      const canvas = document.querySelector("canvas");
      if (
        (chartContainer && chartContainer.contains(event.target)) ||
        (canvas && canvas.contains(event.target))
      ) {
        return;
      }
      setTooltip({ visible: false, content: "", x: 0, y: 0 });
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const handleLearningAssessment = () => {
    if (!isAdmin && completionStatus.learning) {
      showToast(
        `You already completed StudyStyle — retake available from ${formatDate(lastCompletionDates.learning)}.`,
        "info", 5000
      );
      return;
    }
    setLearningSessionId(null);
    localStorage.removeItem("learningSessionId");
    navigate("/learningassessment", { state: { startNewAssessment: true } });
  };

  // Placeholder navigation handlers
const handleSubjectAssessment = () => {
  const cachedRole = localStorage.getItem(`app_role_${userId}`);
  const cachedRestriction = localStorage.getItem(`restriction_until_${userId}`);
  const cachedAccess = localStorage.getItem(`dashboard_enrich_access_${userId}`);

  let dashboardAccess = null;
  try {
    const parsedAccess = cachedAccess ? JSON.parse(cachedAccess) : null;
    if (parsedAccess && Date.now() - parsedAccess.timestamp < 60 * 60 * 1000) {
      dashboardAccess = parsedAccess.hasAccess;
    }
  } catch {
    localStorage.removeItem(`dashboard_enrich_access_${userId}`);
  }

  navigate("/dashboard", {
    state: {
      cachedUserData: {
        app_role: cachedRole || userRole,
        restriction_until: cachedRestriction || restrictionUntil,
        dashboard_enrich_access: dashboardAccess,
      },
    },
  });
};

  const formatDate = (date) => {
    if (!date) return "Unknown date";
    try {
      return new Date(date).toLocaleDateString("en-UK", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch {
      return "Invalid date";
    }
  };

const renderLearningRadarChart = () => {
    if (!learningVisualizations) {
      return (
        <div className="learning-empty-state" style={{ color: "white", fontSize: "14px" }}>
          ⚠️ Note: You can only submit StudyStyle Assessment once every 6 months.
        </div>
      );
    }
    const data = combineRadarData();

    // Dim (not hide) datasets outside the focused group, so the overall
    // shape stays visible for context but attention goes to the selected
    // group's own, genuinely comparable facets.
    const displayDatasets = data.datasets.map((ds) => {
      if (!selectedRadarGroup || ds.groupKey === selectedRadarGroup) return ds;
      return {
        ...ds,
        backgroundColor: 'rgba(255,255,255,0.02)',
        borderColor: 'rgba(255,255,255,0.15)',
        pointBackgroundColor: 'rgba(255,255,255,0.15)',
        pointRadius: 0,
        borderWidth: 1,
      };
    });

   return (
    <div className="learning-radar-layout" style={{
      display: 'flex', gap: spacing.lg, alignItems: 'flex-start',
      justifyContent: 'center', flexWrap: 'wrap', width: '100%',
    }}>
<div className="learning-radar-card" style={{
        ...gradientBorder, borderRadius: radius.lg, padding: '5px 5px',
        width: 'min(950px, 94vw)', boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
      }}>
        <p style={{ textAlign: 'center', margin: '4px 0 0 0', fontSize: '12px', color: '#888' }}>
          {selectedRadarGroup
            ? <>Showing only <strong style={{ color: '#40c4ff' }}>{data.datasets.find(d => d.groupKey === selectedRadarGroup)?.label}</strong> facets — click it again to show all.</>
            : 'Click a category in the legend to focus on just its facets — scores aren\'t comparable across categories.'}
        </p>
        <div className="learning-radar-wrapper" style={{ position: 'relative' }}>
          <Radar
            ref={learningRadarChartRef}
            data={{ labels: data.labels, datasets: displayDatasets }}
            options={getRadarOptions('StudyStyle Profile Index', data.notesMap, data.facetsByGroup)}
            aria-label="Learning Assessment Radar Chart"
            redraw={false}
          />
          {tooltip.visible && (
            <div
              role="tooltip"
              className="facet-tooltip-mobile dash-tooltip-panel"
              style={{
                position: "absolute", left: `${tooltip.x}px`, top: `${tooltip.y}px`,
                background: color.bgPanelAlt, color: "white", padding: spacing.base,
                border: '1px solid rgba(54,167,248,0.25)', borderRadius: radius.lg,
                maxWidth: 'min(550px, calc(100vw - 32px))', width: '450px', zIndex: 9999,
                pointerEvents: 'auto', boxShadow: '0 16px 44px rgba(0,0,0,0.5), 0 0 0 1px rgba(54,167,248,0.08)',
              }}
            >
              {tooltip.content}
            </div>
          )}
        </div>
      </div>

           <div className="learning-side-panel" style={{ width: '340px', display: 'flex', flexDirection: 'column', gap: spacing.lg }}>
        <StudyProfileMatchesSidePanel matchesByGroupKey={profileMatchesByGroup} loading={loadingProfileMatches} />

        <div className="learning-panel-card" style={{
          background: 'rgba(2,139,232,0.06)', border: '1px solid rgba(2,139,232,0.3)',
          borderRadius: radius.lg, padding: spacing.base, textAlign: 'center',
        }}>
          <FaChessKnight style={{ fontSize: '20px', color: '#028be8', marginBottom: '8px' }} />
          <p style={{ margin: `0 0 ${spacing.sm} 0`, fontSize: fontSize.sm, color: '#ccc', lineHeight: 1.5 }}>
            See what these results mean and get a personalised learning strategy.
          </p>
          <button
            onClick={() => setActiveSidebarItem('strategy')}
            style={{
              width: '100%', background: 'linear-gradient(90deg, #028be8, #00e1ff)',
              color: 'white', fontWeight: 700, border: 'none', borderRadius: radius.sm,
              padding: '10px 16px', fontSize: fontSize.sm, cursor: 'pointer',
              boxShadow: '0 6px 18px rgba(2,139,232,0.3)',
            }}
          >
            Strategy →
          </button>
        </div>
      </div>
    </div>
  );
};


return (
  <div className="specific-page-enrich dashboard-wrapper">
    <div className="sidebar-enrich">
      <div className="rotate-overlay">
      <FaSyncAlt size={40} style={{ marginBottom: 16 }} />
      <h3>Please rotate your device</h3>
      <p>This experience works best in portrait mode.</p>
    </div>
      <div className="sidebar-header enrich-mobile-header">
        <button
          className={`OG-logo  sidebar-item-logo-enrich ${
            activeSidebarItem === "uniready" ? "selected" : ""
          }`}
          onClick={handleSubjectAssessment}
          aria-current={activeSidebarItem === "uniready" ? "page" : undefined}
        >
          <span className="aspire-enrich">ASPIREdeck</span>
        </button>
        {/* Mobile bell - appears in header */}
{window.innerWidth <= 850 && (
<button
  className={`sidebar-item-enrich ${showInvitationList ? "selected" : ""}`}
  onClick={async () => {
    // Fetch pending invitations AND statuses
    await fetchTeamData({ 
      fetchFullDetails: false,
      fetchInvitations: true,    // Get pending invites list
      fetchStatusOnly: true,     // Also refresh statuses
    });
    setShowInvitationList(true);
  }}
>
  <FaBell className="sidebar-icon-notification-mobile" />
  <span className="sidebar-text-enrich">Notifications</span>
  {notificationCount > 0 && (
    <span className="notification-badge">{notificationCount}</span>
  )}
</button>
)}
        {isAdmin && <p className="admin-status-enrich">Admin</p>}
        <h2 className="title">Enrich+</h2>
        
            {/* ── MOBILE account menu ── */}
            <div className="account-icon-container account-icon-mobile">
              <button
                className="account-icon career-account-icon"
                onClick={toggleAccountMenu}
                aria-label="Account menu"
                style={{boxShadow: "none", position: 'relative', marginTop: "-56px",}}
              >
                <div
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "50%",
                    overflow: "hidden",
                    background: "#222",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "2px solid #444",
                    flexShrink: 0,
                  }}
                >
                  {currentAvatar?.startsWith("fa-avatar-") ? (
                    (() => {
                      const index = parseInt(currentAvatar.split("-")[2], 10) - 1;
                      const style = avatarStyles[index] || avatarStyles[0];
                      return (
                        <div
                          style={{
                            width: "100%",
                            height: "100%",
                            borderRadius: "50%",
                            backgroundColor: style.bg,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: `2.5px solid ${style.color}`,
                          }}
                        >
                          <i
                            className={`fas fa-${style.icon}`}
                            style={{ fontSize: "20px", color: style.color }}
                          />
                        </div>
                      );
                    })()
                  ) : (
                    <img
                      src={`/avatars/${currentAvatar}`}
                      alt="User avatar"
                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                      onError={(e) => { e.target.src = "/avatars/default.png"; }}
                    />
                  )}
                </div>
                <span className="account-username-enrich" style={{ marginLeft: "10px" }}>
                  {displayName}
                </span>
              </button>
        
              {showAccountMenu && (
  <div className="account-menu" ref={mobileMenuRef}>
                  <div className="account-menu-header">
                    <span>{userEmail}</span>
                  </div>
                  {!isReadOnly && (
                    <button
                    className="account-menu-item"
                    onMouseEnter={prewarmDeckSpace}
                    onTouchStart={prewarmDeckSpace}
                    onClick={() => { setShowAccountMenu(false); openModal('deckspace'); }}
                    >
                      My deckSPACE
                    </button>
                  )}
                  {!isReadOnly && (
                    <button
                      className="account-menu-item"
                    onClick={() => { setShowAccountMenu(false); openModal('calendar'); }}
                    >
                      My Calendar
                    </button>
                  )}
                  {!isReadOnly && (
                    <button
                      className="account-menu-item"
                     onClick={() => { setShowAccountMenu(false); openModal('pathways'); }}
                    >
                      Pathways
                    </button>
                  )}
                  <button
                    className="account-menu-item logout"
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowAccountMenu(false);
                      onLogout();
                    }}
                  >
                    Log out
                  </button>
                </div>
              )}
            </div>
            {/* ── end MOBILE ── */}

      </div>
      <nav className="sidebar-nav-enrich">
        <button
  className={`sidebar-item-enrich ${
    activeSidebarItem === "back" ? "selected" : ""
  }`}
  onClick={() => {
  setActiveSidebarItem("back");
  const cachedRole = localStorage.getItem(`app_role_${userId}`);
  const cachedRestriction = localStorage.getItem(`restriction_until_${userId}`);
  const cachedAccess = localStorage.getItem(`dashboard_enrich_access_${userId}`);

  let dashboardAccess = null;
  try {
    const parsedAccess = cachedAccess ? JSON.parse(cachedAccess) : null;
    if (parsedAccess && Date.now() - parsedAccess.timestamp < 60 * 60 * 1000) {
      dashboardAccess = parsedAccess.hasAccess;
    }
  } catch {
    localStorage.removeItem(`dashboard_enrich_access_${userId}`);
  }

  // Build the target path — always include parent context if present
  const targetSearch = isParentView && viewingChildId
    ? `?viewingChildId=${encodeURIComponent(viewingChildId)}&childName=${encodeURIComponent(viewingChildName)}`
    : "";

  navigate(
    { pathname: "/dashboard", search: targetSearch },
    {
      state: {
        cachedUserData: {
          app_role: cachedRole || userRole,
          restriction_until: cachedRestriction || restrictionUntil,
          dashboard_enrich_access: dashboardAccess,
        },
        // Always pass these — Dashboard reads from state as fallback
        ...(isParentView && viewingChildId && {
          viewingChildId,
          childName: viewingChildName,
        }),
      },
    }
  );
}}
  aria-current={activeSidebarItem === "back" ? "page" : undefined}
>
  <FaArrowLeft className="sidebar-icon-enrich" />
  <span className="sidebar-text-enrich">back</span>
</button>
        <button
          className={`sidebar-item-enrich ${
            activeSidebarItem === "enrich" ? "selected" : ""
          }`}
          onClick={() => setActiveSidebarItem("enrich")}
          aria-current={activeSidebarItem === "enrich" ? "page" : undefined}
        >
          <FaIdBadge className="sidebar-icon-enrich" />
          <span className="sidebar-text-enrich">StudyStyle</span>
        </button>
         <button
    className={`sidebar-item-enrich ${
      activeSidebarItem === "strategy" ? "selected" : ""
    }`}
    onClick={() => setActiveSidebarItem("strategy")}
    aria-current={activeSidebarItem === "strategy" ? "page" : undefined}
  >
    <FaChessKnight className="sidebar-icon-enrich" />
    <span className="sidebar-text-enrich">Strategy</span>
  </button>
        <button
          className={`sidebar-item-enrich ${
            activeSidebarItem === "knowledge" ? "selected" : ""
          }`}
          onClick={() => setActiveSidebarItem("knowledge")}
          aria-current={activeSidebarItem === "knowledge" ? "page" : undefined}
        >
          <FaBookOpen className="sidebar-icon-enrich" />
          <span className="sidebar-text-enrich">Knowledge</span>
        </button>


         <button
    className={`sidebar-item-enrich ${
      activeSidebarItem === "supercurricular" ? "selected" : ""
    }`}
    onClick={() => setActiveSidebarItem("supercurricular")}
    aria-current={activeSidebarItem === "supercurricular" ? "page" : undefined}
  >
    <FaBolt className="sidebar-icon-enrich" />
    <span className="sidebar-text-enrich">SuperCurricular</span>
  </button>

{!isReadOnly ? (
<button
  className={`sidebar-item-enrich ${
    activeSidebarItem === "personalstatement" ? "selected" : ""
  }`}
  onClick={() => {
    setActiveSidebarItem("personalstatement");
    setShowPersonalStatement(true);
  }}
>
  <FaEdit className="sidebar-icon-enrich" />
  <span className="sidebar-text">UniStatement</span>
</button>
 ) : (
  <TooltipUIViewOnly
    text="This section is for student self-learning and is only visible to students. Visit the other parent/mentor dashboard sections for test results and insights."
    position="right"
  >
    <button
      className="sidebar-item-enrich disabled-readonly"
      disabled
      style={{ opacity: 0.2, cursor: "not-allowed" }}
    >
      <FaEdit className="sidebar-icon-enrich" style={{ opacity: 0.6 }} />
      <span className="sidebar-text">UniStatement</span>
    </button>
  </TooltipUIViewOnly>
)}
   {!isReadOnly ? (
        <button
          className={`sidebar-item-enrich ${
            activeSidebarItem === "team" ? "selected" : ""
          }`}
          onClick={() => setActiveSidebarItem("team")}
          aria-current={activeSidebarItem === "team" ? "page" : undefined}
        >
          <FaUsers className="sidebar-icon-enrich" />
          <span className="sidebar-text-enrich">Team</span>
        </button>
      ) : (
  <TooltipUIViewOnly
    text="This section is for student self-learning and is only visible to students. Visit the other parent/mentor dashboard sections for test results and insights."
    position="right"
  >
    <button
      className="sidebar-item-enrich disabled-readonly"
      disabled
      style={{ opacity: 0.2, cursor: "not-allowed" }}
    >
      <FaUsers className="sidebar-icon-enrich" style={{ opacity: 0.6 }} />
      <span className="sidebar-text-enrich">Team</span>
    </button>
  </TooltipUIViewOnly>
)}
  <button
  className={`sidebar-item-enrich ${
    activeSidebarItem === "enrichfeed" ? "selected" : ""
  }`}
  onClick={() => {
    setActiveSidebarItem("enrichfeed");
    navigate('/enrichfeed', {
  state: {
    ...(isParentView && { viewingChildId, childName: viewingChildName }),
    sortedScores,
    sortedPart3Scores,
    chosenTopSubject,
  },
});
  }}
  aria-current={activeSidebarItem === "enrichfeed" ? "page" : undefined}
>
  <FaRss className="sidebar-icon-enrich" />
  <span className="sidebar-text-enrich">AcadFeed</span>
</button>
        <div style={{ flexGrow: 1 }}></div> {/* Spacer to push button to bottom */}
       <button
  className={`sidebar-item-enrich ${
    showInvitationList ? "selected" : "" // Use showInvitationList for styling
  }`}
  onClick={async () => {
    await fetchAndValidateInvitations();   // ← Trigger fetch here
    setShowInvitationList(true);
  }}
  aria-current={showInvitationList ? "page" : undefined}
>
  <FaBell className="sidebar-icon-notification" />
  <span className="sidebar-text-enrich">Notifications</span>
  {notificationCount > 0 && (
    <span className="notification-badge">{notificationCount}</span>
  )}
</button>

 {/* ── DESKTOP account menu ── */}
    <div className="account-icon-container account-icon-desktop">
      <button
        className="account-icon career-account-icon"
        onClick={toggleAccountMenu}
        aria-label="Account menu"
        style={{boxShadow: "none"}}
      >
        <div
          style={{
            width: "40px",
            height: "40px",
            borderRadius: "50%",
            overflow: "hidden",
            background: "#222",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "2px solid#E9E9E9",
            flexShrink: 0,
          }}
        >
          {currentAvatar?.startsWith("fa-avatar-") ? (
            (() => {
              const index = parseInt(currentAvatar.split("-")[2], 10) - 1;
              const style = avatarStyles[index] || avatarStyles[0];
              return (
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "50%",
                    backgroundColor: style.bg,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: `2.5px solid ${style.color}`,
                  }}
                >
                  <i
                    className={`fas fa-${style.icon}`}
                    style={{ fontSize: "22px", color: style.color }}
                  />
                </div>
              );
            })()
          ) : (
            <img
              src={`/avatars/${currentAvatar}`}
              alt="User avatar"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              onError={(e) => { e.target.src = "/avatars/default.png"; }}
            />
          )}
        </div>
        <span className="account-username-enrich" style={{ marginLeft: "10px" }}>
          {displayName}
        </span>
      </button>

      {showAccountMenu && (
  <div className="account-menu" ref={menuRef}>
          <div className="account-menu-header">
            <span>{userEmail}</span>
          </div>
          {!isReadOnly && (
            <button
              className="account-menu-item"
              onMouseEnter={prewarmDeckSpace}
              onTouchStart={prewarmDeckSpace}
              onClick={() => { setShowAccountMenu(false); openModal('deckspace'); }}
            >
              My deckSPACE
            </button>
          )}
          {!isReadOnly && (
            <button
              className="account-menu-item"
              onClick={() => { setShowAccountMenu(false); openModal('calendar'); }}
            >
              My Calendar
            </button>
          )}
          {!isReadOnly && (
            <button
              className="account-menu-item"
onClick={() => { setShowAccountMenu(false); openModal('pathways'); }}
            >
              Pathways
            </button>
          )}
          <button
            className="account-menu-item logout"
            onClick={(e) => {
              e.stopPropagation();
              setShowAccountMenu(false);
              onLogout();
            }}
          >
            Log out
          </button>
        </div>
      )}
    </div>
    {/* ── end DESKTOP ── */}

      </nav>
{showWhatsNextModal && (
  <div
    className="modal"
    style={{
      position: "fixed",
      backgroundColor: "rgba(0, 0, 0, 0.79)",
      zIndex: 1000,
    }}
  >
    <div
      className="modal-insights"
      style={{
        backgroundColor: "#0b1021",
        padding: "20px",
        borderRadius: "10px",
        color: "white",
        width: "600px",
        maxWidth: "90%",
        position: "relative",
        top: "-20%",
        left: "7.5%",
      }}
    >
      <button
        className="modal-close-button"
        onClick={() => setShowWhatsNextModal(false)}
        aria-label="Close What's Next modal"
      >
        ×
      </button>

      <h4 style={{ color: "#028be8" }}>What's Next?</h4>

      <p>
        <br />
        The strategy generated may serve as a starting point for optimising your study habits and academic preparation for university. We recommend taking time to reflect on the techniques and routines suggested, and discuss them with a teacher, tutor, academic advisor, or study skills coach. They can help you tailor these strategies to your specific subjects and learning goals.
      </p>

      <p>
        Consider experimenting with the recommended methods to build on your natural learning strengths, while gradually incorporating practices to address areas for improvement. As your skills develop and your academic demands evolve, revisit and refine your approach — stay adaptable, persistent, and proactive in mastering effective learning.
      </p>

      {/* Subtly highlighted consultation section */}
      <div
      className="modal-whatsnext-consultation"
        style={{
          marginTop: "28px",
          padding: "16px 20px",
          backgroundColor: "rgba(2, 139, 232, 0.08)", // very subtle blue tint
          borderLeft: "4px solid #028be8",
          borderRadius: "6px",
          fontSize: "0.98rem",
          lineHeight: "1.45",
        }}
      >
        <p style={{ margin: "0 0 12px 0", fontWeight: "bold" }}>
          Ready for personalised academic guidance?
        </p>
        <p style={{ margin: "0 0 16px 0", opacity: 0.92 }}>
          Contact Oxbridge Gateway for expert consultation — our advisors can provide tailored study strategies, subject-specific advice, and support aligned with your university goals.
        </p>
        <div className="report-book">
        <button
  onClick={handleDownloadFullReportFromEnrich}
  className="full-report"
  style={{
    display: "inline-block",
    backgroundColor: "transparent",
    color: "#00e1ff",
    border: "1px solid #00e1ff",
    padding: "10px 22px",
    borderRadius: "6px",
    fontWeight: "bold",
    fontSize: "0.97rem",
    cursor: "pointer",
    marginBottom: "12px",
    transition: "all 0.2s ease",
    height: "45px",
  }}
  onMouseOver={(e) => { e.currentTarget.style.backgroundColor = "rgba(0,225,255,0.12)"; }}
  onMouseOut={(e) => { e.currentTarget.style.backgroundColor = "transparent"; }}
>
  <FaDownload style={{ marginRight: '10px' }} /> Full Report
</button>
<br />
        <a
          href="https://www.oxbridgegateway.com/aspiredeck"
          target="_blank"
          rel="noopener noreferrer"
          className="modal-whatsnext-consultation"
          style={{
            display: "inline-block",
            backgroundColor: "#028be8",
            color: "white",
            padding: "12px 22px",
            borderRadius: "6px",
            textDecoration: "none",
            fontWeight: "bold",
            fontSize: "0.97rem",
            transition: "background-color 0.2s ease",
            height: "45px"
          }}
          onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#0270c0")}
          onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#028be8")}
        >
          Book Consultation →
        </a>
      </div>
    </div>
    </div>
  </div>
)}
{showWhatsNextModalStudyStyle && (
  <div
    className="modal"
    style={{
      position: "fixed",
      backgroundColor: "rgba(0, 0, 0, 0.79)",
      zIndex: 1000,
    }}
  >
    <div
      className="modal-insights"
      style={{
        backgroundColor: "#0b1021",
        padding: "20px",
        borderRadius: "10px",
        color: "white",
        width: "600px",
        maxWidth: "90%",
        position: "relative",
        top: "-20%",
        left: "7.5%",
      }}
    >
      <button
        className="modal-close-button"
        onClick={() => setShowWhatsNextModalStudyStyle(false)}
        aria-label="Close What's Next modal"
      >
        ×
      </button>

      <h4 style={{ color: "#028be8" }}>What's Next?</h4>

      <p>
        <br />
       Your StudyStyle Profile Index gives you a strong foundation for understanding how you learn best and where your academic strengths lie. It highlights the patterns, preferences, and approaches that shape your study habits and overall performance.     
        </p>
         <p>
The next step is to turn these insights into action. Visit the Strategy page to generate your personalised study strategy. This tailored guidance translates your results into practical techniques, helping you study more effectively, stay organised, and achieve stronger academic outcomes.        
</p>

      {/* Subtly highlighted consultation section */}
      <div
      className="modal-whatsnext-consultation"
        style={{
          marginTop: "28px",
          padding: "16px 20px",
          backgroundColor: "rgba(2, 139, 232, 0.08)", // very subtle blue tint
          borderLeft: "4px solid #028be8",
          borderRadius: "6px",
          fontSize: "0.98rem",
          lineHeight: "1.45",
        }}
      >
        <p style={{ margin: "0 0 12px 0", fontWeight: "bold" }}>
          Ready for personalised academic guidance?
        </p>
        <p style={{ margin: "0 0 16px 0", opacity: 0.92 }}>
          Contact Oxbridge Gateway for expert consultation — our advisors can provide tailored study strategies, subject-specific advice, and support aligned with your university goals.
        </p>
         <div className="report-book">
        <button
  onClick={handleDownloadFullReportFromEnrich}
  className="full-report"
  style={{
    display: "inline-block",
    backgroundColor: "transparent",
    color: "#00e1ff",
    border: "1px solid #00e1ff",
    padding: "10px 22px",
    borderRadius: "6px",
    fontWeight: "bold",
    fontSize: "0.97rem",
    cursor: "pointer",
    marginBottom: "12px",
    transition: "all 0.2s ease",
    height: "45px",
  }}
  onMouseOver={(e) => { e.currentTarget.style.backgroundColor = "rgba(0,225,255,0.12)"; }}
  onMouseOut={(e) => { e.currentTarget.style.backgroundColor = "transparent"; }}
>
  <FaDownload style={{ marginRight: '10px' }} /> Full Report
</button>
<br />
        <a
          href="https://www.oxbridgegateway.com/aspiredeck"
          target="_blank"
          rel="noopener noreferrer"
          className="modal-whatsnext-consultation"
          style={{
            display: "inline-block",
            backgroundColor: "#028be8",
            color: "white",
            padding: "12px 22px",
            borderRadius: "6px",
            textDecoration: "none",
            fontWeight: "bold",
            fontSize: "0.97rem",
            transition: "background-color 0.2s ease",
            height: "45px",
          }}
          onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#0270c0")}
          onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#028be8")}
        >
          Book Consultation →
        </a>
      </div>
       </div>
    </div>
  </div>
)}
    {showInvitationList && (
  <div className="invitation-menu" ref={invitationMenuRef}>
    <div className="invitation-menu-header">
      <span>Pending Invitations</span>
    </div>
    {pendingInvitations.length > 0 ? (
      <ul className="invitation-list">
        {pendingInvitations.map((invitation) => (
          <li key={invitation.invitation_id} className="invitation-item">
            <span>
              Invitation from {invitation.inviter_email} for Team Challenge subject{" "}
              {invitation.subject}
            </span>
            <div className="invitation-actions">
              <button
                className="invitation-action-button accept"
                onClick={() =>
                  handleInvitationAction(invitation.invitation_id, "accept")
                }
                aria-label={`Accept invitation ${invitation.invitation_id}`}
                disabled={isProcessingInvitation}
              >
                <FaCheck />
              </button>
              <button
                className="invitation-action-button decline"
                onClick={() =>
                  handleInvitationAction(invitation.invitation_id, "decline")
                }
                aria-label={`Decline invitation ${invitation.invitation_id}`}
                disabled={isProcessingInvitation}
              >
                <FaTimes />
              </button>
            </div>
            {/* Show specific error for this invitation if it exists */}
            {invitationErrors && 
             typeof invitationErrors === 'object' && 
             invitationErrors[invitation.invitation_id] && (
              <p className="invitation-error">{invitationErrors[invitation.invitation_id]}</p>
            )}
          </li>
        ))}
      </ul>
    ) : (
      <div className="invitation-empty">No pending invitations.</div>
    )}
    {/* Show general error if it's a string */}
    {invitationErrors && typeof invitationErrors === 'string' && (
      <p className="invitation-error">{invitationErrors}</p>
    )}
  </div>
)}
{showStudyLearnerIntelligenceModal && (
  <StudyLearnerIntelligenceModal
    userId={userId}
    initialData={studyLearnerIntelligence}
    onClose={(finalData) => {
      setStudyLearnerIntelligence(finalData);
      setShowStudyLearnerIntelligenceModal(false);
    }}
  />
)}
    </div>
    <div className="main-content ">
      {activeSidebarItem === "enrich" && (
        <div className="learningpage">
                 {viewModeBannerText && (
              <div className="view-mode-banner">
                <div className="banner-content">
                  <span style={{fontSize: "1.1rem"}} className="banner-icon"><FaEye></FaEye></span>
                  <span style={{fontSize: "1rem", padding: "9px 0 9px 0"}} className="banner-text banner-text-mobile">{viewModeBannerText}</span>
                </div>
              </div>
            )}
        <div
          className="charts-container"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: "rgba(249, 250, 251, 0)",
            marginTop: "0px",
            marginBottom: "40px",
            maxWidth: "1500px",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
      {loading.learningVisualizations ? (
            <div className="learning-loading-text" style={{ color: "white", fontSize: "14px" }}>Loading...</div>
          ) : (
            <>
              <div
                className="learning-inner-wrapper"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                <div
                  className="button-container"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "20px",
                    justifyContent: "center",
                  }}
                >
                  
                   {!isReadOnly && (   // ← Hide completely for parents/mentors
              <TooltipUI
                text={
                  !isAdmin && completionStatus.learning
                    ? `Last completed on ${formatDate(lastCompletionDates.learning)}. Retake available from ${formatDate(
                        new Date(new Date(lastCompletionDates.learning).getTime() + 6 * 30 * 24 * 60 * 60 * 1000)
                      )}.`
                    : ""
                }
              >
                <button
                  className={`assessment-button ${!isAdmin && completionStatus.learning ? "disabled" : ""}`}
                  onClick={handleLearningAssessment}
                  disabled={!isAdmin && completionStatus.learning}
                >
                  Take StudyStyle Assessment
                </button>
              </TooltipUI>
            )}
                  {lastCompletedSessionIds.learning && learningVisualizations && (
                    <button
                      className="scoring-details-button"
                     onClick={() =>
  navigate("/learning-scores", {
    state: {
      sessionId: lastCompletedSessionIds.learning,
      visualizations: learningVisualizations,
      ...(isParentView && {
        viewingChildId,
        childName: viewingChildName,
      }),
    },
  })
}
                    >
                      StudyStyle Scoring Details
                    </button>
                  )}

                  
              {/* ── NEW: What's Next? button ── */}
              {learningVisualizations && (   // only show after results are loaded
                <button
                  className="whats-next-button insights-button whats-next-assessment"
                  onClick={() => setShowWhatsNextModalStudyStyle(true)}
                >
                  What's Next?
                </button>
              )}
                </div>
                {renderLearningRadarChart()}
              </div>
              {error.learningVisualizations && (
                <div
                  className="learning-error-text"
                  style={{ color: "white", fontSize: "14px", marginTop: "20px" }}
                >
                  {error.learningVisualizations}
                </div>
              )}
            </>
          )}
        </div>
        </div>
      )}
      {activeSidebarItem === "strategy" && renderStrategyPage()}
           {activeSidebarItem === "knowledge" && renderKnowledgePage()}
      {activeSidebarItem === "team" && renderTeamPage({ 
  helpButtonRef,
  isDropdownOpen,
  setIsDropdownOpen,
  invitationDropdownRef
})}
{activeSidebarItem === "supercurricular" && renderSuperCurricularSection()}
{activeSidebarItem === "personalstatement" && renderPersonalStatementPage()}
  </div>
  {/* ─── Progress Celebration Modal ─── */}
{showProgressModal && justCompleted && (
  <div
    className="progress-modal-overlay"
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 2000,
    }}
  >
    <div
      style={{
        background: "linear-gradient(135deg, #0f1629, #1a2342)",
        color: "white",
        padding: "2.4rem 2.2rem",
        borderRadius: "16px",
        maxWidth: "520px",
        width: "90%",
        textAlign: "center",
        boxShadow: "0 12px 50px rgba(0,225,255,0.35)",
        border: "1px solid rgba(0,225,255,0.28)",
      }}
    >
      <h2 style={{ margin: "0 0 1.6rem", color: "#00e1ff", fontSize: "2.2rem" }}>
        Well Done!
      </h2>

      <p style={{ fontSize: "1.25rem", margin: "0 0 2.2rem", lineHeight: 1.5 }}>
        You just completed the{" "}
        <strong style={{ color: "#36a7f8" }}>
          {justCompleted === "uniready"
            ? "UniReady"
            : justCompleted === "studystyle"
            ? "StudyStyle"
            : "FutureReady"}{" "}
        </strong>{" "}
        assessment!
      </p>

      {/* ── New: Three Star / Check Icons Layout ── */}
      <div
      className="completion-progress-stars-study"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "16px",
          margin: "2rem 0 2.5rem",
          padding: "0 10px",
        }}
      >
        {[
          { key: "uniready",    label: "UniReady",    icon: "⭐" },
          { key: "studystyle",  label: "StudyStyle",  icon: "⭐" },
          { key: "futureready", label: "FutureReady", icon: "⭐" },
        ].map((item) => (
          <div
            key={item.key}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <div
              style={{
                fontSize: "3.2rem",
                lineHeight: 1,
                opacity: completedAssessments[item.key] ? 1 : 0.35,
                filter: completedAssessments[item.key] ? "drop-shadow(0 0 12px #ffd700)" : "none",
                transition: "all 0.4s ease",
              }}
            >
              {completedAssessments[item.key] ? "★" : "☆"}
            </div>
            <span
              style={{
                fontSize: "1.05rem",
                fontWeight: completedAssessments[item.key] ? 600 : 400,
                color: completedAssessments[item.key] ? "#00e1ff" : "#888",
              }}
            >
              {item.label}
            </span>
          </div>
        ))}
      </div>

      <button
        onClick={() => setShowProgressModal(false)}
        className="completion-progress-button"
        style={{
          padding: "1rem 2.6rem",
          background: "linear-gradient(90deg, #028be8, #00e1ff)",
          color: "white",
          border: "none",
          borderRadius: "12px",
          fontSize: "1.25rem",
          fontWeight: "bold",
          cursor: "pointer",
          boxShadow: "0 5px 18px rgba(2,139,232,0.45)",
          transition: "all 0.2s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-2px)";
          e.currentTarget.style.boxShadow = "0 8px 25px rgba(2,139,232,0.55)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 5px 18px rgba(2,139,232,0.45)";
        }}
      >
        Continue
      </button>
    </div>
  </div>
)}

{/* ─── Avatar Selection Modal ─── */}
{showAvatarModal && (
  <div
    className="avatar-modal-overlay"
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.8)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 2100,
    }}
  >
    <div
      style={{
        background: "#0f1629",
        color: "white",
        padding: "2.2rem",
        borderRadius: "16px",
        maxWidth: "620px",
        width: "92%",
        maxHeight: "88vh",
        overflowY: "auto",
        boxShadow: "0 15px 60px rgba(0,225,255,0.35)",
        border: "1px solid rgba(0,225,255,0.3)",
      }}
    >
      <h2
        style={{
          margin: "0 0 1.4rem",
          textAlign: "center",
          color: "#00e1ff",
          fontSize: "2.1rem",
        }}
      >
        Choose Your Avatar
      </h2>

      <p
        style={{
          textAlign: "center",
          color: "#a0e7ff",
          marginBottom: "1.8rem",
          fontSize: "1.1rem",
        }}
      >
        Congratulations! You've completed all three core assessments.<br />
        Pick your favorite avatar:
      </p>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr))",
          gap: "1.4rem",
          margin: "2rem 0",
        }}
      >
        {Array.from({ length: 15 }, (_, i) => {
          const num = i + 1;
          const avatarName = `avatar-${num}.png`;
          const isSelected = selectedAvatar === avatarName;
          const isCurrent = currentAvatar === avatarName;

          return (
            <div
              key={num}
              onClick={() => setSelectedAvatar(avatarName)}
              style={{
                border: isSelected
                  ? "4px solid #028be8"
                  : isCurrent
                  ? "4px solid #ffaa00"
                  : "2px solid #444",
                borderRadius: "14px",
                padding: "10px",
                cursor: "pointer",
                background: isSelected ? "rgba(2,139,232,0.22)" : "transparent",
                textAlign: "center",
                transition: "all 0.25s ease",
                transform: isSelected ? "scale(1.08)" : "scale(1)",
              }}
            >
              <img
                src={`/avatars/${avatarName}`} // ← place images in public/avatars/
                alt={`Avatar ${num}`}
                style={{
                  width: "100%",
                  borderRadius: "12px",
                  display: "block",
                  boxShadow: isCurrent ? "0 0 20px #ffaa00aa" : "none",
                }}
                onError={(e) => (e.target.src = "/avatars/default.png")}
              />
              <div
                style={{
                  marginTop: "8px",
                  fontSize: "0.9rem",
                  color: isCurrent ? "#ffaa00" : isSelected ? "#36a7f8" : "#aaa",
                }}
              >
                {isCurrent ? "Current" : isSelected ? "Selected" : `Avatar ${num}`}
              </div>
            </div>
          );
        })}
      </div>

      <div
        style={{
          display: "flex",
          gap: "1.5rem",
          justifyContent: "center",
          marginTop: "2rem",
        }}
      >
        <button
          onClick={() => setShowAvatarModal(false)}
          style={{
            padding: "1rem 2rem",
            background: "#444",
            color: "white",
            border: "none",
            borderRadius: "12px",
            fontSize: "1.1rem",
            cursor: "pointer",
          }}
        >
          Cancel
        </button>

        <button
          onClick={async () => {
            if (!selectedAvatar) return;

            try {
           
            } catch (err) {
              console.error("Avatar save failed", err);
              // Fallback: still save locally
              localStorage.setItem(`user_avatar_${userId}`, selectedAvatar);
              setCurrentAvatar(selectedAvatar);
              setShowAvatarModal(false);
    showToast('Saved locally (server save failed).', 'error');
            }
          }}
          disabled={!selectedAvatar}
          style={{
            padding: "1rem 2rem",
            background: selectedAvatar ? "#028be8" : "#555",
            color: "white",
            border: "none",
            borderRadius: "12px",
            fontSize: "1.1rem",
            cursor: selectedAvatar ? "pointer" : "not-allowed",
            boxShadow: selectedAvatar ? "0 4px 15px rgba(2,139,232,0.5)" : "none",
          }}
        >
          Save Avatar
        </button>
      </div>
    </div>
  </div>
)}
     </div>
);
}
